<template>
  <v-card>
    <v-stepper v-model="e1" flat>
      <v-stepper-items>
        <v-stepper-content step="1" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="1">
            <v-card-title class="education_title">
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              <v-divider vertical class="hidden-md-and-up ml-2 mr-2 mx-2"></v-divider>
              <v-divider vertical class="hidden-sm-and-down ml-5 mr-5"></v-divider>
              <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="red--text text--darken-2 education_title_notitext">출입자 안전교육</div>
              <div v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" class="red--text text--darken-2 education_title_notitext">방문객 안전교육</div>
              <div v-else class="red--text text--darken-2 education_title_notitext">출입 안전교육</div>
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2" style="overflow:auto;height:200px;">
              모두에게 가치 있는 최고의 파트너, <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}}</strong> 방문을 환영합니다. <br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4" min-height="520" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">개 요</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 pb-0">
              <strong class="deep-orange--text">목 적</strong><br>
              <span>
                {{ $store.state.CustomInfo.SiteNm }}에서 알아야 할 유의사항 및 위험요인에 대한 교육을 통해 아래의 목적을 달성하기 위함
              </span>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>사업장 출입 시 유의사항 안내를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>내방객 및 협력사 구성원에 대한 <strong class="red--text text--lighten-1">안전의식 고취</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                3.&nbsp;
                <div>사내 규정 교육을 통한 <strong class="red--text text--lighten-1">안전작업 정착화</strong></div>
              </div>
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></p>                
              <p class="ml-4 font-weight-bold body-1">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>                
              <p class="ml-4 font-weight-bold body-1">3. 사내 규정 교육을 통한 안전 작업 정착화</p>                 -->
              <!-- <div class="mb-2">{{$store.state.CustomInfo.SiteNm}} 사내 규정 및 주의사항 등의 안전교육을 통한</div>
              <p class="text-h6 font-weight-bold ml-4">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 사고 예방</p>
              <p class="text-h6 font-weight-bold ml-4">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>
              <p class="text-h6 font-weight-bold ml-4">3. 사내 규정 교육을 통한 안전 작업 정착화</p> -->
            </v-card-text>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">대 상</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                <div>내방객 / 관계사 / 협력사 전체</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4" min-height="520" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">SHE Standard Pack 안내</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 pb-0">
              SK머티리얼즈제이엔씨는 경영 전반에 있어 인간과 환경의 보호를 최우선 가치로 추구하며, 안전하고 건강한 사업장 구축을 위해 최선을 다하고 있습니다.<br>
              당사와의 협력사의 동반 성장을 근간으로 하고 지속적인 개선을 위해, 잠재적인 위험요인을 관리하고자, 협력사의 SHE Standard Pack 을 제정하여 배포합니다.<br>
              본 문서는 SK머티리얼즈제이엔씨가 협력사에게 SHE분야에 요구사항을 제시하고 있습니다. 적용대상은 당사에 납품, 공사, 용역 등 서비스를 제공하는 모든 협력회사를 포함합니다.<br>
              당사와 거래하는 모든 협력사는 본 SHE Standard를 만족하기 위하여 노력해야 합니다. 본 문서외에 세부적인 사항은 별도의 문서를 통해 확인 가능합니다.<br>
              본 문서에 모든 법적인 사항을 포함한 것은 아니며 협력사는 본 문서에 포함되지 않은 법적사항도 모두 만족하여야 합니다. 또한 법적 사항외에 추가적으로 요구하는 사항이 포함되어 있습니다. <br>
              당사와 협력함에 있어서 모든 구성원의 안전을 위해 본 SHE Standard를 참고하여 주시기 바랍니다.<br>
            </v-card-text>
            <v-card-text class="education_content lineHeight2" style="text-align: right;">
            Standard Pack : 계약 전 확인 및 <strong class="red--text text--lighten-1"> 제출서류</strong>
            <br>* 제출서류는 문서 마지막 별첨을 참고하시기 바랍니다.
          </v-card-text>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="2" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4" min-height="520" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주의사항 및 교육 안내</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 pb-0">
              <strong class="deep-orange--text">본 교육의 목적</strong><br>
              <span v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
                {{ $store.state.CustomInfo.SiteId }} 사내 규정 및 주의사항 등의 안전교육을 통한
              </span>
              <span v-else>
                {{ $store.state.CustomInfo.SiteNm }} 사내 규정 및 주의사항 등의 안전교육을 통한
              </span>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>내방객 및 협력사 인력에 대한 안전의식 고취</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                3.&nbsp;
                <div>사내 규정 교육을 통한 안전 작업 정착화</div>
              </div>
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></p>                
              <p class="ml-4 font-weight-bold body-1">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>                
              <p class="ml-4 font-weight-bold body-1">3. 사내 규정 교육을 통한 안전 작업 정착화</p>                 -->
              <!-- <div class="mb-2">{{$store.state.CustomInfo.SiteNm}} 사내 규정 및 주의사항 등의 안전교육을 통한</div>
              <p class="text-h6 font-weight-bold ml-4">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 사고 예방</p>
              <p class="text-h6 font-weight-bold ml-4">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>
              <p class="text-h6 font-weight-bold ml-4">3. 사내 규정 교육을 통한 안전 작업 정착화</p> -->
            </v-card-text>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">주의사항</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>서약서 동의 : 환경안전 서약서에 동의하여야 교육 수료가 완료됩니다.</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>진도율 : 교육내용은 처음부터 마지막까지 정독하셔야 진도율 100%가 달성됩니다.</div>
              </div>
              <!-- <p class="text-h6 font-weight-bold ml-4">1. 서약서 동의 : 환경안전 서약서에 동의하여야 교육 수료가 완료됩니다.</p>
              <p class="text-h6 font-weight-bold ml-4">2. 진도율 : 교육내용은 처음부터 마지막까지 정독하셔야 진도율 100%가 달성됩니다.</p> -->
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">교육 안내</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>인증 대상 : 내방객 / 관계사 / 협력사 전체</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>
                  <div class="mb-2">인증 기간 : 교육 수료일로부터 6개월</div>
                  (인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)
                </div>
              </div>
              <!-- <p class="mt-n8 ml-8 mb-2 ml-4 text_first_font">(인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)</p>                 -->
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 인증 대상 : 내방객 / 관계사 / 협력사 전체</p>
              <p class="ml-4 font-weight-bold body-1">2. 인증 기간 : 교육 수료 일로부터 6개월</p>
              <p class="mt-n4 ml-8 font-weight-bold body-1">(인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)</p>                 -->
              <!-- <p class="text-h6 font-weight-bold ml-4">1. 인증 대상 : 내방객 / 관계사 / 협력사 전체</p>
              <p class="text-h6 font-weight-bold ml-4">
                2. 인증 기간 : 교육 수료 일로부터 6개월<br>
                (인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)
              </p> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">01. SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2" v-if="$store.state.CustomInfo.SiteId == 'SKTC' && $store.state.CustomInfo.SiteId == 'SKMG14'">                
              {{$store.state.CustomInfo.SiteNm}}은 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>      
            <v-card-text class="education_content lineHeight2" v-else>                
              {{$store.state.CustomInfo.SiteNm}}는 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>          
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 조성</strong><br>
                  SHE 경영체계를 지속적으로 개선하여 구성원, 지역사회, 고객 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장을 함께 만들어간다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 가치 추구</strong><br>
                  친환경적 설계, 자원의 효율적 사용, 화학물질의 철저한 관리를 통해 사업장과 지역사회의 환경을 보호하고, 선제적으로 온실가스를 감축함으로써 전 지구적 기후변화 위기에 적극적으로 대응한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법 경영 및 투명한 정보공개</strong><br>
                  SHE 법규, 사규 및 이해관계자의 요구사항을 준수하고, 투명한 정보공개를 통해 이해관계자의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  모든 구성원은 인간과 환경 보호를 최우선 가치로 인식하고, 보다 안전하고 건강한 사업장을 만들기 위해 적극적으로 동참한다.
                </div>
              </div>
            </v-card>

            <!-- <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>             -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12 pledge_content" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상대피안내 (Evacuation notice)</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex justify-space-between align-items-start">
                <div>
                  <v-row>
                    <v-col cols="12" md="6" sm="12">
                      <strong class="deep-orange--text font-weight-black">비상대피 시 행동요령</strong><br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>대피인원 파악</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>현장지휘소에 대피인원 및 환자유무 등 이상점 보고</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>현장지휘소 통제에 따라 행동</div>
                    </div>
                    <strong class="deep-orange--text font-weight-black">집결장소</strong><br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>평택공장: <strong>사무동 출입구 비상대피집결지</strong></div><br>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>동탄연구소: 동익미라벨타워 1층 집결지</div><br>
                    </div>

                    <strong class="deep-orange--text font-weight-black">[집결장소 행동요령]</strong><br>
                    <div class="d-flex">
                      1.&nbsp;
                      <div>대피 인원 파악 <br>Count evaluated people</div>
                    </div>
                    <div class="d-flex">
                      2.&nbsp;
                      <div>현장지휘소에 대피인원 및 환자발생 이상 유무 보고 <br>Report to command post of situation <br>& emergency patients</div>
                    </div>
                    <div class="d-flex">
                      3.&nbsp;
                      <div>현장지휘소 통제에 따라 행동 <br>Follow command post's orders</div>
                    </div>
                    <div class="box_3 education_content pa-2 ml-3" style="font-size: 20px; font-weight: bold; color: LightGoldenRodYellow;">
                      ☏ 비상전화 : 010-3665-7483(평택) <br>
                      [SHE Part] : 010-5280-3626(동탄)
                    </div>
                    </v-col>
                    <!-- 오른쪽 이미지 영역 -->
                    <v-col cols="12" md="6" sm="12">
                      <div style="flex: 1; text-align: right; margin-right: 20px;">
                        <img src="../assets/SKMJ_map1.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;" />
                        <img src="../assets/SKMJ_map2.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">Contents</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div class="education_content flex-wrap d-flex justify-left mt-0 mb-0">
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">1.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">일반안전</strong>
                    <p class="mt-2 text_first_font">S.G.R(Safety Golden Rules)</p>
                    <p class="mt-2 text_first_font">사업장 內 금지 행위 및 차량 출입 시 준수사항</p>
                    <p class="text_first_font">접견/회의 등 단순 방문 이외 작업 시 주의사항</p>
                    <p class="text_first_font">원부재료 납품 및 폐기물 처리 업체 주의 사항</p>
                    <p class="text_first_font">Penalty</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">2.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">공정 안전</strong>
                    <p class="mt-2 text_first_font">공정의 특징 및 안전 수칙</p>
                    <p class="text_first_font">화학물질 누출 시 대응 요령</p>
                    <p class="text_first_font">안전 보호구</p>
                    <p class="text_first_font">중량물 취급 안전</p>
                    <p class="text_first_font">안전표지</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">3.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">안전 작업 허가제</strong>
                    <p class="mt-2 text_first_font">허가 절차</p>
                    <p class="mt-2 text_first_font">공구 검수</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">4. 안전 작업 수칙</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">5. 비상 대응 절차(비상 대피 등)</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">6. 준수 서약서</strong><br>
                </div>

              </div>
              <v-card-text class="text-h5 lineHeight2 text-center iron_center_contents" style="margin-top: 80px;">
                <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMP.svg" style="height:300px"/>
                </div> -->
              </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">Contents</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div class="education_content flex-wrap d-flex justify-left mt-0 mb-0">
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">1.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">일반안전</strong>
                    <p class="mt-2 text_first_font">S.G.R(Safety Golden Rules)</p>
                    <p class="text_first_font">보행자 및 운전자 안전 수칙</p>
                    <p class="text_first_font">흡연 및 화재 예방 안전 수칙</p>
                    <p class="text_first_font">Penalty</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">2.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">공정 안전</strong>
                    <p class="mt-2 text_first_font">공정의 특징 및 안전 수칙</p>
                    <p class="text_first_font">화학물질 누출 시 대응 요령</p>
                    <p class="text_first_font">안전 보호구</p>
                    <p class="text_first_font">중량물 취급 안전</p>
                    <p class="text_first_font">안전표지</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">3.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">안전 작업 허가제</strong>
                    <p class="mt-2 text_first_font">허가 절차</p>
                    <p class="mt-2 text_first_font">공구 검수</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">4. 안전 작업 수칙</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">5. 비상 대응 절차(비상 대피 등)</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">6. 준수 서약서</strong><br>
                </div>

              </div>
              <v-card-text class="text-h5 lineHeight2 text-center iron_center_contents" style="margin-top: 80px;">
                <!-- <div v-if="$store.state.CustomInfo.SiteId != 'SKTC' && $store.state.CustomInfo.SiteId != 'SKMG14'" class="iron_center_contents" style="width:inherit; height:350px;">
                  <img src="../assets/fire_center_logo.png" style="height:300px"/>
                </div> -->
                <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKTC.svg" style="height:300px"/>
                </div> -->
                <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMG14.svg" style="height:300px"/>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMP.svg" style="height:300px"/>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMJ.svg" style="height:300px"/>
                </div>
              </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">개정이력</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">

              <div class="d-flex">
                -&nbsp;
                <div>Rev. 0 ('25.01.01') 최초제정</div>
              </div>
              
            </v-card-text> 
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">S.G.R(Safety Golden Rules) 준수항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2">
              사업장 내에서 <strong class="red--text text--lighten-1">지켜야할 필수안전수칙(SGR) 준수</strong><br>
            </v-card-text>
            <v-divider></v-divider>

            <div class="d-flex">
              <v-row align="start" no-gutters>
                <v-col cols="12" md="6">
                  <v-card-text class="education_content lineHeight2">
                    <div class="iron_center_contents" ><img src="../assets/SKMP_SGR.jpg" style="height:80%; width: 60%;"/></div>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card-text class="education_content lineHeight2">
                    <div class="d-flex">
                      * &nbsp;
                      <div>Safety Golden Rules 위반 시 제재사항</div>
                    </div>
                    <div class="d-flex">
                      &nbsp;&nbsp;
                      <div>- 당사 관계자의 확인/신고 등을 통해 위반사실이 확인될 경우, 당사 규정에 의거 제재될 수 있음.</div>
                    </div>
                    <div class="d-flex">
                      &nbsp;&nbsp;
                      <div>- 누적기간 : 1년</div>
                    </div>
                    <table class="type09 text-center">
                      <thead>
                        <tr>
                          <th scope="cols">위반횟수</th>
                          <th scope="cols">소속법인</th>
                          <th scope="cols">개인</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1차</td>
                          <td>작업중지 1일<br></td>
                          <td>출입금지 1개월</td>
                        </tr>
                        <tr>
                          <td>2차</td>
                          <td>작업중지 3일 + 입찰제한 6개월</td>
                          <td>출입금지 6개월</td>
                        </tr>
                        <tr>
                          <td>3차</td>
                          <td>입찰 불가</td>
                          <td>영구 출입금지</td>
                        </tr>
                      </tbody>
                    </table>
                  </v-card-text>
                </v-col>
              </v-row>


              
            </div>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="4" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div v-if="$store.state.CustomInfo.SiteId == 'SKMA'" class="red--text text--darken-2 education_title_text">02. Safety Golden Rules</div>
              <div v-else class="red--text text--darken-2 education_title_text">S.G.R(Safety Golden Rules) 준수항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="education_content lineHeight2">
              사업장 내에서 <strong class="red--text text--lighten-1">반드시 지켜야 할 8대 S.G.R(Safety Golden Rules)</strong><br>
            </v-card-text>
            <v-card-text v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="education_content lineHeight2">
              사업장 내에서 <strong class="red--text text--lighten-1">반드시 지켜야 할 10대 S.G.R(Safety Golden Rules)</strong><br>
            </v-card-text>
            <v-card-text v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" class="education_content lineHeight2">
              SK에어플러스에서 반드시 지켜야 할 8대 Golden Rule 안전 방침입니다.<br>
              이를 미 준수 시 <strong class="red--text text--lighten-1">무관용 원칙(One Strike Out)</strong>이 적용됩니다.<br>
            </v-card-text>
            <v-card-text v-else class="education_content lineHeight2">
              사업장 내에서 <strong class="red--text text--lighten-1">반드시 지켜야 할 10대 S.G.R(Safety Golden Rules)</strong><br>
            </v-card-text>
            <v-divider></v-divider>

            
            <v-card-text v-if="$store.state.CustomInfo.SiteId != 'SKTC'" class="education_content lineHeight2 text-center">
              <strong>Safety Golden Rules</strong><br>
            </v-card-text>
            <v-card-text v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="education_content lineHeight2">
              <div class="iron_center_contents" ><img src="../assets/SKTC_SGR.png" style="height:50%; width: 50%;"/></div>
            </v-card-text>

            <v-card-text v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="education_content lineHeight2">
              <div class="d-flex">
                1.&nbsp;
                <div>화학물질 취급/작업 時 지정된 보호구 착용</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>사고보고 기준 준수</div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>작업 時 작업허가서 승인 후 작업</div>
              </div>
              <div class="d-flex">
                4.&nbsp;
                <div>밀폐작업 時 산소농도/유해가스 측정</div>
              </div>
              <div class="d-flex">
                5.&nbsp;
                <div>고소지역 작업 時 추락 예방 조치 후 작업</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>변경 관리 절차 준수</div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>지정된 장소 外 금연</div>
              </div>
              <div class="d-flex">
                8.&nbsp;
                <div>사내 운송수단 안전수칙 준수</div>
              </div>
              <div class="d-flex">
                9.&nbsp;
                <div>안전장치 임의 해제 금지</div>
              </div>
              <div class="d-flex">
                10.&nbsp;
                <div>위험작업 時 2인 1조 작업 </div>
              </div>
            </v-card-text>

            <v-card-text v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" class="education_content lineHeight2">
              <div class="d-flex align-start pledge_content">
                <div style="flex: 1; margin-top:0px;">
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules1.png" style="height:40px"/>
                    </div>
                    1.&nbsp;
                    <div>유해·위험물질 취급/작업 時 지정된 보호구 착용</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules2.png" style="height:40px"/>
                    </div>
                    2.&nbsp;
                    <div>사고보고 기준 준수</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules3.png" style="height:40px"/>
                    </div>
                    3.&nbsp;
                    <div>작업 時 작업허가서 승인 후 작업</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules4.png" style="height:40px"/>
                    </div>
                    4.&nbsp;
                    <div>밀폐작업 時 산소농도/유해가스 측정</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules5.png" style="height:40px"/>
                    </div>
                    5.&nbsp;
                    <div>고소지역 작업 時 추락 예방 조치 후 작업</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules6.png" style="height:40px"/>
                    </div>
                    6.&nbsp;
                    <div>변경 관리 절차 준수</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-1 mt-1 ">
                      <img src="../assets/SKMA_rules7.png" style="height:30px"/>
                    </div>
                    7.&nbsp;
                    <div>지정된 장소 外 금연</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-1 mt-1 ">
                      <img src="../assets/SKMA_rules8.png" style="height:30px"/>
                    </div>
                    8.&nbsp;
                    <div>사내 운송수단 안전수칙 준수</div>
                  </div>
                </div>

                <div>
                  <table class="type10 text-center" style="width: 100%; margin-top:0px;">
                    <thead>
                      <tr>
                        <th scope="cols">S.G.R 항목</th>
                        <th scope="cols">세부 지침</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>유해·위험물질 취급/작업 時 지정된 보호구 착용</td>
                        <td> 
                          - 유해·위험물질의 취급 및 작업 시 규정된 <strong class="red--text text--lighten-1"> 안전보호구</strong> 및 안전장비를 <strong class="red--text text--lighten-1">착용</strong>하여야 한다. <br>*방독마스크, 내산복, 내산장갑, 내산장화, 방염복, Face Shield 등</td>
                      </tr>
                      <tr>
                        <td>사고보고 기준 준수</td>
                        <td>- 산업사고를 포함한 모든 사고 발생 시 <strong class="red--text text--lighten-1">즉시</strong> 보고한다.<br>(사고 은폐가 발생한 경우 1년 내 인지한 시점으로 적용한다.)</td>
                      </tr>
                      <tr>
                        <td>작업 時 작업허가서 승인 후 작업</td>
                        <td>
                          - 안전작업허가 절차에 따라 <strong class="red--text text--lighten-1">작업허가서 발행 승인</strong>을 받고 작업을 실시하여야 한다.<br>
                          - 최종 승인권자의 승인 없이 작업을 금지한다.<br>
                          - <strong class="red--text text--lighten-1">작업 전 위험성 평가</strong>를 반드시 실시하여야 한다.<br>
                          - 화기 작업의 경우 인화성 가스 농도를 측정해야 한다.<br>
                          - 유해화학물질이 있는 배관은 Drain / Purge 여부를 확인해야 한다.<br>
                        </td>
                      </tr>
                      <tr>
                        <td>밀폐작업 時 산소농도/유해가스 측정</td>
                        <td>
                          - 밀폐작업 時 반드시 <strong class="red--text text--lighten-1">산소 농도를 </strong>주기적으로 <strong class="red--text text--lighten-1">측정</strong>해야 한다.<br>
                          - 내부 보관된 물질이 있는 경우 유해가스를 측정해야 한다.<br>
                          - Valve 차단 확인, 맹판(Blind) 설치, 단관 분리 등의 조치를 통해 안전을 확보하여야 한다.<br>
                          - 허가서에 기재된 비상 대기자는 반드시 상주하여야 한다.<br>
                        </td>
                      </tr>
                      <tr>
                        <td>고소지역 작업 時 추락 예방 조치 후 작업</td>
                        <td>
                          - 고소작업 시 <strong class="red--text text--lighten-1">안전벨트 착용 </strong>및 체결해야 한다. (철골 등의 작업 시 2중 안전고리 사용)                          <br>
                          - 비계설치 후 작업 시에는 비계 승인표 승인 후 작업해야 한다.<br>
                        </td>
                      </tr>
                      <tr>
                        <td>변경관리 절차 준수</td>
                        <td>
                          - 변경사항 발생시 기술검토 또는 위험성평가를 실시하고 변경승인 후 작업을 실시해야 한다.<br>
                          - 가동 전 점검을 반드시 실시하고 승인 후에 가동한다. (비상변경의 경우에는 절차를 따른다.)<br>
                        </td>
                      </tr>
                      <tr>
                        <td>지정된 장소 外 금연</td>
                        <td>
                          - 공장 내 <strong class="red--text text--lighten-1">지정된 장소</strong> (흡연장)에서 흡연해야 한다.<br>
                          - 공장 출입 時 라이터는 휴대할 수 없다. (단, 작업용 라이터(작업 전용)는 제외한다.)<br>
                        </td>
                      </tr>
                      <tr>
                        <td>사내 운송수단 안전수칙 준수</td>
                        <td>
                          - 사내 모든 운송수단은 <strong class="red--text text--lighten-1">10km/h</strong> 속도를 준수해야 한다. (지게차, 크레인 등 10km/h)<br>
                          * 충전작업 장소의 운행 속도는 10km/h 준수<br>
                          * 입주사 및 고객사 내부 도로 통행 시 내부에서 규정하는 운행속도 준수<br>
                          - 운전 중 통화·문자·영상물 시청을 하여서는 안 된다.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </v-card-text>
            <v-card-text v-else class="education_content lineHeight2">
              <div class="d-flex red--text">
                1.&nbsp;
                <div>유해 위험물질 취급/작업 時 지정된 보호구 착용 (위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>사고 보고 기준 준수(즉시 보고/서면 보고)</div>
              </div>
              <div class="d-flex red--text">
                3.&nbsp;
                <div>작업 時 작업허가서 승인 후 작업(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex red--text">
                4.&nbsp;
                <div>밀폐작업 時 산소농도/유해가스 측정(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex red--text">
                5.&nbsp;
                <div>고소지역 작업 時 추락 예방 조치 후 작업(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>변경 관리 절차 준수 (변경 검토, 가동 전 점검)</div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>지정된 장소 外 금연 (라이터 휴대 금지)</div>
              </div>
              <div class="d-flex">
                8.&nbsp;
                <div>사내 운송수단 안전 수칙 준수</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <!-- SKTC일때만 이순서로 -->
        <v-stepper-content step="5" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - Penalty</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>GOLDEN RULE을 기본으로, 즉시 Penalty 적용<br></strong>
              <strong class="red--text text--lighten-1">작업자 위반사항 발생 시 경고 없이 즉시 적용 : 개인 출입 정지 및 업체 평가 반영</strong><br>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                SGR위반 Penalty세부기준
                <v-spacer></v-spacer>
                <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              SGR위반 Penalty세부기준<br>
              <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
            </div>

            <table class="type09 text-center" style="margin-top: 40px;">
              <thead>
                <tr>
                  <th scope="cols">위반 차수 </th>
                  <th scope="cols">협력사 법인</th>
                  <th scope="cols">협력사 구성원, 작업자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차</td>
                  <td>작업중지 1일<br></td>
                  <td>출입금지 1개월<br></td>
                </tr>
                <tr>
                  <td>2차</td>
                  <td>작업중지 3일 + 입찰제한 6개월<br></td>
                  <td>출입금지 6개월<br></td>
                </tr>
                <tr>
                  <td>3차</td>
                  <td>등록 취소 <br></td>
                  <td>영구 출입 금지<br></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">S.G.R_Penalty</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>GOLDEN RULE을 기본으로, 즉시 Penalty 적용<br></strong>
              <strong class="red--text text--lighten-1">작업자 위반사항 발생 시 경고 없이 즉시 적용 : 개인 출입 정지 및 업체 평가 반영</strong><br>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                Penalty세부기준
                <v-spacer></v-spacer>
                <!-- <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong> -->
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              Penalty세부기준<br>
              <!-- <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong> -->
            </div>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">구성원</th>
                  <th scope="cols">협력업체 법인</th>
                  <th scope="cols">협력업체 직원</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차 위반</td>
                  <td>경고<br></td>
                  <td>작업중지 * 1일</td>
                  <td>출입금지 1개월</td>
                </tr>
                <tr>
                  <td>2차 위반</td>
                  <td>견책</td>
                  <td>작업중지 * 3일 + 입찰제한 6개월</td>
                  <td>출입금지 6개월</td>
                </tr>
                <tr>
                  <td>3차 위반</td>
                  <td>감봉</td>
                  <td>등록 취소</td>
                  <td>영구 출입금지</td>
                </tr>
                <tr>
                  <td>기타</td>
                  <td colspan='3' class="text-left">
                    <strong class="indigo--text d-flex mb-4">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>SGR 위반 발견 시 즉시 제재</div>
                    </strong>
                    <strong class="indigo--text d-flex">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>
                        누적기한 : 발생일로부터 1년간 유효한다.
                      </div>
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">02. Safety Golden Rules</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div></div>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              Safety Golden Rules를 지키지 않아 위반상황 발생 시 SK에어플러스 구성원을 포함한 모두 경고없이<br>
              <strong class="red--text text--lighten-1">즉시 Penalty가 적용</strong>되며 협력사의 경우 개인 출입 정지 및 업체 평가에 반영됩니다.<br>
            </v-card-text>

            <span class="text-center font-weight-bold d-block" style="font-size: 24px;">위반상황 발생 시</span>
            <div class="mt-2">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="cols">구 분</th>
                    <th scope="cols">1차 위반</th>
                    <th scope="cols">2차 위반</th>
                    <th scope="cols">3차 위반</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>구성원</td>
                    <td>위반자 경고(팀장)</td>
                    <td>위반자 경고(팀장)</td>
                    <td>인사 위원회</td>
                  </tr>
                  <tr>
                    <td>협력회사</td>
                    <td>대표 주관 안전교육</td>
                    <td>6개월 출입금지</td>
                    <td>영구 출입금지</td>
                  </tr>
                </tbody>
              </table>
              </div>

            <span class="text-center font-weight-bold d-block" style="font-size: 24px; margin-top:60px;">위반 적발 시</span>

            <div class="mt-2">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>즉시 작업중지 & 안전교육</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>SHE팀 보고 및 승인</div>
              </div>
            </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">Contents</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div class="education_content flex-wrap justify-left mt-0 mb-0">
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">1.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">SHE방침</strong>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">2.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">안전수칙준수</strong>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">3.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">MSDS</strong>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">4. 교육</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">5. SHE평가</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">6. 건설공사 산업재해 예방기술지도</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">7. 작업허가</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">8. 기타 (폐기물, 도급신고/승인)</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <span class="deep-orange--text">별첨. 제출서류</span><br>
                </div>
              </div>
              <v-card-text class="text-h5 lineHeight2 text-center iron_center_contents" style="margin-top: 80px;">
                <!-- <div v-if="$store.state.CustomInfo.SiteId != 'SKTC' && $store.state.CustomInfo.SiteId != 'SKMG14'" class="iron_center_contents" style="width:inherit; height:350px;">
                  <img src="../assets/fire_center_logo.png" style="height:300px"/>
                </div> -->
                <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKTC.svg" style="height:300px"/>
                </div> -->
                <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMG14.svg" style="height:300px"/>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMP.svg" style="height:300px"/>
                </div>
                <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMJ.svg" style="height:300px"/>
                </div> -->
              </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>


        <v-stepper-content v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'" step="5" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 사업장 內 금지 행위 및 차량 출입 시 준수사항</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <!-- <strong class="red--text text--lighten-1">보행자가</strong> -->
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  사업장 內 금지 행위<br>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      1.&nbsp;
                      <div>출입허가 된 장소 외 출입 금지 (공정지역/작업구역 출입 시, 당사 구성원 입회 및 안전보호구 착용 필수)</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>
                        설비, 장비, 기구, 표식 등 임의조작 금지, 지정된 통행로 및 뛰는 행위 금지
                        <strong class="red--text text--lighten-1">(단, 비상상황, 훈련상황 예외)</strong>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>지정된 장소 외 흡연금지, 작업자는 라이터 소지 금지(보안실에서 수거 후 출입)</div>
                    </div>
                  </div>                  
                  차량 출입 시 준수사항<br>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      1.&nbsp;
                      <div>
                        작업/납품차량 외 현장 출입 제한
                        <strong class="indigo--text text--lighten-1">(1.5톤 이상 차량 후문으로 출입) </strong>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>
                        사내 제한속도 10km/h 준수, 교차로에서 일단정지 후 서행, 추월금지, 경적금지
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>반드시 지정된 주차구역 이용</div>
                    </div>
                  </div>                  
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>작업/납품 등 지정장소 外 주/정차 필요 시,  다음사항 준수</div>
                    </div>
                  </div>                  
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      &nbsp;&nbsp;
                      <div>(비상등 점등, 바퀴 2개 고임목 설치, 하역차량은 하역 후  즉시 외부 및 지정된 주차구역으로 이동)</div>
                    </div>
                  </div>                  
                </v-card-text>
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-content v-else step="5" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 보행자 및 운전자 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">보행자가</strong> 꼭 지켜야 할 사항<br>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      1.&nbsp;
                      <div>인도 보행 준수</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>횡단보도 생활화</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>야간, 새벽 보행 시 가급적 밝은색 의복 착용</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>건널목 통행 시 좌, 우 확인 후 통행</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>음주 후 사내 출입 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      6.&nbsp;
                      <div>차량 바로 앞/뒤 보행 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      7.&nbsp;
                      <div>공사 현장 내 출입 및 접근금지</div>
                    </div>
                  </div>
                  <p class="iron_center_contents"><img src="../assets/under-construction.jpg" style="height:200px; border-radius: 10px;"/></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">운전자가</strong> 꼭 지켜야 할 사항<br>
                  <p class="mt-2 ml-4 text_first_font">1. 사내 규정 속도 준수</p>
                  <p class="ml-4 text_first_font">공장 내 (20km) 공장 외(30km)이내</p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      ※&nbsp;
                      <div>위반 시 <strong class="red--text text--lighten-1">"출입 정지"</strong> 등 규정에 따름</div>
                    </div>
                  </div>

                  <p class="iron_center_contents"><img src="../assets/traffic-light.png" style="height:80px"/></p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>주ㆍ정차 구역 外 주차금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>방지턱 우회 운행 및 앞지르기 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>방향 전환 시 방향 지시등 점등</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>차내 흡연 및 휴대전화 사용금지</div>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 교통</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex justify-space-between align-items-start">
                    <div>
                      <div class="d-flex">
                        1.&nbsp;
                        <div>사내 운송수단 속도제한 준수</div>
                      </div>
                      <div class="d-flex ml-5">
                        <v-icon>mdi-check</v-icon>
                        <div class="ml-2">차량/오토바이/자전거 10km/h, 지게차 10km/h</div>
                      </div>
                      <div class="d-flex">
                        2.&nbsp;
                        <div>운전자는 반드시 <strong class="red--text text--lighten-1">좌석 안전벨트 착용</strong></div>
                      </div>
                      <div class="d-flex">
                        3.&nbsp;
                        <div>규정된 탑승인원 준수 및 화물칸 탑승 금지</div>
                      </div>
                      <div class="d-flex">
                        4.&nbsp;
                        <div>교차로에서는 반드시 서행, 차량/사람의 통행 유무 확인 후 진행</div>
                      </div>
                      <div class="d-flex">
                        5.&nbsp;
                        <div>주행중인 차량 추월 금지(지게차, 구내운반차 등)</div>
                      </div>
                      <div class="d-flex">
                        6.&nbsp;
                        <div><strong class="red--text text--lighten-1">차량 정지 시, </strong>정지브레이크와 기어 등을 사용하여 <strong class="red--text text--lighten-1">확실히 제동 </strong> 실시</div>
                      </div>
                      <div class="d-flex">
                        7.&nbsp;
                        <div>정차 시, 받침목 설치 및 벽면으로 핸들을 조정한 후 주차</div>
                      </div>    
                    </div> 
                    <div style="float: right; margin-right: -150px; margin-top: 100px;">
                      <div class="iron_center_contents mt-5"><img src="../assets/under-construction.jpg" style="height:200px; border-radius: 10px;"/></div>            
                    </div> 
                  </div>
                </v-card-text>
              </v-col>


              <!-- <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">운전자가</strong> 꼭 지켜야 할 사항<br>
                  <p class="mt-2 ml-4 text_first_font">1. 사내 규정 속도 준수</p>
                  <p class="ml-4 text_first_font">공장 내 (20km) 공장 외(30km)이내</p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      ※&nbsp;
                      <div>위반 시 <strong class="red--text text--lighten-1">"출입 정지"</strong> 등 규정에 따름</div>
                    </div>
                  </div>

                  <p class="iron_center_contents"><img src="../assets/traffic-light.png" style="height:80px"/></p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>주ㆍ정차 구역 外 주차금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>방지턱 우회 운행 및 앞지르기 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>방향 전환 시 방향 지시등 점등</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>차내 흡연 및 휴대전화 사용금지</div>
                    </div>
                  </div>
                </v-card-text>
              </v-col> -->
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'" step="6" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 보행자 및 운전자 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">보행자가</strong> 꼭 지켜야 할 사항<br>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      1.&nbsp;
                      <div>인도 보행 준수</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>횡단보도 생활화</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>야간, 새벽 보행 시 가급적 밝은색 의복 착용</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>건널목 통행 시 좌, 우 확인 후 통행</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>음주 후 사내 출입 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      6.&nbsp;
                      <div>차량 바로 앞/뒤 보행 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      7.&nbsp;
                      <div>공사 현장 내 출입 및 접근금지</div>
                    </div>
                  </div>
                  <p class="iron_center_contents"><img src="../assets/under-construction.jpg" style="height:200px; border-radius: 10px;"/></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">운전자가</strong> 꼭 지켜야 할 사항<br>
                  <p class="mt-2 ml-4 text_first_font">1. 사내 규정 속도 준수</p>
                  <p class="ml-4 text_first_font">[사내 운송수단 기준 속도]<br>- 승용차, 오토바이, 자전거 : 20km/h<br>- 화물차량(1ton), 중장비, 지게차 : 10km/h</p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      ※&nbsp;
                      <div>위반 시 <strong class="red--text text--lighten-1">"출입 정지"</strong> 등 규정에 따름</div>
                    </div>
                  </div>

                  <p class="iron_center_contents"><img src="../assets/traffic-light.png" style="height:80px"/></p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>주ㆍ정차 구역 外 주차금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>방지턱 우회 운행 및 앞지르기 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>방향 전환 시 방향 지시등 점등</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>차내 흡연 및 휴대전화 사용금지</div>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" step="6" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">03. 안전보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    사업장 공정 內 모든 장소에서는 <strong class="red--text text--lighten-1">안전모</strong>와 <strong class="red--text text--lighten-1">안전화</strong> 착용을 원칙으로 합니다.<br>
                    작업 종류에 따라 지정된 안전보호구를 착용 후 작업합니다.<br>
                  </v-card-text>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <p class="iron_center_contents">
                      <img src="../assets/safe_tool_0.jpg" style="height:200px; border-radius: 10px;"/>
                      <img src="../assets/safe_tool_1.jpg" class= "ml-12" style="height:200px; border-radius: 10px;"/>
                    </p>
                  </div>
                </v-card-text>
                <v-card-text class="education_content lineHeight2 mt-12">
                  ※  안전보호구 미착용 시 <strong class="red--text text--lighten-1">무관용 원칙(One Strike Out)이 적용됩니다.</strong>
                </v-card-text>
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">1. SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 첨단소재로 지속가능한 미래를 만든다는 경영철학을 바탕으로, 경영활동의 모든 단계에서 안전, 보건, 환경의 가치를 최우선으로 추구하며, 구성원 및 이해관계자의 신뢰를 확보하고 지속가능한 SHE 경영을 위하여 다음 사항을 적극 실천한다.
            </v-card-text> 
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">      
              <!-- <v-container> -->
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="ma-5 pa-5 education_content lineHeight2 grey--text text--darken-1 fill-height">
                      <v-card-title class="d-flex justify-center align-center">
                        <strong class="deep-orange--text" style="font-size:30px;">SHE 방침</strong>
                      </v-card-title>
                      <div class="d-flex mt-2">
                        <strong>1.&nbsp;</strong>
                        <div>
                          <strong>안전하고 쾌적한 사업장 조성</strong><br>
                          SHE 중심 경영을 통해 구성원, 지역사회, 고객 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장 구축을 지속적으로 추진한다.
                        </div>
                      </div>
                      <div class="d-flex">
                        <strong>2.&nbsp;</strong>
                        <div>
                          <strong>구성원 참여</strong><br>
                          사업장의 모든 구성원은 연구, 개발, 생산, 분석 등의 전 공정에서 유해∙위험요인을 제거하고 개선활동에 적극적으로 참여하여, 효과적인 SHE 관리체계를 구축한다.
                        </div>
                      </div>
                      <div class="d-flex">
                        <strong>3.&nbsp;</strong>
                        <div>
                          <strong> 준법경영을 통한 신뢰 확보</strong><br>
                          안전/보건/환경 관련 법규 요구사항 이상을 준수하기 위하여, SHE 운영시스템의 고도화를 통해 성과를 투명하게 공개함으로써 이해관계자의 신뢰를 확보한다.
                        </div>
                      </div>
                      <div class="d-flex">
                        <strong>4.&nbsp;</strong>
                        <div>
                          <strong>친환경 기업 문화 추구</strong><br>
                          친환경적 설계, 자원의 효율적인 사용 및 최적방지시설 도입으로 오염물질의 배출을 최소화하고 유해화학물질의 체계적인 관리를 바탕으로 화학사고를 예방하여 지역사회의 환경을 보호한다.
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="ma-5 pa-5 education_content lineHeight2 grey--text text--darken-1 fill-height" >
                      <v-card-title class="d-flex justify-center align-center">
                        <strong class="deep-orange--text" style="font-size:30px;">품질 방침</strong>
                      </v-card-title>
                      <div class="d-flex mt-2">
                        <strong>1.&nbsp;</strong>
                        <div>
                          <strong>최고의 품질과 서비스로 고객 안전과 행복 추구</strong><br>
                          고객 만족 가치를 최우선으로 하는 파트너로서 최고 품질의 제품과 서비스를 제공하여 고객의 안전과 행복을 추구한다.
                        </div>
                      </div>
                      <div class="d-flex">
                        <strong>2.&nbsp;</strong>
                        <div>
                          <strong>고도화된 품질시스템 운영으로 신뢰 구축</strong><br>
                          선제적이고 고도화된 품질 시스템 운영과 지속적인 품질 혁신으로 고객으로부터 차별적 품질 경쟁력의 신뢰를 구축한다.
                        </div>
                      </div>
                      <div class="d-flex">
                        <strong>3.&nbsp;</strong>
                        <div>
                          <strong> 혁신적인 제품과 기술을 보유한 최고의 파트너</strong><br>
                          기술의 개발과 발전을 통한 혁신적인 제품 개발로 고객 만족을 제공하는 최고의 파트너가 된다.
                        </div>
                      </div>
                      <div class="d-flex">
                        <strong>4.&nbsp;</strong>
                        <div>
                          <strong>전 구성원의 자발적/ 의욕적 참여</strong><br>
                          모든 구성원은 VWBE 조직문화를 바탕으로 세계 최고의 품질경영 실행에 최선을 다해 동참한다.
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              <!-- </v-container> -->
            </v-card-text>


            <v-card-text class="greeting_date text-center mt-5">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 접견/회의 등 단순 방문 이외 작업 시 주의사항</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              접견/회의 등 단순 방문 이외 작업을 하는 경우, 별도 안전교육 및 작업허가절차 준수
            </v-card-text>
            <v-divider class="ma-3"></v-divider>
            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>사소한 작업도 작업허가 대상에 해당되며, 임의로 작업 미대상 판단 금지</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div><span class="indigo--text text--lighten-1">모든 작업 시에는 지정된 안전보호구 착용 필수</span></div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>사고 위험이 있다고 예상 또는 목격한 경우, 누구든지 작업중지 요청 가능</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
            <v-divider class="ma-3"></v-divider>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="6" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 흡연 및 화재 예방 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              1. <strong class="red--text text--lighten-1">보행 중</strong> 흡연 <strong class="red--text text--lighten-1">금지</strong>되어 있습니다.<br>
              2. 담배는 <strong class="red--text text--lighten-1">지정된</strong> 흡연 장소에서만 피운다.<br>
              3. 담배꽁초를 <strong class="red--text text--lighten-1">아무 데나</strong> 버리는 행동을 하지 않는다.<br>
              4. 담뱃불은 손가락으로 <strong class="red--text text--lighten-1">튕기지</strong> 않는다.<br>
              5. 불이 <strong class="red--text text--lighten-1">덜 꺼진</strong> 담배꽁초를 쓰레기통에 버리지 않는다.<br>
            </v-card-text>
            <div class="iron_center_contents mt-5"><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"/></div> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><span class="red--text text--lighten-1">보행 중</span> 흡연 <span class="red--text text--lighten-1">금지</span>되어 있습니다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>담배는 <span class="red--text text--lighten-1">지정된</span> 흡연 장소에서만 피운다.</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>담배꽁초를 <span class="red--text text--lighten-1">아무 데나</span> 버리는 행동을 하지 않는다.</div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>담뱃불은 손가락으로 <span class="red--text text--lighten-1">튕기지</span> 않는다.</div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>불이 <strong class="red--text text--lighten-1">덜 꺼진</strong> 담배꽁초를 쓰레기통에 버리지 않는다.</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <div class="iron_center_contents "><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"/></div>    
              </v-col>
            </v-row>
            <v-divider class="ma-3"></v-divider>
            <v-card-text>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div st>흡연 적발자는 <strong class="red--text text--lighten-1">관계사 통보</strong> 및 사전 경고 없이 <strong class="red--text text--lighten-1">퇴출, 각서징구</strong> 등 불이익 처리가 따릅니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div>담뱃불(약 500˚C) 특성상 <strong class="red--text text--lighten-1">실효습도 50% 이하</strong>에는 대기 중에서 <strong class="red--text text--lighten-1">인화</strong>하기 쉽습니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <template v-if="$store.state.CustomInfo.SiteId == 'SKMP'">
                  <div>
                    화재 등 {{$store.state.CustomInfo.SiteNm}} 신고 전화는
                    <strong class="red--text text--lighten-1">044-998-8114</strong>입니다.
                  </div>
                </template>

                <template v-else>
                  <div>
                    화재 등 {{$store.state.CustomInfo.SiteNm}} 신고 전화는
                    <strong class="red--text text--lighten-1">054-630-8119</strong>입니다.
                  </div>
                </template>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        
        <v-stepper-content step="7" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 금지행위</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>지정된 흡연구역 外 흡연금지(라이터 소지 금지)</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div><span class="red--text text--lighten-1">위험물저장소 및 인화성/폭발성 물질</span>을 취급 및 사용장소 주변에서 점화원을 가까이 하는 행위 금지</div>
                    
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>탑승하거나 올라설 수 있도록 설계된 것이 아닌 운반기구, 컨베이어, 이륜 및 사륜 장비, 손수레 등에 <span class="red--text text--lighten-1">탑승하거나 올라서는 행위 금지</span></div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div><span class="red--text text--lighten-1">뛰는 행위 금지</span>(화재 또는 생명위협, 훈련 등 예외)</div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>위험 및 유해작업장소에 사전 승인 없이 출입/통행 금지</div>
                  </div>
                  <div class="d-flex">
                    6.&nbsp;
                    <div>의도적으로 사내의 물건이나 재산에 손해를 끼치는 행위 금지</div>
                  </div>
                  <div class="d-flex">
                    7.&nbsp;
                    <div><span class="red--text text--lighten-1">작업시 휴대전화 사용금지</span></div>
                  </div>
                  <div class="d-flex">
                    8.&nbsp;
                    <div><span class="red--text text--lighten-1">위험 및 공정지역</span> 內 2차 점화원(측정기, 무전기 등) <span class="red--text text--lighten-1">승인 후 사용 가능</span>
                    </div>
                  </div>
                  <div class="d-flex">
                    9.&nbsp;
                    <div>사업장 內 전 지역 <span class="red--text text--lighten-1">사진촬영 금지</span>(단, 승인된 경우 제외)</div>
                  </div>
                  <div class="d-flex">
                    10.&nbsp;
                    <div>USB, PC, 노트북 및 기타 모든 저장매체, 전기기기 사용 금지</div>
                  </div>
                  <div class="d-flex">
                    11.&nbsp;
                    <div><span class="red--text text--lighten-1">도면 및 서류 등 사내 문서의 반출행위 금지</span></div>
                  </div>
                  <div class="d-flex">
                    12.&nbsp;
                    <div>공정지역 및 작업지역 內 음식물 반입 및 취식행위 금지(휴게공간 이용)</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <div class="iron_center_contents mt-5"><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"/></div>    
              </v-col>
            </v-row>
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 흡연 및 화재 예방 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider>
            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><span class="red--text text--lighten-1">보행 중</span> 흡연 <span class="red--text text--lighten-1">금지</span>되어 있습니다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>담배는 <span class="red--text text--lighten-1">지정된</span> 흡연 장소에서만 피운다.</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>담배꽁초를 <span class="red--text text--lighten-1">아무 데나</span> 버리는 행동을 하지 않는다.</div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>담뱃불은 손가락으로 <span class="red--text text--lighten-1">튕기지</span> 않는다.</div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>불이 <strong class="red--text text--lighten-1">덜 꺼진</strong> 담배꽁초를 쓰레기통에 버리지 않는다.</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <div class="iron_center_contents "><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"/></div>    
              </v-col>
            </v-row>
            <v-divider class="ma-3"></v-divider>
            <v-card-text>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div st>흡연 적발자는 <strong class="red--text text--lighten-1">관계사 통보</strong> 및 사전 경고 없이 <strong class="red--text text--lighten-1">퇴출, 각서징구</strong> 등 불이익 처리가 따릅니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div>담뱃불(약 500˚C) 특성상 <strong class="red--text text--lighten-1">실효습도 50% 이하</strong>에는 대기 중에서 <strong class="red--text text--lighten-1">인화</strong>하기 쉽습니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div>화재 등 {{$store.state.CustomInfo.SiteNm}} 신고 전화는 <strong class="red--text text--lighten-1">054-907-0904</strong>입니다.</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" step="7" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">04. 안전∙보건 표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    작업장 또는 건물 내부 출입 시에는 <strong class="red--text text--lighten-1">금지</strong>/ <strong class="amber--text">경고</strong>/ <strong class="blue--text">지시</strong>/ <strong class="green--text">안내</strong>/
                    안전∙보건표지를 확인하고, 해당하는 행동을 반드시 준수하여야 합니다.<br>
                  </v-card-text>
                  <v-card-text class="education_content lineHeight2" style="font-size:20px;">
                    작업자가 <strong class="red--text text--lighten-1">판단이나 행동의 잘못</strong>을 일으키기 쉬운 장소 또는 작업자가 
                    <strong class="red--text text--lighten-1">실수로 인해 중대한 재해</strong>를 일으킬 위험이 있는 장소에는 
                    안전보건표지를 게시함으로써 <strong class="red--text text--lighten-1">근로자의 안전보건 확보</strong>를 위해 표시하는 표지
                    <br>
                  </v-card-text>
                  
                  <v-row class="mt-2 ml-4 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="red--text text--lighten-1">금 지(특정 행동을 금지)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/safe_01.png" style="height:150px; border-radius: 10px;"/></div>출입 금지
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/safe_07.png" style="height:150px; border-radius: 10px;"/></div>화기 금지
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="amber--text">경 고(위험한 상태 및 장소에 대한 경고)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/warn_08.png" style="height:150px; border-radius: 10px;"/></div>위험장소 경고
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents mt-2"><img src="../assets/warn_12.png" style="height:130px; border-radius: 10px;"/></div>
                            <div class="mt-3">저온 경고</div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="blue--text">지 시 (보호구 착용을 지시)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:150px; border-radius: 10px;"/></div>안전모 착용
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:150px; border-radius: 10px;"/></div>안전화 착용
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="green--text">안 내(정보전달 목적 안내대상을 지시)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:150px; border-radius: 10px;"/></div>세안장치
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:150px; border-radius: 10px;"/></div>들것
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>SGRs의 준수</div>
                  </div>
                  <div class="d-flex ml-6">   
                    <div>- 위반시 제재조치</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>사업장 일반안전 수칙</div>
                  </div>
                  <div class="d-flex ml-6">   
                    <div>- 출입자 전원 준수 필수사항</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>작업안전수칙</div>
                  </div>
                  <div class="d-flex ml-6">   
                    <div>- 안전작업허가제 운영 및 작업전 선결사항</div>
                  </div>
                  <div class="d-flex ml-6">   
                    <div>- 작업 중 위반 시 작업중지</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 원부재료 납품 및 폐기물 처리 업체 주의 사항</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>원부재료 납품 및 폐기물 처리 업체 주의 사항<br></strong>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                모든 작업에 대하여 작업시작 前, 
                <strong class="indigo--text text--lighten-1"> 당사 직원 입회 하에 승인 후 작업 실시</strong>
              </div>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              작업도중 작업장소 이탈 금지<br>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              차량 정차 시, 바퀴고임목/비상등 필수<br>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              화재 및 화학물질 누출 발생 시, 즉시 대피 및 당사 구성원 또는 보안실 즉시 신고<br>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              화학물질 접촉 시,  즉시 비상샤워설비 사용하여 세척 실시<br>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              손상된 안전보호구 착용 금지<br>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              보호구 미소지 경우, 당사 구성원에게 사전 지급요청 필요<br>
            </div>
            <div class="text_first_font hidden-sm-and-down mb-2">
              작업 중 휴대폰 사용 금지<br>
            </div>
            
            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">필수 안전보호구</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>현장(공정지역) 출입시</td>
                  <td>안전모, 안전화, 보안경,  저온장갑, 저온앞치마</td>
                </tr>
                <tr>
                  <td>질소/아르곤 등 가스납품 시</td>
                  <td>안전모, 안전화</td>
                </tr>
                <tr>
                  <td>폐유기용제/폐수 반출 작업시</td>
                  <td>안전모, 안전화, 보안경, 안전장갑</td>
                </tr>
                <tr>
                  <td>그 외 납품/작업</td>
                  <td>지정된 안전보호구 착용</td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="7" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - Penalty</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>GOLDEN RULE을 기본으로, 즉시 Penalty 적용<br></strong>
              <strong class="red--text text--lighten-1">작업자 위반사항 발생 시 경고 없이 즉시 적용 : 개인 출입 정지 및 업체 평가 반영</strong><br>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                SGR위반 Penalty세부기준
                <v-spacer></v-spacer>
                <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              SGR위반 Penalty세부기준<br>
              <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
            </div>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">구성원</th>
                  <th scope="cols">협력업체 직원</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차 위반</td>
                  <td>위반자 경고<br><strong class="indigo--text">(팀장)</strong></td>
                  <td>협력업체 대표가<br>위반자 경고/<strong class="indigo--text">안전교육 실시</strong><br><strong class="indigo--text">협력업체 관리부서 통보</strong></td>
                </tr>
                <tr>
                  <td>2차 위반</td>
                  <td>위반자 경고<br><strong class="indigo--text">(공장장/실장)</strong></td>
                  <td>[직원] 6개월 출입 금지<br><strong class="indigo--text">협력업체 관리부서 통보</strong></td>
                </tr>
                <tr>
                  <td>3차 위반</td>
                  <td>인사(소) 위원회 회부<br><strong class="indigo--text">(공장장/실장)</strong></td>
                  <td>[직원] 영구 출입 금지<br>[회사] 업체 대표 면담 <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SHE 평가 반영</td>
                </tr>
                <tr>
                  <td>기타</td>
                  <td colspan='2' class="text-left">
                    <strong class="indigo--text d-flex mb-4">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>SGR 위반으로 사고 발생 시 즉시 제재</div>
                    </strong>
                    <strong class="indigo--text d-flex">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>
                        누적 기한 : 발생일로부터 2년 혹은 1년간 유효하다.<br>
                        (SGR : <strong class="red--text text--lighten-1">2</strong>년, 일반안전 수칙 : <strong class="red--text text--lighten-1">1</strong>년)
                      </div>
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 기타 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>사소하더라도 아래 사항은 즉시 SK트리켐㈜ 직원에게 알려주세요.</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">방문 중 발생한 <span class="red--text text--lighten-1">상해, 화학물질 흡입 및 접촉사고</span> 발생 또는 목격 시</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2"><span class="red--text text--lighten-1">화재, 폭발 및 화학물질 누출 </span>목격 시</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2"><span class="red--text text--lighten-1">시설물의 손상, 운반수단의 사고, 이상한 냄새, 소음 발생 </span>시</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>작업장 통행 시 <span class="red--text text--lighten-1">지정된 통로</span>를 이용하여 통행(우측통행 원칙)</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>허가 또는 승인이 필요한 장소에 임의로 출입 금지</div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                  <div>계단 사용 시, 난간 사용</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">1. 안전수칙 목록 및 Penalty</strong><br>
            </v-card-text>

            <table class="type12 text-center">
              <thead>
                <tr>
                  <th rowspan="3">구 분</th>
                  <th rowspan="3">세부내용</th> 
                  <th colspan="2">벌점</th>
                </tr>
                <tr>
                  <!-- <th></th>
                  <th></th> -->
                  <th colspan="2">SKMG14/협력회사</th>
                </tr>
                <tr>
                  <th>팀/회사</th>
                  <th>구성원/직원</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="5">1. 작업허가</td>
                  <td>작업허가서 현장 미비치(타 지역 비치, 개인 휴대 포함)<br></td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>작업허가서에 협력회사 관계자 및 교육자 서명 누락<br>(구성원 포함, 1명당 2점)</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>작업 허가서 상 필요서류 미첨부</td>
                  <td>4</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>작업 허가서 내 각 작업별 조치사항 미준수</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td >작업 허가서 내용 임의 수정(보호구, 작업방법, 도구 변경 등)</td>
                  <td>7</td>
                  <td>6</td>
                </tr>

                <tr>
                  <td rowspan="3">2. 안전보호구</td>
                  <td>필수 보호구 미착용<br></td>
                  <td>5</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>작업복장 부적합(반바지, 반팔, 토시, 냉장고 바지 등)</td>
                  <td>3</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>방독면 필터 유효기간 초과 및 사용 날짜 미기입(방독면 미휴대 포함)</td>
                  <td>4</td>
                  <td>3</td>
                </tr>

                <tr>
                  <td rowspan="2">3. 작업용 공도구 관리</td>
                  <td >사용도구의 방호장치 해제 상태로 사용(임의 개조 포함)<br></td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>부적합 공도구 사용 시(미인증 제품/ 미 점검 공도구 사용 등)</td>
                  <td>7</td>
                  <td>6</td>
                </tr>

                <tr>
                  <td rowspan="3">4. 가스(고압) 용기 관리</td>
                  <td>산소/ LPG 절단기 역화방지기 미부착<br></td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>고압용기 Regulator 파손/ 관리 불량(압력계 포함)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>고압용기 전도예방조치 및 보관 용기 마감 캡 미설치</td>
                  <td>3</td>
                  <td>4</td>
                </tr>

                <tr>
                  <td  rowspan="7">5. 화기 작업 안전 기준</td>
                  <td>화기작업구역 내 불티 차단/ 비산 방지 조치 미 부서시<br></td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
                  
                  <td >화재 감시자 휴대물품 미휴대(확성기, 방염마스크, 휴대용 렌턴)<br>회사에서 미지급</td>
                  <td>4</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>화재 감시자 휴대물품 미휴대(확성기, 방염마스크, 휴대용 렌턴)<br>개인 미소지</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>화기 작업구역 내 인화성/가연성 물질 방치 상태로 작업 시</td>
                  <td>5</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>화기 작업구역에 화재감시자 미 배치</td>
                  <td>4</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>부적격자 화재감지자 배치(화재 감시자 교육 미 이수자)</td>
                  <td>4</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>화기 작업이 수행되는 동일한 장소에서 도장작업 시</td>
                  <td>7</td>
                  <td>6</td>
                </tr>

                <tr>
                  <td rowspan="2">6. 작업장 정리정돈</td>
                  <td>정리정돈 및 청소상태 불량</td>
                  <td>3</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>자재 관리 상태 불량(종류별 구분, 전도/ 낙하 위험)</td>
                  <td>3</td>
                  <td>2</td>
                </tr>

                <tr>
                  <td rowspan="7">7. 장비 관리 및 작업 시 조치</td>
                  <td>작업계획서 및 관련 서류 미제출/ 미승인 상태로 작업<br>(차량등록증, 운전자격, 보험서류, 검사서류 등)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>안전조치 불량<br>(권과방지, 비상정지, 과상승방지, 중량초과, 전도방지조치 등)</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>

                  <td>장비 사용 시 현장 신호수 등 미배치<br>(필요 시 통신장비 사용)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>

                  <td>장비 사용 시 등 위험작업 경계구역 미구분<br>(통제 구역 내 임의 출입)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>

                  <td>토양오염 방지 대책 미부서시<br>(누유 방지대책 미부서시)</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
      
                  <td>부적격 인양공도구 사용</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
                
                  <td>중장비 사용시 무자격자 활용</td>
                  <td>10</td>
                  <td>9</td>
                </tr>

                <tr>
                  <td rowspan="5">8. 시설물 파손 및 사고조사</td>
                  <td>시설물 파손 시(사고조사위원회 결과와 별도로 1건 당)<br></td>
                  <td>10</td>
                  <td>0</td>
                </tr>
                <tr>
    
                  <td>사고현장 주변 교통 방해 또는 긴급차량 이동 방해</td>
                  <td>10</td>
                  <td>0</td>
                </tr>
                <tr>
            
                  <td>사고조사 비협조(허위진술 등)</td>
                  <td>10</td>
                  <td>0</td>
                </tr>
                <tr>
                
                  <td>자체 사고조사 미 부서시(기록관리 미부서시 등)</td>
                  <td>10</td>
                  <td>0</td>
                </tr>
                <tr>
          
                  <td>사고발생 후 개선활동 미부서시(개선계획서 미이행)</td>
                  <td>10</td>
                  <td>0</td>
                </tr>

                <tr>
                  <td rowspan="2">9. 소방활동 방해</td>
                  <td>소방시설물 주변 자재 적재/주차(소화전, 방화셔터 등)<br></td>
                  <td>5</td>
                  <td>5</td>
                </tr>
                <tr>
               
                  <td>소방활동을 방해하거나 비협조</td>
                  <td>5</td>
                  <td>5</td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">05. 사고공유 기준 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              아래와 같은 사고 발생시 <strong class="red--text text--lighten-1">즉시 </strong>공유 하여야 함. 
            </v-card-text>


            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>공정 및 환경 사고</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">화재 및 폭발 사고 / 설비 파손 사고 / 환경 누출 사고</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">작업 중 자재, 공구 등을 떨어뜨려 공정설비(기계, 배관, 계측기 등)에 영향을 준 경우</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">수질/대기 오염물질의 유출, 유해화학물질의 토양 또는 하천으로의 유입 등이 발생한 경우</div>
                  </div>
                  <div class="d-flex ml-5">
                    <div class="ml-8">ex : 오일이 토양으로 유출된 경우, 작업 도중 실수로 설비가 파손된 경우</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>안전사고(상해사고)</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">병원에 가지 않고 자체적으로 치료가 가능한 상해사고</div>
                  </div>
                  <div class="d-flex ml-5">
                    <div class="ml-8">ex : 오일이 토양으로 유출된 경우, 작업 도중 실수로 설비가 파손된 경우</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">병원에서의 의료 처치</div>
                  </div>
                  <div class="d-flex ml-5">
                    <div class="ml-8">ex : 주사를 맞거나 처방전을 받은 경우/입원 또는 자택 등에서 요양 하는 경우, 사망사고 등 대외적으로 물의를 일으키거나 회사경영에 손실을 입힌 사고</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

           
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              SGRs (Safety Golden Rules)<br>
              : SK머티리얼즈제이엔씨의 사고예방을 위한 필수안전수칙 8대 사항입니다. 하기 SGR 위반시 제재조치가 동반되므로 상시 준수하여 주시기 바랍니다.
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="iron_center_contents" ><img src="../assets/SKTC_SGR.png" style="height:50%; width: 50%;"/></div>
            </v-card-text>
          </v-card>
          <div style="text-align:right; margin-right:10%;" >
            <strong class="indigo--text">제출서류 : SGRs 준수 서약서</strong>
          </div>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 흡연 및 화재 예방 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider>
            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><span class="red--text text--lighten-1">보행 중</span> 흡연 <span class="red--text text--lighten-1">금지</span>되어 있습니다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>담배는 <span class="red--text text--lighten-1">지정된</span> 흡연 장소에서만 피운다.</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>담배꽁초를 <span class="red--text text--lighten-1">아무 데나</span> 버리는 행동을 하지 않는다.</div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>담뱃불은 손가락으로 <span class="red--text text--lighten-1">튕기지</span> 않는다.</div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>불이 <strong class="red--text text--lighten-1">덜 꺼진</strong> 담배꽁초를 쓰레기통에 버리지 않는다.</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <div class="iron_center_contents "><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"/></div>    
              </v-col>
            </v-row>
            <v-divider class="ma-3"></v-divider>
            <v-card-text>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div st>흡연 적발자는 <strong class="red--text text--lighten-1">관계사 통보</strong> 및 사전 경고 없이 <strong class="red--text text--lighten-1">퇴출, 각서징구</strong> 등 불이익 처리가 따릅니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div>담뱃불(약 500˚C) 특성상 <strong class="red--text text--lighten-1">실효습도 50% 이하</strong>에는 대기 중에서 <strong class="red--text text--lighten-1">인화</strong>하기 쉽습니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div>화재 및 사고 발생 시 SHE팀으로 연락주시기 바랍니다.</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        


        <v-stepper-content step="8" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 특징 및 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">공정의 특징</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">안전 보호구 반드시 착용</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>공정 내 화학물질 누출시 화재위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">비상 대피로 파악</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>배관 / 설비에 의한 충돌 및 전도 위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">보행 시 전방 주시</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">사물을 멀리 보고 심호흡</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">상시 안전에 유의</span></div>
                </div>
              </div>
              <!-- <strong class="text-h6">1. 화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">안전 보호구 반드시 착용</strong><br>
              <strong class="text-h6">2. 공정 내 취급 가스 누출 시 화재위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">비상 대피로 파악</strong><br>
              <strong class="text-h6">3. 배관 / 설비에 의한 충돌 및 전도 위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">보행 시 전방 주시</strong><br>
              <strong class="text-h6">4. 내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">사물을 멀리 보고 심호흡</strong><br>
              <strong class="text-h6">5. 다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">상시 안전에 유의</strong> -->
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">공정 내 안전 수칙</strong><br>
              <!-- text_first_font -->
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>당사 관리감독자의 지시에 따를 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>업무와 연관이 없는 각종 설비, 장비의 임의 조작을 금지할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>"출입 금지", "통제구역"은 출입하지 않는다.</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>Eye & Body Shower 위치를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비상 대피로 및 비상 전화번호를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="d-flex mb-2">
                  *&nbsp;
                  <div>비상전화 : 044-902-0253</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 특징 및 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">공정의 특징</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">안전 보호구 반드시 착용</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>공정 내 화학물질 누출시 화재위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">비상 대피로 파악</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>배관 / 설비에 의한 충돌 및 전도 위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">보행 시 전방 주시</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">사물을 멀리 보고 심호흡</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">상시 안전에 유의</span></div>
                </div>
              </div>
              <!-- <strong class="text-h6">1. 화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">안전 보호구 반드시 착용</strong><br>
              <strong class="text-h6">2. 공정 내 취급 가스 누출 시 화재위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">비상 대피로 파악</strong><br>
              <strong class="text-h6">3. 배관 / 설비에 의한 충돌 및 전도 위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">보행 시 전방 주시</strong><br>
              <strong class="text-h6">4. 내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">사물을 멀리 보고 심호흡</strong><br>
              <strong class="text-h6">5. 다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">상시 안전에 유의</strong> -->
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">공정 내 안전 수칙</strong><br>
              <!-- text_first_font -->
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>당사 관리감독자의 지시에 따를 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>업무와 연관이 없는 각종 설비, 장비의 임의 조작을 금지할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>"출입 금지", "통제구역"은 출입하지 않는다.</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>Eye & Body Shower 위치를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비상 대피로 및 비상 전화번호를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="d-flex mb-2">
                  *&nbsp;
                  <div>비상전화 : 044-902-0253</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <table class="type12 text-center">
              <thead>
                <tr>
                  <th rowspan="3">구 분</th>
                  <th rowspan="3">세부내용</th>
                  <th colspan="2">벌점</th>
                </tr>
                <tr>
                  <!-- <th></th>
                  <th></th> -->
                  <th colspan="2">SKMG14/협력회사</th>
                </tr>
                <tr>
                  <th>팀/회사</th>
                  <th>구성원/직원</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="6" >10. 전기 시설 사용 및 관리</td>
                  <td>전기사용설비 접지 미실시(용접기, 발전기 등등)<br></td>
                  <td>4</td>
                  <td>3</td>
                </tr>
                <tr>
              
                  <td>리드선 피복 상태/ 콘센트 상태 불량(무접지 콘센트, 케이블 등등)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
             
                  <td>미승인 상태로 전기 Panel 임의 연결 사용하여 작업</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
            
                  <td>휴식/ 미사용 시 전원 분리 미흡(전기를 이용한 공도구)</td>
                  <td>3</td>
                  <td>4</td>
                </tr>
                <tr>
              
                  <td>방폭지역 내 방폭 장비 미사용</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
     
                  <td>전기분전반 관리상태 불량(잠금장치, 연락처)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>

                <tr>
                  <td rowspan="2" >11. 굴착 작업 관리</td>
                  <td>굴착 전 지장물 조사 미실시(관계기관 통보 포함)<br></td>
                  <td>10</td>
                  <td>-</td>
                </tr>
                <tr>
  
                  <td>굴착지점 안전조치 미실시(Fence, 추락방지조치, 안내판 등)</td>
                  <td>10</td>
                  <td>-</td>
                </tr>

                <tr>
                  <td rowspan="6" >12. 차량운행 및 주차관리<br>(자전거/ 중장비 포함)</td>
                  <td>지정 주차장 외 주차<br>(보행자 통로, 공정 출입구, 소화전 주변 주차 포함)</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
           
                  <td>차량 주차 시 고임목 미설치(1개소 이상)</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
          
                  <td>자전거/ 오토바이에 2인 이상 탑승하여 운행(차량 정원 초과 포함)</td>
                  <td>1</td>
                  <td>2</td>
                </tr>
                <tr>
             
                  <td>작업 차량 표시 불량(차량 4면 표기)</td>
                  <td>2</td>
                  <td>1</td>
                </tr>
                <tr>
       
                  <td>차량 정차 후 이탈 시 열쇠 미분리(지게차 포함)</td>
                  <td>3</td>
                  <td>4</td>
                </tr>
                <tr>
             
                  <td>고압용기 이동 시 적재 상태 불량(고정상태 불량, 눕힌 상태로 이동)</td>
                  <td>3</td>
                  <td>4</td>
                </tr>

                <tr>
                  <td rowspan="5" >13. 음주/ 도박/ 폭행</td>
                  <td>작업 중 음주행위를 한 자(숙취 상태 포함)<br></td>
                  <td>20</td>
                  <td>30</td>
                </tr>
                <tr>
          
                  <td>사내에서 도박행위를 한 자</td>
                  <td>20</td>
                  <td>30</td>
                </tr>
                <tr>
             
                  <td>사내에서 폭행/ 폭언 등의 폭력행위를 한 자(쌍방 적용)</td>
                  <td>20</td>
                  <td>30</td>
                </tr>
                <tr>
      
                  <td>법규 및 절차 등에 대한 지시 불이행</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
   
                  <td>현장 위험요인에 대한 개선 지시 불이행</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                

                <tr>
                  <td rowspan="2" >14. 관리감독자, 안전관리자의 지시 불이행</td>
                  <td>법규 및 절차 등에 대한 지시 불이행</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
           
                  <td>현장 위험요인에 대한 개선 지시 불이행</td>
                  <td>7</td>
                  <td>6</td>
                </tr>

                <tr>
                  <td rowspan="6" >15. 불안전한 행동 및 위험구역 무단출입</td>
                  <td>인적, 물적사고로 이어질 수 있는 불안전한 행동</td>
                  <td>5</td>
                  <td>6</td>
                </tr>
                <tr>

                  <td>출입 통제구역 무단출입(비계시설, 인양작업 등)</td>
                  <td>5</td>
                  <td>6</td>
                </tr>
                <tr>
        
                  <td>공정 출입 통제 시스템 미 인가 상태의 출입한 자</td>
                  <td>5</td>
                  <td>6</td>
                </tr>
                <tr>
   
                  <td>현장에 부착/ 설치된 안전표지를 훼손한 자</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
           
                  <td>상/하 병행 작업 실시</td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
    
                  <td>사업장 내 보행 중 스마트폰, 테블릿 등 전자기기 사용으로 인한 주시태만 및 넘어짐, 부딪힘 위험이 있는 자</td>
                  <td>5</td>
                  <td>6</td>
                </tr>
                
                <tr>
                  <td rowspan="2" >16. 안전교육</td>
                  <td>필수 교육 미 이수자 작업 투입(특별교육 포함)<br></td>
                  <td>7</td>
                  <td>6</td>
                </tr>
                <tr>
              
                  <td>교육 필증 미부착 및 기간 초과한 자</td>
                  <td>5</td>
                  <td>4</td>
                </tr>

                <tr>
                  <td rowspan="3" >17. 안전시설 임의 해체</td>
                  <td>허가 없이 안전시설 임의해체/ 변경</td>
                  <td>8</td>
                  <td>9</td>
                </tr>
                <tr>
                
                  <td>인적, 물적사고로 이어질 수 있는 불안전한 상태 방치</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
             
                  <td>위험장소 작업 시 안전시설 설치 불이행</td>
                  <td>7</td>
                  <td>6</td>
                </tr>

                <tr>
                  <td rowspan="4" >18. 유해 위험물 관리</td>
                  <td>MSDS 미 게시/ 부착(소분용기 경고표지 포함)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
        
                  <td>위험물 구획 및 보관 관리 상태 미흡</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
           
                  <td>위험물(가스, 유류) 보관소 관리 기준 미준수</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
                <tr>
        
                  <td>현장 내 유해 위험물 방치(유류, 신너, 페인트, 락커 등)</td>
                  <td>5</td>
                  <td>4</td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">05. 사고공유 기준 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">1</strong><br>사고발생</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>최초 목격자</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black yellow--text"><strong class="text-h4 font-weight-black">3</strong><br>SK에어플러스(조정실)</div>
              </div>
            </v-card-text>
            <strong class="deep-orange--text font-weight-black ml-6">사고 등 비상상황 발생 시 즉시 SK에어플러스로 사고 공유</strong>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">SGR (Safety Golden Rules) 상세 내용</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th>S.G.R 항목</th>
                  <th>세부 지침</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>화학물질 취급/작업 時 지정된 보호구 착용</td>
                  <td>
                    - 화학물질 취급 작업시 ①작업허가서/②구두지시/③작업지도서(또는 SOP 등)/➃위험성평가 등에 따라 보호구를 착용하여야 한다. 보호구 내용이 중첩될 경우 상기 순서에 따라 우선순위를 정한다.<br>
                    - 공정 출입 시 안전모/보안경/안전화 착용 필수, 연구실/분석실 출입 시 보안경/안전화를 착용한다 (도로제외)
                  </td>
                </tr>
                <tr>
                  <td class="blue--text">밀폐작업 時 산소/유해가스 농도 측정</td>
                  <td class="blue--text">
                    - 밀폐작업 時 반드시 산소 및 유해가스의 농도를 작업허가 절차에 따라 주기적으로 측정해야 한다.<br>
                    - 내부에 화학물질을 보관했던 경우 작업 전 반드시 환기를 시켜야 하고 내부 진입 전에는 산소 및 유해 가스 농도를 측정하고 기록 및 서명해야 한다.<br>
                    - 가스 저장시설과 연결되어 있는 배관 등은 작업 전 Valve 차단 확인, 맹판(Blind) 설치, 단관 분리 등의 조치를 통해 가스와의 접촉 가능성을 차단한 이후 작업하여야 한다.                    <br>
                    - 허가서에 기재된 비상대기자는 반드시 상주하여야 한다.<br>
                  </td>
                </tr>
                <tr>
                  <td>사고보고 기준 준수</td>
                  <td>- 사고관리 절차에 따라 사고<strong>발생</strong> 즉시 보고한다.(사고 은폐가 발생한 경우 1년 내 인지한 시점으로 적용한다.)</td>
                  
                </tr>
                <tr>
                  <td>작업 時 작업 허가서 승인 후 작업</td>
                  <td>
                    - 안전작업허가 절차에 따라 작업허가서 발행 승인을 받고 작업을 실시하여야 한다.<br>
                    - 최종 승인권자의 승인 없이 작업을 금지한다.<br>
                    <span class="blue--text">- 승인된 작업허가 시간 이전/이후에 작업을 금지한다.</span><br>
                    - 작업 전 위험성 평가를 반드시 실시하여야 한다.<br>
                    - 화기 작업의 경우 인화성 가스 농도를 측정해야 한다.<br>
                    - 유해화학물질이 있는 배관은 Drain / Purge 여부를 확인해야 한다.<br>
                  </td>
                </tr>
                <tr>
                  <td>고소 작업 時 추락 예방 조치 후 작업</td>
                  <td>
                    - 2m이상 고소작업 시 안전벨트 착용 및 체결해야 한다.<br>
                    <span  class="blue--text">- 이동 시에는 반드시 1줄 이상이 걸이대에 걸려 있어야 한다.</span><br>
                    - 승인된 작업허가 시간 이전/이후에 작업을 금지한다.<br>
                    - 비계설치 후 작업 시에는 비계 승인 후 작업해야 한다.<br>
                    - 비계 작업대 위에 사다리, 발판 등을 설치 후 작업할 수 없다.<br>
                    - 안전난간대를 밟고 올라서서 작업할 수 없다.<br>
                  </td>
                </tr>
                <tr>
                  <td>변경관리 절차 준수</td>
                  <td>
                    - 변경사항 발생시 기술검토 또는 위험성평가를 실시한 후 변경승인 후 작업을 실시해야 한다.<br>
                    - 가동 전 점검을 반드시 실시하고 승인 후에 가동한다.(비상변경의 경우에는 절차를 따른다.)<br>
                  </td>
                </tr>
                <tr>
                  <td>위험작업 시 2인1조 작업</td>
                  <td>
                    - 작업 절차서에 명시된 공정위험작업, 공정 계의 Open, 화학물질 노출 우려, 작업허가 대상작업, 그 외 관리감독자가 2인1조 작업을 지시한 작업은 2인1조 작업을 실시 한다.<br>
                  </td>
                </tr>
                <tr>
                  <td>안전장치 임의 해제 금지</td>
                  <td>
                    - <span  class="blue--text">Interlock 및 시건장치(자물쇠), LOTO, 방호커버, 접지, 충돌방지장치, 압력조절장치 등의</span> 안전장치를 관리감독자 승인 없이 해제 금지 (창고 출입 제외)
                    * Interlock 해제는 팀장 승인 필요<br>
                  </td>
                </tr>
              </tbody>
            </table>


            <!-- <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">3. 안전수칙 협력회사 Penalty</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="col">구 분</th>
                  <th scope="col">제 재</th>
                  <th scope="col">비 고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>매 위반 시</td>
                  <td>자체교육</td>
                  <td rowspan="4">윤리 규정 위반 시 개인 및 현장 소장<br>"영구출입금지"</td>
                </tr>
                <tr>
                  <td>10점 초과 시</td>
                  <td>1개월 출입금지</td>

                </tr>
                <tr>
                  <td>20점 초과 시</td>
                  <td>6개월 출입금지</td>

                </tr>
                <tr>
                  <td>30점 초과 시</td>
                  <td>영구출입금지</td>
                </tr>
              </tbody>
            </table>
            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                <v-spacer></v-spacer>
                ※당해 년도 內 누적(연도 변경 시 Reset)
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              ※당해 년도 內 누적(연도 변경 시 Reset)
            </div> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - Penalty</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>Safety Golden Rules(SGR)을 기본으로, 즉시 Penalty 적용<br></strong>
              <strong class="red--text text--lighten-1">작업자 위반사항 발생 시 경고 없이 즉시 적용 : 개인 출입 정지 및 업체 평가 반영</strong><br>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                SGR위반 Penalty세부기준
                <v-spacer></v-spacer>
                <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              SGR위반 Penalty세부기준<br>
              <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
            </div>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">구성원</th>
                  <th scope="cols">협력업체 직원</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차 위반</td>
                  <td>경고</td>
                  <td>작업중지 1일<br>(해당 작업자 출입금지 1개월)</td>
                </tr>
                <tr>
                  <td>2차 위반</td>
                  <td>견책</td>
                  <td>작업중지 3일 + 입찰제한 6개월<br>(해당 작업자 출입금지 6개월)</td>
                </tr>
                <tr>
                  <td>3차 위반</td>
                  <td>감봉</td>
                  <td>입찰 불가<br>(해당 작업자 영구 출입금지)</td>
                </tr>
                <tr>
                  <td>기타</td>
                  <td colspan='2' class="text-left">
                    <strong class="indigo--text d-flex mb-4">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>관리책임자의 의무를 이행하지 않아 위반이 발생한 경우 부서장/임원 등 관리책임자도 위반자에 준하는 징계</div>
                    </strong>
                    <!-- <strong class="indigo--text d-flex mb-4">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>SGR 위반으로 사고 발생 시 즉시 제재</div>
                    </strong>
                    <strong class="indigo--text d-flex">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>
                        누적 기한 : 발생일로부터 2년 혹은 1년간 유효하다.<br>
                        (SGR : <strong class="red--text text--lighten-1">2</strong>년, 일반안전 수칙 : <strong class="red--text text--lighten-1">1</strong>년)
                      </div>
                    </strong> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex">
              작업재개를 위해서는 위반업체의 전 구성원 대상으로 4시간 이상의 안전교육을 실시하고 재발방지대책을 수립하여<br> SHE경영주관부서장 및 사업장의 안전보건(총괄)책임자 승인 필요함. (안전교육 및 재발방지대책의 승인 없이는 작업재개 불가능)
            </div>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="9" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="9">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질(Gas/Chemical)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">Gas, Chemical 누출을 조기 감지하고자</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 독성 / 가연성 Gas, Chemical의 경우 공정 내 가스검지기 설치 운용 중</p>
              <p class="ml-4 text_first_font"> 모든 감지기는 모니터링되고 있으며, 감지기 동작 시 즉시 현장 확인 조치</p>
              <p class="ml-4 text_first_font"> 작업자가 직접 누출을 목격하거나, 냄새 발생으로 인지할 시 반드시 신고하여야 함</p>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_01.jpg" style="height:200px; border-radius: 10px;"/></div>보거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_02.jpg" style="height:200px; border-radius: 10px;"/></div>냄새 맡거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_03.jpg" style="height:200px; border-radius: 10px;"/></div>감지기가 작동하거나
              </div>

            </div>
            <div v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="iron_center_contents ml-4 text_first_font" style="width:inherit; height:250px;">
              <img src="../assets/SKTC_E.svg" style="height:300px"/>
            </div>
            <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
              <img src="../assets/SKMG14.svg" style="height:300px"/>
            </div>
            <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
              <img src="../assets/SKMP.svg" style="height:300px"/>
            </div>
            <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
              <img src="../assets/SKMJ.svg" style="height:300px"/>
            </div>
            <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - MSDS 이해 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">물질안전보건자료(MSDS) 란?</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 물질안전보건자료(Material Safety Data Sheet) 란 물질에 관한 여러가지 정보를 담은 자료이다.</p>
              <p class="ml-4 text_first_font"> 물질에 관한 정보는 그 물질의 이름, 성분, 유해성, 위험성, 보관방법, 다룰 때 주의할 점, 필요한 보호구, 몸에 묻거나 먹었을 때 등의 응급조치 등 여러가지 정보가 포함된다.</p>
              <v-divider class="mb-2"></v-divider>
              <strong class="deep-orange--text">물질안전보건자료 게시 및 비치</strong><br>
              <p class="ml-4 mt-2 text_first_font">
                게시, 비치 방법 : 취급 근로자가 쉽게 보거나 접근할 수 있는 장소에 각 화학물질 별로 물질안전보건자료를 항상 게시 하거나 갖추어 둠,
                
              </p>
              <p class="ml-4 mt-2 text_first_font"><span style="margin-left: 127px;">취급 작업자가 물질안전보건자료를 쉽게 확인할 수 있는 전산장비를 갖추어야 함.</span></p>
              <p class="ml-4 text_first_font"> 게시 장소: 대상화학물질 취급작업 공정 내, 안전사고 또는 직업병 발생 우려가 있는 장소, 사업장 내 근로자가 가장 보기 쉬운 장소 등</p>
            </v-card-text>

          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">2. 안전수칙 구성원 Penalty</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th rowspan="2">구 분</th>
                  <th rowspan="2">기 준</th>
                  <th colspan="2">SK머티리얼즈G14(주) 구성원</th>
                </tr>
                <tr>
                  <th >해당부서</th> 
                  <th>주관부서</th> 
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11점 이하</td>
                  <td>면담</td>
                  <td>- 위반자에 위반 사부서 통보<br>- 해당 팀장 내용 공유<br>- 팀장: 위반자 면담 실시 후 결과 회신</td>
                  <td>SHE부서<br>SHE부서<br>-</td>
                </tr>
                <tr>
                  <td>12점~20점 이하</td>
                  <td>교육</td>
                  <td>- 위반자 경고, 해당 팀장 통보<br>- 팀장 주관 자체 안전교육(0.5HR) <br>*교육결과 회신</td>
                  <td>SHE부서<br>해당 팀<br><br></td>
                </tr>
                <tr>
                  <td>21점~35점 이하</td>
                  <td>참여</td>
                  <td>- 위반자 경고, 해당 팀장/ 임원 통보<br>- 위반자: 안전교육(1HR) 참여<br>- 위반자: 해당 팀 주관 안전수칙, 단속활동 2회, 결과를 팀 내 공유</td>
                  <td>SHE부서<br>해당 팀<br>해당 팀</td>
                </tr>
                <tr>
                  <td style="background-color: #FAFAD2;">36점~50점 이하</td>
                  <td style="background-color: #FAFAD2;">징계</td>
                  <td style="background-color: #FAFAD2;">- 인사위원회 회부<br>- 해당 팀장: 개선 계획 발표</td>
                  <td style="background-color: #FAFAD2;">SHE부서</td>
                </tr>
                <tr>
                  <td>10건(or 50점)</td>
                  <td>참여</td>
                  <td>- 팀: 자체 전 구성원 안전교육 실시(1hr)<br>*임원에게 보고<br>- 팀장: 안전수칙 위반 개선 계획 수립 발표(임원&SHE)</td>
                  <td>해당 팀<br><br>해당 팀</td>
                </tr>
              </tbody>
            </table>
            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                <v-spacer></v-spacer>
                ※당해 년도 內 누적(연도 변경 시 Reset)
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              ※당해 년도 內 누적(연도 변경 시 Reset)
            </div>


            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">3. 안전수칙 협력회사 Penalty</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="col">구 분</th>
                  <th scope="col">제 재</th>
                  <th scope="col">비 고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>매 위반 시</td>
                  <td>자체교육</td>
                  <td rowspan="4">윤리 규정 위반 시 개인 및 현장 소장<br>"영구출입금지"</td>
                </tr>
                <tr>
                  <td>10점 초과 시</td>
                  <td>1개월 출입금지</td>

                </tr>
                <tr>
                  <td>20점 초과 시</td>
                  <td>6개월 출입금지</td>

                </tr>
                <tr>
                  <td>30점 초과 시</td>
                  <td>영구출입금지</td>
                </tr>
              </tbody>
            </table>
            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                <v-spacer></v-spacer>
                ※당해 년도 內 누적(연도 변경 시 Reset)
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              ※당해 년도 內 누적(연도 변경 시 Reset)
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">06. 차량 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              SK에어플러스 內 차량 운행 시에는 <strong class="red--text text--lighten-1">5대 중요사항</strong>을 실천하여 차량 안전사고를 예방합니다. 
            </v-card-text>

            <v-row class="mt-2 ml-4 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>규정 속도 준수</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_speedlimit.jpg" style="height:150px; border-radius: 10px;"/></div>사내 규정속도 10km/h 준수<br>(건설기계,운송차량 10km)
                    </div> 
                  </div>
                </v-card>
              </v-col>


              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>휴대폰 사용금지</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_noCellphone.png" style="height:150px; border-radius: 10px;"/></div>운전 중 스마트폰 사용 금지
                    </div>
                  </div>
                </v-card>
              </v-col>



              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>주∙정차 위반금지</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_noCar.png" style="height:150px; border-radius: 10px;"/></div>주∙정차 구역 외 주차금지

                    </div>
                  </div>
                </v-card>
              </v-col>



              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>고임목 설치</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_rubber.png" style="height:150px; border-radius: 10px;"/></div>주∙정차 시 고임목 설치
                    </div> 
                  </div>
                </v-card>
              </v-col>



              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>방향 지시등 점등</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_light.png" style="height:150px; border-radius: 10px;"/></div>사내 이동 중 방향 지시등 점등
                    </div>
                  </div>
                </v-card>
              </v-col>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 mt-12 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/SKMA_car.png" style="height:150px; border-radius: 10px;"/></div>
                </div>
              </div> 
            </v-row>

          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">위반시 제재조치</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="col">양정기준</th>
                  <th scope="col">협력사 법인</th>
                  <th scope="col">협력사 구성원, 작업자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차</td>
                  <td>작업중지* 1일</td>
                  <td>출입금지 1개월</td>
                </tr>
                <tr>
                  <td>2차</td>
                  <td>작업중지* 3일 + 입찰제한 6개월</td>
                  <td>출입금지 6개월</td>
                </tr>
                <tr>
                  <td>3차</td>
                  <td>등록 취소 *</td>
                  <td>영구 출입금지</td>
                </tr>
              </tbody>
            </table>
              <v-row class="ma-0 mb-2">
                <v-col cols="12" md="12" sd="12">
                  <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>작업중지 범위</div>
                </v-col>
                <div class="ml-9" style="text-align: start; line-height: 2;">
                  1) 1차 위반 시<br>
                  - 위반 당일 : ‘위반이 확인된 작업허가서 대상 작업’에 한하여 중지<br>
                  - 위반 익일 : 위반 업체 전구성원 대상 안전교육 4시간 이상 실 시 후, 작업 재개(익일이 휴일인 경우에는 휴일의 다음 날 적용)<br>
                  2) 2차 위반 시<br>
                  - 위반일부터 D+2일 까지 : 위반이 확인된 작업허가서 대상 작업에 한하여 중지<br>
                  - 위반일부터 D+3일 이후 : 위반업체 전구성원 대상 안전교육 4시간 이상 실시 후, 작업 재개(익일이 휴일인 경우에는 휴일의 다음 날 적용)<br>
                  3)작업 재개를 위해서는 위반업체의 전 구성원 대상으로 4시간 이상의 안전교육을 실시하고
                  재발 방지 대책을 수립하여 SHE 조직의 장 및 사업장의 안전보건(총괄)책임자 승인 필요(안전교육 및 재발방지대책의 승인 없이는 작업재개 불가능)<br>
                  4)단, 중지대상 작업 중 긴급히 시행이 필요하고 판단되어 최상위 임원의 결재를 득하고 안전보건(총괄)책임자에게 보고한 작업은 당일 작업 재개 가능
                  *등록취소 - 대체불가 협력사인 경우 대표이사 승인下, 등록취소 유예 가능
                </div>
              </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 특징 및 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">공정의 특징</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">안전 보호구 반드시 착용</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>공정 내 화학물질 누출시 화재위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">비상 대피로 파악</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>배관 / 설비에 의한 충돌 및 전도 위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">보행 시 전방 주시</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">사물을 멀리 보고 심호흡</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">상시 안전에 유의</span></div>
                </div>
              </div>
              <!-- <strong class="text-h6">1. 화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">안전 보호구 반드시 착용</strong><br>
              <strong class="text-h6">2. 공정 내 취급 가스 누출 시 화재위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">비상 대피로 파악</strong><br>
              <strong class="text-h6">3. 배관 / 설비에 의한 충돌 및 전도 위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">보행 시 전방 주시</strong><br>
              <strong class="text-h6">4. 내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">사물을 멀리 보고 심호흡</strong><br>
              <strong class="text-h6">5. 다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">상시 안전에 유의</strong> -->
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">공정 내 안전 수칙</strong><br>
              <!-- text_first_font -->
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>당사 관리감독자의 지시에 따를 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>업무와 연관이 없는 각종 설비, 장비의 임의 조작을 금지할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>"출입 금지", "통제구역"은 출입하지 않는다.</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>Eye & Body Shower 위치를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비상 대피로 및 비상 전화번호를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="d-flex mb-2">
                  *&nbsp;
                  <div>비상전화 : 044-902-0253</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - HF(불화수소)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">HF (불화수소)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">자료 없음</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">자료 없음</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">0.997</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">19.5℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">HF</td>
                      <td class="table_line_right">Hydrogen Fluoride</td>
                      <td class="table_line_right">7664-39-3</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 0.5 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_1.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                          <img src="../assets/graph_1.svg" style="height:120px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">물과 접촉을 피할 것</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>피부에&nbsp;<span class="red--text text--lighten-1">심한 화상</span>을 일으킴.</div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 심한 손상을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입하면 치명적임
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부, 눈, 점막, 폐 등에 손상을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>약한 상처는 바로 나타나지 않지만 수 시간 후에 통증이 생길 수 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="9">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질(Gas/Chemical)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">Gas, Chemical 누출을 조기 감지하고자</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 독성 / 가연성 Gas, Chemical의 경우 공정 내 가스검지기 설치 운용 중</p>
              <p class="ml-4 text_first_font"> 모든 감지기는 모니터링되고 있으며, 감지기 동작 시 즉시 현장 확인 조치</p>
              <p class="ml-4 text_first_font"> 작업자가 직접 누출을 목격하거나, 냄새 발생으로 인지할 시 반드시 신고하여야 함</p>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_01.jpg" style="height:200px; border-radius: 10px;"/></div>보거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_02.jpg" style="height:200px; border-radius: 10px;"/></div>냄새 맡거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_03.jpg" style="height:200px; border-radius: 10px;"/></div>감지기가 작동하거나
              </div>

            </div>
            <div class="iron_center_contents ml-4 mt-5 text_first_font">
              <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKTC_E.svg" style="height:300px"/>
              </div>
              <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKMG14.svg" style="height:300px"/>
              </div>
              <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKMP.svg" style="height:300px"/>
              </div>
              <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKMJ.svg" style="height:300px"/>
              </div>
            </div>
            <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 특징 및 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">공정의 특징</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">안전 보호구 반드시 착용</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>공정 내 화학물질 누출시 화재위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">비상 대피로 파악</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>배관 / 설비에 의한 충돌 및 전도 위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">보행 시 전방 주시</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">사물을 멀리 보고 심호흡</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">상시 안전에 유의</span></div>
                </div>
              </div>
              <!-- <strong class="text-h6">1. 화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">안전 보호구 반드시 착용</strong><br>
              <strong class="text-h6">2. 공정 내 취급 가스 누출 시 화재위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">비상 대피로 파악</strong><br>
              <strong class="text-h6">3. 배관 / 설비에 의한 충돌 및 전도 위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">보행 시 전방 주시</strong><br>
              <strong class="text-h6">4. 내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">사물을 멀리 보고 심호흡</strong><br>
              <strong class="text-h6">5. 다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">상시 안전에 유의</strong> -->
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">공정 내 안전 수칙</strong><br>
              <!-- text_first_font -->
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>당사 관리감독자의 지시에 따를 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>업무와 연관이 없는 각종 설비, 장비의 임의 조작을 금지할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>"출입 금지", "통제구역"은 출입하지 않는다.</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>Eye & Body Shower 위치를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비상 대피로 및 비상 전화번호를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  *&nbsp;
                  <div>비상전화 : 054-907-0904</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">07. 흡연 및 화재예방 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              흡연은 지정된 장소에서만 가능합니다. 미 준수 시 <strong class="red--text text--lighten-1">무관용 원칙(One Strike Out)</strong>이 적용됩니다.
            </v-card-text>
            <v-row class="ma-0">
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="mt-2 ml-4 mb-2 text_first_font d-flex justify-center">
                    <v-card>
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong class="deep-orange--text">흡연 및 화재예방 안전수칙</strong><br>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke1.png" style="height:150px; border-radius: 10px;"/>
                          </div>사내 지정된 장소에서만 흡연
                        </div> 
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke2.png" style="height:150px; border-radius: 10px;"/>
                          </div>담배꽁초 무단투기 금지
                        </div> 
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke3.png" style="height:150px; border-radius: 10px;"/>
                          </div>흡연 후 재떨이에 담뱃불 소화
                        </div> 
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke4.png" style="height:150px; border-radius: 10px;"/>
                          </div>담배꽁초 불씨 확인
                        </div> 
                      </div>
                    </v-card>
                  </div>
                </v-card-text>
                
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex justify-space-between align-items-start">
                    <div>
                      <v-card-text class="education_content lineHeight2 pa-0">
                        <strong class="deep-orange--text">사업장 안전수칙 : 교통안전</strong>
                      </v-card-text>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_speedlimit.jpg" style="height:70px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            1. 사내 운송수단 속도제한 준수<br> 
                            <v-icon>mdi-check</v-icon>차량/오토바이/자전거 10km/h, <strong class="red--text text--lighten-1">지게차 10km/h</strong>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_seatbelt.jpg" style="height:70px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            2. 운전자는 반드시 <strong class="red--text text--lighten-1">좌석 안전벨트 착용</strong><br>
                            3. 규정된 탑승인원 준수 및 화물칸 탑승 금지
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_yield.jpg" style="height:50px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            4. 교차로에서는 반드시 서행, 차량/사람의 통행 유무 확인 후 진행<br>
                            5. 주행중인 차량 추월 금지(지게차, 구내운반차 등)
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_gear.jpg" style="height:50px; border-radius: 0px;"/>
                          </div>
                          <div class="ml-2">
                            6. <strong class="red--text text--lighten-1">차량 정지 시, </strong>정지브레이크와 기어 등을 사용하여 <strong class="red--text text--lighten-1">확실히 제동 </strong> 실시<br>
                            7. 주행중인 차량 추월 금지(지게차, 구내운반차 등)
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_name.jpg" style="height:40px; border-radius: 0px;"/>
                          </div>
                          <div class="ml-2">
                            8. 차량 4면에 <strong class="red--text text--lighten-1">업체명 부착</strong>, 전면 유리 안쪽 연락처 표기
                          </div>
                        </div>
                      </div>
                    </div> 
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="9">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질(Gas/Chemical)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">Gas, Chemical 누출을 조기 감지하고자</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 독성 / 가연성 Gas, Chemical의 경우 공정 내 가스검지기 설치 운용 중</p>
              <p class="ml-4 text_first_font"> 모든 감지기는 모니터링되고 있으며, 감지기 동작 시 즉시 현장 확인 조치</p>
              <p class="ml-4 text_first_font"> 작업자가 직접 누출을 목격하거나, 냄새 발생으로 인지할 시 반드시 신고하여야 함</p>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_01.jpg" style="height:200px; border-radius: 10px;"/></div>보거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_02.jpg" style="height:200px; border-radius: 10px;"/></div>냄새 맡거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_03.jpg" style="height:200px; border-radius: 10px;"/></div>감지기가 작동하거나
              </div>

            </div>
            <div v-if="$store.state.CustomInfo.SiteId == 'SKTC'" class="iron_center_contents ml-4 text_first_font" style="width:inherit; height:250px;">
              <img src="../assets/SKTC_E.svg" style="height:300px"/>
            </div>
            <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
              <img src="../assets/SKMG14.svg" style="height:300px"/>
            </div>
            <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
              <img src="../assets/SKMP.svg" style="height:300px"/>
            </div> -->
            <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
              <img src="../assets/SKMJ.svg" style="height:300px"/>
            </div>
            <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
          </v-card>
        </v-stepper-content>

        

        <v-stepper-content step="11" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="11">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - NF3(삼불화질소)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">NF<sub>3</sub> (삼불화질소)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">해당없음</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">해당없음</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">증기밀도 2.5</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">-129 ~ 120℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">NF<sub>3</sub></td>
                      <td class="table_line_right">트리블루오르화 질소</td>
                      <td class="table_line_right">7783-54-2</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 10 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_2.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                          <img src="../assets/graph_2.svg" style="height:120px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">점화원 및 열과의 접촉 금지<br>구리스, 오일과 접촉 금지</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">용기가 전도되지 않도록 조치<br>서늘하고 건조한 장소에 보관</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>허용농도&nbsp;:&nbsp;<span class="blue--text">10 ppm, 30mg/m<span class="superscript">3</span></span></div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>고압가스이며 가열시 폭발할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <div class="d-flex align-start">
                      <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                      <div>산화제(오일, 구리스 등), 가연성 물질과 접촉하면&nbsp;<span class="red--text text--lighten-1">발화되거나 폭발할 수 있음</span></div>
                    </div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입 시 유해할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입 시 현기증이 일어날 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>장기간 또는 반복적으로 노출되면 장기에 손상을 일으킬 수 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질 누출 시 대응 요령</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전 보호구</strong>
              는 필히
              <strong class="red--text text--lighten-1">착용</strong>
              하고
              <strong class="red--text text--lighten-1">작업</strong>
            </v-card-text>
            
            <table class="type09 text-center">
            <!-- <table class="type09 text-center text-subtitle-1 font-weight-medium"> -->
              <thead>
                <tr>
                  <th scope="cols">구분</th>
                  <th scope="cols">Action</th>
                  <th scope="cols">PPE(보호구)</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>신고</td>
                  <td class="text-left">
                  Chemical 누출 사고 발생 시 긴급전화(044-902-0253)로 신고한다.
                    <br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>신고 시 누출명 및 누출 정도, 장소를 정확히 신고</div>
                    </div>
                  </td>
                  <td ></td>
                </tr>
                <tr>
                  <td>약품 접촉 시</td>
                  <td class="text-left">Chemical 누출 접촉 시 즉시 흐르는 물에 15분 이상 씻고, 관리감독자 지시에 따라 의료기관으로 후송</td>
                  <td><strong class="red--text text--lighten-1">비상 샤워기</strong></td>
                </tr>
                <tr>
                  <td>공급원 차단</td>
                  <td class="text-left">누출 공급원을 차단하여 추가적인 누출을 막는다.</td>
                  <td><strong class="red--text text--lighten-1">내산복, 내산장갑, 내산장화 착용<br>전면방독면 착용</strong></td>
                </tr>
                <tr>
                  <td>확산 방지 조치</td>
                  <td class="text-left">누출원 확산 방지에 주력한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>사고지점 출입 통제 및 방호조치</div>
                    </div>
                  </td>
                  <td>흡착 펜스 or 흡착포<br>
                  Fume 발생 시:배풍기 설치</td>
                </tr>
                <tr>
                  <td>누출원 수거</td>
                  <td class="text-left">
                    누출되어진 Chemical을 수거한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>다량 누출 시 (Chemical 수거기 이용)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>소량 누출 시 (흡착포 사용)</div>
                    </div>
                  </td>
                  <td>Chemical 수거기, 흡착포</td>
                </tr>
                <tr>
                  <td>폐기물 처리</td>
                  <td class="text-left">
                    폐 흡착 펜스 및 흡착포 비닐 포장 & 전용 수거 용기 사용 수거<br>
                    <strong class="red--text d-flex">
                      ※&nbsp;
                      <div>폐기물 처리 절차에 의한 폐기실시</div>
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - MSDS 이해 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <strong class="deep-orange--text">물질안전보건자료(MSDS) 란?</strong><br>
                <p class="ml-4 mt-2 text_first_font"> 물질안전보건자료(Material Safety Data Sheet) 란 물질에 관한 여러가지 정보를 담은 자료를 말한다.</p>
                <p class="ml-4 text_first_font"> 물질에 관한 정보는 그 물질의 이름, 성분, 유해성, 위험성, 보관방법, 다룰 때 주의할 점, 필요한 보호구, 몸에 묻거나 먹었을 때 등의 응급조치 등 여러가지 정보가 포함된다.</p>
                <p class="mt-5"></p>
                <div class="d-flex">
                  <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_03.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:100px; border-radius: 20px;"/></div>
                  <div class="iron_center_contents"><img src="../assets/warn_11.png" style="height:100px; border-radius: 20px;"/></div>
                </div>
                <p class="mt-5"></p>


                <div class="mt-6" style="background-color: #FF8700; border: 1px; padding: 3px; display: inline-block; border-radius: 12px;">
                  <strong class="white--text"  >물질안전보건자료의 필요성</strong>
                </div>
                <p></p>
                <div class="mt-6 ml-2" style="border: 2px solid orange; padding: 3px; display: inline-block; border-radius: 12px;">
                  <p class="ml-4 mt-3 text_first_font">
                    <span style="text-align:center;">
                      <v-icon>mdi-check</v-icon> 
                      사례 1: 경기도 소재 사업장에서 수산화테트라메틸암모늄(TMAH)이라는 세척제가 몸에 쏟아졌으나 해당물질의 유해, 위험성을 알지 못한 근로자가 작업이 끝난 후 닦으려고 하다가 급성 중독으로 사망
                    </span>
                  </p>
                  <p class="ml-4 mt-2 text_first_font">
                    <span style="text-align:center;">
                      <v-icon>mdi-check</v-icon> 
                      사례 2: 충북 소재 사업장에서 수산화테트라메틸암모늄(TMAH)이 작업자의 얼굴, 목 등 부위에 분사되어 샤워실에서 얼굴, 목 등을 닦았으나 20여분이 지난 후 급성중독으로 사망
                    </span>
                  </p>
                </div>
                <p class="ml-4 mt-6 text_first_font">
                  수산화테트라메틸암모늄에 대한 물질안전보건자료(MSDS)의 유해위험문구에 "피부와 접촉하면 치명적임", "근육 약화 및 호흡기 마비를 야기함", "미스트 및 에어로즐 형태로 흡입시 기도에 자극성이 있음" 등의
                  정보가 포함되어 있으나 작업자는 헤당 내용을 알지 못하고 일하던 중 사망하였다.
                </p>
                <p class="ml-4 text_first_font">
                  MSDS 교육을 통해 안전한 작업방법 및 보호구를 착용하고 작업을 할 경우 사고를 예방할 수 있다.               
                </p>

                <div class="mt-12">
                  <strong class="deep-orange--text">물질안전보건자료의 정보 및 게시</strong><br>
                </div>
                
                <div class="mt-2" style="background-color: #FF8700; border: 1px; padding: 3px; display: inline-block; border-radius: 12px;">
                  <strong class="white--text"  >물질안전보건자료의 정보</strong>
                </div>
                <v-spacer></v-spacer>
                
                <div style="text-align: center;">
                  <strong class="deep-orange--text">[품질안전보건자료에 포함되는 정보]</strong>
                </div>
                <p class="ml-4 mt-2 text_first_font">
                  <table class="type09 text-center">
                    <thead>
                      <tr>
                        <th scope="col">구 분</th>
                        <th scope="col">정 보</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>화학제품과 회사에 관한 정보</td>
                        <td>제품명, 제품의 권고용도와 사용상의 제한 등</td>
                      </tr>
                      <tr>
                        <td>유해 · 위험성 정보</td>
                        <td>유해 · 위험성 분류, 예방조치문구를 포함한 경고표지 항목 등</td>
                      </tr>
                      <tr>
                        <td>구성 성분의 명칭 및 함유량</td>
                        <td>화학물질명, 관용명 및 이명, CAS 번호 또는 식별번호, 함유량</td>
                      </tr>
                      <tr>
                        <td>응급조치 요령</td>
                        <td>눈에 들어갔을 때, 피부에 접촉했을 때, 흡입했을 때</td>
                      </tr>
                      <tr>
                        <td>폭발 · 화재 시 대처방법</td>
                        <td>적절한 소화제, 화재 진압 시 착용할 보호구 및 예방조치 등</td>
                      </tr>
                      <tr>
                        <td>누출 사고 시 대처방법</td>
                        <td>인체 보호를 위한 조치사항 및 보호구, 정화 또는 제거방법 등</td>
                      </tr>
                      <tr>
                        <td>취급 및 저장방법</td>
                        <td>안전취급요령, 안전한 저장방법</td>
                      </tr>
                      <tr>
                        <td>노출방지 및 개인보호구</td>
                        <td>노출기준, 적절한 공학적 관리, 개인보호구 등</td>
                      </tr>
                      <tr>
                        <td>물리화학적 특성</td>
                        <td>외관, 냄새, 인화점, 인화 또는 폭발한계 상 · 하한, 자연발화온도 등</td>
                      </tr>
                      <tr>
                        <td>안정성 및 반응성</td>
                        <td>화학적 안정성, 유해반응의 가능성, 피해야 할 조건 등등</td>
                      </tr>
                      <tr>
                        <td>독성에 관한 정보</td>
                        <td>가능성이 높은 노출경로에 대한 정보, 단기 및 장기 노출에 의한 영향 등</td>
                      </tr>
                      <tr>
                        <td>환경에 미치는 영향</td>
                        <td>수생 · 육생 생태독성, 잔류성과 분해성, 생물 농축성 등</td>
                      </tr>
                      <tr>
                        <td>폐기 시 주의사항</td>
                        <td>폐기방법, 폐기 시 주의사항</td>
                      </tr>
                      <tr>
                        <td>운송에 필요한 정보</td>
                        <td>유엔번호(UN No.), 유엔 적정 운송명, 운송 시외 위험등급 등</td>
                      </tr>
                      <tr>
                        <td>법적 규제 현황</td>
                        <td>산업안전보건법에 의한 규제제, 유해화학물질관리법에 의한 규제 등</td>
                      </tr>
                      <tr>
                        <td>기타 참고사항</td>
                        <td>자료의 출처, 최초 작성일자, 개정횟수 및 최종 개정일자 등</td>
                      </tr>
                      
                    </tbody>
                  </table>
                </p>

                <div class="d-flex justify-center mt-5 mb-6">         
                  <img src="../assets/sec/Sec_Study_man2.jpg" style="height:250px"/>
                </div>   
              
                <div style="background-color: #FF8700; border: 1px; padding: 3px; display: inline-block; border-radius: 12px;">
                  <strong class="white--text"  >물질안전보건자료 게시, 비치</strong>
                </div>
                <p class="ml-4 mt-2 text_first_font">
                  <v-icon>mdi-check</v-icon>
                  게시, 비치 방법(산업안전보건법 시행규칙 제92조의 4)<br>
                  - 취급 근로자가 쉽게 보거나 접근할 수 있는 장소에 각 화학물질별로 물질안전보건자료를 항상 게시 하거나 갖추어 둠<br>
                  - 취급 작업자가 물질안전보건자료를 쉽게 확인할 수 있는 전산장비를 갖추어야 함.
                </p>
                <p class="ml-4 mt-2 text_first_font">
                  <v-icon>mdi-check</v-icon>
                  게시 내용(산업안전보건법 시행규칙 제92조의 4)<br>
                  - 물리, 화학적 특성<br>
                  - 독성에 관한 정보<br>
                  - 폭발, 화재 시의 대처 방법<br>
                  - 응급조치 요령 등
                </p>
                <p class="ml-4 mt-2 text_first_font">
                  <v-icon>mdi-check</v-icon>
                  게시 장소<br>
                  - 대상화학물질 취급작업 공정 내<br>
                  - 안전사고 또는 직업병 발생 우려가 있는 장소<br>
                  - 사업장 내 근로자가 가장 보기 쉬운 장소 등등
                </p>
              </v-card-text>
            </div>

            
            <!-- <v-col cols="12" md="8" sd="12">
              <v-card-text class="education_content lineHeight2 pa-0">
                <strong class="deep-orange--text"></strong>
              </v-card-text>
              <table class="type11 text-center">
                <thead>
                  <tr class="text_first_font">
                    <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table_line_right" rowspan="4">물성</td>
                    <td class="table_line_right">인화점</td>
                    <td class="table_line_right">자료 없음</td>
                    <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                    <td rowspan="4" colspan="3">
                      <div class="d-flex">
                        <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">자연발화점</td>
                    <td class="table_line_right">자료 없음</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">비중</td>
                    <td class="table_line_right">0.997</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">끓는점</td>
                    <td class="table_line_right">19.5℃</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                    <td class="table_line_right">화학물질명</td>
                    <td class="table_line_right">관용명 및 이명</td>
                    <td class="table_line_right">CAS. No</td>
                    <td class="table_line_right">함유량</td>
                    <td>노출기준</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">HF</td>
                    <td class="table_line_right">Hydrogen Fluoride</td>
                    <td class="table_line_right">7664-39-3</td>
                    <td class="table_line_right">100%</td>
                    <td>TWA 0.5 ppm</td>
                  </tr>
                </tbody>
                <thead>
                  <tr class="text_first_font">
                    <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                    <th scope="cols" colspan='3'>NFPA CODE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table_line_right" rowspan="4">보호구</td>
                    <td class="table_line_right">개인보호구</td>
                    <td class="table_line_right" colspan="2">방독 마스크</td>
                    <td rowspan="4" colspan="3">
                      <div class="d-flex align-center justify-center">
                        <img src="../assets/graph-text_1.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                        <img src="../assets/graph_1.svg" style="height:120px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">눈 보호</td>
                    <td class="table_line_right" colspan="2">보안경, 고글</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">손 보호</td>
                    <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">신체 보호</td>
                    <td class="table_line_right" colspan="2">내화학성 보호의</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" colspan="2">공학적 관리</td>
                    <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                    <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                    <td class="table_line_right">취급</td>
                    <td class="table_line_right" colspan="2">물과 접촉을 피할 것</td>
                    <td rowspan="2" colspan="3" class="img_area">
                      <div class="d-flex flex-wrap">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">저장</td>
                    <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" md="4" sd="12">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                  <div>피부에&nbsp;<span class="red--text text--lighten-1">심한 화상</span>을 일으킴.</div>
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 심한 손상을 일으킴
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입하면 치명적임
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부, 눈, 점막, 폐 등에 손상을 일으킴
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>약한 상처는 바로 나타나지 않지만 수 시간 후에 통증이 생길 수 있음
                </div>
              </v-card-text>
            </v-col> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" >
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
                <v-card-title class="education_title">
                  <div class="red--text text--darken-2 education_title_text">08. 비상 대응 절차</div>
                  <v-spacer></v-spacer>
                  <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
                </v-card-title>
                <v-divider class="mb-2"></v-divider>
                <div class="pledge_content">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    누출, 화재, 폭발 등 비상상황 발생 시 <strong class="red--text text--lighten-1">신속∙정확한 신고 </strong>및 주변 전파를 실시하고 
                    <strong class="red--text text--lighten-1">대피</strong>를 통해 인명피해를 최소화 합니다.
                  </v-card-text>

                  <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                    <!-- 왼쪽 텍스트 영역 -->
                    <div style="flex: 1;">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          
                        <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <strong class="text-h4 yellow--text font-weight-black">1</strong><br>
                              <span style="color: black;">비상상황</span>
                            </div>
                          </div>
                          <div class="circle_Box2_no d-flex" style="margin: -60px 65px;">
                            <v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon>
                          </div>
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <strong class="text-h4 yellow--text font-weight-black">2</strong><br>
                              <span style="color: black;">신 고</span><br>
                            </div>
                          </div>
                          <div class="mt-2 ml-3">
                            <span style="color: black;">※ 사고 장소</span><br>
                            <span style="color: black;">※ 사고 유형(규모)</span><br>
                            <span style="color: black;">※ 부상자 유무</span><br>
                          </div>
                          <div class="square_Box_no d-flex" style="margin: -60px 65px;">
                            <v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon>
                          </div>
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <strong class="text-h4 yellow--text font-weight-black">3</strong><br>
                              <span style="color: black;">비상방송,경보</span><br>
                            </div>
                          </div>
                          <div class="square_Box_no d-flex" style="margin: -60px 65px;">
                            <v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon>
                          </div>
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <div class="d-flex align-items-center justify-center mr-15">
                                <img src="../assets/SKMA_E.png" style="height:50px; border-radius: 10px; margin-right: 8px;">
                                <strong class="text-h4 yellow--text font-weight-black">4</strong>
                              </div>
                              <br>
                              <div style="margin-top: -35px;">
                                <span style="color: black;">지정장소 대피</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </div>
              
                    <!-- 오른쪽 -->
                    <div style="flex: 3; text-align: right; margin-top: 10px; margin-right: 20px;">
                      <v-card>
                        <v-card-text class="text_first_font lineHeight2">
                          <div style="text-align: start;">
                            <strong class="text-h5 deep-orange--text font-weight-black">비상 상황</strong> 
                          </div>
                          <v-row class="ma-0 mb-2">
                            <v-col cols="12" md="12" sd="12">
                              <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>조업상 비상상황</div>
                            </v-col>
                            <div class="ml-9" style="text-align: start;">
                              - 가스누출 : 제조∙취급 물질의 누출로 알람 발생 또는 가스냄새 발생 시<br>
                              - 화재∙폭발 : 가연성, 인화성 가스 누출로 인한 연기 및 화재 발생<br>
                              - 인체상해 : 추락, 협착, 질식 등의 사고<br>
                              - 인근사 비상상황 : 인근사 또는 인근지역에서 발생한 사고로 공정에 영향을 미치는 경우<br> 
                              - 환경오염사고 : 공정상 발생 오염물질이 외부로 유출되어 환경오염사고를 발생한 경우<br>
                            </div>

                            <v-col cols="12" md="12" sd="12">
                              <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>자연재해에 따른 비상상황</div>
                            </v-col>
                            <div class="ml-9" style="text-align: start;">
                              - 태풍, 낙뢰, 홍수, 지진 등 천재지변에 의한 재해 발생으로 공정에 영향을 미치는 경우<br>
                            </div>
                          </v-row>
                        </v-card-text> 
                      </v-card>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex justify-space-between align-items-start">
                    <div>
                      <v-card-text class="education_content lineHeight2 pa-0">
                        <strong class="deep-orange--text">사업장 안전수칙 : 금지수칙</strong>
                      </v-card-text>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/no-smoking.png" style="height:50px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            1. 지정된 흡연구역 外흡연금지(라이터 소지 금지)<br> 
                            2. <strong class="red--text text--lighten-1">위험물저장소 및 인화성/폭발성 물질</strong>을 취급 및 사용장소 주변에서 점화원을 가까이 하는 행위 금지
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_notake.jpg" style="height:60px; border-radius: 0px;"/>
                          </div>
                          <div class="ml-2">
                            3. 탑승하거나 올라설 수 있도록 설계된 것이 아닌 운반기구, 컨베이어, 이륜 및 사륜 장비, 손수레 등에 <strong class="red--text text--lighten-1">탑승하거나 올라서는 행위 금지</strong><br>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_norunning.jpg" style="height:70px; border-radius: 0px;"/>
                          </div>
                          <div class="ml-2">
                            4. <strong class="red--text text--lighten-1">뛰는 행위 금지</strong>(화재 또는 생명위협, 훈련 등 예외)<br>
                            5. 위험 및 유해작업장소에 사전 승인 없이 출입/통행 금지<br>
                            6. 의도적으로 사내의 물건이나 재산에 손해를 끼치는 행위 금지<br>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_noCellphone.png" style="height:50px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            7. <strong class="red--text text--lighten-1">보행 중 휴대전화 사용금지</strong>, 잠시 멈춰서서 휴대폰 사용 할 것<br> 
                            8. 사업장 內전 지역 <strong class="red--text text--lighten-1">사진촬영 금지</strong>(단, 승인된 경우 제외)
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_nousb.png" style="height:50px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            9. USB, PC, 노트북 및 기타 모든 저장매체, 전기기기 사용 금지<br>
                            10. <strong class="red--text text--lighten-1">도면 및 서류 등 사내 문서의 반출행위 금지</strong>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_nofood.png" style="height:50px; border-radius: 10px;"/>
                          </div>
                          <div class="ml-2">
                            11. 공정지역 內음식물 반입 및 취식행위 금지
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="11">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - PGME</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">PGME</strong>
                </v-card-text>
                <div style="overflow-x:auto; -webkit-overflow-scrolling:touch;">
                  <table class="type11 text-center">
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">물성</td>
                        <td class="table_line_right">인화점</td>
                        <td class="table_line_right">46.5℃</td>
                        <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex">
                            <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_13.png" style="height:80px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">자연발화점</td>
                        <td class="table_line_right">344℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">비중</td>
                        <td class="table_line_right">0.969</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">끓는점</td>
                        <td class="table_line_right">146℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                        <td class="table_line_right">화학물질명</td>
                        <td class="table_line_right">관용명 및 이명</td>
                        <td class="table_line_right">CAS. No</td>
                        <td class="table_line_right">함유량</td>
                        <td>노출기준</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">PGMEA(PMA-P)<br>[Propylene glycol monomethyl ether acetate]</td>
                        <td class="table_line_right">1-Methoxy-2-propanol acetate,<br>1-Methoxy-2-propyl acetate</td>
                        <td class="table_line_right">108-65-6</td>
                        <td class="table_line_right">99.5%</td>
                        <td>자료없음</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                        <th scope="cols" colspan='3'>NFPA CODE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">보호구</td>
                        <td class="table_line_right">개인보호구</td>
                        <td class="table_line_right" colspan="2">방독 마스크</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex align-center justify-center">
                            자료 없음
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">눈 보호</td>
                        <td class="table_line_right" colspan="2">보안경, 고글</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">손 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">신체 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호의</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" colspan="2">공학적 관리</td>
                        <td class="table_line_right" colspan="2">국소배기, 환기장치</td>
                        <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                        <td class="table_line_right">취급</td>
                        <td class="table_line_right" colspan="2">환기가 잘 되는 곳에서 사용할</td>
                        <td rowspan="2" colspan="3" class="img_area">
                          <div class="d-flex flex-wrap">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_06.svg" class="ml-2" style="height:65px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">저장</td>
                        <td class="table_line_right" colspan="2">서늘하고 건조하며<br>환기가 잘 되는곳에 보관할 것</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="12">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - SiH4(실란)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">SiH<sub>4</sub> (실란)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">자연발화</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">-50℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">증기밀도 1.3</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">-112℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">SiH<sub>4</sub></td>
                      <td class="table_line_right">모노실란, 실레인</td>
                      <td class="table_line_right">7803-62-5</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 5 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크, 귀마개</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_3.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                          <img src="../assets/graph_3.svg" style="height:120px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내열성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">방염재질, 내열성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">점화원 및 열과의 접촉 금지</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">용기가 전도되지 않도록 조치<br>서늘하고 건조한 장소에 보관</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>허용농도&nbsp;:&nbsp;<span class="blue--text">5ppm, 7mg/m<span class="superscript">3</span></span></div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>공기 중 노출시&nbsp;<span class="red--text text--lighten-1">자연발화</span> 되는 가스임</div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>고압가스이며 가열시 폭발할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부 접촉 시 자극을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 접촉 시 심한 자극을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입 시 호흡기계 자극을 일으킬 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>장기간 또는 반복적으로 노출되면 장기에 손상을 일으킬 수 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전모, 안전화, 보안경</strong><strong>은 기본 착용 사항입니다.</strong>
            </v-card-text>
            
            <table class="type09 text-center text_first_font">
              <thead>
                <tr>
                  <th scope="cols">작업 장소</th>
                  <th scope="cols">착용 보호구</th>
                  <th scope="cols">사진</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div>  -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>Gas 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>전기 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안면</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>절연계 보호구(절연장감, 절연화 등)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>검전 장비</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_7.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_8.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_9.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>공통사항</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>【보호구】 작업장소 및 공정지역 출입시 <strong class="red--text text--lighten-1">안전모, 보안경, 안전화</strong> 착용 필수 
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="ml-5">※ 기타 구역별 보호구가 지정된 장소는 해당 보호구 추가 착용 필수</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>【복장】 단정한 복장</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>【긴 머리인 경우】 묶어서 안전모 안으로 넣어 단정하게 정리</div>
                    </div>
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>안전화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안경</div>
                    </div> -->
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방독면(반면/휴대)</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_0.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_6.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <!-- <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="9">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질(Gas/Chemical)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">Gas, Chemical 누출을 조기 감지하고자</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 독성 / 가연성 Gas, Chemical의 경우 공정 내 가스검지기 설치 운용 중</p>
              <p class="ml-4 text_first_font"> 모든 감지기는 모니터링되고 있으며, 감지기 동작 시 즉시 현장 확인 조치</p>
              <p class="ml-4 text_first_font"> 작업자가 직접 누출을 목격하거나, 냄새 발생으로 인지할 시 반드시 신고하여야 함</p>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_01.jpg" style="height:200px; border-radius: 10px;"/></div>보거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_02.jpg" style="height:200px; border-radius: 10px;"/></div>냄새 맡거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_03.jpg" style="height:200px; border-radius: 10px;"/></div>감지기가 작동하거나
              </div>

            </div>
            <div class="iron_center_contents ml-4 mt-5 text_first_font">
              <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKTC_E.svg" style="height:300px"/>
              </div>
              <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKMG14.svg" style="height:300px"/>
              </div>
              <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKMP.svg" style="height:300px"/>
              </div>
              <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKMJ.svg" style="height:300px"/>
              </div>
            </div>
            <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">09. 비상 집결지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              작업 전 <strong class="red--text text--lighten-1">대피 경로와 비상구를 확인</strong>하고, 건물 밖으로 대피시에는 <strong class="red--text text--lighten-1">비상구(계단)을 이용</strong>
              하여 비상 집결지로 대피하여 주시기 바랍니다. 
            </v-card-text>
            
            <v-row class="ma-0">
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <v-row class="ma-0" no-gutters>
                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>대피 안내도</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency1.jpg" style="height:150px; border-radius: 10px;"/>
                              </div>
                              <span style="font-size: 13px;">※ 각 공장별 표지 양식 상이</span>
                            </div> 
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>비상 유도등</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency2.jpg" style="height:150px; border-radius: 10px;"/>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>대피 안내 표지</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency3.jpg" style="height:150px; border-radius: 10px;"/>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>대피 안내 표지</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency4.jpg" style="height:150px; border-radius: 10px;"/>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>

                <v-card>
                  <v-row class="ma-0 mb-2">
                    <v-col cols="12" md="12" sd="12">
                      <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>대피 시 행동요령</div>
                    </v-col>
                    <div class="ml-9" style="text-align: start; line-height: 2;">
                      1. 본인의 안전 확보 불가 판단 시, 집결지로 대피 한다.<br>
                      2. 안내방송(사이렌)을 경청하고, 비상 집결지로 대피 한다.<br>
                      <strong class="red--text text--lighten-1">3. 대피 후에는 관리자에게 대피현황을 공유 한다.</strong><br>
                      4. 대피 완료 후 착용한 의류나 신발은 세척 또는 폐기한다. (독성가스 누출 시)<br> 
                    </div>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex justify-space-between align-items-start">
                    <div>
                      <v-card-text class="education_content lineHeight2 pa-0">
                        <strong class="deep-orange--text">사업장 안전수칙 : 기타사항</strong>
                      </v-card-text>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_safety.jpg" style="height:70px; border-radius: 0px;"/>
                          </div>
                          <div class="ml-2">
                            1. 사소하더라도 아래 사항은 즉시 SK머티리얼즈제이엔씨㈜ 직원에게 알려주세요.<br> 
                            <v-icon>mdi-check</v-icon>방문 중 발생한 <strong class="red--text text--lighten-1">상해, 화학물질 흡입 및 접촉사고 </strong> 발생 또는 목격 시<br>
                            <v-icon>mdi-check</v-icon><strong class="red--text text--lighten-1">화재, 폭발 및 화학물질 누출 </strong><br>
                            <v-icon>mdi-check</v-icon><strong class="red--text text--lighten-1">시설물의 손상, 운반수단의 사고, 이상한 냄새, 소음 발생 </strong>시<br>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mt-5">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMJ_stair.jpg" style="height:70px; border-radius: 0px;"/>
                          </div>
                          <div class="ml-2">
                            2. 작업장 통행 시 <strong class="red--text text--lighten-1">지정된 통로</strong>를 이용하여 통행(우측통행 원칙)<br>
                            3. 허가 또는 승인이 필요한 장소에 임의로 출입 금지<br>
                            4. 계단 사용 시, 난간 사용
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="11">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - PGME</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">PGME</strong>
                </v-card-text>
                <div style="overflow-x:auto; -webkit-overflow-scrolling:touch;">
                  <table class="type11 text-center">
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">물성</td>
                        <td class="table_line_right">인화점</td>
                        <td class="table_line_right">38℃</td>
                        <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex">
                            <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_13.png" style="height:80px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">자연발화점</td>
                        <td class="table_line_right">270℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">비중</td>
                        <td class="table_line_right">0.923</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">끓는점</td>
                        <td class="table_line_right">120℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                        <td class="table_line_right">화학물질명</td>
                        <td class="table_line_right">관용명 및 이명</td>
                        <td class="table_line_right">CAS. No</td>
                        <td class="table_line_right">함유량</td>
                        <td>노출기준</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">PGME(MFG)<br>[1-Methoxypropan-2-ol]</td>
                        <td class="table_line_right">PROPYLENE GLYCOL MONO<br>METHYL ETHER</td>
                        <td class="table_line_right">107-98-2</td>
                        <td class="table_line_right">100%</td>
                        <td>TWA: 100ppm</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                        <th scope="cols" colspan='3'>NFPA CODE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">보호구</td>
                        <td class="table_line_right">개인보호구</td>
                        <td class="table_line_right" colspan="2">방독 마스크</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex align-center justify-center">
                            보건 2<br>
                            화재 2<br>
                            반응성 0<br>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">눈 보호</td>
                        <td class="table_line_right" colspan="2">보안경, 고글</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">손 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">신체 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호의</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" colspan="2">공학적 관리</td>
                        <td class="table_line_right" colspan="2">국소배기, 환기장치</td>
                        <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                        <td class="table_line_right">취급</td>
                        <td class="table_line_right" colspan="2">점화원과 접촉을 피할 것</td>
                        <td rowspan="2" colspan="3" class="img_area">
                          <div class="d-flex flex-wrap">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_06.svg" class="ml-3" style="height:65px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">저장</td>
                        <td class="table_line_right" colspan="2">혼합금지물질과 접촉을 피하고<br>밀봉하여 저장</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="13">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - WF6(육불화텅스텐)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">WF<sub>6</sub> (육불화텅스텐)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">해당없음</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">해당없음</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">증기밀도 10.3</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">18 ~ 20℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">WF<sub>6</sub></td>
                      <td class="table_line_right">텅스텐 플로라이드</td>
                      <td class="table_line_right">7803-82-6</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 5 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_4.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                          <img src="../assets/graph_4.svg" style="height:120px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">직접적인 접촉을 피할 것<br>취급 담당자만 취급</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">용기가 전도되지 않도록 조치<br>환기가 되는 장소에 보관</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="21">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">지시표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"/></div>보안경 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:120px; border-radius: 10px;"/></div>방독마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:120px; border-radius: 10px;"/></div>방진 마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:120px; border-radius: 10px;"/></div>보안면 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"/></div>안전모 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:120px; border-radius: 10px;"/></div>귀마개 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"/></div>안전화 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"/></div>안전 장갑 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:120px; border-radius: 10px;"/></div>안전복 착용
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안내표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <!-- <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_01.png" style="height:120px; border-radius: 10px;"/></div>녹십자
                </div> -->
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_02.png" style="height:120px; border-radius: 10px;"/></div>응급구호
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:120px; border-radius: 10px;"/></div>들것
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:120px; border-radius: 10px;"/></div>세안 장치
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_05.png" style="height:120px; border-radius: 10px;"/></div>비상구
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질 누출 시 대응 요령</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전 보호구</strong>
              는 필히
              <strong class="red--text text--lighten-1">착용</strong>
              하고
              <strong class="red--text text--lighten-1">작업</strong>
            </v-card-text>
            
            <table class="type09 text-center">
            <!-- <table class="type09 text-center text-subtitle-1 font-weight-medium"> -->
              <thead>
                <tr>
                  <th scope="cols">구분</th>
                  <th scope="cols">Action</th>
                  <th scope="cols">PPE(보호구)</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>신고</td>
                  <td class="text-left">
                  Chemical 누출 사고 발생 시 방재센터(054-907-0904)로 신고한다.
                    <br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>신고 시 누출명 및 누출 정도, 장소를 정확히 신고</div>
                    </div>
                  </td>
                  <td ></td>
                </tr>
                <tr>
                  <td>약품 접촉 시</td>
                  <td class="text-left">Chemical 누출 접촉 시 즉시 흐르는 물에 15분 이상 씻고, 의료기관으로 후송한다.</td>
                  <td><strong class="red--text text--lighten-1">비상 샤워기</strong></td>
                </tr>
                <tr>
                  <td>공급원 차단</td>
                  <td class="text-left">누출 공급원을 차단하여 추가적인 누출을 막는다.</td>
                  <td><strong class="red--text text--lighten-1">내산복, 내산장갑, 내산장화 착용<br>전면방독면 착용</strong></td>
                </tr>
                <tr>
                  <td>확산 방지 조치</td>
                  <td class="text-left">누출원 확산 방지에 주력한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>사고지점 출입 통제 및 방호조치</div>
                    </div>
                  </td>
                  <td>흡착 펜스 or 흡착포<br>
                  Fume 발생 시:배풍기 설치</td>
                </tr>
                <tr>
                  <td>누출원 수거</td>
                  <td class="text-left">
                    누출되어진 Chemical을 수거한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>다량 누출 시 (Chemical 수거기 이용)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>소량 누출 시 (흡착포 사용)</div>
                    </div>
                  </td>
                  <td>Chemical 수거기, 흡착포</td>
                </tr>
                <tr>
                  <td>폐기물 처리</td>
                  <td class="text-left">
                    폐 흡착 펜스 및 흡착포 비닐 포장 & 전용 수거 용기 사용 수거<br>
                    <strong class="red--text d-flex">
                      ※&nbsp;
                      <div>폐기물 처리 절차에 의한 폐기실시</div>
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">10. 작업 중지권</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <div class="pledge_content">
              <v-row>
                <v-col cols="12" md="6" sd="6">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    SK에어플러스는 안전이 확보되지 않은 <strong class="red--text text--lighten-1">작업은 지시하지 않으며</strong>, 지시하더라고 이를 <strong class="red--text text--lighten-1">거부할 권리</strong>
                    가 있으며 이로 인한 <strong class="red--text text--lighten-1">불이익은 없습니다.</strong>
                  </v-card-text>
                  <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                    <!-- 왼쪽 -->
                    <div>
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <img src="../assets/SKMA_rights.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;" />
                      </v-card-text>
                  
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <div class="box_4 education_content pa-2 ml-0" style="font-size: 20px; font-weight: bold; color: LightGoldenRodYellow;">
                          <div style="width: 100%; max-width: 858px; border-radius: 20px;">
                            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                              <span><strong class="text-h4 font-weight-bold">작업 중지권</strong></span><br>
                              안전하지 않은 근로조건이나 행동이 존재 할 경우, <strong class="red--text text--lighten-1">근로자는 작업을 중단할 권리를 </strong>
                              가지고 있습니다.
                            </v-card-text>
                          </div>
                        </div>
                      </v-card-text>
                    </div>
                  </div>
                </v-col>
                <!-- 오른쪽 -->
                <v-col cols="12" md="6" sd="6">
                  <div style="margin-top: 13%; margin-right: 10%;">
                    <v-card>
                      <v-card-text class="text_first_font lineHeight2 mt-3">
                        <div style="text-align: start;">
                          <strong class="text-h5 deep-orange--text font-weight-black">비상 상황</strong> 
                        </div>
                        <v-row class="ma-0 mb-2">
                          <v-col cols="12" md="12" sd="12">
                            <div class="d-flex"><strong class="deep-orange--text caption mr-2 ">●</strong> 중지권 행사가 필요한 경우</div>
                          </v-col>
                          <div class="ml-9" style="text-align: start;">
                            1. 중대재해 발생 시<br>
                            2. 급박한 위험상황(화재, 폭발, 누출 등) 발생 시<br>
                            3. 현장 점검 중 위험상황 발견 시<br>
                          </div>

                          <v-col cols="12" md="12" sd="12">
                            <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>작업 중지 후 행동요령</div>
                          </v-col>
                          <div class="ml-9" style="text-align: start;">
                            1. 위험요인 확인 요청<br>
                            2. 위험요인 개선 조치 및 SKAP 관리자 확인<br>
                            3. 작업 재개<br>
                          </div>
                        </v-row>
                      </v-card-text> 
                    </v-card>
                    <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>위험 확인 시<br><strong class="red--text text--lighten-1">작업중지</strong></div>
                        <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                        <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>현장 확인<br>및 개선<br></div>
                        <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                        <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>작 업<br>재 개<br></div>
                      </div>
                    </v-card-text>
                  </div>
                </v-col>
              </v-row>    
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex justify-space-between align-items-start">
                <div>
                  <v-card-text class="education_content lineHeight2 pa-0">
                    <strong class="deep-orange--text">사업장 안전수칙 : 복장 및 보호구</strong>
                  </v-card-text>
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    작업장소 및 공정지역(생산시설 및 부대시설 포함)을 출입하는 모든 인원은 요구되는 보호구와 복장을 착용합니다.
                  </v-card-text>
                  <v-row>
                    <v-col cols="12" md="4" sm="12">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-2 text-center font-weight-black">
                          <div class="iron_center_contents "><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"/></div>안전모 착용
                        </div>
                        <div class="ma-2 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"/></div>보안경 착용
                        </div>
                        <div class="ma-2 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"/></div>안전화 착용
                        </div>
                        <div class="ma-2 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"/></div>장갑 착용
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="8" sm="12">
                      <div class="ml-9 mt-3">
                        【보호구】 작업장소 및 공정지역 출입시 <strong class="red--text text--lighten-1">안전모, 안전화</strong> 착용 필수<br>
                        ※ 기타 구역별 보호구가 지정된 장소는 해당 보호구 추가 착용 필수<br>
                        【복장】 단정한 복장<br>
                        【긴 머리인 경우】 묶어서 안전모 안으로 넣어 단정하게 정리
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="14">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - 아세톤</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">ACETONE</strong>
                </v-card-text>
                <div style="overflow-x:auto; -webkit-overflow-scrolling:touch;">
                  <table class="type11 text-center">
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">물성</td>
                        <td class="table_line_right">인화점</td>
                        <td class="table_line_right">-17℃</td>
                        <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex">
                            <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_13.png" style="height:80px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">자연발화점</td>
                        <td class="table_line_right">465℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">비중</td>
                        <td class="table_line_right">0.8</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">끓는점</td>
                        <td class="table_line_right">56.1℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                        <td class="table_line_right">화학물질명</td>
                        <td class="table_line_right">관용명 및 이명</td>
                        <td class="table_line_right">CAS. No</td>
                        <td class="table_line_right">함유량</td>
                        <td>노출기준</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">ACETONE</td>
                        <td class="table_line_right">2-PROPANONE</td>
                        <td class="table_line_right">67-64-1</td>
                        <td class="table_line_right">100%</td>
                        <td>TWA: 500 ppm</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                        <th scope="cols" colspan='3'>NFPA CODE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">보호구</td>
                        <td class="table_line_right">개인보호구</td>
                        <td class="table_line_right" colspan="2">방독 마스크</td>
                        <td rowspan="4" colspan="3">
                          보건 1<br>
                          화재 3<br>
                          반응성 0<br>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">눈 보호</td>
                        <td class="table_line_right" colspan="2">보안경, 고글</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">손 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">신체 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호의</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" colspan="2">공학적 관리</td>
                        <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                        <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                        <td class="table_line_right">취급</td>
                        <td class="table_line_right" colspan="2">환기가 잘되는 곳에서 취급할 것</td>
                        <td rowspan="2" colspan="3" class="img_area">
                          <div class="d-flex flex-wrap">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">저장</td>
                        <td class="table_line_right" colspan="2">직사광선을 피할 것, 원래의 용기에 저장할 것</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="14">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - NH3(암모니아)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">NH<sub>3</sub> (암모니아)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">11℃</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/warn_11.png" style="height:80px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">651℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">0.59</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">-33℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">NH<sub>3</sub></td>
                      <td class="table_line_right">무수 암모니아</td>
                      <td class="table_line_right">7664-41-7</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 25 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_5.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                          <img src="../assets/graph_5.svg" style="height:120px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">화기와의 접촉을 피할 것</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <span class="red--text text--lighten-1">극인화성 가스</span>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>고압가스이며, <span class="red--text text--lighten-1">가열하면 폭발</span>할 수 있음</div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>고온에서 분해되어 독성가스를 생성할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>가열시 용기가 폭발할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>물에 녹으며 열을 발생함
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>증기는 매우 자극적이고 부식성이 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="text_first_font lineHeight2">
              <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
              <v-row class="ma-0 mb-2">
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
              </v-row>
              ※ 공구 검수 장소 : 해당 현장
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 기본 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
              <div class="education_content flex-wrap d-flex justify-left mt-0 mb-0">
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">1.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">ISBL(GA동) 출입인원 필수 보호구</strong>
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMG14_보호구.jpg" style="height:650px; width:500px; border-radius: 10px;"/></div>
                    </div>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">2.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">QSBL(Utility 구역) 출입인원 필수 보호구</strong>
                    <p class="mt-2 text_first_font">: ISBL(GA동) 보호구 중 보안경, 방진마스크 제외. 단, 작업에 따라 필요 시 착용</p>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">11. 종사자 의견 청취</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <div class="pledge_content">
              <v-row>
                <v-col cols="12" md="6" sd="6">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    SK에어플러스는 안전하고 쾌적한 작업환경을 확보하기 위하여 SHE 소리함을 운영함으로써, 종사자 분들의 의견을 듣고자 합니다.
                  </v-card-text>
                  <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                    <!-- 왼쪽 -->
                    <div>
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <img src="../assets/SKMA_SHE.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;" /><br>
                        <div style="margin-left:25%;">SHE 소리함 비치 사진</div>
                      </v-card-text>
                    </div>
                  </div>
                </v-col>
                <!-- 오른쪽 -->
                <v-col cols="12" md="6" sd="6">
                  <div style="margin-top: 15%; margin-right: 10%;">
                    <v-card>
                      
                    </v-card>
                    <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>SHE 소리<br>카드 작성<br><strong class="red--text text--lighten-1">(익명)</strong></div>
                    <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>SHE 소리<br>건의<br></div>
                    <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>SHE팀<br>확인,검토<br>(1회/월)<br></div>
                  </div>
                </v-card-text>
                  </div>
                </v-col>
              </v-row>    
            </div>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              SK에어플러스는 안전하고 쾌적한 작업환경을 확보하기 위하여 SHE 소리함을 운영함으로써, 종사자 분들의 의견을 듣고자 합니다.
            </v-card-text>
            <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">

              <div style="flex: 1; margin-top:-5px;" >
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <img src="../assets/SKMA_SHE.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;" /><br>
                  <div style="margin-left:135px;">SHE 소리함 비치 사진</div>
                </v-card-text>
              </div>
        

              <div style="flex: 2; text-align: right; margin-top: 10px; margin-right: 20px;">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>SHE 소리<br>카드 작성<br><strong class="red--text text--lighten-1">(익명)</strong></div>
                    <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>SHE 소리<br>건의<br></div>
                    <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>SHE팀<br>확인,검토<br>(1회/월)<br></div>
                  </div>
                </v-card-text>
              </div>
            </div> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12 pledge_content" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>


            <v-card-text class="education_content lineHeight2 grey--text text--darken-1 ">
              <strong class="deep-orange--text">작업중지권</strong><br>
              <strong> 작업중지권 발동 요건</strong>
              <div class="d-flex justify-space-between align-items-start">
                <div>
                  <v-row>
                    <v-col cols="12" md="6" sm="12">
                      <div class="ml-9 mt-3">
                        1. 권한 - 누구나 (작업자, 관리자, 목격자 모두)<br>
                        2. 상황<br>
                        - 사고발생 위험이 있다고 판단한 경우<br>
                        - 고소작업 시 안전밸트 미고정<br>
                        - 화기작업 시 화재위험이 높다고 판단한 경우<br>
                        - 감전의 위험이 있다고 판단한 경우<br>
                        - 보호구착용이 미흡한 작업자를 발견한 경우<br>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <div style="margin-top: 0%; margin-right: 10%;">
                    <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                      <img src="../assets/SKMJ_rights.png" style="width: 100%; max-width: 500px; border-radius: 20px;" />
                    </v-card-text>
                  </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
            
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="14">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - 암모니아</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">NH<sub>3</sub></strong>
                </v-card-text>
                <div style="overflow-x:auto; -webkit-overflow-scrolling:touch;">

                  <table class="type11 text-center">
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">물성</td>
                        <td class="table_line_right">인화점</td>
                        <td class="table_line_right">자료없음</td>
                        <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex">
                            <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"/></div>
                          </div>
                          <div class="d-flex">  
                            <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_11.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">자연발화점</td>
                        <td class="table_line_right">651℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">비중</td>
                        <td class="table_line_right">0.7</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">끓는점</td>
                        <td class="table_line_right">-33℃</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                        <td class="table_line_right">화학물질명</td>
                        <td class="table_line_right">관용명 및 이명</td>
                        <td class="table_line_right">CAS. No</td>
                        <td class="table_line_right">함유량</td>
                        <td>노출기준</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">AMMONIA (NH<sub>3</sub>)</td>
                        <td class="table_line_right">AMMONIA, GAS</td>
                        <td class="table_line_right">7664-41-7</td>
                        <td class="table_line_right">99.5%</td>
                        <td>TWA: 25 ppm</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr class="text_first_font">
                        <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                        <th scope="cols" colspan='3'>NFPA CODE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table_line_right" rowspan="4">보호구</td>
                        <td class="table_line_right">개인보호구</td>
                        <td class="table_line_right" colspan="2">방독 마스크, 송기 마스크</td>
                        <td rowspan="4" colspan="3">
                          <div class="d-flex align-center justify-center">
                            보건 3<br>
                            화재 1<br>
                            반응성 0<br>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">눈 보호</td>
                        <td class="table_line_right" colspan="2">보안경, 고글</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">손 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                      </tr>
                      <tr>
                        <td class="table_line_right">신체 보호</td>
                        <td class="table_line_right" colspan="2">내화학성 보호의</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" colspan="2">공학적 관리</td>
                        <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                        <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                      </tr>
                      <tr>
                        <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                        <td class="table_line_right">취급</td>
                        <td class="table_line_right" colspan="2">분진, 흄, 가스 등의 흡입을 피할 것</td>
                        <td rowspan="2" colspan="3" class="img_area">
                          <div class="d-flex flex-wrap">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                            <div class="iron_center_contents"><img src="../assets/guide_06.svg" class="ml-3" style="height:65px; border-radius: 10px;"/></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="table_line_right">저장</td>
                        <td class="table_line_right" colspan="2">직사광선을 피하고 환기가 잘 되는 곳에 보관할 것</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        
        <v-stepper-content step="15" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="15">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화학사고 발생 시</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">화학사고 발생 시 대피 요령</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>독성가스는 대부분 공기보다 무겁기 때문에 낮은 곳보다는 <span class="red--text text--lighten-1">높은 곳으로 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>바람은 독성물질을 운반하는 역활을 하므로 반드시 <span class="red--text text--lighten-1">바람을 거슬러 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동하려는 방향에서 가스가 날아오는 경우 <span class="red--text text--lighten-1">바람이 부는 방향의 직각으로 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>화학물질에 노출되었다면 즉시 병원에 가서 <span class="red--text text--lighten-1">의사의 진찰을 받아야 함</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>지하철 등 실내 공간에서는 <span class="red--text text--lighten-1">신속히 실외로 대피</span></div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">화학물질 접촉 시 행동 요령</strong><br>
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>즉시 당사 <span class="red--text text--lighten-1">직원에게 통보</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>흐르는 물로 15분 이상 씻고 오염된 옷 또는 장갑류는 벗을 것
                    <div class="mt-2">- 초기 증상 없음 : 물과 비누로 피부 오염부위 세척</div>
                    <div class="mt-1 mb-2">- 진행(붓기, 물집 등) : 흐르는 물로 가볍게 씻을 것</div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>경미한 접촉이라도 <span class="red--text text--lighten-1">즉시 방제센터로 신고</span> 하시기 바랍니다.</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="26">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">공통</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>모든 작업은 관리감독자가 현장에 배치되어야 하며, 사전 작업허가를 득하여야 한다.</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>관리감독자는 작업절차 교육, 작업자는 작업절차 준수</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>작업과 관계없는 밸브, 버튼 조작 금지</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>이상 상황 발견 시 관리감독자에게 즉시 보고</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>협착, 전도, 추락, 감전, Chemical/가스 누출 및 접촉에 유의할 것</div>
                </div>
                <div class="d-flex mb-2">
                  6.&nbsp;
                  <div>장비 및 배관 등의 설비에 유해를 가하지 않도록 할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">밀폐공간 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>현장입회자는 현장에 상주할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>그 외 밀폐공간 안전 작업기준을 준수할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">화기 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가연성 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>불티 비산 대비책을 수립하여 시행하고 화기 감시자를 배치할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>주변 가연물 제거 및 소화기를 비치 후 작업할 것</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정안전 - 작업 종류별 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <table class="type09 text-center text_first_font">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">착용 보호구</th>
                  <th scope="cols">사 진</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div> 
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>Gas 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>전기 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안면</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>절연계 보호구(절연장감, 절연화 등)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>감전 장비</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_7.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_8.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_9.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>그외 지역</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>안전모, 안전화, 보안경, 방독면(반면/휴대)
                      </div>
                    </div>

                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>안전화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안경</div>
                    </div> -->
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방독면(반면/휴대)</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_0.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_6.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'" >
          <!-- <div class="pledge_content"> -->
            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1 pledge_content"> -->
              <v-card class="pl-4 pr-4 mb-12 pledge_content" min-height="520" flat id="22">
                <v-card-title class="education_title">
                  <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
                  <v-spacer></v-spacer>
                  <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
                </v-card-title>
                <v-divider class="mb-2"></v-divider>
                
                
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="deep-orange--text">작업중지권: 발동 방법 및 절차</strong><br>
                  <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        1</strong><br><span style="color: black;">사고 위험 발견</span><br><span style="color: black;">작업 중지 요청</span>
                      </div>
                      <div class="ml-3">
                        "사고 위험이 있으니 작업을 중지해 주시기 바랍니다."<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex justify-center align-center" style="width: 12%; height: 100px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        2</strong><br><span style="color: black;">작업 중지</span>
                      </div>
                      <div class="ml-3 mt-3">
                        <span class="font-weight-bold">작업자</span><br>
                        <v-icon>mdi-check</v-icon>작업을 멈추고 안전한 장소로 이동<br>
                        <span class="font-weight-bold">작업감독자/관리감독자</span><br>
                        <v-icon>mdi-check</v-icon>작업을 중지하지 않은 인원의 작업을 중지시키고 안전한 장소로 이동 시킴<br>
                        <v-icon>mdi-check</v-icon>SK머티리얼즈제이엔씨 관리감독자에게 연락<br> "사고 위험 우려가 있어 작업중지 통보를 받았으니 현장확인을 요청합니다."<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex justify-center align-center " style="width: 12%; height: 100px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        3</strong><br><span style="color: black;">위험요인 제거</span><br><span style="color: black;">&작업재개</span>
                      </div>
                      <div class="ml-3 mt-3">
                        <span class="font-weight-bold">작업감독자/관리감독자</span><br>
                        <v-icon>mdi-check</v-icon>위험요인의 제거, 구호조치(필요시), 추가 피해 방지 조치<br>
                        <span class="font-weight-bold">SKMJ 관리감독자(해당작업) & SHE</span><br>
                        <v-icon>mdi-check</v-icon>위험요인 제거 및 추가 피해 방지 조치, 추가 위험요인 등 확인<br>
                        <v-icon>mdi-check</v-icon>모든 위험요인 제거 후 작업재개 요청<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex justify-center align-center" style="width: 12%; height: 100px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        4</strong><br><span style="color: black;">기록관리</span>
                      </div>
                      <div class="ml-3">
                        <span class="font-weight-bold">SKMJ SHE팀</span><br>
                        <v-icon>mdi-check</v-icon>통합SHE시스템 기록 관리<br>
                      </div>
                    </div>
                  </div>
                </v-card-text> 
              </v-card>
            <!-- </v-card-text> -->
          <!-- </div> -->
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="15">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화학사고 발생 시</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">화학사고 발생 시 대피 요령</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>독성가스는 대부분 공기보다 무겁기 때문에 낮은 곳보다는 <span class="red--text text--lighten-1">높은 곳으로 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>바람은 독성물질을 운반하는 역활을 하므로 반드시 <span class="red--text text--lighten-1">바람을 거슬러 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동하려는 방향에서 가스가 날아오는 경우 <span class="red--text text--lighten-1">바람이 부는 방향의 직각으로 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>화학물질에 노출되었다면 즉시 병원에 가서 <span class="red--text text--lighten-1">의사의 진찰을 받아야 함</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>지하철 등 실내 공간에서는 <span class="red--text text--lighten-1">신속히 실외로 대피</span></div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">화학물질 접촉 시 행동 요령</strong><br>
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>즉시 당사 <span class="red--text text--lighten-1">직원에게 통보</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>흐르는 물로 15분 이상 씻고 오염된 옷 또는 장갑류는 벗을 것
                    <div class="mt-2">- 초기 증상 없음 : 물과 비누로 피부 오염부위 세척</div>
                    <div class="mt-1 mb-2">- 진행(붓기, 물집 등) : 흐르는 물로 가볍게 씻을 것</div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>경미한 접촉이라도 <span class="red--text text--lighten-1">SHE팀 신고</span> 하시기 바랍니다.</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질 누출 시 대응 요령</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전 보호구</strong>
              는 필히
              <strong class="red--text text--lighten-1">착용</strong>
              하고
              <strong class="red--text text--lighten-1">작업</strong>
            </v-card-text>
            
            <table class="type09 text-center">
            <!-- <table class="type09 text-center text-subtitle-1 font-weight-medium"> -->
              <thead>
                <tr>
                  <th scope="cols">구분</th>
                  <th scope="cols">Action</th>
                  <th scope="cols">PPE(보호구)</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>신고</td>
                  <td class="text-left">
                    <span v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
                      Chemical 누출 사고 발생 시 방재센터(044-902-0253)로 신고한다.
                    </span>
                    <span v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
                      Chemical 누출 사고 발생 시 방재센터(044-998-8114)로 신고한다.
                    </span>
                    <span v-else>
                      Chemical 누출 사고 발생 시 방재센터(054-630-8119)로 신고한다.
                    </span>
                    <br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>신고 시 누출 명 및 누출 정도, 장소를 정확히 신고</div>
                    </div>
                  </td>
                  <td ></td>
                </tr>
                <tr>
                  <td>약품 접촉 시</td>
                  <td class="text-left">Chemical 누출 접촉 시 즉시 흐르는 물에 15분 이상 씻고, 관리감독자 지시에 따라 의료기관으로 후송</td>
                  <td><strong class="red--text text--lighten-1">비상 샤워기</strong></td>
                </tr>
                <tr>
                  <td>공급원 차단</td>
                  <td class="text-left">누출 공급원을 차단하여 추가적인 누출을 막는다.</td>
                  <td><strong class="red--text text--lighten-1">내산복, 내산장갑, 내산장화 착용<br>전면방독면 착용</strong></td>
                </tr>
                <tr>
                  <td>확산 방지 조치</td>
                  <td class="text-left">누출원 확산 방지에 주력한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>사고지점 출입 통제 및 방호조치</div>
                    </div>
                  </td>
                  <td>흡착 펜스 or 흡착포<br>
                  (유독) 가스 발생 시:배풍기 설치</td>
                </tr>
                <tr>
                  <td>누출원 수거</td>
                  <td class="text-left">
                    누출된 Chemical을 수거한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>다량 누출 시 (Chemical 수거기 이용)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>소량 누출 시 (흡착포 사용)</div>
                    </div>
                  </td>
                  <td>Chemical 수거기, 흡착포</td>
                </tr>
                <tr>
                  <td>폐기물 처리</td>
                  <td class="text-left">
                    폐 흡착 펜스 및 흡착포 비닐 포장 & 전용 수거 용기 사용 수거<br>
                    <strong class="red--text d-flex">
                      ※&nbsp;
                      <div>폐기물 처리 절차에 의한 폐기실시</div>
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="27">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">고소 작업(사다리 포함)</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반입되는 사다리는 모두 Outtrigger가 설치된 것을 사용</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>사다리 작업 시 2인 1조로 작업을 실시</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동식 고소 작업대는 반입 전 검사를 득하고 반입(SHE팀)</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>고소 작업 시 반드시 안전벨트 및 걸이대를 설치 후 작업</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비계(고정식, 이동식) 사용 시 설치 후 SHE팀의 승인을 득한 다음 사용</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">정전 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>전기작업은 담당자만 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>시건장치를 하고, 작업 전 해당 설비 및 Panel 전원 차단</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>해당 Panel 시건조치 및 꼬리표 부착</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>              
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">굴착 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>
                    허가서 발행 후 굴착 전 굴착 예정지 지하 매설물 확인<br>
                    <div class="d-flex mt-1">
                      -&nbsp;
                      <div>굴착신고 후 작업 </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>
                    굴착 장소 주변은 통제를 실시하고 개구부 관리를 철저히 할 것
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="18">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 작업 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="6" sd="12">
                <v-card-text class="lineHeight2 grey--text text--darken-1">
                  <div class="education_content d-flex mb-2">
                    1.&nbsp;
                    <div>안전 작업 <strong class="red--text text--lighten-1">허가 승인</strong> 절차 준수(JSA 포함)</div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      2.&nbsp;
                      <div>작업 공구 검수 준수</div>
                    </div>
                    <div class="red--text ml-6 text_first_font">[전기릴선, 용접기, 그라인더, 절단기, 사다리 등]</div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      3.&nbsp;
                      <div>작업 반경 內 <strong class="red--text text--lighten-1">방호조치</strong> 철저</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>교통통제 요원, 신호수, 작업지휘자 배치</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업구획(펜스, 라바콘 설치), 공사 안전 표지판 설치 및 안전 작업허가서 게시</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>장비 이동 전용 안전 받침대 사용, 크레인 전용 받침목, 차량 고임목 설치</div>
                    </div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      4.&nbsp;
                      <div>작업 주관부서 관리감독자 현장 상주</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 전:작업순서 및 그 순서마다 작업 방법을 정하고 작업을 지휘할 것, 보호구 및 기구, 공구 점검, 정비할 것</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 중:관계 작업자 이외 출입 금지, 보호구 착용 상태를 점검할 것</div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      5.&nbsp;
                      <div>작업 안전 보호구 착용</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(지상 작업 시) 안전모, 안전화, 보안경, 방독면(휴대)</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(고소작업 시)해당 보호구 별도 착용</div>
                    </div>
                  </div>
                  <div class="education_content d-flex mb-2">
                    6.&nbsp;
                    <div>기상 이상 시 <strong class="red--text text--lighten-1">작업 중지</strong> 기준</div>
                    
                  </div>
                </v-card-text>

                <div class="education_content d-flex mb-2 ml-4">
                  <div>작업제한 기준(SHE팀에서 기상정보 확인)</div>
                </div>
                
                <table class="type09 text-center ">
                  <thead>
                    <tr class="text_first_font hidden-xs-only">
                      <th scope="cols">강우량<br>(mm/hr)</th>
                      <th scope="cols">강설량<br>(cm/hr)</th>
                      <th scope="cols">순간 최대<br>풍속(m/sec)</th>
                      <th scope="cols" style="min-width:100px;">작업기준</th>
                    </tr>
                      <!-- <th scope="cols" class="" style="max-width:10px">작업기준</th>
                      <th scope="cols" class="" style="max-width:10px">작업기준</th> -->

                    <tr class="text_first_font d-sm-none">
                      <th scope="cols" style="max-width:20px;">강우량<br>(mm/hr)</th>
                      <th scope="cols" style="max-width:20px;">강설량<br>(cm/hr)</th>
                      <th scope="cols">순간 최대<br>풍속(m/sec)</th>
                      <th scope="cols" style="">작업기준</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan='3'>1.0 이상</td>
                      <td rowspan='3'>1.0 이상</td>
                      <td>8 이상 ~ 11 미만</td>
                      <td>외부 용접, 도장 작업 중지</td>
                    </tr>
                    <tr>
                      <td>11 이상 ~ 15 미만</td>
                      <td>적재, 건립 작업 중지</td>
                    </tr>
                    <tr>
                      <td>15 이상</td>
                      <td>모든 고소 작업 중지</td>
                    </tr>
                  </tbody>
                </table>
                <div class="education_content d-flex mb-2">
                  ※&nbsp;
                  <div>Penalty 위반 시 사내 규정에 의거 처리</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" sd="12">
                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">크레인 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_1.png" class="flow_picture_type1"/>
                  </div>
                </div>

                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">지게차 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_2.png" class="flow_picture_type1"/>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 작업구역 설정</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업용 조명</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 탁상용 드릴</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 : 제20조(출입의 금지), 제446조(출입의 금지등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 작업시작 전 작업구획을 설정하여 작업관계자 외 임의출입에 의한 위험요소를 차단<br>
                    2. 안전작업허가서, 작업계획서등 제반서류 및 안전관련표지를 게시하여 작업자 및 관리자에게 해당공사안전에 대한정보를 제공  
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>일반작업(적백색) 또는 안전펜스, 라바콘등(작업구간과 이동통로 감안하여 설치)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_install1.png" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>※ 바리케이드설치높이: 약1m (출입통제)
                        </div> 
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>유해화학물질취급작업(황흑색)(액 비산거리 감안하여 넓게 설치)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_install2.png" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>※ 내산복 및 보호장구 미착용 출입불가
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질 누출 시 대응 요령</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전 보호구</strong>
              는 필히
              <strong class="red--text text--lighten-1">착용</strong>
              하고
              <strong class="red--text text--lighten-1">작업</strong>
            </v-card-text>
            
            <table class="type09 text-center">
            <!-- <table class="type09 text-center text-subtitle-1 font-weight-medium"> -->
              <thead>
                <tr>
                  <th scope="cols">구분</th>
                  <th scope="cols">Action</th>
                  <th scope="cols">PPE(보호구)</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>신고</td>
                  <td class="text-left">
                    <span v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
                      Chemical 누출 사고 발생 시 방재센터(044-902-0253)로 신고한다.
                    </span>
                    <span v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
                      Chemical 누출 사고 발생 시 SHE팀으로 신고한다.
                    </span>
                    <span v-else>
                      Chemical 누출 사고 발생 시 방재센터(054-630-8119)로 신고한다.
                    </span>
                    <br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>신고 시 누출 명 및 누출 정도, 장소를 정확히 신고</div>
                    </div>
                  </td>
                  <td ></td>
                </tr>
                <tr>
                  <td>약품 접촉 시</td>
                  <td class="text-left">Chemical 누출 접촉 시 즉시 흐르는 물에 15분 이상 씻고, 관리감독자 지시에 따라 의료기관으로 후송</td>
                  <td><strong class="red--text text--lighten-1">비상 샤워기</strong></td>
                </tr>
                <tr>
                  <td>공급원 차단</td>
                  <td class="text-left">누출 공급원을 차단하여 추가적인 누출을 막는다.</td>
                  <td><strong class="red--text text--lighten-1">내산복, 내산장갑, 내산장화 착용<br>전면방독면 착용</strong></td>
                </tr>
                <tr>
                  <td>확산 방지 조치</td>
                  <td class="text-left">누출원 확산 방지에 주력한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>사고지점 출입 통제 및 방호조치</div>
                    </div>
                  </td>
                  <td>흡착 펜스 or 흡착포<br>
                  (유독) 가스 발생 시:배풍기 설치</td>
                </tr>
                <tr>
                  <td>누출원 수거</td>
                  <td class="text-left">
                    누출된 Chemical을 수거한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>다량 누출 시 (Chemical 수거기 이용)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>소량 누출 시 (흡착포 사용)</div>
                    </div>
                  </td>
                  <td>Chemical 수거기, 흡착포</td>
                </tr>
                <tr>
                  <td>폐기물 처리</td>
                  <td class="text-left">
                    폐 흡착 펜스 및 흡착포 비닐 포장 & 전용 수거 용기 사용 수거<br>
                    <strong class="red--text d-flex">
                      ※&nbsp;
                      <div>폐기물 처리 절차에 의한 폐기실시</div>
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0"  v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정안전 - 작업 종류별 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <table class="type09 text-center text_first_font">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">착용 보호구</th>
                  <th scope="cols">사 진</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div> 
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>Gas 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>전기 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안면</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>절연계 보호구(절연장감, 절연화 등)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>감전 장비</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_7.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_8.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_9.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>그외 지역</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>안전모, 안전화, 보안경, 방독면(반면/휴대)
                      </div>
                    </div>

                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>안전화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안경</div>
                    </div> -->
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방독면(반면/휴대)</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_0.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_6.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <!-- <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="28">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화재 발생 시</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><strong class="red--text font-weight-black">"불이야"</strong> 큰 소리로 알리고 신고한다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>
                      주변의 소화기로 초기소화를 시도한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>소화기 위치는 평소 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>
                      초기소화 실패 시에는 <strong class="red--text font-weight-black">신속히 대피한다.</strong><br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>비상구 위치는 평소 익혀둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>
                      낮은 자세로 코와 입을 막고 대피한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>엘리베이터 사용 금지 / 계단 이용</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>화재 상황을 보고한다. (육하원칙)</div>
                  </div>
                </v-card-text>
              </v-col>
              <div class="iron_center_contents ml-4 mt-5 text_first_font">
                <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKTC_E.svg" style="height:300px"/>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMG14.svg" style="height:300px"/>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMP.svg" style="height:300px"/>
                </div>
                <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKMJ.svg" style="height:300px"/>
                </div>
              </div>
              <!-- <v-col cols="12" md="6" sm="12">
                <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div>
              </v-col> -->
            </v-row>

            <div class="ma-4">
              <div class="box_2 education_content pa-5">
                비상 대피는 빠른 대피보다 <strong class="white--text font-weight-black ml-4 mr-4">"정확한"</strong> 대피가 우선입니다.
              </div>
            </div>

            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>화재를 발견하면 '불이야'하고 큰 소리로 외쳐서 다른 사람에게 알립시다.</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>
                  방재센터로 신고합니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>"본관 2층 휴게실에서 화재가 발생했습니다."</div>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>
                  화재경보 비상벨을 누릅니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>평소 주위에 있는 소화기, 옥내소화전 사용법을 숙지했다가 초기에 진화합니다.</div>
                  </div>
                </div>
              </div>
            </v-card-text>              
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="19">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 운반 시 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 인력 운반 시 재해 발생 형태</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>염좌 : 중량물을 무리하게 또는 갑작스럽게 들어 올리거나 운반 시 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>협착 : 중량물을 들어 올리거나 내릴 때 손 또는 발이 취급 중량물과 지면 또는 건축물 등에 끼어 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>낙하 : 중량물을 들어 올리거나 운반하다가 힘에 겨워 중량물을 떨어뜨려 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>충돌 : 물건을 운반하는 중에 다른 사람과 부딪혀서 발생</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">운반 재해예방의 기본원칙</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>작업공정을 개선하여 운반의 필요성이 없도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반작업을 줄인다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반횟횟수(빈도) 및 거리를 최소화, 최단거리화한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>중량물의 경우 2~3인이 운반하도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반 보조 기구 및 기계를 이용한다.</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 운반 시 올바른 자세 및 방법</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move01.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">1</div>무게 중심을 확인한다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move02.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">2</div>가까이 선다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move03.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">3</div>쪼그리고 앉는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move04.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">4</div>안정되게 잡는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move05.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">5</div>다리를 이용해 들어 올린다.
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업구역 설정</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 작업용 조명</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 탁상용 드릴</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 : 제7조(채광 및 조명), 제8조(조도), 제301조(전기기계기구 등의 충전부 방호), 제302조(전기기계기구의 접지), 제303조 (전기 기계기구의 적정설치 등),
                    제311조(폭발위험장소에서사용하는 전기기계기구의 선정 등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 줄줄이 전등: 통로 또는 작업장의 조도확보 목적으로 설치하는 전등으로 단일 케이블에 전등이 3개이상 연속되어 설치된 것<br>
                    2. 투광등: 메탈램프 투광등: 발광효율 높으나 램프 파손시 봉입가스 분출로 인한 파편비산, 찔림, 베임, 램프발열로 인한 화상, 감전사고 발생위험 높음
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>1. 전선이 하중을 직접 받지 않도록 pp로프 시공</strong><br>
                        <strong>2. 전등을 끼우지 않은 소켓은 절연물로 막음 조치</strong><br>
                        <strong>3. 절연재질 전구 보호망 사용</strong><br>
                        <strong></strong><br>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_light1.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>1. 메탈램프 사용시 안정기 설치 필수</strong><br>
                        <strong>2. 구조물에 클램프 등으로 고정하여 이탈방지</strong><br>
                        <strong>3. 투광기 외함 접지실시</strong><br>
                        <strong>4. 에너지 효율높은 LED 타입 사용권고</strong><br>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_light2.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정안전 - 작업 종류별 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <table class="type09 text-center text_first_font">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">착용 보호구</th>
                  <th scope="cols">사 진</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div> 
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>Gas 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>전기 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안면</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>절연계 보호구(절연장감, 절연화 등)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>감전 장비</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_7.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_8.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_9.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
                <tr>
                  <td>그외 지역</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>안전모, 안전화, 보안경, 방독면(반면/휴대)
                      </div>
                    </div>

                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>안전화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안경</div>
                    </div> -->
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방독면(반면/휴대)</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_0.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_6.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="18">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 작업 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="6" sd="12">
                <v-card-text class="lineHeight2 grey--text text--darken-1">
                  <div class="education_content d-flex mb-2">
                    1.&nbsp;
                    <div>안전 작업 <strong class="red--text text--lighten-1">허가 승인</strong> 절차 준수(JSA 포함)</div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      2.&nbsp;
                      <div>허가 승인 검수 준수</div>
                    </div>
                    <div class="red--text ml-6 text_first_font">[전기릴선, 용접기, 그라인더, 절단기, 사다리 등]</div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      3.&nbsp;
                      <div>작업 반경 內 <strong class="red--text text--lighten-1">방호조치</strong> 철저</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>교통통제 요원, 신호수, 작업지휘자 배치</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업구획(펜스, 라바콘 설치), 공사 안전 표지판 설치 및 안전 작업허가서 게시</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>장비 이동 전용 안전 받침대 사용, 크레인 전용 받침목, 차량 고임목 설치</div>
                    </div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      4.&nbsp;
                      <div>작업 주관부서 관리감독자 현장 상주</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 전:작업순서 및 그 순서마다 작업 방법을 정하고 작업을 지휘할 것, 보호구 및 기구, 공구 점검, 정비할 것</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 중:관계 작업자 이외 출입 금지, 보호구 착용 상태를 점검할 것</div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      5.&nbsp;
                      <div>작업 안전 보호구 착용</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(지상 작업 시) 안전모, 안전화, 보안경, 방독면(휴대)</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(고소작업 시)해당 보호구 별도 착용</div>
                    </div>
                  </div>
                  <div class="education_content d-flex mb-2">
                    6.&nbsp;
                    <div>기상 이상 시 <strong class="red--text text--lighten-1">작업 중지</strong> 기준(방제센터에서 기상정보 확인)</div>
                  </div>
                </v-card-text>
                
                <table class="type09 text-center ">
                  <thead>
                    <tr class="text_first_font hidden-xs-only">
                      <th scope="cols">강우량<br>(mm/hr)</th>
                      <th scope="cols">강설량<br>(cm/hr)</th>
                      <th scope="cols">순간 최대<br>풍속(m/sec)</th>
                      <th scope="cols" style="min-width:100px;">작업기준</th>
                    </tr>
                      <!-- <th scope="cols" class="" style="max-width:10px">작업기준</th>
                      <th scope="cols" class="" style="max-width:10px">작업기준</th> -->

                    <tr class="text_first_font d-sm-none">
                      <th scope="cols" style="max-width:20px;">강우량<br>(mm/hr)</th>
                      <th scope="cols" style="max-width:20px;">강설량<br>(cm/hr)</th>
                      <th scope="cols">순간 최대<br>풍속(m/sec)</th>
                      <th scope="cols" style="">작업기준</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan='3'>1.0 이상</td>
                      <td rowspan='3'>1.0 이상</td>
                      <td>8 이상 ~ 11 미만</td>
                      <td>외부 용접, 도장 작업 중지</td>
                    </tr>
                    <tr>
                      <td>11 이상 ~ 15 미만</td>
                      <td>적재, 건립 작업 중지</td>
                    </tr>
                    <tr>
                      <td>15 이상</td>
                      <td>모든 고소 작업 중지</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="6" sd="12">
                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">크레인 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_1.png" class="flow_picture_type1"/>
                  </div>
                </div>

                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">지게차 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_2.png" class="flow_picture_type1"/>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="19" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="29">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 소화 기구 사용법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">소화기 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">                       
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">옥내 소화전 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">         
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">1</div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">2</div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">3</div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-40px;margin-bottom:10px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-57px; height:0px; padding:20px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-77px; height:0px; padding:20px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-37px; height:0px; padding:20px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="19" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="20">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전- 중량물 운반시 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">금지표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_01.png" style="height:120px; border-radius: 10px;"/></div>출입 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_02.png" style="height:120px; border-radius: 10px;"/></div>보행 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_03.png" style="height:120px; border-radius: 10px;"/></div>차량 통행금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_04.png" style="height:120px; border-radius: 10px;"/></div>사용금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_05.png" style="height:120px; border-radius: 10px;"/></div>탑승 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_06.png" style="height:120px; border-radius: 10px;"/></div>금연
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_07.png" style="height:120px; border-radius: 10px;"/></div>화기 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_08.png" style="height:120px; border-radius: 10px;"/></div>물체 이동금지
                </div>
              </div>
            </v-card-text>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">경고표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:120px; border-radius: 10px;"/></div>인화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:120px; border-radius: 10px;"/></div>산화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_03.png" style="height:120px; border-radius: 10px;"/></div>폭발성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:120px; border-radius: 10px;"/></div>급성 독물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:120px; border-radius: 10px;"/></div>부식성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_06.png" style="height:120px; border-radius: 10px;"/></div>방사성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_07.png" style="height:120px; border-radius: 10px;"/></div>고압전기
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_08.png" style="height:120px; border-radius: 10px;"/></div>위험장소
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="19" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업구역 설정</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 작업용 조명</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 탁상용 드릴</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 : 제7조(채광 및 조명), 제8조(조도), 제301조(전기기계기구 등의 충전부 방호), 제302조(전기기계기구의 접지), 제303조 (전기 기계기구의 적정설치 등), 제311조(폭발위험장소에서사용하는 전기기계기구의 선정 등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 줄줄이 전등: 통로 또는 작업장의 조도확보 목적으로 설치하는 전등으로 단일 케이블에 전등이 3개 이상 연속되어 설치된 것<br>
                    2. 투광등: 메탈램프 투광등: 발광효율 높으나 램프 파손시 봉입가스 분출로 인한 파편비산, 찔림, 베임, 램프발열로 인한 화상, 감전사고 발생위험 높음
                  </span>
                </v-card-text>

                <!-- 이미지와 텍스트가 나란히 배치 -->
                <div class="pledge_content">
                  <v-row class="mt-2 ml-2 mb-2 text_first_font">
                    <v-col cols="12" md="6" sm="12">
                      <div class="d-flex" style="margin-left: 50%;">   
                        
                        <!-- 이미지 부분 -->
                        <div class="d-flex">
                          <div class="ma-3 text-center font-weight-bold" style="color: red;">
                            <div class="iron_center_contents">
                              <img src="../assets/SKMJ_light3.jpg" style="max-width: 300px; height: auto; border-radius: 10px;" />
                            </div>철재 전구보호망 사용금지
                          </div>
                          <div class="ma-3 text-center font-weight-bold" style="color: red;">
                            <div class="iron_center_contents">
                              <img src="../assets/SKMJ_light4.jpg" style="max-width: 300px; height: auto; border-radius: 10px;" />
                            </div>메탈 투광기 이동식 작업 등 용도 금지
                          </div>
                          <div class="ma-3 text-center font-weight-bold blue--text">
                            <div class="iron_center_contents">
                              <img src="../assets/SKMJ_light5.jpg" style="max-width: 300px; height: auto; border-radius: 10px;" />
                            </div>LED 작업 등 이동식 작업 등 용도 가능
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2 ml-2 mb-2 text_first_font">
                    <v-col cols="12" md="6" sm="12">
                      <div class="d-flex">   
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <span style="display: block;"><strong>설치 기준</strong><br>
                            1. 수리, 교체 작업시 전원 차단<br>
                            2. 활선상태에서 조명 이동, 설치 작업금지<br>
                            3. 전선 연결부 습기, 수분침투방지 조치(수축튜브 등)<br>
                            4. 적절한 규격의 케이블 선정(램프용량, 램프수량, 케이블 길이)<br>
                          </span>
                        </v-card-text>
                      </div>                    
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <div class="d-flex">   
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <v-col cols="12" md="9">
                            <table class="type09 text-center text_first_font">
                            <!-- <table class="type09 text-center subtitle-1 font-weight-bold"> -->
                              <thead>
                                <tr>
                                  <th scope="cols">작업구분</th>
                                  <th scope="cols">기준</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>초정밀 작업</td>
                                  <td>750lux 이상</td>
                                </tr>
                                <tr>
                                  <td>정밀 작업</td>
                                  <td>300lux 이상</td>
                                </tr>
                                <tr>
                                  <td>보통 작업</td>
                                  <td>150lux 이상</td>
                                </tr>
                                <tr>
                                  <td>그 밖의 작업</td>
                                  <td>75lux 이상</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-card-text>
                      </div>                    
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="19" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="18">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 작업 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="6" sd="12">
                <v-card-text class="lineHeight2 grey--text text--darken-1">
                  <div class="education_content d-flex mb-2">
                    1.&nbsp;
                    <div>안전 작업 <strong class="red--text text--lighten-1">허가 승인</strong> 절차 준수(JSA 포함)</div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      2.&nbsp;
                      <div>허가 승인 검수 준수</div>
                    </div>
                    <div class="red--text ml-6 text_first_font">[전기릴선, 용접기, 그라인더, 절단기, 사다리 등]</div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      3.&nbsp;
                      <div>작업 반경 內 <strong class="red--text text--lighten-1">방호조치</strong> 철저</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>교통통제 요원, 신호수, 작업지휘자 배치</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업구획(펜스, 라바콘 설치), 공사 안전 표지판 설치 및 안전 작업허가서 게시</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>장비 이동 전용 안전 받침대 사용, 크레인 전용 받침목, 차량 고임목 설치</div>
                    </div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      4.&nbsp;
                      <div>작업 주관부서 관리감독자 현장 상주</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 전:작업순서 및 그 순서마다 작업 방법을 정하고 작업을 지휘할 것, 보호구 및 기구, 공구 점검, 정비할 것</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 중:관계 작업자 이외 출입 금지, 보호구 착용 상태를 점검할 것</div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      5.&nbsp;
                      <div>작업 안전 보호구 착용</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(지상 작업 시) 안전모, 안전화, 보안경, 방독면(휴대)</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(고소작업 시)해당 보호구 별도 착용</div>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sd="12">
                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">크레인 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_1.png" class="flow_picture_type1"/>
                  </div>
                </div>

                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">지게차 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_2.png" class="flow_picture_type1"/>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="19" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="19">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 운반 시 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 인력 운반 시 재해 발생 형태</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>염좌 : 중량물을 무리하게 또는 갑작스럽게 들어 올리거나 운반 시 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>협착 : 중량물을 들어 올리거나 내릴 때 손 또는 발이 취급 중량물과 지면 또는 건축물 등에 끼어 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>낙하 : 중량물을 들어 올리거나 운반하다가 힘에 겨워 중량물을 떨어뜨려 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>충돌 : 물건을 운반하는 중에 다른 사람과 부딪혀서 발생</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">운반 재해예방의 기본원칙</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>작업공정을 개선하여 운반의 필요성이 없도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반작업을 줄인다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반회수(빈도) 및 거리를 최소화, 최단거리화한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>중량물의 경우 2~3인이 운반하도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반 보조 기구 및 기계를 이용한다.</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 운반 시 올바른 자세 및 방법</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move01.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">1</div>무게 중심을 확인한다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move02.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">2</div>가까이 선다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move03.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">3</div>쪼그려 앉는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move04.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">4</div>안정되게 잡는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move05.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">5</div>다리를 이용해 들어 올린다.
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="30">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 환자 발생</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">환자 발생 시</strong><br>
                    <div class="text_first_font mb-2 mt-2 ml-4">
                      <div class="d-flex mb-2">
                        1.&nbsp;
                        <div>침착하게 상황을 알리고 신고한다.</div>
                      </div>
                      <div class="d-flex mb-2">
                        2.&nbsp;
                        <div>
                          환자의 상태를 확인하고 안정에 힘쓴다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>호흡 유무, 맥박 상태, 출혈 여부 등</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        3.&nbsp;
                        <div>
                          구호대 또는 구급차 요원에게 인계한다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>사고 현장 출입 통제 & 현장보존</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        4.&nbsp;
                        <div>
                          의료기관으로 긴급 후송한다.<br>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        5.&nbsp;
                        <div>
                          사고 상황을 보고한다. (육하원칙)<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>유선(즉시), 서면(24Hr이내)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>                 
                </v-col>
                <v-col cols="12" md="7" sm="12">
                  
                  <div class="iron_center_contents flex-wrap d-flex" style="width:inherit; max-height:520px;">
                    <img src="../assets/ambulance.jpg" style="max-height:180px;height:80%;"/>
                    <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                      <img src="../assets/SKTC_E.svg" style="height:300px"/>
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId =='SKMG14'" class="iron_center_contents ml-4 mt-5 text_first_font">
                      <img src="../assets/SKMG14.svg" style="height:300px"/>
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId =='SKMP'" class="iron_center_contents ml-4 mt-5 text_first_font">
                      <img src="../assets/SKMP.svg" style="height:300px"/>
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId =='SKMJ'" class="iron_center_contents ml-4 mt-5 text_first_font">
                      <img src="../assets/SKMJ.svg" style="height:300px"/>
                    </div>
                    <!-- <img src="../assets/fire_center_logo.png" style="height:300px;"/> -->
                    <!-- <div class=" text-center">
                      <img src="../assets/ambulance.jpg" style="height:220px"/>
                      <img src="../assets/fire_center_logo.png" style="height:300px;"/>
                    </div> -->
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="21">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전- 안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">지시표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"/></div>보안경 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:120px; border-radius: 10px;"/></div>방독마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:120px; border-radius: 10px;"/></div>방진 마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:120px; border-radius: 10px;"/></div>보안면 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"/></div>안전모 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:120px; border-radius: 10px;"/></div>귀마개 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"/></div>안전화 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"/></div>안전 장갑 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:120px; border-radius: 10px;"/></div>안전복 착용
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안내표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_01.png" style="height:120px; border-radius: 10px;"/></div>녹십자
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_02.png" style="height:120px; border-radius: 10px;"/></div>응급구호
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:120px; border-radius: 10px;"/></div>들것
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:120px; border-radius: 10px;"/></div>세안 장치
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_05.png" style="height:120px; border-radius: 10px;"/></div>비상구
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업구역 설정</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업용 조명</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 탁상용 드릴</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제80조, 산업안전보건법시행규칙제98조(방호조치), 산업안전보건기준에관한규칙제87조(원동기. 회전축등의위험방지), 제95조(장갑의사용금지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 가동 전에 드릴이 올바르게 고정되어 있는지 확인<br>
                    2. 면장갑 착용금지 (가죽제장갑착용) / 감김재해예방<br>
                    3. 칩 비산대비 눈을 보호할 수 있는 보안경착용<br>
                    4. 드릴이 회전중에는 칩을 입으로 불거나 손으로 털지 않을 것(전용브러쉬사용)<br>
                    5. 드릴을 회전시킨 후 테이블을 고정시키지 않을 것<br>
                    6. 공작물은 드릴바이스에 고정하여 작업할 것<br>
                    7. 탁상용 드릴 외함 접지 후 사용할 것<br>
                    8. 벨트커버 잠금상태 확인(내부에드릴등보관금지)<br>
                    9. 작업중단 시 전원스위치를 끄고 드릴이 정지하였는지 확인할 것<br>
                    10. 작업종료 시 작업장 주변 정리 정돈 실시<br>
                  </span>
                </v-card-text>

                <!-- 이미지와 텍스트가 나란히 배치 -->
                <v-row class="mt-2 ml-2 mb-2 text_first_font">
                  <v-col cols="12" md="6" sm="12">
                    <div class="d-flex">   
                      <div class="ma-3 text-center font-weight-black ">
                        <div class="iron_center_contents mt-4">
                          <img src="../assets/SKMJ_drill1.jpg" style="height:280px; border-radius: 10px;" />
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <img src="../assets/SKMJ_drill2.jpg" style="height:300px; border-radius: 10px;" /><br>
                        드릴 바이스 고정 후 사용<br>공작물을 손으로 잡고 작업하지 않도록 드릴 바이스 설치 후 사용
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="19">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 운반 시 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 인력 운반 시 재해 발생 형태</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>염좌 : 중량물을 무리하게 또는 갑작스럽게 들어 올리거나 운반 시 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>협착 : 중량물을 들어 올리거나 내릴 때 손 또는 발이 취급 중량물과 지면 또는 건축물 등에 끼어 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>낙하 : 중량물을 들어 올리거나 운반하다가 힘에 겨워 중량물을 떨어뜨려 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>충돌 : 물건을 운반하는 중에 다른 사람과 부딪혀서 발생</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">운반 재해예방의 기본원칙</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>작업공정을 개선하여 운반의 필요성이 없도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반작업을 줄인다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반회수(빈도) 및 거리를 최소화, 최단거리화한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>중량물의 경우 2~3인이 운반하도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반 보조 기구 및 기계를 이용한다.</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 운반 시 올바른 자세 및 방법</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move01.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">1</div>무게 중심을 확인한다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move02.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">2</div>가까이 선다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move03.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">3</div>쪼그려 앉는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move04.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">4</div>안정되게 잡는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move05.png" style="height:160px; border-radius: 10px;"/></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">5</div>다리를 이용해 들어 올린다.
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="20">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">금지표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_01.png" style="height:120px; border-radius: 10px;"/></div>출입 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_02.png" style="height:120px; border-radius: 10px;"/></div>보행 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_03.png" style="height:120px; border-radius: 10px;"/></div>차량 통행금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_04.png" style="height:120px; border-radius: 10px;"/></div>사용금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_05.png" style="height:120px; border-radius: 10px;"/></div>탑승 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_06.png" style="height:120px; border-radius: 10px;"/></div>금연
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_07.png" style="height:120px; border-radius: 10px;"/></div>화기 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_08.png" style="height:120px; border-radius: 10px;"/></div>물체 이동금지
                </div>
              </div>
            </v-card-text>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">경고표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:120px; border-radius: 10px;"/></div>인화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:120px; border-radius: 10px;"/></div>산화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_03.png" style="height:120px; border-radius: 10px;"/></div>폭발성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:120px; border-radius: 10px;"/></div>급성 독물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:120px; border-radius: 10px;"/></div>부식성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_06.png" style="height:120px; border-radius: 10px;"/></div>방사성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_07.png" style="height:120px; border-radius: 10px;"/></div>고압전기
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_08.png" style="height:120px; border-radius: 10px;"/></div>위험장소
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 비상시 대피 방법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <div class="pledge_content">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
                <div class="d-flex">
                  -&nbsp;
                  <div>비상 방송 / 싸이렌 / 화재 / Gas Leak 등의 상황 전파 시 사업장 내 관리자의 지시에 따라 지정된 장소로 대피한다.</div>
                </div>
              </v-card-text> 
              
              
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <strong class="deep-orange--text font-weight-black">[집결장소]</strong><br>
                <div class="d-flex">
                  -&nbsp;
                  <div>주차장 서편 펜스 앞쪽</div>
                </div>
              </v-card-text>


              <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                <!-- 왼쪽 텍스트 영역 -->
                <div style="flex: 1;" >
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">[집결장소 행동요령]</strong><br>
                    <div class="d-flex" style="color: black">
                      1.&nbsp;
                      <div>대피 인원 파악 <br>Count evaluated people</div>
                    </div>
                    <div class="d-flex" style="color: black">
                      2.&nbsp;
                      <div>현장지휘소에 대피인원 및 환자발생 이상 유무 보고 <br>Report to command post of situation <br>& emergency patients</div>
                    </div>
                    <div class="d-flex" style="color: black">
                      3.&nbsp;
                      <div>현장지휘소 통제에 따라 행동 <br>Follow command post's orders</div>
                    </div>
                  </v-card-text>
                  <div class="box_3 education_content pa-2 ml-3" style="font-size: 20px; font-weight: bold; color: LightGoldenRodYellow;">
                    비상전화 044-902-0253
                  </div>
                </div>
                
                <!-- 오른쪽 이미지 영역 -->
                <v-col cols="12" md="4" sd="6">
                  <div style="flex: 1; text-align: right; margin-top: -100px; margin-right: 20px;">
                    <img src="../assets/SKTC_map.svg" style="width: 100%; max-width: 858px; border-radius: 20px;" />
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
              <v-card-text class="text_first_font lineHeight2">
                <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
                <v-row class="ma-0 mb-2">
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
                </v-row>
                ※ 공구 검수 장소 : 해당 현장
              </v-card-text>
              <div class="text-center font-weight-black ml-12" style="margin-top: 5%;">
                <div class="iron_center_contents">
                  <img src="../assets/SKMG14_sticker1.jpg" style="height:200px; border-radius: 10px;"/>
                  <img src="../assets/SKMG14_sticker2.jpg" style="height:200px; border-radius: 10px;"/>
                </div>
              </div>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1 ">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제42조제4항 (추락의 방지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <span class="blue--text">1. 접이식 A형 사다리 외 사용금지</span><br>
                    <span class="blue--text" style="text-decoration: underline;">2. 안전모 착용, 2인 1조 작업, 안전대 결속, 아웃트리거 설치, 최상부 2단 사용 금지</span><br>
                    <span class="red--text text--lighten-1">3. 평탄·견고하고 미끄럼이 없는 바닥에 설치, 경작업*, 고소작업대·비계 등 설치가 어려운 협소한 장소에서 사용</span><br>
                    <div class="ml-5">
                      * 경작업 : 손 또는 팔을 가볍게 사용하는 작업으로써 전구교체 작업, 기·통신 작업, 평탄한 곳의 조경작업 등<br>
                      * 제외 작업 : 사다리 위 화기 작업, 중량물 취급작업, 각종 공구 사용작업 (경량수공구 제외(1Kg 미만), 	케이블 포설 작업 등<br>
                    </div>
                    4. 경작업을 제외하는 모든 작업의 경우 A형 사다리를 사용 할수 없음.<br>
                    <span class="red--text text--lighten-1" style="text-decoration: underline;">5. 사다리 사용작업이 필요한 경우 사전 협의 필요</span>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_ladder1.png" style="max-width: 70%; height: auto; border-radius: 10px;"/></div>
                        ※ 사다리 작업간 3.5m 이상 작업, 경작업 이외 작업시에는 고소작업대 또는 이동식 틀비계, 작업발판형 사다리 사용
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="20">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">금지표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_01.png" style="height:120px; border-radius: 10px;"/></div>출입 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_02.png" style="height:120px; border-radius: 10px;"/></div>보행 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_03.png" style="height:120px; border-radius: 10px;"/></div>차량 통행금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_04.png" style="height:120px; border-radius: 10px;"/></div>사용금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_05.png" style="height:120px; border-radius: 10px;"/></div>탑승 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_06.png" style="height:120px; border-radius: 10px;"/></div>금연
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_07.png" style="height:120px; border-radius: 10px;"/></div>화기 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_08.png" style="height:120px; border-radius: 10px;"/></div>물체 이동금지
                </div>
              </div>
            </v-card-text>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">경고표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:120px; border-radius: 10px;"/></div>인화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:120px; border-radius: 10px;"/></div>산화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_03.png" style="height:120px; border-radius: 10px;"/></div>폭발성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:120px; border-radius: 10px;"/></div>급성 독물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:120px; border-radius: 10px;"/></div>부식성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_06.png" style="height:120px; border-radius: 10px;"/></div>방사성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_07.png" style="height:120px; border-radius: 10px;"/></div>고압전기
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_08.png" style="height:120px; border-radius: 10px;"/></div>위험장소
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="21">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">지시표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"/></div>보안경 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:120px; border-radius: 10px;"/></div>방독마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:120px; border-radius: 10px;"/></div>방진 마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:120px; border-radius: 10px;"/></div>보안면 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"/></div>안전모 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:120px; border-radius: 10px;"/></div>귀마개 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"/></div>안전화 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"/></div>안전 장갑 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:120px; border-radius: 10px;"/></div>안전복 착용
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안내표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_01.png" style="height:120px; border-radius: 10px;"/></div>녹십자
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_02.png" style="height:120px; border-radius: 10px;"/></div>응급구호
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:120px; border-radius: 10px;"/></div>들것
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:120px; border-radius: 10px;"/></div>세안 장치
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_05.png" style="height:120px; border-radius: 10px;"/></div>비상구
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 중지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>

            <v-card-text class="education_content lineHeight2 text-center">
              <v-divider class="mb-2"></v-divider>
              <div class="iron_center_contents" ><img src="../assets/SKTC_stop.jpg" style="height:50%; width: 50%;"/></div>
            </v-card-text>
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="23">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">사다리</strong>
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_01.jpg" style="height:180px; border-radius: 10px;"/></div>
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                  <!-- <table class="type09 text-center subtitle-1 font-weight-bold"> -->
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>바닥 고정장치 <br>(미끄럼 방지 장치)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>플라스틱 또는 고무 재질의 보호 Cap 설치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외형상 보호용 Cap의 손상이 없을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>사다리 고정장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>A자, L자 전개 후 고정장치 체결 시 유동이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외관상 휘어짐 등의 변형이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>Push Type의 경우 누른 부위와 고정 부위가 일치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>아웃트리거(Outtrigger)가 설치되어 있을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>발판</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 폭 : 30cm 이상이 될 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 끝에는 미끄럼 방지 조치가 되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판의 휘어짐이나 변형이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_02.png" style="height:180px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>자동 전격 방지 장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>
                              자동 전격 방지 장치가 부착(내장)되어 있을 것<br>
                              (산업안전공단 형식 승인 外)
                            </div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>케이블 커넥터</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접단지 부위의 접속은 커넥터 또는 절연 Tape로 마감되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>케이블 피복은 노출되지 않을 것(케이블 손상이 없을 것)</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>용접홀더</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 홀더의 재질은 비전도성일 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접봉의 탈착 또는 제거가 쉬울 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>접지장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지용 클럼프가 설치되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>클럼프의 외관상 변형이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>기타</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 작업 보호 장비 : 헬멧, 핸드 쉴드, 장갑, 부착포 등 차폐막을 구비할 것</div>
                          </div>
                        </td>                          
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
              <v-card-text class="text_first_font lineHeight2">
                <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
                <v-row class="ma-0 mb-2">
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                  <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
                </v-row>
                ※ 공구 검수 장소 : 해당 현장
              </v-card-text>
              <div class="text-center font-weight-black ml-12" style="margin-top: 5%;">
                <div class="iron_center_contents">
                  <img src="../assets/SKMG14_sticker1.jpg" style="height:200px; border-radius: 10px;"/>
                  <img src="../assets/SKMG14_sticker2.jpg" style="height:200px; border-radius: 10px;"/>
                </div>
              </div>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제24조 (사다리식 통로 등의 구조)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 경작업 이외의 사다리 작업이 필요한 경우 작업 발판형 사다리 사용 필요.(산업안전보건공단 인증품 사용)<br>
                    <span class="red--text text--lighten-1" style="text-decoration: underline;">2. 사용 전 작업, 운전부서, SHE Part 협의 필요</span><br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_ladder2.jpg" style="max-width: 70%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="21">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">지시표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"/></div>보안경 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:120px; border-radius: 10px;"/></div>방독마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:120px; border-radius: 10px;"/></div>방진 마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:120px; border-radius: 10px;"/></div>보안면 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"/></div>안전모 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:120px; border-radius: 10px;"/></div>귀마개 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"/></div>안전화 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"/></div>안전 장갑 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:120px; border-radius: 10px;"/></div>안전복 착용
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안내표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_01.png" style="height:120px; border-radius: 10px;"/></div>녹십자
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_02.png" style="height:120px; border-radius: 10px;"/></div>응급구호
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:120px; border-radius: 10px;"/></div>들것
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:120px; border-radius: 10px;"/></div>세안 장치
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_05.png" style="height:120px; border-radius: 10px;"/></div>비상구
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        

        <v-stepper-content step="22" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="text_first_font lineHeight2">
              <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
              <v-row class="ma-0 mb-2">
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
              </v-row>
              ※ 공구 검수 장소 : 해당 현장
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업중지 절차</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        1</strong><br><span style="color: black;">사고 위험 발견</span><br><span style="color: black;">작업 중지 요청</span>
                      </div>
                      <div class="ml-3">
                        "사고 위험이 있으니 작업을 중지해 주시기 바랍니다."<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex" style="margin: -60px 65px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        2</strong><br><span style="color: black;">작업 중지</span>
                      </div>
                      <div class="ml-3 mt-3">
                        <span class="font-weight-bold">작업자</span><br>
                        <v-icon>mdi-check</v-icon>작업을 멈추고 안전한 장소로 이동<br>
                        <span class="font-weight-bold">작업감독자/관리감독자</span><br>
                        <v-icon>mdi-check</v-icon>작업을 중지하지 않은 인원의 작업을 중지시키고 안전한 장소로 이동 시킴<br>
                        <v-icon>mdi-check</v-icon>"사고 위험 우려가 있어 작업중지 통보를 받았으니 현장확인을 요청합니다."<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex" style="margin: -60px 65px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        3</strong><br><span style="color: black;">위험요인 제거</span><br><span style="color: black;">&작업재개</span>
                      </div>
                      <div class="ml-3 mt-3">
                        <span class="font-weight-bold">작업감독자/관리감독자</span><br>
                        <v-icon>mdi-check</v-icon>위험요인의 제거, 구호조치(필요시), 추가 피해 방지 조치<br>
                        <span class="font-weight-bold">SKTC 관리감독자(해당작업) & SHE</span><br>
                        <v-icon>mdi-check</v-icon>위험요인 제거 및 추가 피해 방지 조치, 추가 위험요인 등 확인<br>
                        <v-icon>mdi-check</v-icon>모든 위험요인 제거 후 작업재개 요청<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex" style="margin: -60px 65px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        4</strong><br><span style="color: black;">기록관리</span>
                      </div>
                      <div class="ml-3">
                        <span class="font-weight-bold">SKTC SHE팀</span><br>
                        <v-icon>mdi-check</v-icon>통합SHE시스템 기록 관리<br>
                      </div>
                    </div>
                  </div>
                </v-card-text> 
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="24">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">가스용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_03.jpg" style="height:180px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>Main V/V</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용기 개방 Main V/V가 설치되어 있을 것(보호용 CAP 포함)</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>밸브 핸들의 이탈 및 파손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>압력계</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>압력계의 변형이 없을 것 / 정상 작동 여부는 현장 점검 시 진행</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>액화 방지기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>액화 방지기는 부착되어 있을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>각 호스</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>호스의 변형 및 훼손이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>도치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>토치 배관 內 막힘 현상 等 이물질이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 공구</strong>        
              <v-row class="mt-n2">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents" style="width:inherit; height: 200px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_04.jpg" style="height:120px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>전선(피복 상태)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>전선 피복의 훼손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>콘센트 Type</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지 가능한 3P Type의 접지형일 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>차단기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>누전 차단기가 있을 것</div>
                          </div>
                        </td>                          
                      </tr>                        
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <!-- <strong class="deep-orange--text font-weight-black" style="z-index:10;!important">전기 그라인더 등(회전 기계)</strong> -->
              <div class="deep-orange--text font-weight-black mb-4" style="float:flex">전기 그라인더 등(회전 기계)</div>
              <div class="d-flex flex-wrap iron_center_contents">
                <img src="../assets/safe_tool_07.jpg" style="height:130px; border-radius: 10px;"/>
                <img src="../assets/safe_tool_06.jpg" style="height:130px; border-radius: 10px;"/>
              </div>
              
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제38조(안전조치) 산업안전보건기준에관한규칙 제9조(작업 발판등), 제13조(난간대 설치기준), 제32조(보호구의 지급등), 제44조(안전대 부착설비등), 제67조(말비계)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 견고한 구조로 심한 손상, 부식등이없는 제품을 사용, 발판의 간격은 일정하게하고 40cm이상으로 사용<br>
                    2. 수직재 기울기를 75도 이하로 하고 보강재가 설치되어 있을 것, 말비계 사용시 평탄한 바닥에서 사용<br>
                    3. 말비계 사용은 의무안전인증기준에 적합한 제품을 사용<br>
                    4. 발판 양 끝 단 부에는 작업제한경고장치를 부착해야함<br>
                    5. 벌어짐 방지 장치 설치 여부 확인<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>높이 1.0m 이내 (안전모, 안전벨트 착용)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents mt-10"><img src="../assets/SKMJ_ladder3.png" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>높이 2m 이내(안전모, 안전벨트 착용, 아웃트리거 난간대 설치)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_ladder4.png" style="max-width: 40%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="text_first_font lineHeight2">
              <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
              <v-row class="ma-0 mb-2">
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
              </v-row>
              ※ 공구 검수 장소 : 해당 현장
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="23">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">사다리</strong>
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_01.jpg" style="height:180px; border-radius: 10px;"/></div>
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                  <!-- <table class="type09 text-center subtitle-1 font-weight-bold"> -->
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>바닥 고정장치 <br>(미끄럼 방지 장치)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>플라스틱 또는 고무 재질의 보호 Cap 설치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외형상 보호용 Cap의 손상이 없을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>사다리 고정장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>A자, L자 전개 후 고정장치 체결 시 유동이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외관상 휘어짐 등의 변형이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>Push Type의 경우 누른 부위와 고정 부위가 일치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>아웃트리거(Outtrigger)가 설치되어 있을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>발판</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 폭 : 30cm 이상이 될 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 끝에는 미끄럼 방지 조치가 되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판의 휘어짐이나 변형이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_02.png" style="height:180px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>자동 전격 방지 장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>
                              자동 전격 방지 장치가 부착(내장)되어 있을 것<br>
                              (산업안전공단 형식 승인 外)
                            </div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>케이블 커넥터</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접단지 부위의 접속은 커넥터 또는 절연 Tape로 마감되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>케이블 피복은 노출되지 않을 것(케이블 손상이 없을 것)</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>용접홀더</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 홀더의 재질은 비전도성일 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접봉의 탈착 또는 제거가 쉬울 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>접지장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지용 클럼프가 설치되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>클럼프의 외관상 변형이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>기타</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 작업 보호 장비 : 헬멧, 핸드 쉴드, 장갑, 부착포 등 차폐막을 구비할 것</div>
                          </div>
                        </td>                          
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">환경 안전 보건 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>              
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <strong class="deep-orange--text font-weight-black">1. SHE 방침</strong><br>
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 구축</strong><br>
                  SHE 중심 경영을 통해 구성원, 지역사회, 고객사, 협력사 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장 구축을 지속적으로 추진한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 기업 문화 추구</strong><br>
                  친환경적 설계, 자원의 효율적 사용 및 최적의 오염방지시설 도입으로 오염물질의 배출을 최소화하고 유해화학물질의 체계적인 관리와 투명한 정보공개를 통해 사업장과 지역사회의 환경을 보호한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법 경영을 통한 신뢰 확보</strong><br>
                  안전/보건/환경 관련 법규 및 이해관계자의 요구사항을 철저히 준수하고, 최고 수준의 SHE 경영체계를 구축하여 투명하게 공개함으로써 이해관계자의의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  전 구성원은 SHE 가치 향상을 경영의 핵심과제로 인식하고, 참여와 협의를 통해 SHE경영체계를 공고히 한다.
                </div>
              </div>
            </v-card>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="25">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 중점 관리 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong></div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시</div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong></div>
              </div>
              <div class="d-flex">
                4.&nbsp;
                <div>작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저</div>
              </div>
              <div class="d-flex">
                5.&nbsp;
                <div>사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong></div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개</div>
              </div>
              <!-- 1. 안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong><br>
              2. 작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시<br>
              3. 작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong><br>
              4. 작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저<br>
              5. 사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)<br>
              6. 지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong><br>
              7. 현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개 -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제68조 (이동식 틀비계) KOSHA GUIDE C-28-2018(이동식비계 설치안전지침)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 높이는 최대2단까지 설치 하도록 제한한다.<br>
                    2. 적재하중 (250kg이하) / 3인 이상 탑승하여 작업하지 않도록한다.<br>
                    3. 작업발판 위 안전난간을 딛고 작업하거나 받침대/사다리 사용하여 작업을 금지한다.<br>
                    4. 근로자가 탑승한 상태에서 이동식비계를 움직이지 않도록 한다.<br>
                    5. 수직재/수평재 재료의 변형,부식,용접부 균열등이 없어야 하고 항상 수평 / 수직을 유지할 것<br>
                    6. 해치발판 해치는 손가락 협착방지 로프/아티론 보온재 보호 할 것<br>
                    7. 틀 비계 이음부는 쉽게 탈락 되지 않도록 결합/보강 해야 함<br>
                    8. 보조틀(아웃트리거)는 45도 방향으로 지면과 견고하게 고정한다.(연약지반일 경우 두께 45mm이상 깔판,깔목 사용)<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>높이 1.0m 이내 (안전모, 안전벨트 착용)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_ladder5.jpg" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>높이 2m 이내(안전모, 안전벨트 착용, 아웃트리거 난간대 설치)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents" style="margin-top:-30px;"><img src="../assets/SKMJ_ladder6.jpg" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>
                          ※ 높이는 나비의 3배 유지
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="23">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">사다리</strong>
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_01.jpg" style="height:180px; border-radius: 10px;"/></div>
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                  <!-- <table class="type09 text-center subtitle-1 font-weight-bold"> -->
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>바닥 고정장치 <br>(미끄럼 방지 장치)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>플라스틱 또는 고무 재질의 보호 Cap 설치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외형상 보호용 Cap의 손상이 없을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>사다리 고정장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>A자, L자 전개 후 고정장치 체결 시 유동이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외관상 휘어짐 등의 변형이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>Push Type의 경우 누른 부위와 고정 부위가 일치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>아웃트리거(Outtrigger)가 설치되어 있을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>발판</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 폭 : 30cm 이상이 될 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 끝에는 미끄럼 방지 조치가 되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판의 휘어짐이나 변형이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_02.png" style="height:180px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>자동 전격 방지 장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>
                              자동 전격 방지 장치가 부착(내장)되어 있을 것<br>
                              (산업안전공단 형식 승인 外)
                            </div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>케이블 커넥터</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접단지 부위의 접속은 커넥터 또는 절연 Tape로 마감되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>케이블 피복은 노출되지 않을 것(케이블 손상이 없을 것)</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>용접홀더</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 홀더의 재질은 비전도성일 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접봉의 탈착 또는 제거가 쉬울 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>접지장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지용 클럼프가 설치되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>클럼프의 외관상 변형이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>기타</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 작업 보호 장비 : 헬멧, 핸드 쉴드, 장갑, 부착포 등 차폐막을 구비할 것</div>
                          </div>
                        </td>                          
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="24">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">가스용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_03.jpg" style="height:180px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>Main V/V</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용기 개방 Main V/V가 설치되어 있을 것(보호용 CAP 포함)</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>밸브 핸들의 이탈 및 파손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>압력계</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>압력계의 변형이 없을 것 / 정상 작동 여부는 현장 점검 시 진행</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>액화 방지기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>액화 방지기는 부착되어 있을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>각 호스</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>호스의 변형 및 훼손이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>도치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>토치 배관 內 막힘 현상 等 이물질이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 공구</strong>        
              <v-row class="mt-n2">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents" style="width:inherit; height: 200px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_04.jpg" style="height:120px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>전선(피복 상태)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>전선 피복의 훼손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>콘센트 Type</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지 가능한 3P Type의 접지형일 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>차단기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>누전 차단기가 있을 것</div>
                          </div>
                        </td>                          
                      </tr>                        
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <!-- <strong class="deep-orange--text font-weight-black" style="z-index:10;!important">전기 그라인더 등(회전 기계)</strong> -->
              <div class="deep-orange--text font-weight-black mb-4" style="float:flex">전기 그라인더 등(회전 기계)</div>
              <div class="d-flex flex-wrap iron_center_contents">
                <img src="../assets/safe_tool_07.jpg" style="height:130px; border-radius: 10px;"/>
                <img src="../assets/safe_tool_06.jpg" style="height:130px; border-radius: 10px;"/>
              </div>
              
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="25" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전제보(익명) </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <div class="iron_center_contents"><img src="../assets/SKTC_QR.png" style="height:50%; width: 50%;"/></div>
            <!-- <v-col cols="12" md="8" sd="12">
              <v-card-text class="education_content lineHeight2 pa-0">
                <strong class="deep-orange--text"></strong>
              </v-card-text>
              <table class="type11 text-center">
                <thead>
                  <tr class="text_first_font">
                    <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table_line_right" rowspan="4">물성</td>
                    <td class="table_line_right">인화점</td>
                    <td class="table_line_right">자료 없음</td>
                    <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                    <td rowspan="4" colspan="3">
                      <div class="d-flex">
                        <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">자연발화점</td>
                    <td class="table_line_right">자료 없음</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">비중</td>
                    <td class="table_line_right">0.997</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">끓는점</td>
                    <td class="table_line_right">19.5℃</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                    <td class="table_line_right">화학물질명</td>
                    <td class="table_line_right">관용명 및 이명</td>
                    <td class="table_line_right">CAS. No</td>
                    <td class="table_line_right">함유량</td>
                    <td>노출기준</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">HF</td>
                    <td class="table_line_right">Hydrogen Fluoride</td>
                    <td class="table_line_right">7664-39-3</td>
                    <td class="table_line_right">100%</td>
                    <td>TWA 0.5 ppm</td>
                  </tr>
                </tbody>
                <thead>
                  <tr class="text_first_font">
                    <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                    <th scope="cols" colspan='3'>NFPA CODE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table_line_right" rowspan="4">보호구</td>
                    <td class="table_line_right">개인보호구</td>
                    <td class="table_line_right" colspan="2">방독 마스크</td>
                    <td rowspan="4" colspan="3">
                      <div class="d-flex align-center justify-center">
                        <img src="../assets/graph-text_1.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                        <img src="../assets/graph_1.svg" style="height:120px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">눈 보호</td>
                    <td class="table_line_right" colspan="2">보안경, 고글</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">손 보호</td>
                    <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">신체 보호</td>
                    <td class="table_line_right" colspan="2">내화학성 보호의</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" colspan="2">공학적 관리</td>
                    <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                    <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                    <td class="table_line_right">취급</td>
                    <td class="table_line_right" colspan="2">물과 접촉을 피할 것</td>
                    <td rowspan="2" colspan="3" class="img_area">
                      <div class="d-flex flex-wrap">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">저장</td>
                    <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" md="4" sd="12">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                  <div>피부에&nbsp;<span class="red--text text--lighten-1">심한 화상</span>을 일으킴.</div>
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 심한 손상을 일으킴
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입하면 치명적임
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부, 눈, 점막, 폐 등에 손상을 일으킴
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>약한 상처는 바로 나타나지 않지만 수 시간 후에 통증이 생길 수 있음
                </div>
              </v-card-text>
            </v-col> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="25" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="26">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">공통</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>모든 작업은 관리감독자가 현장에 배치되어야 하며, 사전 작업허가를 득하여야 한다.</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>관리감독자는 작업절차 교육, 작업자는 작업절차 준수</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>작업과 관계없는 밸브, 버튼 조작 금지</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>이상 상황 발견 시 관리감독자에게 즉시 보고</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>협착, 전도, 추락, 감전, Chemical/가스 누출 및 접촉에 유의할 것</div>
                </div>
                <div class="d-flex mb-2">
                  6.&nbsp;
                  <div>장비 및 배관 등의 설비에 유해를 가하지 않도록 할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">밀폐공간 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>비상 대기자는 현장에 상주할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>그 외 밀폐공간 안전 작업기준을 준수할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">화기 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가연성 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>불티 비산 대비책을 수립하여 시행하고 화기 감시자를 배치할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>주변 가연물 제거 및 소화기를 비치 후 작업할 것</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="25" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제171조 ~ 제178조, 제186조 KOSHA GUIDE C-74-2015 건설공사의 고소작업대 안전보건작업지침<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 작업대는 규정인원탑승 및 정격하중을 준수할 것<br>
                    2. 주행, 상승, 하강, 과부하 시 경보 및 경광등이 작동할 것/ 누유, 손상, 마모 등이 없을 것<br>
                    3. 작업장소는 지반침하등 장비의 전도위험이 없을 것<br>
                    4. 작업구역에 바리케이드 설치 및 신호수를배치하며이동통로의 요철상태, 장애물 유무 점검 및 제거할 것<br>
                    5. 최대풍속 8m/s 이상 등 기상악화시 작업을 중지할 것<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>높이 1.0m 이내 (안전모, 안전벨트 착용)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_work1.jpg" style="max-width: 75%; height: auto; border-radius: 10px;"/></div>
                          - 안전인증서 및 보험증명서, 제원표 부착<br>
                          - 과상승 방지봉 4개소 60cm 이상 상승 설치<br>
                          - 비상하강장치, 주행차단장치 작동상태<br>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong>높이 2m 이내(안전모, 안전벨트 착용, 아웃트리거 난간대 설치)</strong>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_work2.png" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>
                          - 비상정지장치, 주행차단장치 등 작동상태<br>
                          - 풋 스위치 덮개설치 및 고정상태<br>
                          - 작업대 확장 스토퍼 이상유무<br>
                          - 케이지 내 정리정돈, 청결상태 
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="25" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="24">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">가스용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_03.jpg" style="height:180px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>Main V/V</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용기 개방 Main V/V가 설치되어 있을 것(보호용 CAP 포함)</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>밸브 핸들의 이탈 및 파손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>압력계</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>압력계의 변형이 없을 것 / 정상 작동 여부는 현장 점검 시 진행</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>액화 방지기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>액화 방지기는 부착되어 있을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>각 호스</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>호스의 변형 및 훼손이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>도치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>토치 배관 內 막힘 현상 等 이물질이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 공구</strong>        
              <v-row class="mt-n2">
                <v-col cols="12" md="3" >
                  <div class="iron_center_contents" style="width:inherit; height: 200px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_04.jpg" style="height:120px; border-radius: 10px;"/></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>전선(피복 상태)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>전선 피복의 훼손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>콘센트 Type</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지 가능한 3P Type의 접지형일 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>차단기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>누전 차단기가 있을 것</div>
                          </div>
                        </td>                          
                      </tr>                        
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <!-- <strong class="deep-orange--text font-weight-black" style="z-index:10;!important">전기 그라인더 등(회전 기계)</strong> -->
              <div class="deep-orange--text font-weight-black mb-4" style="float:flex">전기 그라인더 등(회전 기계)</div>
              <div class="d-flex flex-wrap iron_center_contents">
                <img src="../assets/safe_tool_07.jpg" style="height:130px; border-radius: 10px;"/>
                <img src="../assets/safe_tool_06.jpg" style="height:130px; border-radius: 10px;"/>
              </div>
              
            </v-card-text>
          </v-card>
        </v-stepper-content>

        
        <v-stepper-content step="25" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="25">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 중점 관리 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong></div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시</div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong></div>
              </div>
              <div class="d-flex">
                4.&nbsp;
                <div>작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저</div>
              </div>
              <div class="d-flex">
                5.&nbsp;
                <div>사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong></div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개</div>
              </div>
              <!-- 1. 안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong><br>
              2. 작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시<br>
              3. 작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong><br>
              4. 작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저<br>
              5. 사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)<br>
              6. 지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong><br>
              7. 현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개 -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="26" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="27">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">고소 작업(사다리 포함)</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반입되는 사다리는 모두 Outtrigger가 설치된 것을 사용</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>사다리 작업 시 2인 1조로 작업을 실시</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동식 고소 작업대는 반입 전 검사를 득하고 반입(SHE팀)</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>고소 작업 시 반드시 안전벨트 및 걸이대를 설치 후 작업</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비계(고정식, 이동식) 사용 시 설치 후 환경안전팀의 승인을 득한 다음 사용</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">정전 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>전기작업은 담당자만 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>시건장치를 하고, 작업 전 해당 설비 및 Panel 전원 차단</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>해당 Panel 시건조치 및 꼬리표 부착</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>              
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">굴착 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>
                    허가서 발행 후 굴착 전 굴착 예정지 지하 매설물 확인<br>
                    <div class="d-flex mt-1">
                      -&nbsp;
                      <div>SHE팀, 공무원, 총무팀 담당자 확인 서명 후 작업 진행</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>
                    굴착 장소 변은 통제를 실시하고 개구부 관리를 철저히 할 것
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="26" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제171조 ~ 제178조, 제186조 KOSHA GUIDE C-74-2015 건설공사의 고소작업대 안전보건작업지침<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row >
                      <!-- 이미지 -->
                      <v-col cols="12" md="6" sm="12">
                        <img src="../assets/SKMJ_lift1.jpg" class="ml-12" style="width: 70%; height: 85%; border-radius: 10px;">
                      </v-col>

                      <!-- 텍스트 -->
                      <v-col cols="12" md="6" sm="12" class="text-body-1 mt-3"> 
                        <strong style="color: green;">[작업대 확인]</strong><br>
                         ·  안전난간 임의해제 금지<br>
                         ·  안전난간 밟고 작업 금지<br>
                         ·  4면감지 과상승방지장치<br>
                         ·  정격하중 초과 금지<br>
                         ·  주변 배관 등 지장물 확인<br>
                         ·  안전대 착용 및 걸기<br>

                        <div class="mt-5">
                          <strong style="color: green;">[안전장치]</strong><br>
                           ·  유압 호스ㆍ실린더 이상 유무<br>
                           ·  과부하방지장치(압력스위치)<br>
                           ·  4면감지 과상승방지장치<br>
                           ·  낙하방지밸브(안전밸브)<br>
                           ·  비상안전장치(하강밸브)<br>
                           ·  경사표시장치 위치, 안전블록 등<br>
                        </div>
                      </v-col>
                    </v-row>

                  </span>
                </v-card-text>
                <v-row class="mt-0 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <v-card class="mt-0 mt-md-0 flex-column fill-height">
                      <v-container>
                        <v-row justify="center" >
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift2.jpg" height="120" contain /> 
                            <div>과상승방지장치(안전바)</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift3.jpg" height="120" contain /> 
                            <div>과부하방지장치(압력스위치)</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift4.jpg" height="120" contain /> 
                            <div>낙하방지장치(안전밸브)</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift5.jpg" height="120" contain /> 
                            <div>주행속도 제한장치</div>
                          </v-col>
                        </v-row>

                        <v-row justify="center">
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift6.jpg" height="120" contain /> 
                            <div>경사표시장치(수평감지센서)</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift7.jpg" height="120" contain /> 
                            <div>비상정지 및 레버잠금장치</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift8.jpg" height="120" contain /> 
                            <div>비상안전장치(하강밸브)</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center">
                            <v-img src="../assets/SKMJ_lift9.jpg" height="120" contain /> 
                            <div>안전블럭</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="26" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="25">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 중점 관리 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong></div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시</div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong></div>
              </div>
              <div class="d-flex">
                4.&nbsp;
                <div>작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저</div>
              </div>
              <div class="d-flex">
                5.&nbsp;
                <div>사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong></div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개</div>
              </div>
              <!-- 1. 안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong><br>
              2. 작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시<br>
              3. 작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong><br>
              4. 작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저<br>
              5. 사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)<br>
              6. 지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong><br>
              7. 현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개 -->
            </v-card-text>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="26" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="26">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">공통</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>모든 작업은 관리감독자가 현장에 배치되어야 하며, 사전 작업허가를 득하여야 한다.</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>관리감독자는 작업절차 교육, 작업자는 작업절차 준수</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>작업과 관계없는 밸브, 버튼 조작 금지</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>이상 상황 발견 시 관리감독자에게 즉시 보고</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>협착, 전도, 추락, 감전, Chemical/가스 누출 및 접촉에 유의할 것</div>
                </div>
                <div class="d-flex mb-2">
                  6.&nbsp;
                  <div>장비 및 배관 등의 설비에 유해를 가하지 않도록 할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">밀폐공간 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>비상 대기자는 현장에 상주할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>그 외 밀폐공간 안전 작업기준을 준수할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">화기 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가연성 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>불티 비산 대비책을 수립하여 시행하고 화기 감시자를 배치할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>주변 가연물 제거 및 소화기를 비치 후 작업할 것</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="27" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="28">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화재 발생 시</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><strong class="red--text font-weight-black">"불이야"</strong> 큰 소리로 알리고 신고한다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>
                      주변의 소화기로 초기소화를 시도한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>소화기 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>
                      초기소화 실패 시에는 <strong class="red--text font-weight-black">신속히 대피한다.</strong><br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>비상구 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>
                      낮은 자세로 코와 입을 막고 대피한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>엘리베이터 사용 금지 / 계단 이용</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>화재 상황을 보고한다. (육하원칙)</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/SKMG14.svg" style="height:300px"/></div>
              </v-col>
            </v-row>

            <div class="ma-4">
              <div class="box_2 education_content pa-5">
                비상 대피는 빠른 대피보다 <strong class="white--text font-weight-black ml-4 mr-4">"정확한"</strong> 대피가 우선입니다.
              </div>
            </div>

            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>화재를 발견하면 '불이야'하고 큰 소리로 외쳐서 다른 사람에게 알립시다.</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>
                  방재센터로 신고합니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>"본관 2층 휴게실에서 화재가 발생했습니다."</div>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>
                  화재경보 비상벨을 누릅니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>평소 주위에 있는 소화기, 옥내소화전 사용법을 숙지했다가 초기에 진화합니다.</div>
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="27" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제171조 ~ 제178조, 제186조 KOSHA GUIDE C-74-2015 건설공사의 고소작업대 안전보건작업지침<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 안전인증서 등 차량계 하역운반기계 작업계획서 제출<br>
                    2. 작업장소는 지반침하등 장비의 전도위험이 없을 것<br>
                    3. 작업대는규정인원탑승 및 정격하중을 준수할 것, 작업대 내 추가 작업대 사용 작업 금지<br>
                    4. 비상정지장치 등 안전장치의 임의해제후 사용 금지, 장치에 누유, 손상, 마모 등이 없을 것<br>
                    5. 운전자격: 기중기운전기능사/2020년 이전 보통, 대형 운전면허로 운전자 → 교육이수후 수료시험합격한 자<br>
                    6. 최대풍속 8m/s 이상 등 기상악화시 작업을 중지할 것<br>
                    7. 아웃트리거는 4개소 전체 최대확장을 할 것<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_sky1.png" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>
                          - 아웃트리거 최대확장 및 타이어 지면 이격<br>
                          <span style="color: red;">- 아웃트리거받침대: 지압판 면적보다 넓게, 일체형 사용(일체형이 아닐 시 깔판 추가)</span><br>
                          - 작업구역 바리케이드 설치 및 유도자 배치
                        </div> 
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_sky2.png" style="max-width: 60%; height: auto; border-radius: 10px;"/></div>
                          - 작업대 4면 안전난간 규정 설치<br>
                          - 이동 시 생명줄은 붐대 안전고리에 체결(PP rope 16mm, 슬링바 25mm 이상)<br>
                          - 작업 시 작업대 이외의 곳에 설치(구조물)
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="27" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="26">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">공통</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>모든 작업은 관리감독자가 현장에 배치되어야 하며, 사전 작업허가를 득하여야 한다.</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>관리감독자는 작업절차 교육, 작업자는 작업절차 준수</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>작업과 관계없는 밸브, 버튼 조작 금지</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>이상 상황 발견 시 관리감독자에게 즉시 보고</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>협착, 전도, 추락, 감전, Chemical/가스 누출 및 접촉에 유의할 것</div>
                </div>
                <div class="d-flex mb-2">
                  6.&nbsp;
                  <div>장비 및 배관 등의 설비에 유해를 가하지 않도록 할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">밀폐공간 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 작업허가서 발행 후 밀폐작업프로그램 준수하여 작업할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>비상 대기자는 현장에 상주할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>그 외 밀폐공간 안전 작업기준을 준수할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">화기 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 작업허가서(화기) 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가연성 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>불티 비산 대비책을 수립하여 시행하고 화기 감시자를 배치할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>주변 가연물 제거 및 소화기를 비치 후 작업할 것</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="27" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="27">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">고소 작업(사다리 포함)</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반입되는 사다리는 모두 Outtrigger가 설치된 것을 사용</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>사다리 작업 시 2인 1조로 작업을 실시</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동식 고소 작업대는 반입 전 검사를 득하고 반입(안전관리팀)</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>고소 작업 시 반드시 안전벨트 및 걸이대를 설치 후 작업</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비계(고정식, 이동식) 사용 시 설치 후 환경안전팀의 승인을 득한 다음 사용</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">정전 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>전기작업은 담당자만 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>시건장치를 하고, 작업 전 해당 설비 및 Panel 전원 차단</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>해당 Panel 시건조치 및 꼬리표 부착</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>              
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">굴착 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>
                    허가서 발행 후 굴착 전 굴착 예정지 지하 매설물 확인<br>
                    <div class="d-flex mt-1">
                      -&nbsp;
                      <div>환경안전팀, 공무원, 총무팀 담당자 확인 서명 후 작업 진행</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>
                    굴착 장소 변은 통제를 실시하고 개구부 관리를 철저히 할 것
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="28" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="29">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 소화 기구 사용법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">소화기 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">                       
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">옥내 소화전 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">         
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">1</div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">2</div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">3</div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-40px;margin-bottom:10px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-57px; height:0px; padding:20px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-77px; height:0px; padding:20px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-37px; height:0px; padding:20px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="28" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제171조 ~ 제178조, 제186조 KOSHA GUIDE C-74-2015 건설공사의 고소작업대 안전보건작업지침<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row >
                      <!-- 이미지 -->
                      <v-col cols="12" md="6" sm="12">
                        <img src="../assets/SKMJ_lift10.jpg" class="ml-12" style="width: 60%; height: 70%; border-radius: 10px;">
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-4" style="margin-left:-2%;">
                        <img src="../assets/SKMJ_sky3.png" style="width: 50%; height: 80%; border-radius: 10px;" /> 
                      </v-col>
                    </v-row>
                    <v-row>
                      
                    </v-row>

                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="3" sm="12" class="text-body-1 mt-3"> 
                    <strong style="color: green;">[안전장치]</strong><br>
                     ·  붐ㆍ선회부 크랙ㆍ균열 유무<br>
                     ·  유압 호스ㆍ실린더 이상 유무<br>
                     ·  붐인출(와이어로프 등) 작동상태<br>
                     ·  하중감지와 위치 제어장치 작동상태<br>

                    <div class="mt-5">
                      <strong style="color: green;">[작업대 확인]</strong><br>
                         ·  안전난간 임의해제 금지<br>
                         ·  안전난간 밟고 작업 금지<br>
                         ·  4면감지 과상승방지장치<br>
                         ·  정격하중 초과 금지<br>
                         ·  주변 배관 등 지장물 확인<br>
                         ·  안전대 착용 및 걸기<br>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <v-row justify="center" >
                      <v-col cols="12" md="12" class="text-center">
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_sky5.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" class="text-body-1 mt-3"> 
                    <strong style="color: green;">[고소작업 안전]</strong><br>
                     ·  붐 길이 표시장치 등<br>
                     ·  작업반경 내 출입금지<br>
                     ·  명판(허용풍속 등) 부착<br>
                     ·  제조사가 정한 작업설명서 (허용 작업반경표 등)<br>
                     ·  중량물 인양 사용금지<br>

                    <div class="mt-12">
                      <strong style="color: green;">[전도방지]</strong><br>
                       ·  지반 침하 방지<br>
                       ·  아웃트리거 근접센서<br>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="28" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="27">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">고소 작업(사다리 포함)</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반입되는 사다리는 모두 Outtrigger가 설치된 것을 사용</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>사다리 작업 시 2인 1조로 작업을 실시</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동식 고소 작업대는 반입 전 검사를 득하고 반입(SHE팀)</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>고소 작업 시 반드시 안전벨트 및 걸이대를 설치 후 작업</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비계(고정식, 이동식) 사용 시 설치 후 환경안전팀의 승인을 득한 다음 사용</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">정전 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>전기작업은 담당자만 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>시건장치를 하고, 작업 전 해당 설비 및 Panel 전원 차단</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>해당 Panel 시건조치 및 꼬리표 부착</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>              
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">굴착 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>
                    허가서 발행 후 굴착 전 굴착 예정지 지하 매설물 확인<br>
                    <div class="d-flex mt-1">
                      -&nbsp;
                      <div>SHE팀, 공무원, 주관부서 담당자 확인 서명 후 작업 진행</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>
                    굴착 장소 주변은 통제를 실시하고 개구부 관리를 철저히 할 것
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="28" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="28">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화재 발생 시</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><strong class="red--text font-weight-black">"불이야"</strong> 큰 소리로 알리고 신고한다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>
                      주변의 소화기로 초기소화를 시도한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>소화기 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>
                      초기소화 실패 시에는 <strong class="red--text font-weight-black">신속히 대피한다.</strong><br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>비상구 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>
                      낮은 자세로 코와 입을 막고 대피한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>엘리베이터 사용 금지 / 계단 이용</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>화재 상황을 보고한다. (육하원칙)</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/SKMP.svg" style="height:300px"/></div>
              </v-col>
            </v-row>

            <div class="ma-4">
              <div class="box_2 education_content pa-5">
                비상 대피는 빠른 대피보다 <strong class="white--text font-weight-black ml-4 mr-4">"정확한"</strong> 대피가 우선입니다.
              </div>
            </div>

            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>화재를 발견하면 '불이야'하고 큰 소리로 외쳐서 다른 사람에게 알립시다.</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>
                  방재센터로 신고합니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>"본관 2층 휴게실에서 화재가 발생했습니다."</div>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>
                  화재경보 비상벨을 누릅니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>평소 주위에 있는 소화기, 옥내소화전 사용법을 숙지했다가 초기에 진화합니다.</div>
                  </div>
                </div>
              </div>
            </v-card-text>              
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="29" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="30">
              <v-card-title class="education_title">
                <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 환자 발생</div>                
                <v-spacer></v-spacer>
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              </v-card-title>
              <v-divider class="mb-2"></v-divider>
              <v-card-text class="pa-0">
                <v-row class="ma-0">
                  <v-col cols="12" md="5" sm="12" class="pa-0">
                    <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                      <strong class="deep-orange--text font-weight-black">환자 발생 시</strong><br>
                      <div class="text_first_font mb-2 mt-2 ml-4">
                        <div class="d-flex mb-2">
                          1.&nbsp;
                          <div>침착하게 상황을 알리고 신고한다.</div>
                        </div>
                        <div class="d-flex mb-2">
                          2.&nbsp;
                          <div>
                            환자의 상태를 확인하고 안정에 힘쓴다.<br>
                            <div class="d-flex mt-1">
                              ※&nbsp;
                              <div>호흡 유무, 맥박 상태, 출혈 여부 등</div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex mb-2">
                          3.&nbsp;
                          <div>
                            구호대 또는 구급차 요원에게 인계한다.<br>
                            <div class="d-flex mt-1">
                              ※&nbsp;
                              <div>사고 현장 출입 통제 & 현장보존</div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex mb-2">
                          4.&nbsp;
                          <div>
                            의료기관으로 긴급 후송한다.<br>
                          </div>
                        </div>
                        <div class="d-flex mb-2">
                          5.&nbsp;
                          <div>
                            사고 상황을 보고한다. (육하원칙)<br>
                            <div class="d-flex mt-1">
                              ※&nbsp;
                              <div>유선(즉시), 서면(24Hr이내)</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>                 
                  </v-col>
                  <v-col cols="12" md="7" sm="12">
                    
                    <div class="iron_center_contents flex-wrap d-flex" style="width:inherit; max-height:520px;">
                      <img src="../assets/ambulance.jpg" style="max-height:180px;height:80%;"/>
                      <img v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" src="../assets/SKMG14.svg" style="height:300px;"/>
                      <img v-else src="../assets/fire_center_logo.png" style="height:300px;"/>
                      <!-- <div class=" text-center">
                        <img src="../assets/ambulance.jpg" style="height:220px"/>
                        <img src="../assets/fire_center_logo.png" style="height:300px;"/>
                      </div> -->
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-stepper-content>

        <v-stepper-content step="29" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제44조(안전대의 부착설비등) 제42조(추락의방지), 제169조(꼬임이 끊어진 섬유로프등의 사용금지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. Rope 규격 및 설치간격<br>
                    <div class="ml-4">
                      <span class="blue--text">1) PP rope: 16mm 이상</span><br>
                    </div>
                    <div class="ml-8">
                      - 구조물 이용 시 5m 이내마다 고정점<br>
                      - 빔난간대설치시 간격: 2m 이내<br>
                    </div>
                    <div class="ml-4">
                      2. Wire rope: <span  class="blue--text">9~10mm, 10m 이내마다 고정점</span><br>
                    </div>
                    <div class="ml-8">
                      - 생명줄은쳐짐이 없도록 설치하고, 끝부분은풀리지 않도록 2회 이상 감아 묶을것<br>
                      - 로프의끝은 30cm 이상유지및 말단부는Tapping 처리를 할 것<br>
                      - 생명줄은 1구간에 1명만 벨트를 걸어 사용 (와이어로프는 3명이하)<br>
                      - 1개월이상이용 시 안전대 부착설비 Tag 부착하여 관리(비계시설 사용승인표 사용)<br>
                    </div>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="6" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_etc1.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>

                  <v-col cols="12" md="6" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_etc2.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="29" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="28">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화재 발생 시</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><strong class="red--text font-weight-black">"불이야"</strong> 큰 소리로 알리고 신고한다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>
                      주변의 소화기로 초기소화를 시도한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>소화기 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>
                      초기소화 실패 시에는 <strong class="red--text font-weight-black">신속히 대피한다.</strong><br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>비상구 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>
                      낮은 자세로 코와 입을 막고 대피한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>엘리베이터 사용 금지 / 계단 이용</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>화재 상황을 보고한다. (육하원칙)</div>
                  </div>
                </v-card-text>
              </v-col>
              <!-- <v-col cols="12" md="6" sm="12">
                <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/SKMP.svg" style="height:300px"/></div>
              </v-col> -->
            </v-row>

            <div class="ma-4">
              <div class="box_2 education_content pa-5">
                비상 대피는 빠른 대피보다 <strong class="white--text font-weight-black ml-4 mr-4">"정확한"</strong> 대피가 우선입니다.
              </div>
            </div>

            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>화재를 발견하면 '불이야'하고 큰 소리로 외쳐서 다른 사람에게 알립시다.</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>
                  SHE팀로 신고합니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>"본관 2층 휴게실에서 화재가 발생했습니다."</div>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>
                  화재경보 비상벨을 누릅니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>평소 주위에 있는 소화기, 옥내소화전 사용법을 숙지했다가 초기에 진화합니다.</div>
                  </div>
                </div>
              </div>
            </v-card-text>              
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="29" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="29">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 소화 기구 사용법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">소화기 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">                       
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">옥내 소화전 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">         
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">1</div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">2</div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">3</div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-40px;margin-bottom:10px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-57px; height:0px; padding:20px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-77px; height:0px; padding:20px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-37px; height:0px; padding:20px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="30" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 비상시 대피 방법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
              <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>비상 방송 / 싸이렌 / 화재 / Gas Leak 등의 상황 전파 시 사업장 내 관리자의 지시에 따라 지정된 장소로 대피한다.</div>
                    </div>
                    <div class="d-flex">
                      1.&nbsp;
                      <div>피해범위 산정</div>
                    </div>
                    <div class="d-flex ml-6">
                      1)&nbsp;
                      <div>화재폭발(Silane, SIH4): 163m</div>
                    </div>
                    <div class="d-flex ml-6">
                      2)&nbsp;
                      <div>누출확산(Silane, SIH4): 488m</div>
                    </div>
                    <div class="d-flex">
                      2.&nbsp;
                      <div>집결지 선정</div>
                    </div>
                    <div class="d-flex ml-6">
                      1)&nbsp;
                      <div>1차 집결지(사내): 행복동 앞 공터</div>
                    </div>
                    <div class="d-flex ml-6">
                      2)&nbsp;
                      <div>2차 집결지(사외): 청리산업단지 입구 다리 밑</div>
                    </div>
                  </v-card-text>                 
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12" md="7" sm="12">
                  <div class="iron_center_contents d-flex" style="flex-wrap: nowrap; justify-content: space-between; max-height: 520px;">
                    <img src="../assets/SKMG14_map1.jpg" style="width:100%; max-width:450px; border-radius: 20px;" />
                    <img src="../assets/SKMG14_map2.jpg" style="width:100%; max-width:450px; border-radius: 20px;" />
                    <img src="../assets/SKMG14_map3.jpg" style="width:100%; max-width:450px; border-radius: 20px;" />
                  </div>
                </v-col>
              </v-row>
              <!-- <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>비상 방송 / 싸이렌 / 화재 / Gas Leak 등의 상황 전파 시 사업장 내 관리자의 지시에 따라 지정된 장소로 대피한다.</div>
                    </div>
                    <div class="d-flex">
                      1.&nbsp;
                      <div>피해범위 산정</div>
                    </div>
                    <div class="d-flex ml-6">
                      1)&nbsp;
                      <div>화재폭발(Silane, SIH4): 163m</div>
                    </div>
                    <div class="d-flex ml-6">
                      2)&nbsp;
                      <div>누출확산(Silane, SIH4): 488m</div>
                    </div>
                    <div class="d-flex">
                      2.&nbsp;
                      <div>집결지 선정</div>
                    </div>
                    <div class="d-flex ml-6">
                      1)&nbsp;
                      <div>1차 집결지(사내): 행복동 앞 공터</div>
                    </div>
                    <div class="d-flex ml-6">
                      2)&nbsp;
                      <div>2차 집결지(사외): 청리산업단지 입구 다리 밑</div>
                    </div>
                  </v-card-text>    
                </v-col>
                <div class="iron_center_contents d-flex" style="flex-wrap: nowrap; max-height:520px;">
                  <img src="../assets/SKMG14_map1.jpg" style="width:100%; max-width:500px; border-radius: 20px;" />
                  <img src="../assets/SKMG14_map2.jpg" style="width:100%; max-width:500px; border-radius: 20px;" />
                  <img src="../assets/SKMG14_map3.jpg" style="width:100%; max-width:500px; border-radius: 20px;" />
                </div>
              </v-row>   -->
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="30" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">고소 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 사다리</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 말비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 틀비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(LIFT)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고소작업대(SKY)</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 그외 안전사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙 제44조(안전대의 부착설비등) 제42조(추락의 방지), 제169조(꼬임이 끊어진 섬유로프등의 사용금지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row >
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <strong>- 안전대부착설비(생명줄) 선정 기준</strong><br>
                        1. PP rope : 16mm 이상(개인 휴대용은 엔드레스(Endles) 타입 권고)<br>
                        2. Wire rope : 9~10mm 이상<br>
                        3. 슬링벨트 : 25mm 이상<br>
                        4. 추락방지대(코브라/로리프)<br>
                        5. 안전벨트용 스크루 클램프 : 0.2T 이상<br>
                        <div class="mt-4"></div>
                        <strong>- 안전대 체결불가 장소</strong><br>
                        1. 40A(1½ inch) 미만 배관<br>
                        2. 유해화학물질 배관 및 보온배관, Tubing line<br>
                        3. 케이블 트레이 및 전선관 등<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <strong>- 안전대부착설비(생명줄) 선정 기준</strong><br>
                        1. PP rope : 16mm 이상(개인 휴대용은 엔드레스(Endles) 타입 권고)<br>
                        2. Wire rope : 9~10mm 이상<br>
                        3. 슬링벨트 : 25mm 이상<br>
                        4. 추락방지대(코브라/로리프)<br>
                        5. 안전벨트용 스크루 클램프 : 0.2T 이상<br>
                        <div class="mt-4"></div>
                        <strong>- 안전대 체결위치 선정 기준</strong><br>
                        1. H-beam 등견고한 구조물<br>
                        2. 40A 이상의 배관(유해화학물질 배관 및 보온배관 체결금지)<br>
                        3. 강관 등의 비계 구조물<br>
                        4. Beam Post 또는 구조물을 활용한 PP rope 및 Wire rope<br>
                           * Beam Post 안전인증 확인 필요<br>
                        5. 인양 러그 포인트<br>
                        6. 구조물을 활용한 추락방지대 및 안전블럭<br>
                        7. H-beam에 고정된 안전벨트 전용 스크루 클램프<br>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <span style="display: block; font-size: 25px;" class="mb-4"><strong>설치 예시</strong><br></span>
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      
                      <v-container>
                        <v-row justify="center" >
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc3.jpg" height="150" contain /> 
                            <div>40A 이상 배관/16mm PP rope</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc4.jpg" height="150" contain /> 
                            <div>Beam Post/16mm PP rope</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc5.jpg" height="150" contain /> 
                            <div>H-beam/16mm PP rope</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc6.jpg" height="150" contain /> 
                            <div>비계 구조물/안전고리 체결</div>
                          </v-col>
                        </v-row>

                        <v-row justify="center">
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc7.jpg" height="150" contain /> 
                            <div>구조물 이용/추락방지대(코브라)</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc8.jpg" height="150" contain /> 
                            <div>빔 포스트/9mm Wire rope</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc9.jpg" height="150" contain /> 
                            <div>비계 구조물/안전고리 체결</div>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_etc10.jpg" height="150" contain /> 
                            <div>구조물 이용/16mm PP rope</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="30" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="29">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 소화 기구 사용법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">소화기 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">                       
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">옥내 소화전 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">         
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">1</div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">2</div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">3</div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="margin-top:-40px;margin-bottom:10px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-57px; height:0px; padding:20px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-77px; height:0px; padding:20px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-37px; height:0px; padding:20px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="30" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="30">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 환자 발생</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">환자 발생 시</strong><br>
                    <div class="text_first_font mb-2 mt-2 ml-4">
                      <div class="d-flex mb-2">
                        1.&nbsp;
                        <div>침착하게 상황을 알리고 신고한다.</div>
                      </div>
                      <div class="d-flex mb-2">
                        2.&nbsp;
                        <div>
                          환자의 상태를 확인하고 안정에 힘쓴다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>호흡 유무, 맥박 상태, 출혈 여부 등</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        3.&nbsp;
                        <div>
                          구호대 또는 구급차 요원에게 인계한다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>사고 현장 출입 통제 & 현장보존</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        4.&nbsp;
                        <div>
                          의료기관으로 긴급 후송한다.<br>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        5.&nbsp;
                        <div>
                          사고 상황을 보고한다. (육하원칙)<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>유선(즉시), 서면(24Hr이내)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>                 
                </v-col>
                <v-col cols="12" md="7" sm="12">
                  <div class="iron_center_contents flex-wrap d-flex" style="width:inherit; max-height:520px;">
                    <img src="../assets/ambulance.jpg" style="max-height:180px;height:80%;"/>
                    <img v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" src="../assets/SKMG14.svg" style="height:300px;"/>
                    <!-- <img v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'" src="../assets/SKMP.svg" style="height:300px;"/> -->
                    <img v-else src="../assets/fire_center_logo.png" style="height:300px;"/>
                    <!-- <div class=" text-center">
                      <img src="../assets/ambulance.jpg" style="height:220px"/>
                      <img src="../assets/fire_center_logo.png" style="height:300px;"/>
                    </div> -->
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="31" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 첨단소재로 지속가능한 미래를 만든다는 경영철학을 바탕으로, 경영활동의 모든 단계에서 안전, 보건, 환경의 가치를 최우선으로 추구하며, 구성원 및 이해관계자의 신뢰를 확보하고 지속가능한 SHE 경영을 위하여 다음 사항을 적극 실천한다.
            </v-card-text>              
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 조성</strong><br>
                  SHE 중심 경영을 통해 구성원, 지역사회, 고객 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장 구축을 지속적으로 추진한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  사업장의 모든 구성원은 연구, 개발, 생산, 분석 등의 전 공정에서 유해∙위험요인을 제거하고 개선활동에 적극적으로 참여하여, 효과적인 SHE 관리체계를 구축한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong> 준법경영을 통한 신뢰 확보</strong><br>
                  안전/보건/환경 관련 법규 요구사항 이상을 준수하기 위하여, SHE 운영시스템의 고도화를 통해 성과를 투명하게 공개함으로써 이해관계자의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>친환경 기업 문화 추구</strong><br>
                  친환경적 설계, 자원의 효율적인 사용 및 최적방지시설 도입으로 오염물질의 배출을 최소화하고 유해화학물질의 체계적인 관리를 바탕으로 화학사고를 예방하여 지역사회의 환경을 보호한다.
                </div>
              </div>
            </v-card>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="31" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제241조(화재위험작업시의준수사항), 제241조의2(화재감시자)<br>
                  </span>
                  <span style="display: block;"><strong>안전 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2"   >
                        <strong>- 작업 기준</strong><br>
                        1. 위험물질의 방출 및 처리(용기, 배관)<br>
                        2. 밸브차단표시판 부착(잠금표지, 맹판표지설치)<br>
                        3. 가연성물질에 대한 방호조치및 소화기구비치<br>
                        4. 불꽃. 용접불티등 비산방지조치<br>
                        5. 인화성물질 가연성가스 농도를 측정 “0(Zero)” %LEL<br>
                        6. 밀폐공간에서 작업 수행 시 강제 환기 조치 필요<br>
                        <div class="mt-4"></div>
                        <strong>- 화재감시자 배치기준</strong><br>
                        1. 작업반경 11미터 이내 가연물 있는 장소<br>
                        2. 불꽃에 의해 쉽게 발화 될 우려가 있는 장소<br>
                        3. 금속으로된 칸막이ㆍ벽ㆍ천장ㆍ지붕의 이면 발화될 위험장소<br>
                        <div class="mt-4"></div>
                        <strong>- 화재감시자 업무</strong><br>
                        1. 화재감시자 착용 품목 구비, 가연물 여부의 확인<br>
                        2. 가스검지, 경보장치등 작동여부의 확인<br>
                        3. 화재발생시 근로자의 대피유도<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12"  >
                        <img src="../assets/SKMJ_fire1.jpg" style="width: 300px; height: 200px; border-radius: 10px;">
                        <div class="mt-4"></div>
                        <strong class="blue--text">- 용접 방화포 사용시 주의사항</strong><br>
                        <span  class="blue--text">
                          1. ANSI FM 4950 성능 검증된 제품 사용<br>
                          2. 기름, 도료 등 가연물에 오염이 없을 것<br>
                          3. 방화포 굴곡 부위 균열이 없을 것<br>
                          4. 방화포에 관통 부분이 없을 것<br>
                          5. 반복 사용으로 성능 상실이 없을 것<br>
                        </span>
                      </v-col>
                      <v-col cols="12" md="12" sm="12">
                        <v-card class="mt-md-0 d-flex flex-column fill-height" style="margin-top:70%;">
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                            <div class="ma-4 text-center font-weight-black ">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_fire2.jpg" style="max-width: 100%; max-height: 100%; border-radius: 10px;"/></div>
                            </div> 
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                    <!-- <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center"> -->
                      
                    <!-- </v-row> -->
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="31" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="30">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 환자 발생</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">환자 발생 시</strong><br>
                    <div class="text_first_font mb-2 mt-2 ml-4">
                      <div class="d-flex mb-2">
                        1.&nbsp;
                        <div>침착하게 상황을 알리고 신고한다.</div>
                      </div>
                      <div class="d-flex mb-2">
                        2.&nbsp;
                        <div>
                          환자의 상태를 확인하고 안정에 힘쓴다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>호흡 유무, 맥박 상태, 출혈 여부 등</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        3.&nbsp;
                        <div>
                          구호대 또는 구급차 요원에게 인계한다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>사고 현장 출입 통제 & 현장보존</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        4.&nbsp;
                        <div>
                          의료기관으로 긴급 후송한다.<br>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        5.&nbsp;
                        <div>
                          사고 상황을 보고한다. (육하원칙)<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>유선(즉시), 서면(24Hr이내)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>                 
                </v-col>
                <v-col cols="12" md="7" sm="12">
                  <div class="iron_center_contents flex-wrap d-flex" style="width:inherit; max-height:520px;">
                    <img src="../assets/ambulance.jpg" style="max-height:180px;height:80%;"/>
                    <!-- <img v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" src="../assets/SKMG14.svg" style="height:300px;"/> -->
                    <!-- <img v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'" src="../assets/SKMP.svg" style="height:300px;"/> -->
                    <!-- <img v-else src="../assets/fire_center_logo.png" style="height:300px;"/> -->
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="31" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 비상시 대피 방법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
              <div class="d-flex">
                -&nbsp;
                <div>비상 방송 / 싸이렌 / 화재 / Gas Leak 등의 상황 전파 시 사업장 내 관리자의 지시에 따라 지정된 장소로 대피한다.</div>
              </div>
              <div class="d-flex">
                1.&nbsp;
                <div>피해범위 산정</div>
              </div>
              <div class="d-flex ml-6">
                1)&nbsp;
                <div>화재폭발(Silane, SIH4): 163m</div>
              </div>
              <div class="d-flex ml-6">
                2)&nbsp;
                <div>누출확산(Silane, SIH4): 488m</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>집결지 선정</div>
              </div>
              <div class="d-flex ml-6">
                1)&nbsp;
                <div>1차 집결지(사내): 행복동 앞 공터</div>
              </div>
              <div class="d-flex ml-6">
                2)&nbsp;
                <div>2차 집결지(사외): 청리산업단지 입구 다리 밑</div>
              </div>
            </v-card-text>              
            <!-- <div class="iron_center_contents" style="width:inherit;"><img src="../assets/safe_map.png" style="height:500px; border-radius: 20px;"/></div> -->
            <div class="iron_center_contents" style="width:inherit;">
              <template v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
                <img src="../assets/SKMG14_map1.jpg" style="width:100%;max-width:500px; border-radius: 20px;" />
                <img src="../assets/SKMG14_map2.jpg" style="width:100%;max-width:500px; border-radius: 20px;" />
                <img src="../assets/SKMG14_map3.jpg" style="width:100%;max-width:500px; border-radius: 20px;" />
              </template>
              <!-- SKMP가 아닌 경우 -->
              <template v-else-if="$store.state.CustomInfo.SiteId != 'SKMP'">
                <img src="../assets/safe_map.png" style="width:100%;max-width:858px; border-radius: 20px;" />
              </template>

              <!-- SKMP인 경우: 아무것도 표시 안 함 -->
              <template v-else>
                <!-- 아무것도 없음 -->
              </template>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="32" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
          <v-card class="pl-4 pr-4" flat id="33">
          <!-- <v-card class="mb-12 mt-n4 mx-auto my-12" min-height="520" flat  > -->
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">사고 예방 4대 원칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            
            <v-card :height="ChangableHeight" v-resize="onResize" class="ma-5 education_content lineHeight2" flat>
              <v-img src="@/assets/industry_back.jpg" style="opacity:0.1;border-radius: 20px; box-shadow: 0px 0px 15px 15px #C0C0C0;height:100%"></v-img>
              <div class="safe_4_rules pa-4" id="safe_4_rules_content">
                <div class="d-flex">
                  1.&nbsp;
                  <div>손실 우연의 법칙<br>사고의 결과로서 생긴 재해손실은 우연에 의해 결정된다.</div>
                </div>
                <div class="d-flex">
                  2.&nbsp;
                  <div>원인계기의 법칙<br>재해 발생은 반드시 원인이 있다.<br>즉 사고와 손실과의 관계는 우연적이지만 원인관계는 필연적인 계기가 있다.</div>
                </div>
                <div class="d-flex red--text">
                  3.&nbsp;
                  <div>예방가능의 원칙<br>재해는 원칙적으로 근원적인 원인만 제거하면 예방 가능하다.</div>
                </div>
                <div class="d-flex">
                  4.&nbsp;
                  <div>대책 선정의 원칙(기술, 교육, 규제)</div>
                </div>
                <v-card-text class="education_content lineHeight2 text-center font-weight-black">
                  모든 사고는 <strong class="red--text text--lighten-1">예방</strong>할 수 있다.
                </v-card-text>
              </div>
            </v-card>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="32" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <div class="pledge_content">
            <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
              <v-card-title class="education_title">
                <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
                <v-spacer></v-spacer>
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              </v-card-title>
              <v-divider class="mb-2"></v-divider>

              <v-row>
<v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
                
                <v-col cols="12" md="12" sm="12" class="">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <span style="display: block;" class="education_content lineHeight2 grey--text text--darken-1"><strong>관련 법령</strong><br>
                      <span style="display: block;">
                        산업안전보건기준에 관한 규칙 제241조(화재위험작업시의준수사항), 제241조의2(화재감시자)<br>
                      </span>
                    </span>
                    <span style="display: block;" class="education_content lineHeight2 grey--text text--darken-1"><strong>화재감시자 기준</strong><br>
                      <v-row>
                        <v-col cols="12" md="12" sm="12" class="mt-2 education_content lineHeight2 grey--text text--darken-1 "   >
                          1. 화재감시자 배치 자격 강화 : 교육 2종 이수 必<br>
                          <div class="ml-4">
                            - 건설업 기초안전보건교육 / SK머티리얼즈제이엔씨 화재감시자자체교육이수(필증부여)<br>
                            ※ SK머티리얼즈제이엔씨 화재감시자 교육은 신규근로자 교육 이후 별도 진행 후 서명(주관부서 : SHE Part)<br>
                          </div>
                          2. 화재감시자 구비물품기준 수립<br>
                          <div class="ml-4">
                            - 업체 자체구비가 기본이나, 미 준비 업체에 대해 당일 물품대여(SHE Part)<br>
                          </div>
                          3. 구비물품상세내역<br>
                          <div class="ml-4">
                            - 화재감시자 안전모, 조끼, 완장<br>
                            - 호루라기, 조명기구<br>
                            - 소화기, 방연마스크, 확성기<br>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                        <v-col cols="12" md="12" sm="12">
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                            <div class="ma-4 text-center font-weight-black ">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_fire3.jpg" style="max-width: 70%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </div>
                        </v-col>
                      </v-row>
                    </span>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-stepper-content>

        <v-stepper-content step="32" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 비상시 대피 방법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
              <div class="d-flex">
                -&nbsp;
                <div>비상상황 발생 시, 비상집결지로 신속히 대피</div>
                <img src="../assets/SKMP_map1.png" style="width:100%;max-width:40px; border-radius: 10px;" />
              </div>
              <div class="d-flex">
                &nbsp;&nbsp;
                <div><strong class="red--text font-weight-black">
                  - 산업재해 발생 위험이 있는 급박한 상황의 경우, 작업중지 및  즉시 대피 → 대피 후 회사 담당자/보안실 연락/신고</strong></div>
              </div>
              <div class="d-flex">
                -&nbsp;
                <div>집결장소 행동 요령 :  인원/환자 파악, 비상통제실 통제에 따름</div>
              </div>
              
            </v-card-text>              
            <!-- <div class="iron_center_contents" style="width:inherit;"><img src="../assets/safe_map.png" style="height:500px; border-radius: 20px;"/></div> -->
            <div class="iron_center_contents" style="width:inherit;">
              <template v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
                <img src="../assets/SKMG14_map1.jpg" style="width:100%;max-width:500px; border-radius: 20px;" />
                <img src="../assets/SKMG14_map2.jpg" style="width:100%;max-width:500px; border-radius: 20px;" />
                <img src="../assets/SKMG14_map3.jpg" style="width:100%;max-width:500px; border-radius: 20px;" />
              </template>
              <!-- SKMP가 아닌 경우 -->
              <template v-else-if="$store.state.CustomInfo.SiteId != 'SKMP'">
                <img src="../assets/safe_map.png" style="width:100%;max-width:858px; border-radius: 20px;" />
              </template>

              <!-- SKMP인 경우: 아무것도 표시 안 함 -->
              <template v-else>
                <img src="../assets/SKMP_map.png" style="width:100%;max-width:858px; border-radius: 20px;" />
              </template>
            </div>
          </v-card>
        </v-stepper-content>

        

        <v-stepper-content step="32" class="education_make_scroll pa-0" v-else>
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>              
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 조성</strong><br>
                  SHE 경영체계를 지속적으로 개선하여 구성원, 지역사회, 고객 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장을 함께 만들어간다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 가치 추구</strong><br>
                  친환경적 설계, 자원의 효율적 사용, 화학물질의 철저한 관리를 통해 사업장과 지역사회의 환경을 보호하고, 선제적으로 온실가스를 감축함으로써 전 지구적 기후변화 위기에 적극적으로 대응한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법 경영 및 투명한 정보공개</strong><br>
                  SHE 법규, 사규 및 이해관계자의 요구사항을 준수하고, 투명한 정보공개를 통해 이해관계자의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  모든 구성원은 인간과 환경 보호를 최우선 가치로 인식하고, 보다 안전하고 건강한 사업장을 만들기 위해 적극적으로 동참한다.
                </div>
              </div>
            </v-card>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="33" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제16조(위험물 등의 보관), 제234조(가스 등의 용기) 고압가스 안전관리법 시행규칙 별표8. 고압가스 저장.사용의 시설.기술.검사 기준<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 가스용기운반 시 전용대차이용 - 밸브 캡 필수 체결<br>
                    2. LPG 용기 색상변경확인 - 짙은 회색 ☞ 밝은회색<br>
                    3. 운반대차는 전도되지않도록 고박 조치- 가스용기고박은 체인 사용<br>
                    4. 인화물 격리 및 소화기 비치<br>
                    5. LPG 역화 방지기 필수 설치<br>
                    6. 직사광선노출금지(40도 이하 보관) - 필요 시 차양막 설치<br>
                    7. 가스용기충전 유효기간확인 후 사용<br>
                    8. 가스 누출 탐지기 비치(보글체크) - 작업 전 용기 및 호스 누설 체크<br>
                    9. 해당 가스의 MSDS 비치<br>
                    10. 화염발생과 가스호스는 역방향 설치<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_gas1.jpg" style="max-width: 70%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="33" class="education_make_scroll pa-0" v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원 및 이해관계자의 신뢰를 확보하고 지속 가능한 SHE 경영을 위하여 다음 사항을 적극 실천한다.
            </v-card-text>              
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 구축</strong><br>
                  SHE 중심 경영을 통해 구성원, 지역사회, 고객사, 협력사 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장 구축을 지속적으로 추진한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 기업 문화 추구</strong><br>
                  친환경적 설계, 자원의 효율적사용 및 최적의 오염방지시설 도입으로 오염물질의 배출을 최소화하고 유해화학물질의 체계적인 관리와 투명한 정보공개를 통해 사업장과 지역사회의 환경을 보호한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법경영을 통한 신뢰 확보</strong><br>
                  안전/보건/환경 관련 법규 및 이해관계자의 요구사항을 철저히 준수하고, 최고 수준의 SHE 경영체계를 구축하여 이해관계자의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여/협의</strong><br>
                  모든 구성원은 SHE 가치 향상을 경영의 핵심과제로 인식하고, 참여화 협업을 통해 SHE 경영체계를 공고히 한다.
                </div>
              </div>
            </v-card>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="33" v-else class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4" flat id="33">
          <!-- <v-card class="mb-12 mt-n4 mx-auto my-12" min-height="520" flat  > -->
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">사고 예방 4대 원칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            
            <v-card :height="ChangableHeight" v-resize="onResize" class="ma-5 education_content lineHeight2" flat>
              <v-img src="@/assets/industry_back.jpg" style="opacity:0.1;border-radius: 20px; box-shadow: 0px 0px 15px 15px #C0C0C0;height:100%"></v-img>
              <div class="safe_4_rules pa-4" id="safe_4_rules_content">
                <div class="d-flex">
                  1.&nbsp;
                  <div>손실 우연의 법칙<br>사고의 결과로써 생긴 재해손실은 우연에 의해 결정된다.</div>
                </div>
                <div class="d-flex">
                  2.&nbsp;
                  <div>재해 발생은 반드시 원인이 있다.<br>즉 사고와 손실과의 관계는 우연적이지만 원인관계는 필연적인 계기가 있다.</div>
                </div>
                <div class="d-flex red--text">
                  3.&nbsp;
                  <div>예방가능의 원칙<br>재해 발생 원칙적으로 근원적인 원인만 제거하면 예방 가능하다.</div>
                </div>
                <div class="d-flex">
                  4.&nbsp;
                  <div>대책 선정의 원칙(기술, 교육, 규제)</div>
                </div>
                <v-card-text class="education_content lineHeight2 text-center font-weight-black">
                  모든 사고는 <strong class="red--text text--lighten-1">예방</strong>할 수 있다.
                </v-card-text>
              </div>
            </v-card>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="34" v-if="$store.state.CustomInfo.SiteId == 'SKMP'" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4" flat id="33">
          <!-- <v-card class="mb-12 mt-n4 mx-auto my-12" min-height="520" flat  > -->
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">사고 예방 4대 원칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            
            <v-card :height="ChangableHeight" v-resize="onResize" class="ma-5 education_content lineHeight2" flat>
              <v-img src="@/assets/industry_back.jpg" style="opacity:0.1;border-radius: 20px; box-shadow: 0px 0px 15px 15px #C0C0C0;height:100%"></v-img>
              <div class="safe_4_rules pa-4" id="safe_4_rules_content">
                <div class="d-flex">
                  1.&nbsp;
                  <div>손실 우연의 법칙<br>사고의 결과로써 생긴 재해손실은 우연에 의해 결정된다.</div>
                </div>
                <div class="d-flex">
                  2.&nbsp;
                  <div>재해 발생은 반드시 원인이 있다.<br>즉 사고와 손실과의 관계는 우연적이지만 원인관계는 필연적인 계기가 있다.</div>
                </div>
                <div class="d-flex red--text">
                  3.&nbsp;
                  <div>예방가능의 원칙<br>재해 발생 원칙적으로 근원적인 원인만 제거하면 예방 가능하다.</div>
                </div>
                <div class="d-flex">
                  4.&nbsp;
                  <div>대책 선정의 원칙(기술, 교육, 규제)</div>
                </div>
                <v-card-text class="education_content lineHeight2 text-center font-weight-black">
                  모든 사고는 <strong class="red--text text--lighten-1">예방</strong>할 수 있다.
                </v-card-text>
              </div>
            </v-card>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="34" v-else class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제233조 (가스용접 등의 작업), 제234조 (가스등의 용기) 제2장 제6절 아세틸렌 용접장치 및 가스집합 용접장치, 제306조(교류아크 용접기 등)<br>
                  </span>
                  <span style="display: block;"><strong>작업 기준</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12">
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_y.jpg" style="max-width: 70%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                  <span style="display: block;"><strong>교류 아크용접기 사용 안전수칙</strong><br>
                    1. 교류 아크 용접기는자동정격방지기 설치 및 작동상태 확인<br>
                    2. 케이블 피복 손상유무확인(손상시 절연 또는 신품교체)<br>
                    3. 용접기 외함은 대지 등에 접지 실시<br>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="35" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제16조(위험물 등의 보관), 제234조(가스 등의 용기) 고압가스 안전관리법 시행규칙 별표8. 고압가스 저장.사용의 시설.기술.검사 기준<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 산소와 가연성 가스 및 독성가스혼합 보관 금지(필요시 격벽 설치)<br>
                    2. 가스용기외 다른 자재 (호스 등) 보관 금지<br>
                    3. 가스용기전도 및 충격금지<br>
                    4. 가스용기는 세워서 보관 (전도방지장치 장착) - 체인 또는 자동바 이용하여 고정<br>
                    5. 밸브 캡 장착 보관 (이동 시 포함)<br>
                    6. 가스용기유효기간(충전기한) 확인 후 보관<br>
                    7. 통풍이나 환기가 충분한 구조일 것<br>
                    8. 직사광선노출금지(40도 이하 보관)<br>
                    9. 충전 용기(실병)와 잔가스 용기 (공병) 및 그 밖의 용기를 명확히 구분할 것<br>
                  </span>
                  <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="6" sm="12">
                      <span style="display: block;" class="education_content lineHeight2 grey--text text--darken-1"><strong>가스보관소 부착물 예시</strong><br>
                        <div class="mt-2 education_content lineHeight2 grey--text text--darken-1">
                          1. 관리책임자 표지(정,부 및 연락처 기재)<br>
                          2. 품목 및 수량 기재표지(공병, 실병 등)<br>
                          3. 가스종류별경고표지판(부착형)<br>
                          4. 가스종류별 MSDS 비치(출력물)<br>
                          5. 위험물 저장소 안전수칙 표지판<br>
                          6. 화기엄금 표지판<br>
                          7. 3.3kg이상 분말 소화기 비치<br>
                          8. 시건장치설치(자물쇠 형태)<br>
                        </div>
                      </span>
                    </v-col>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center"> 
                      <v-col cols="12" md="6" sm="12">
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents" style="margin-right:10%;"><img src="../assets/SKMJ_gas2.jpg" style="max-width: 90%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="36" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제122조(연삭숫돌의덮개등), 산업안전보건법 시행령 제77조(자율안전 확인대상 기계등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 전면 보안면(보안경), 가죽제장갑, 용접토시또는 와이어토시, 방진마스크<br>
                    2. 숫돌보호덮개(180°)장착(해체/절개금지)<br>
                    3. 전원연결전 그라인더본체 스위치OFF 상태확인<br>
                    4. 숫돌선택시 그라인더보다 숫돌의 회전수가 높은 것을 사용할 것<br>
                    5. 숫돌교체시: 그라인더전원OFF ☞전원플러그제거☞전용공구사용숫돌교체<br>
                    <span  class="blue--text">6. 그라인더시 운전: 작업시작전 1분, 숫돌교체시 3분이상시 운전<br></span>
                    7. 2중 절연구조확인, 전원코드피복 등 손상여부확인<br>
                    8. 절연저항점검(기준치0.2MΩ이상)<br>
                  </span>
                  <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center"> 
                    <v-col cols="12" md="12" sm="12">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_grinder1.jpg" style="height:250px; border-radius: 10px;"/></div>
                        </div>
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_grinder2.jpg" style="height:250px; border-radius: 10px;"/></div>
                        </div>
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_grinder3.jpg" style="height:250px; border-radius: 10px;"/></div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="37" class="education_make_scroll pa-0" v-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">화기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화기작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스용기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 용접기/용접대차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가스보관소</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 휴대용 그라인더</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 고속절단기</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법 제80조(유해하거나위험한기계.기구에대한방호조치), 산업안전보건법시행규칙 제98조(방호조치), 산업안전보건기준에관한규칙 제122조(연삭숫돌의덮개등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 방호커버 체결상태 확인<br>
                    2. 가공물을 견고하게 고정(고정바이스이용)<br>
                    3. 절단 작업 시 파편이나칩의 비래, 비산방지를 위한 방호덮개설치 상태확인<br>
                    4. 가죽제장갑, 보안면, 팔토시(가죽, 와이어)<br>
                    5. 불티 비산방지커버 및 소화기비치 후 작업<br>
                    6. 작업종료시 작업장 주변정리정돈 실시<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_speed.jpg" style="max-width: 70%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="38" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">전기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 이동식 발전기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업용 전선</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설 분전함</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제 301조(전기 기계.기구 등의 충전부 방호), 제 302조(전기기계 기구의 접지), 제 304조(누전차단기에 의한 감전방지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 보호구 착용 철저(절연보호구/필요시 귀마개 착용)<br>
                    2. 외부인 출입금지조치(구획설정)<br>
                    3. 동력 전달 부 협착 방지(동력전달부 방호덮개설치)<br>
                    4. 이동식 발전기 주위 전도 예방조치<br>
                    5. 배기가스에 의한 질식 예방<br>
                    - 이동식 발전기의배기가스는 옥외로 배출하도록 설치<br>
                    - 옥내에 배기가스을 배출 할 경우 환기팬 및 강제 환기 설비 설치/가동<br>
                    - 질식 재해 위험이 있는 경우 밀폐공간보건작업프로그램에 따라 산소 측정/환기 실시/호흡용 보호구 착용<br>
                  </span>
                  <v-row class="mt-2 ml-0 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="6" sm="12" style="margin-left:-20%;">
                      <div class="flex-wrap d-flex justify-center mt-6 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_M2.png" style="max-width: 90%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" style="margin-left:-10%;">
                      <div class="flex-wrap d-flex justify-center mt-6 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_M1.png" style="max-width: 80%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="39" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">전기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 발전기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 작업용 전선</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설 분전함</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙 제301조(전기기계 기구등의충전부방호), 제302조(전기기계기구의접지), 제303조(전기기계기구의적정설치등), 제313조(배선등의절연피복), 제314조(습윤한장소의이동전선), 제315조(통로바닥에서의전선사용금지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 작업용 이동전선(작업전선, 릴선)공중가공 원칙<br>
                    2. 빗물 등이 유입되지않도록 난연성 재질포장<br>
                    3. 작업용 이동전선은 일일 작업 종료 시 정리하여 보관<br>
                    4. 작업전선최대작업허용범위 20m 미만 - 20m이상: 릴선사용, 릴선 작업허용범위초과: 가설분전반설치<br>
                    5. 손상이 있는 작업용 전선 사용 금지(피복손상, 열화쇼트흔적, 접지극 탈락, 접지선 누락 및 미연결 등)<br>
                    6. 사무용 멀티탭, 문어발식 멀티탭 <span style="color: red;">사용 금지</span><br>
                  </span>
                  <v-row class="mt-2 ml-0 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="12" sm="12" style="margin-left:-20%;">
                      <div class="flex-wrap d-flex justify-center mt-6 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents"><img src="../assets/SKMJ_elec.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="40" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">전기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 발전기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 작업용 전선</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설 분전함</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙 제301조(전기기계`기구등의충전부방호), 제302조(전기기계기구의접지), 제303조(전기기계기구의적정설치등), 제313조(배선등의절연피복), 제314조(습윤한장소의이동전선), 제315조(통로바닥에서의전선사용금지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 가설전선은 반드시 접지극이 있는 3P형 플러그와 콘센트 사용<br>
                    2. 전원 연장선(릴선)을 사용 시 누전차단기가 부착된 릴선 사용<br>
                    3. 가설전선은 거치대를 이용하여 공중으로 띄우거나 바닥으로 포설 시에는 피복이 손상되지 않도록 전선보호대(황.흑색)를 설치하여 차량 등에 의한 손상을 방지<br>
                    4. 도로 횡단 케이블 보호대 설치 시 보행자 통로를 제외한 전체에 케이블 보호대 설치 (한쪽면을 바리 케이드 등으로 차단 시 제외)<br>
                    5. 작업선 가공 시 출입문 등 손상방지를 위한 관통부 보양조치<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_line1.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        
        <v-stepper-content step="41" class="education_make_scroll pa-0" >
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">전기 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 이동식 발전기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 작업용 전선</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설 분전함</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법 제80조(유해하거나 위험한기계. 기구에대한 방호조치) 산업안전보건기준에 관한 규칙제301조(전기기계. 기구등의 충전부방호)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 절연재질로 제작된 가설 분전함 사용<br>
                    2. 충전부 절연덮개설치(단자대포함), 사용용도(부하명) 표기<br>
                    3. 외함 접지 및 분전반 고정(전도방지)<br>
                    4. 시건장치설치(관계자외촉수엄금)<br>
                    5. 절연저항확인(전원OFF 상태, 본체 → Main cable R,S,T 3상연결부)<br>
                    6. 분전반 실명제 표지부착(정/부,연락처,업체), 사용허가증 부착<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_line2.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="42" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제80조(유해하거나 위험한 기계.기구에 대한 방호조치) 산업안전보건법시행규칙제98조(방호조치), 산업안전보건기준에관한규칙제122조(연삭숫돌의 덮개등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 지게차 승차 시 개인보호구 착용, 지게차 안전벨트착용<br>
                    2. 지게차포크를 지면에서 10~30cm 간격 유지하고운행<br>
                    3. 교통에 방해되지않는 평탄한 장소에 주차/정차<br>
                    4. 주차 시 시동키 제거, 포크지면에접촉, 스토퍼설치<br>
                    5. 점검 등 포크하부에서 작업이 필요할 때, 블록설치하는 등 포크의 갑작스런 낙하방지 조치실시<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                      <div class="ma-4 text-center font-weight-black ">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_car1.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="43" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제80조(유해하거나 위험한 기계.기구에 대한 방호조치) 산업안전보건법시행규칙제98조(방호조치), 산업안전보건기준에관한규칙제122조(연삭숫돌의 덮개등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="4" sm="12" class="text-body-1 mt-3 education_content lineHeight2 grey--text text--darken-1"> 
                        <strong style="color: green;">[운전석 확인]</strong><br>
                         ·  조종장치, 제동장치<br>
                         ·  좌석 안전띠<br>
                         ·  전조등, 후미등<br>
                         ·  시야 확보상태<br>

                        <div class="mt-12">
                          <strong style="color: green;">[탑승 금지]</strong><br>
                           ·  포크에 탑승 및 고소작업 등 금지<br>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12">
                      
                        <v-row justify="center" >
                          <v-col cols="12" md="12" class="text-center">
                            <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" style="margin-left:-35%">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_car2.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="text-body-1 mt-3 education_content lineHeight2 grey--text text--darken-1"> 
                        <strong style="color: green;">[부딪힘 방지]</strong><br>
                         ·  작업장소 내 출입금지<br>
                         ·  작업자, 지게차 운행경로 분리<br>
                         ·  유도자 배치<br>

                        <div class="mt-5">
                          <strong style="color: green;">[후방확인]</strong><br>
                           ·  후방감지기<br>
                           ·  경광등<br>
                           ·  후진경보기<br>
                           ·  후방카메라<br>
                        </div>

                        <div class="mt-5">
                          <strong style="color: green;">[화물 하역운반 상태]</strong><br>
                           ·  지게차 허용하중 준수 여부<br>
                           ·  화물의 높이 · 균형 등 적재 상태<br>
                           ·  팔레트 등의 강도 및 손상 여부<br>
                           ·  부정형 화물 등의 고정 상태<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="44" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제20조(출입의금지등), 제38조(사전조사및작업계획서의작성등), 제338조(지반등의굴착시위험방지), 제341조(매설물등파손에의함위험방지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 지면을 30cm 이상 굴착하는 경우<br>
                    2. 지하 매설물 유무확인후 SKMJ 해당부서팀장의 확인서명(자료첨부)<br>
                    3. 위험성평가를 실시하고 굴착 작업계획수립<br>
                    4. 지하 매설물 존재 시 관련부서담당자입회, One call 시스템을 이용하여 도시가스배관 유무확인<br>
                    5. 의심이 가는 지하 매설물이있을 경우 확인 굴착작업(인력작업) 실시<br>
                    6. 굴착장소  주위에는바리케이드 설치 후 관계자 외 출입통제<br>
                    7. 굴착 깊이1.5m 이상시 승강설비설치<br>
                  </span>
                </v-card-text>
                <v-col cols="12" md="12" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                  <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMJ_car3.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="45" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제20조(출입의금지등), 제38조(사전조사및작업계획서의작성등), 제338조(지반등의굴착시위험방지), 제341조(매설물등파손에의함위험방지)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row class="mt-0 ml-2 mb-2 text_first_font d-flex justify-center education_content lineHeight2 grey--text text--darken-1">
                      <v-col cols="12" md="4" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_car5.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="8" sm="12" class="mt-0" style="font-size:23px; line-height: 1.8; font-weight: normal;">
                        ※ 아래 내용을 모두 충족하는 경우 굴착기로 인양작업 가능<br>
                        1. 퀵커플러 또는 작업장치에 달기구(훅 등)가 부착되어 인양작업이 가능하도록 제작된 굴착기일 것<br>
                        2. 제조사에서 정한 정격하중이 확인되는 굴착기를 사용할 것<br>
                        3. 해지장치 사용 등 작업 중 인양물 낙하 우려가 없을 것<br>
                        4. 와이어로프 등 줄걸이 용구의 상태를 확인 후 작업할 것<br>
                        5. 인양물이 균형에 맞게 로프와 연결되어 있는지 확인<br>

                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="text-body-1 mt-3 education_content lineHeight2 grey--text text--darken-1"> 
                        <strong style="color: green;">[인양작업 안전]</strong><br>
                         ·  훅 해지장치<br>
                         ·  2줄 걸이 결속<br>
                         ·  퀵커플러 해지장치<br>
                         ·  제조사가 정한 작업설명서 준수(인양능력표, 정격하중 등)<br>
                        <div class="mt-5">
                          <strong style="color: green;">[기계 점검]</strong><br>
                           ·  붐 구조부 균열·변형<br>
                        </div>
                        <div class="mt-5">
                          <strong style="color: green;">[전도 방지]</strong><br>
                           ·  지반 침하 방지<br>
                           ·  무한궤도 트랙 상태<br>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12">
                        <v-row justify="center" >
                          <v-col cols="12" md="12" class="text-center">
                            <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" style="margin-left:-35%">
                              <div class="ma-4 text-center font-weight-black">
                                <div class="iron_center_contents"><img src="../assets/SKMJ_car6.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                              </div> 
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="text-body-1 mt-3 education_content lineHeight2 grey--text text--darken-1"> 
                        <strong style="color: green;">[충돌 방지]</strong><br>
                         ·  작업반경 내 출입금지<br>
                         ·  유도자 배치<br>

                        <div class="mt-5">
                          <strong style="color: green;">[후방확인]</strong><br>
                           ·  후방카메라<br>
                           ·  후방경고음<br>
                           ·  후미등<br>
                        </div>

                        <div class="mt-5">
                          <strong style="color: green;">[화물 하역운반 상태]</strong><br>
                           ·  지게차 허용하중 준수 여부<br>
                           ·  화물의 높이 · 균형 등 적재 상태<br>
                           ·  팔레트 등의 강도 및 손상 여부<br>
                           ·  부정형 화물 등의 고정 상태<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="46" class="education_make_scroll pa-0">
          <div class="pledge_content">
            <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
              <v-card-title class="education_title">
                <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
                <v-spacer></v-spacer>
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              </v-card-title>
              <v-divider class="mb-2"></v-divider>

              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <div class="education_content flex-wrap justify-left mt-0 mb-0">
                    <div class="ma-4 mb-0 lineHeight2 d-flex">
                      <div style="height: 10px;"></div> 
                      <div>
                        <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                        <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                        <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                        <strong class="deep-orange--text">▶ 크레인</strong>&nbsp;&nbsp;&nbsp;
                        <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                        <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                        <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="12" sm="12">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1" >
                    <span class="education_content lineHeight2 grey--text text--darken-1"  style="display: block;"><strong>관련 법령</strong><br>
                      산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                    </span>
                    <span class="education_content lineHeight2 grey--text text--darken-1"  style="display: block;"><strong>설치 기준</strong><br>
                      <v-row class="mt-0 ml-2 mb-2 text_first_font d-flex justify-center">
                        <v-col cols="12" md="6" sm="12" class="mt-0" style="font-size:23px; line-height: 1.8; font-weight: normal;">
                          <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                            <div class="d-flex align-center">
                              <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                                1</strong><br><span style="color: black;">작업계획 수립/ 검토</span><br><span style="color: black;">(호이스트, 크레인, 카고)</span>
                              </div>
                              <div class="ml-3 education_content lineHeight2 grey--text text--darken-1">
                                - 장비 종류/ 성능<br>
                                - 운행 경로<br>
                                - 작업 방법<br>
                                - 안전점검 사항<br>
                              </div>
                            </div>
                            <div class="circle_Box2_no d-flex" style="margin: -60px 110px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                            <div class="d-flex align-center">
                              <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                                2</strong><br><span style="color: black;">크레인 상태 점검</span><br><span style="color: black;">(변형 및 크랙 확인)</span>
                              </div>
                              <div class="ml-3 education_content lineHeight2 grey--text text--darken-1">
                                - 지브, 훅/도르래<br>
                                - 아웃트리거<br>
                                - 턴테이블<br>
                                - 와이어 등<br>
                              </div>
                            </div>
                            <div class="circle_Box2_no d-flex" style="margin: -60px 110px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                            <div class="d-flex align-center">
                              <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                                3</strong><br><span style="color: black;">설치 위치 점검</span><br>
                              </div>
                              <div class="ml-3 mt-3 education_content lineHeight2 grey--text text--darken-1">
                                - 지반(연약/암반)<br>
                                - 아웃트리거 확장<br>
                                - 아웃트리거 받침목<br>
                                - 신호수/구획 설정<br>
                              </div>
                            </div>
                            <div class="circle_Box2_no d-flex" style="margin: -60px 110px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                            <div class="d-flex align-center">
                              <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                                4</strong><br><span style="color: black;">인양 공구 점검</span><br><span style="color: black;">(변형 및 마모 등등)</span>
                              </div>
                              <div class="ml-3 education_content lineHeight2 grey--text text--darken-1">
                                - 줄걸이(슬링/와이어)<br>
                                - 줄걸이 장력/각도<br>
                                - 샤클 인증 상태<br>
                                - 중량물 확인<br>
                              </div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                          <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_car7.jpg" style="width: 350px; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </div>
                        </v-col>
                      </v-row>
                    </span>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-stepper-content>

        <v-stepper-content step="47" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row class="mt-0 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_paper.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                          ※ 크레인 관련 작업자(운전자, 신호수)는 산업안전보건법 시행규칙 [별표 5] 중 특별안전보건교육 14. 1톤 이상의 크레인을 사용하는 작업에 대한 교육을 이수하고 그 교육이수결과를 작업허가 시 첨부
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
<!-- 
        <v-stepper-content step="48" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>
                    </div>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <strong class="deep-orange--text">▷&nbsp;</strong>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 5px;"></div> 
                    <div style="margin-top:-10px;">
                      <strong class="deep-orange--text">지게차</strong>
                    </div>
                  </div>
                  <div style="height: 5px;"></div> 
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <strong class="deep-orange--text">▷&nbsp;</strong>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="margin-top:-10px;">
                      <strong class="deep-orange--text">굴삭기</strong>
                    </div>
                  </div>
                  <div style="height: 5px;"></div> 
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <strong class="deep-orange--text">▶&nbsp;</strong>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="margin-top:-10px;">
                      <strong class="deep-orange--text">크레인</strong>
                    </div>
                  </div>
                
                  <div style="height: 5px;"></div> 
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <strong class="deep-orange--text">▷&nbsp;</strong>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="margin-top:-10px;">
                      <strong class="deep-orange--text">인양작업</strong>
                    </div>
                  </div>
                  <div style="height: 5px;"></div> 
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <strong class="deep-orange--text">▷&nbsp;</strong>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="margin-top:-10px;">
                      <strong class="deep-orange--text">중량물취급</strong>
                    </div>
                  </div>
                  <div style="height: 5px;"></div> 
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <strong class="deep-orange--text">▷&nbsp;</strong>
                  </div>
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="margin-top:-10px;">
                      <strong class="deep-orange--text">기타</strong>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row class="mt-0 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="6" sm="12" class="mt-0" style="font-size:23px; line-height: 1.8; font-weight: normal;">
                        <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                          <div class="d-flex align-center">
                            <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                              1</strong><br><span style="color: black;">작업계획 수립/ 검토</span><br><span style="color: black;">(호이스트, 크레인, 카고)</span>
                            </div>
                            <div class="ml-3">
                              - 장비 종류/ 성능<br>
                              - 운행 경로<br>
                              - 작업 방법<br>
                              - 안전점검 사항<br>
                            </div>
                          </div>
                          <div class="circle_Box2_no d-flex" style="margin: -60px 110px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                          <div class="d-flex align-center">
                            <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                              2</strong><br><span style="color: black;">크레인 상태 점검</span><br><span style="color: black;">(변형 및 크랙 확인)</span>
                            </div>
                            <div class="ml-3">
                              - 지브, 훅/도르래<br>
                              - 아웃트리거<br>
                              - 턴테이블<br>
                              - 와이어 등<br>
                            </div>
                          </div>
                          <div class="circle_Box2_no d-flex" style="margin: -60px 110px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                          <div class="d-flex align-center">
                            <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                              3</strong><br><span style="color: black;">설치 위치 점검</span><br>
                            </div>
                            <div class="ml-3 mt-3">
                              - 지반(연약/암반)<br>
                              - 아웃트리거 확장<br>
                              - 아웃트리거 받침목<br>
                              - 신호수/구획 설정<br>
                            </div>
                          </div>
                          <div class="circle_Box2_no d-flex" style="margin: -60px 110px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                          <div class="d-flex align-center">
                            <div class="square_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                              4</strong><br><span style="color: black;">인양 공구 점검</span><br><span style="color: black;">(변형 및 마모 등등)</span>
                            </div>
                            <div class="ml-3">
                              - 줄걸이(슬링/와이어)<br>
                              - 줄걸이 장력/각도<br>
                              - 샤클 인증 상태<br>
                              - 중량물 확인<br>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_sky5.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content> -->

        <v-stepper-content step="48" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2">
                        1. 악천 후 작업중지(현장기준)<br>
                        <div class="ml-4">
                          - 순간최대풍속(m/sec) : 11~15미만<br>
                          - 강우량(mm/hr) : 1.0 이상<br>
                          - 강설량(cm/hr) : 1.0이상<br>
                        </div>
                        2. 작업구간낙하물 예방 하부 출입통제및 신호수배치 (바리케이트 또는 라바콘)<br>
                        3. 아웃트리거 최대 확장 또는 협소시 보강조치<br>
                        4. 크레인차륜의 전체바퀴는 지면에서 1cm 이상 이격<br>
                        5. 지면 오일 누유 방지 조치 (천막/함석판등설치)<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_crain1.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                  <span style="display: block;"><strong>전도방지 안전기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2">
                        1. 절토 및 성토부 상부에 이동식 크레인 거치금지<br>
                        2. 절개지 또는 옹벽 등에 이동식 크레인 설치가 불가피한경우 지반 조건 및 충분한 거리를 두고 설치하여야 한다.(권장: 4m이상거리 확보 / 필요 시 구조검토실시)<br>
                        3. 이동식 크레인 작업장소의 경사가 지면의 평편도 기준 1%이내일것 <br>
                        4. 받침목 크기는 아웃트리거 바닥 면적 보다 넓게(연약지반: 철판(깔판)+받침목설치)<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_crain2.png" style="width: 110%; height: auto; border-radius: 0px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
                
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="49" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>작업 시 준수사항</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_crain3.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_crain4.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        1. 건설기계조종사면허증(기중기면허증) 소지자에한하여 운전을 허용함(운전면허증단독소지자X)<br>
                        2. 작업 반경 내 출입통제, 아웃트리거는 최대 확장하고 받침목은 수평유지<br>
                        3. 권과/과부하 방지장치 등의 방호장치 수시점검<br>
                        4. 인양 작업 시 신호수를배치하며신호/통신체계확보<br>
                        5. 인양물과 구조물 간 충돌방지를 위한 보조로프 체결<br>
                        6. 주의구간: 정격하중의 10~30%이내 중량물 작업<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_crain5.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="50" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>작업 시 준수사항</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center education_content lineHeight2 grey--text text--darken-1">
                      <v-col cols="12" md="3" sm="12" class="text-body-1 mt-3"> 
                        <strong style="color: green;">[안전장치]</strong><br>
                         ·  붐ㆍ선회부 크랙ㆍ균열 유무<br>
                         ·  선회부 볼트 체결상태<br>
                         ·  유압 호스ㆍ실린더 이상 유무<br>
                         ·  붐길이, 각도센서<br>
                         ·  하중감지와 위치 제어장치<br>
                         ·  비상정지장치 작동 상태<br>
                         ·  불법 탑승설비 부착 유무<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12">
                        <v-row justify="center" class="mt-12">
                          <v-col cols="12" md="12" class="text-center mt-12">
                            <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                              <div class="ma-4 text-center font-weight-black">
                                <div class="iron_center_contents"><img src="../assets/SKMJ_crain6.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                              </div> 
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="text-body-1 mt-3"> 
                        <strong style="color: green;">[인양작업 안전]</strong><br>
                         ·  붐 인출(와이어로프 등) 작동 상태<br>
                         ·  줄걸이 작업안전(와이어로프 변형, 	체결상태, 안전율 등) 확인<br>
                         ·  명판(허용풍속 등) 부착<br>
                         ·  제조사가 정한 작업설명서(인양 하중표 등)<br>
                         ·  작업반경 내 출입금지<br>
                         ·  유도자 및 신호수 배치[전도방지]<br>
                         ·  지반 침하 방지<br>
                         ·  아웃트리거 받침대 설치<br>
                         ·  아웃트리거(안정기) 근접센서<br>
                         ·  아웃트리거 최대 펼침 및 대책<br>

                        <div class="mt-5">
                          <strong style="color: green;">[전도 방지]</strong><br>
                           ·  지반 침하 방지<br>
                           ·  아웃트리거 받침대 설치<br>
                           ·  아웃트리거(안정기) 근접센서<br>
                           ·  아웃트리거 최대 펼침 및 대책<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="51" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>작업 시 준수사항(카고크레인 사용 시)</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12" class="text-body-1 mt-3" > 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_crain7.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="52" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건법제34조(안전인증), 산업안전보건시행령제28조(안전인증대상기계.기구등) 산업안전보건기준에관한규칙제38조(사전조사및작업계획서의작성등)제132조(양중기) ~ 제135조(과부하의제한등)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 신호수 배치(조끼착용, 무전기, 메가폰)<br>
                    2. 받침목(철판)은 평탄하고견고한 지반에 설치 (받침대는 일체형 이용권고)<br>
                    3. 크레인주변 작업구획설정 (회전반경감안)<br>
                    4. 슬링벨트는 안전인증제품만 사용, 점검 받은 줄걸이도구사용(사용전점검)<br>
                    5. 인양작업중 인양물 하부 통행 및 출입금지<br>
                    6. 아웃트리거 양쪽 모두 최대 확장실시<br>
                    7. 권과방지장치 등 안전장치 임의해제 절대금지<br>
                    8. 다발자재는 자동바, 소둔철사(번선)등으로 견고하게고박 후 인양실시(양중함사용가능)<br>
                    9. 중장비 사용시 적재하중에 80%만 사용 / 예시) 최대하중 10톤 → 8톤까지허용<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="4" sm="12">
                    <v-card class="mt-4 mt-md-0 flex-column fill-height">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 ">
                        <div class="ma-4 text-center font-weight-black ">
                          <div class="iron_center_contents mt-5"><img src="../assets/SKMJ_up1.jpg" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="8" sm="12">
                    <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents mt-5"><img src="../assets/SKMJ_up2.png" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="53" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제169조(꼬임이 끊어진 섬유로프 등의 사용금지) KOSHA GUIDE M-85-2011 크레인 달기기구 및 줄걸이 작업에 관한 기술지침<br>
                  </span>
                  <span style="display: block;"><strong>작업 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div style="margin-left:50%;">
                              장력계수
                            </div>
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy1.png" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <!-- <v-col cols="12" md="4" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            장력계수
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy2.png" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col> -->
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            안전하중 공식
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy2.png" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                         <!-- 공간 -->
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          예) 1. 총중량(2.5ton) =자재중량(2ton), 훅 중량(0.5ton)<br>
                              2. 사용하중(2.4ton) = 슬링벨트75mm의 Straight 방식<br>
                              3. 인양줄걸이 수(2줄)<br>
                              4. 장력계수(1.1547) = 각도 60º<br>
                              5. 안전하중(T : 4.15ton) = (② x ③)/➃ : 안전하중(4.15ton) > 총중량(2.5ton) 양중 가능<br>
                        </div>
                      </v-col>
                      <div class="mt-4 mb-4">
                        ※ 크레인 작업 시 줄걸이 안전하중 확인 후 작업 진행하여야 한다.
                      </div>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-0" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy4.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy5.png" style="width: 70%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      ※ 벨트 슬링에 손상이 있을경우 사용 할 수 없음 - 예) 파손, 손상, 절단, 찢어짐 실손상등
                      </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="54" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제169조(꼬임이 끊어진 섬유로프 등의 사용금지) KOSHA GUIDE M-85-2011 크레인 달기기구 및 줄걸이 작업에 관한 기술지침<br>
                  </span>
                  <span style="display: block;"><strong>작업 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy6.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            [Color별 벨트슬링 사용]
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy7.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                           - 벨트슬링 고리에 필중 묶음 조치<br>
                           - Color Belt Sling 사용<br>
                           - 안전인증 Tag 확인품 사용<br>
                           - 안전율(장비 제원표의 80%)<br>
                           예) 10t x 80% = 8t 이하 허용<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="55" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제169조(꼬임이 끊어진 섬유로프 등의 사용금지) KOSHA GUIDE M-85-2011 크레인 달기기구 및 줄걸이 작업에 관한 기술지침<br>
                  </span>
                 
                  <span style="display: block;"><strong>사용 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy8.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                           1. S.W.L(안전작업하중)/W.L.L(작업하중제한)<br>
                           2. 제조사 또는 제조국 표기가 있을 것<br>
                           3. 샤클 핀 직경 표기(단위=inch)가 있을 것<br>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                           1. CE 인증마크의 글자간 간격을 확인할 것<br>
                           2. 대한민국 샤클 주요 제작사는 KBC(경부산업), DCH(대창마린테크), 부성<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                  <span style="display: block;" class="mt-5"><strong>사용금지(폐기)</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy9.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                           1. 열 영향을 받은 것<br>
                           2. 변형된 것(변형률 8% 이상)<br>
                           3. 수정한 것 또는 흠, 상처가 있는 것<br>
                           4. 마모가 있는 것(10% 이상)<br>
                           5. 나사산이 마모된 것<br>
                           6. 안전하중 표기가 없는 것<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="56" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="education_content lineHeight2 grey--text text--darken-1">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제20조(출입의 금지 등) / 제38조 (사전조사 및 작업계획서의 작성 등)/ 작업지휘자의 지정) / 제171조 (전도 등의 방지) / 제172조 (접촉의 방지)<br>
                  </span>
                 
                  <span style="display: block;"><strong>사용 기준</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy10.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy11.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                            반입구 개방 작업
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3 education_content lineHeight2 grey--text text--darken-1"> 
                        <div class="flex-wrap justify-center mt-0 mb-0 text-h6">
                          <strong>※ 작업 계획 시</strong><br>
                           √ 현장특성(지반, 반입 또는 반출 동선 등) 확인<br>
                           √ 자재/설비의 SPEC 확인(중량, 너비, 폭, 높이, 무게중심 등)<br>
                           √ 인양장비(크레인, 지게차) 및 인양도구준비<br>
                           √ 크레인 안전장치(권과방지 등) 해제금지<br>
                        </div>
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_heavy12.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                           1. 작업대기 시 : √ 반입구 닫힘상태 유지<br>
                           2. 작업완료 시 : √ 반입구 시건조치<br>
                           3. 호이스트 조종작업 → 신호수 교육 이수자만 조종할 것<br>
                           4. 반입구 개방 전<br>
                           <!-- <span class="ml-4"> -->
                            √ 담당자에게 사전 통보<br>
                            √ 관련 작업자 안전벨트 착용 및 안전고리 체결<br>
                           <!-- </span> -->
                           5. 반입구가 개방된 경우<br>
                           <!-- <span class="ml-4"> -->
                            √ 관련 작업자외 작업구역 (단부에서 1.5m 이내) 접근금지<br>
                           <!-- </span> -->
                           6. 작업자간 동선겹침 주의 (구명줄 꼬임으로 인한 전도, 추락 주의)<br>
                           7. 권상/권하(크레인/호이스트 등) 작업 시<br>
                           <!-- <span class="ml-1"> -->
                            √ 통제원 배치하여 양방향 통제<br>
                           <!-- </span> -->
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="57" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">중장비 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 지게차</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 굴삭기</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 크레인</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 인양작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 중량물취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    콘크리트 펌프카 작업안전<br>
                  </span>
                  <span style="display: block;"><strong>작업 시 준수사항</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center education_content lineHeight2 grey--text text--darken-1">
                      <v-col cols="12" md="3" sm="12" class="text-body-1 mt-3"> 
                        <strong style="color: green;">[작업장치]</strong><br>
                         ·  붐대, 연결부 균열·변형<br>
                         ·  배관 내구성, 절곡부 손상<br>
                         ·  호스(가이드) 상태<br>
                         ·  호퍼 변형, 덮개 등<br>
                        <div class="mt-5">
                          <strong style="color: green;">[방호장치]</strong><br>
                           ·  비상정지장치<br>
                           ·  아웃트리거 받침대 설치<br>
                           ·  아웃트리거<br>
                           ·  후진경보장치<br>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12">
                        <v-row justify="center">
                          <v-col cols="12" md="12" class="text-center mt-0">
                            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                              <div class="ma-4 text-center font-weight-black">
                                <div class="iron_center_contents"><img src="../assets/SKMJ_etc11.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                              </div> 
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="text-body-1 mt-3 "> 
                        <strong style="color: green;">[충돌방지]</strong><br>
                         ·  작업반경 내 출입금지<br>
                         ·  유도자 배치<br>
                        <div class="mt-5">
                          <strong style="color: green;">[구동부]</strong><br>
                           ·  주요구조부(선회장치, 유압장치)<br>
                           ·  조종·제동장치(브레이크, 클러치 등)<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="58" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제56조(작업발판의구조), 산업안전보건기준에관한규칙제57조(비계등의조립.해체및변경), 산업안전보건기준에관한규칙제58조(비계의점검및보수), 산업안전보건기준에관한규칙제60조(강관비계의구조)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 비계 설치작업 절차
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12" class="text-body-1 mt-3"> 
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>비계 설치계획서 및 관련자료 제출</div>
                            <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                            <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>작업허가서 발행/승인 특별안전교육 실시</div>
                            <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                            <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>비계 설치 시작<br><span style="color: red">비계설치계획서 현장 비치</span></div>
                            <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                            <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>비계 설치 현장 검수<br><span style="color: red">SKMJ SHE Part</span></div>
                            <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                            <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">5</strong><br>승인 및 사용<br><span style="color: red">사용승인 필증 부착</span></div>
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </span>
                  2. 비계 설치 사전 제출자료<br>
                  비계설치계획서, 비계자재 인증서, 비계작업 근로자 자격사항
                  <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="3" sm="12">
                      <v-row justify="center" class="mt-12">
                        <v-col cols="12" md="12" class="text-center mt-12">
                          <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_submit1.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                              <span  class="blue--text">[비계 설치계획서]</span>
                            </div> 
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <v-row justify="center" class="mt-12">
                        <v-col cols="12" md="12" class="text-center mt-12">
                          <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_submit2.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                              <div>
                                <span style="color: blue-darken-1; font-size:20px;"><strong>[비계자재 인증서]</strong></span>
                              </div>
                            </div> 
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <v-row justify="center" class="mt-12">
                        <v-col cols="12" md="12" class="text-center mt-12">
                          <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_submit3.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <v-row justify="center" class="mt-12">
                        <v-col cols="12" md="12" class="text-center mt-12">
                          <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents mr-12"><img src="../assets/SKMJ_submit4.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <div style="margin-top:-4%; margin-left:50%;" class="text-h6">
                      <span style="color: blue-darken-1; font-size:20px;"><strong>[비계작업 근로자 자격사항]</strong></span>
                    </div>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="59" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제56조(작업발판의구조), 57조(비계등의조립.해체및변경) 제58조(비계의점검및보수), 제60조(강관비계의구조)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    1. 표준설치 기준<br>
                    - 산업안전보건기준에 관한 규칙 법령에 의거하여 설치 필요
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="4" sm="12">
                        <v-row justify="center" class="mt-12">
                          <v-col cols="12" md="12" class="text-center mt-12">
                            <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                              <div class="ma-4 text-center font-weight-black">
                                <div class="iron_center_contents"><img src="../assets/SKMJ_standard1.jpg" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                                - 계단발끝단부 및 계단참미끄럼방지 조치<br>
                                - 경사각 30~60도 이내에 설치<br>
                                - 발판폭35cm이상, 너비18cm이상<br>
                                - 발판의높이24cm이하, 동일계단에서발판의높이는일정하게유지<br>
                              </div> 
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" sm="12">
                        <v-row justify="center" class="mt-12">
                          <v-col cols="12" md="12" class="text-center mt-12">
                            <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                              <div class="ma-4 text-center font-weight-black">
                                <div class="iron_center_contents"><img src="../assets/SKMJ_standard2.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                                <div>
                                <strong>개구부발판기준 색상</strong><br>
                                - 바탕: 노랑색<br>
                                <strong>크기</strong><br>
                                - 350 x 200이하<br>
                                </div>
                              </div> 
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" sm="12">
                        <v-row justify="center" class="mt-12">
                          <v-col cols="12" md="12" class="text-center mt-12">
                            <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                              <div class="ma-4 text-center font-weight-black">
                                <div class="iron_center_contents"><img src="../assets/SKMJ_standard3.jpg" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                                - 각 단에 개폐식(hatchcover)으로 설치<br>
                                - 해치커버에 닫힘 충격보호 커버설치(권고)<br>
                                - 해치커버에 당김 줄(로프)설치<br>
                                -각 단마다 지그재그설치(일직선 설치금지)<br>
                              </div> 
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="60" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제56조(작업발판의구조), 57조(비계등의조립.해체및변경) 제58조(비계의점검및보수), 제60조(강관비계의구조)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <strong>- 비계 안전표지 설치 기준</strong><br>
                    <div class="ml-4">
                      1. 산업안전보건기준에 관한 규칙 법령에 의거하여 설치 필요<br>
                      2. 비계사용금지표지-안전상의문제로사용불가시(유지/보수등)<br>
                      3. 추락, 낙하물주의안전표지부착 각단마다부착(추락주의, 낙하물주의)<br>
                    </div>
                    <strong>- 비계 하부통로 설치시 기준</strong><br>
                    <div class="ml-4">
                      1. 통행구간 밑둥잡이 상부에 발판 설치 또는 밑둥잡이 및 통행간섭부분 충격흡수대 설치<br>
                      2. 안전통로표지 및 통로구획설정<br>
                      3. 충돌주의 표지 등 부착<br>
                    </div>
                    <strong>- 비계 임의 해체 절대금지</strong><br>
                    <div class="ml-4">
                      1. 비계 수정작업필요 시 작업허가서 발행 후 수정 및 재승인 검사 후 이용<br>
                      2. 임의 수정 시 안전수칙위반 페널티부여<br>
                    </div>
                    <strong>- 도로 등 통행로에 돌출되어 설치 시</strong><br>
                    <div class="ml-4">
                      1. 충돌방호조치 및 시각화 조치<br>
                      2. 야간식별장치 부착하여 관리 - 호스윙카 또는 경광등, 반사띠등설치<br>
                    </div>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="61" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제56조(작업발판의구조), 57조(비계등의조립.해체및변경) 제58조(비계의점검및보수), 제60조(강관비계의구조)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12" class="text-body-1 mt-3" > 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_standard4.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                  
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="62" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제56조(작업발판의구조), 57조(비계등의조립.해체및변경) 제58조(비계의점검및보수), 제60조(강관비계의구조)<br>
                  </span>
                  <span style="display: block;"><strong>설치 기준</strong><br>
                    <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12" class="text-body-1 mt-3" > 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_standard6.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                    <strong>안전인증 대상 품목</strong><br>
                    <div class="ml-4">
                      1. 강관비계용 부재 : 강관조인트, 벽 연결용 철물<br>
                      2. 틀형 비계용 부재 : 주틀, 교차가새, 띠장틀<br>
                      3. 시스템비계용 부재 : 수직재, 수평재, 가새재, 연결조인트<br>
                      4. 이동식 비계용 부재 : 주틀, 발바퀴, 난간틀, 아웃트리거<br>
                      5. 작업발판 : 클램프, 철골용 클램프<br>
                      6. 받침철물 : 조절형 받침철물, 피벗형 받침철물<br>
                      7. 조립식 안전난간<br>
                      8. 추락 또는 낙하물 방지망 : 추락방호망, 수직형 추락방망, 낙하물 방지망, 수직 보호망<br>
                    </div>
                    <strong class="mt-5" style="color: blue-darken-1; text-decoration: underline;">비계의 조립 및 해체 작업에 필요한 자격, 면허, 경험 또는 기능</strong><br>
                    <div class="ml-4">
                      1. 「국가기술자격법」에 따른 비계기능사보 이상의 자격<br>
                      2. 이 규칙에서 정하는 해당 교육기관에서 교육을 이수한 사람 단, 비계설치공사 규모가 10m 이내인 경우<br>
                      3. 3개월 이상 해당 작업에 경험이 있는 사람(층높이가 10미터 미만인 작업에 한정한다)<br>
                    </div>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="63" class="education_make_scroll pa-0">
          <!-- <div class="t"> -->
            <v-card class="pl-4 pr-4 mb-12 pledge_content" min-height="520" flat id="3">
              <v-card-title class="education_title">
                <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
                <v-spacer></v-spacer>
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              </v-card-title>
              <v-divider class="mb-2"></v-divider>

              <v-row>
                <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
                <v-col cols="12" md="12" sm="12">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <span style="display: block;"><strong>관련 법령</strong><br>
                      산업안전보건기준에관한규칙제56조(작업발판의구조), 57조(비계등의조립.해체및변경) 제58조(비계의점검및보수), 제60조(강관비계의구조)<br>
                    </span>
                    <span style="display: block;"><strong>설치 기준</strong><br>
                      <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                        
                        <table class="type09 text-center" style="margin-top: 40px;">
                          <thead>
                            <tr>
                              <th scope="cols">구분</th>
                              <th scope="cols">준수사항</th>
                              <th scope="cols">기준</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>재료</td>
                              <td  class="blue--text">- 안전인증성능기준이상<br></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td rowspan="6">지반</td>
                              <td>
                                <strong>- 띠장방향: 1.5m ~ 1.8m 이하<br></strong>
                              </td>
                              <td>간격</td>
                            </tr>
                            <tr>
                              <td><strong>- 장선방향: 1.5m 이하<br></strong></td>
                              <td>간격</td>
                            </tr>
                            <tr>
                              <td>- 설치높이가 31m 초과시 기둥최상부에서 31m 지점아래부분은강관기둥을 2본으로 결속하여보강(단, 강관기둥 2본의 결속강도를 확보하는 브래킷등으로 보강가능)</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>- 주출입구 통행을 위해 기둥미설치구간 인접기둥에 2본으로 보강 및 상부가새 재보강</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><strong>- 비계기둥 1개에 작용하는하중 700kgf이내(허용하중 700kgf)<br></strong></td>
                              <td>작용하중</td>
                            </tr>
                            <tr>
                              <td><strong>- 비계기둥간적재하중 400kgf 이내(최상단에서최하단까지의누계적재하중: 그림1참조)<br></strong></td>
                              <td>적재하중</td>
                            </tr>
                            <tr>
                              <td>띠장</td>
                              <td>
                                <strong>- 첫번째띠장: 2m 이하, 그외띠장: 1.5m 이하<br></strong>
                                단, 작업발판단부에 안전난간대를 설치하고, 구조안전성 검토결과 안정성이 확보된 경우 두번째이상 띠장간격은 1.8m 이내 가능
                              </td>
                              <td>간격</td>
                            </tr>
                            <tr>
                              <td>장선</td>
                              <td>
                                <strong>- 비계내외측모두기둥에결속, 간격 1.85M<br></strong>
                                <strong>- 띠장으로부터 50mm 이상돌출<br></strong>
                              </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td rowspan="4">벽이음</td>
                              <td>
                                <strong>- 수평 5m 이내마다, 수직 5m 이내마다<br></strong>
                              </td>
                              <td rowspan="2">전용철물원칙</td>
                            </tr>
                            <tr>
                              <td>
                                - 비계의 최상단과 가장자리 끝에 도벽 이음설치(비폐합구조필수)
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>- 벽이음재는 수직재와 수평재의 교차부에서 비계면에 대하여 가능한한 직각(최대15eh 이내)이 되도록 수직재에 설치한다.<br></strong>
                              </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>
                                <strong>- 띠장에는 벽이음재를 비계기둥으로부터 30cm 이내에 부착하여야한다.<br></strong>
                              </td>
                              <td></td>
                            </tr>

                            <tr>
                              <td rowspan="2">가새</td>
                              <td>
                                <strong>- 기둥간격 10m 이내마다 40~60도 각도로 비계기둥 및 띠장에결속<br></strong>
                              </td>
                              <td ></td>
                            </tr>
                            <tr>
                              <td>
                                - 모든비계기둥은 가새에 결속
                              </td>
                              <td ></td>
                            </tr>

                            <tr>
                              <td rowspan="2">작업발판</td>
                              <td>
                                - 한국산업규격 또는 <span style="color:blue; text-decoration: underline;">안전인증규격</span>에 적합하거나 이와 동등이상의 제품사용
                              </td>
                              <td ></td>
                            </tr>
                            <tr>
                              <td>
                                <strong>- 폭 40cm 이상 발판재료간 틈 3cm이하 (비계설치, 해체시 폭 20cm 이상)<br></strong>
                              </td>
                              <td ></td>
                            </tr>

                            <tr>
                              <td>승강설비</td>
                              <td>
                                - 작업발판간 이동을위해승강설비설치(가설계단, 수직사다리등)<br>
                                - 사다리식통로(수직통로) 비계 외측 설치금지(단,지상에서2m 이하가능)<br>
                                - 비계내부에 설치시각단에 개폐식(hatchcover)으로 설치<br>
                                - Clamp로 최소4개 소고정(가능한 하부지지점에 지지하여설치)<br>
                                - 각층마다 설치되는 사다리는 지그재그형태로 수직추락할수없는 구조로 설치<br>
                              </td>
                              <td ></td>
                            </tr>
                            <tr>
                              <td>안전난간대</td>
                              <td>
                                - 작업발판등 단부에안전난간대설치(100kgf 이상하중에 견딜수 있는구조)<br>
                                * 상부난간대 : 90~120cm/ * 중간난간대 : 상부난간대와 작업발판 중간 위치/ * 발끝막이판 : 10cm 이상<br>
                              </td>
                              <td ></td>
                            </tr>
                            <tr>
                              <td>구조물사이간격</td>
                              <td>
                                - 비계기둥과 구조물 사이의 간격은 떨어짐방지를 위해 30cm 이내<br>
                              </td>
                              <td ></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </span>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          <!-- </div> -->
        </v-stepper-content>

        <v-stepper-content step="64" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6 education_content lineHeight2 grey--text text--darken-1" >
                  <!-- <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제56조(작업발판의구조), 57조(비계등의조립.해체및변경) 제58조(비계의점검및보수), 제60조(강관비계의구조)<br>
                  </span> -->
                  <span style="display: block;">
                    <!-- <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                      <v-col cols="12" md="12" sm="12" class="text-body-1 mt-3" >  -->
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                          <!-- <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_construct.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </div> -->
                          <table class="type09 text-center" style="margin-top: 40px;">
                            <thead>
                              <tr>
                                <th scope="cols">항목</th>
                                <th scope="cols">중점점검 확인사항</th>
                                <th scope="cols">관련사진</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>지반상태</td>
                                <td>- 연약지반에 비계기둥 설치 시 지반다짐 및 깔목(두계 45mm 이상), 밑받침철물 설치상태<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check1.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    깔목의 두께 및 설치상태 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>비계기둥 시공</td>
                                <td>- 교차부 및 연결부 설치 시 전용철물 체결 상태<br>- 가설구조물 설치 전, 중, 후 수직수평도 확인인<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check2.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    클램프 조임상태(너트풀림 여부) 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>띠장 설치</td>
                                <td>- 띠장의 수직간격 2.0m 이하 설치기준 준수 및 겹침이음 상태<br>(각각의 띠장끼리 최소 300mm이상 엇갈리게 설치)<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check3.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    띠장(작업대)과 띠장(작업대)간격 설치기준 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>장선 설치</td>
                                <td>- 장선 간격은 1.85m 이하 설치 및 여장길이 확보 여부<br>(띠장으로부터 50mm이상 돌출)<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check4.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    장선 여장길이 확보 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>교차가새 시공</td>
                                <td>- 교차가새 설치각도 준수여부<br>(수평면에 대해 40도~60도 방향으로 비계기둥에 결속) 및 교차부 체결상태<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check5.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    가새재 교차부 및 수직재 체결상태 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>벽이음</td>
                                <td>- 강관비계의 붕괴와 전도방지를 위한 벽이음 설치간격(수직, 수평 5m 이사), 위치 및 체결상태<br>- 수직재와 수평재(띠장) 결합부분에 설치 여부<br>- 비계 최상단 및 가장자리 끝 설치여부</td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check6.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    벽이음은 수직재와 수평재 결합부에 설치
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>작업발판(작업대)</td>
                                <td>- 작업발판 설치상태(폭 40cm 이상, 발판간의 틈 3cm 이하)<br>- 작업발판 설치 시 걸침고리 및 이탈방지장치 작동여부<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check7.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    걸침고리 및 이탈방지장치 작동상태 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>안전난간</td>
                                <td>- 작업발판 단부 추락방지조치(안전난간) 실시여부<br>* 산업안전보건기준에 관한 규칙 제13조 참고<br></td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check8.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    바닥면에서 상부난간대 상단까지 간격 측정 시 90cm 이상 및 난간대와 난간대 간격은 60cm 이하 확인
                                  </div> 
                                </td>
                              </tr>
                              <tr>
                                <td>안전시설</td>
                                <td>- 추락재해 방지시설 설치상태(추락방호망 등)<br>
                                  · 중앙부 처짐: 짧은 변의 12% 이상<br>
                                  · 내민길이: 3m 이상<br>
                                  · 망의 겹침길이: 0.75m 이상<br>
                                  · 망과 구조체 사이 간격: 100mm 이하<br>
                                  - 낙하물재해 방시설 설치상태(낙하물방지망, 수직보호망 등)<br>
                                  · 설치각도: 20도 이상 30도 이하<br>
                                  · 내민길이: 2m 이상<br>
                                  · 망의 겹침길이: 150mm 이하하<br>
                                  · 수직보호망 체결간격: 350mm 이하<br>
                                  · 수직보호망 지지재 수평간격: 1.85m 이하<br>
                                </td>
                                <td>
                                  <div class="ma-4 text-center font-weight-black">
                                    <div class="iron_center_contents"><img src="../assets/SKMJ_check9.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                                    추락 및 낙하문재해 방지시설 설치상태 확인
                                  </div> 
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      <!-- </v-col>
                    </v-row> -->
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="65" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제20조(출입의 금지 등) / 제38조 (사전조사 및 작업계획서의 작성 등)/ 작업지휘자의 지정) / 제171조 (전도 등의 방지) / 제172조 (접촉의 방지)<br>
                  </span>
                 
                  <span style="display: block;"><strong>사용 기준</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            강관 비계
                            <div class="iron_center_contents"><img src="../assets/SKMJ_standard7.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            이동식 틀비계
                            <div class="iron_center_contents"><img src="../assets/SKMJ_standard8.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_standard9.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="8" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                           1. 비계설치계획서는 비에 젖지 않도록 케이스 등에 넣어 보호조치 한다.<br>
                           2. 비계설치계획서, 승인표, 안전통로 표지는 1단 메인 승강로 옆에 설치한다.<br>
                           3. 추락주의, 낙하물주의 표지는 세트로 각 층마다 길이방향 첫 번째 기둥 칸에서 설치 후 4m (난간기둥 기준 3번째 마다)간격으로 설치한다.<br>
                           4. 추락주의, 낙하물주의 표지는 각 층마다 설치하며 후면도 설치한다.(후면이 벽면, 구조물 등으로 가려질 시 제외)<br>
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="66" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에 관한 규칙 제20조(출입의 금지 등) / 제38조 (사전조사 및 작업계획서의 작성 등)/ 작업지휘자의 지정) / 제171조 (전도 등의 방지) / 제172조 (접촉의 방지)<br>
                  </span>
                 
                  <span style="display: block;"><strong>소형 개구부</strong>
                    <v-row>
                      <v-col cols="12" md="3" sm="12" class="mt-3 education_content lineHeight2 grey--text text--darken-1 "> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 font-weight-black ">
                            <strong>색상</strong><br>
                            -바탕: 노랑색<br>
                            <strong>크기</strong><br>
                            -350 x 200이하<br>
                            <strong>성능</strong><br>
                            -시험성적서필수<br>
                            -설치시 유격최소화(쉽게 뒤집히거나 탈락되지않을것)<br>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                              <!-- 개구부 이미지 -->
                            <div class="iron_center_contents"><img src="../assets/SKMJ_standard2.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_G.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <!-- <v-col cols="12" md="4" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cover2.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col> -->
                    </v-row>
                  </span>

                  <span style="display: block;"><strong>중대형 개구부 안전난간 상세</strong><br>
                    높이: 중간난간 450~600, 상부난간 900~1200<br>
                    지주간격: 1800(최대)
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cover1.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                          * 개구부의 형태 및 크기별 가이드를 적용할 수 없을 경우 관리감독자와 협의 후 적절할 조치 가능
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-3" style="font-size:25px; line-height: 1.8;"> 
                        <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cover2.jpg" style="width: 200px; height: auto; border-radius: 10px; margin-top:-30%;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="67" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="education_content lineHeight2 grey--text text--darken-1">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제42조, 43조, 45조, 56조, 고용노동부고시제2016-54호(방호장치안전인증고시)<br>
                  </span>
                 
                  <span style="display: block;"><strong>설치 기준</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <!-- <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 education_content lineHeight2 grey--text text--darken-1"> -->
                          1. 설치위치는 작업면으로부터 가까운위치에 설치<br>
                          2. 높이10미터 이내마다 Span 단위로 분리하여 설치<br>
                          3. 안전방망은 수평으로설치하고, 망의쳐짐(S)은 짧은변길이(N)의 12%이상이 되도록할것[그림1 참조]<br>
                          4. 추락방호망과 구조물 사이는10cm 이하일것<br>
                          5. 방망과 방망을 연결시 겹침폭은75cm 이상일것<br>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0"> 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_mesh1.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>

                  <span style="display: block;"><strong>기타 준수 사항</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3" > 
                        <!-- <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6"> -->
                          1. 테두리 로프 및 달기로프: 인장강도1,500kg 이상<br>
                          2. 추락방호망 위에서 화기작업 시 불티비산방지조치를 하고 작업이 끝나면 방망의 손상여부를 점검할것<br>
                          3. 추락방호망위의 낙하물은 수시로 점검 및 제거<br>
                          4. 마모가 현저하거나, 찢어짐, 파손된방망은 즉시교체<br>
                          5. 추락방호망설치 전 확인사항<br>
                            - 제조자명또는 그 약호<br>
                            - 제조연월<br>
                            - 안전인증번호<br>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0"> 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_mesh2.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="68" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="education_content lineHeight2 grey--text text--darken-1">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제13조(안전난간의구조및설치요건),제22조(통로의설치), 제23조(가설통로의구조), 제26조(계단의강도), 제27조(계단의폭),제28조(계단참의높이), 제29조(천장의높이), 제30조(계단의난간)<br>
                  </span>
                 
                  <span style="display: block;"><strong>설치 기준</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <!-- <div class="flex-wrap d-flex  mt-0 mb-0 text-h6"> -->
                          1. 난간대(상부,중간) ,발끝막이판 및 난간 기둥구성할 것<br>
                          2. 난간대는 100kg 이상하중에 견딜 것<br>
                          3. 안전난간은 높이50㎝이상 이거나 , 계단이 4단이상 일경우 설치할 것<br>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0" > 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_road1.jpg" style="width: 350px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>

                  <span style="display: block;"><strong>관리 기준</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <!-- <div class="flex-wrap d-flex mt-0 mb-0 text-h6"> -->
                          1. 진입통로∙계단을 안전하게 확보<br>
                          2. 통로에는 케이블/호스/자재보관및설치금지<br>
                          3. 자재를 밟거나 뛰어 넘지 않을 것<br>
                          4. 발판에서 머리공간 높이는2m이상이어야한다.<br>
                          5. 경사각38도 이내로설치<br>
                          6. 통로이동 시 3점 접촉(양손난간대파지)<br>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0" > 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_road2.jpg" style="width: 350px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        
        <v-stepper-content step="69" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건기준에관한규칙제3조(전도의방지), 제4조(작업장의청결) 제22조(통로의설치), 제393조(화물의적재)
                  </span>
                 
                  <span style="display: block;"><strong>준수 기준</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3" > 
                        <!-- <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6"> -->
                          1. 자재적재 구간에는 라바콘+걸이대 또는 이미지휀스를 이용하여 구획설정을 할 것<br>
                          2. 대형자재 적재구간은 위험띠 추가 사용가능<br>
                          3. 자재야적장은 4면구획을 원칙으로 하고 자재보관실명제Tag 및 접근금지 표지를 부착할것<br>
                          4. 자재 야적장의 위치는 동선에 간섭 되지 않도록 할 것<br>
                          5. 자재사용을 고려하여 통행로를 구획하여 관리 할 것<br>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0" > 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place1.png" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>

                  <span style="display: block;" class="mt-4"><strong>야적 시 주의사항</strong>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-3"> 
                        <!-- <div class="flex-wrap d-flex mt-0 mb-0 text-h6"> -->
                          1. 자재는 형상별, 종류별, Size별구분하여보관할것<br>
                          2. Shop장에 야적가능한자재는 현장적재금지할것<br>
                          3. 폐자재 및 쓰레기의 발생시 현장방치금지(폐자재수거함에 보관 또는 즉시 반출)<br>
                          4. 도로에 돌출되어 적재시 야간식별장치부착(경광등, 윙카호스, 반사띠중부착/전,후2개소)<br>
                          5. 불안정할 정도로 높이 쌓아 올리지말 것<br>
                          6. 하중이 한쪽으로 치우치지 않도록 쌓을 것<br>
                          7. 비산의 위험이 있는 자재는 포장 등의 비산방지조치를 할 것<br>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-0" > 
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place2.png" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="70" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>차량 제한속도 알림판 설치</strong><br>
                    <v-row>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        1. 제한속도 10km/h 이하<br>
                        2. 덤프트럭, 살수차, 펌프카 등 전체 대상<br>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place3.png" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place4.png" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                  <span style="display: block;"><strong>차량-근로자 통로 분리</strong><br>
                    <v-row>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        1. 차량과 근로자 통로가 명확하게 구분되어야 함<br>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <v-container>
                      <v-row justify="center" >
                        <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_place5.jpg" height="200" contain /> 
                        </v-col>
                        <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_place6.jpg" height="200" contain/> 
                        </v-col>
                        <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_place7.jpg" height="200" contain /> 
                        </v-col>
                        <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_place8.jpg" height="200" contain /> 
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="71" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>출입문 + 안전간판</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        1. 안전간판디자인 상부 : 안전계몽문구, 하부 : 현장 정보 바탕색 및 글씨 색상 자유<br>
                        2. 안전간판제작 사양 사이즈 : 12000 x 600(출입문 사이즈별변동) 재질 : AL + 후렉스<br>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place9.png" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                  <span style="display: block;"><strong>안전간판 설치 사례</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place10.jpg" style="width: 400px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place11.jpg" style="width: 400px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="72" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>안전 출입구 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        1. 색상 바탕 : 노랑색<br>
                        2. 재질<br>
                        <span class="ml-4">- 간판 : 후렉스<br></span>
                        <span class="ml-4">- 프레임 : 각파이프<br></span>                        
                        3. 크기<br>
                        <span class="ml-4">- 출입구 : 구조물별크기에 맞춤<br></span>
                        <span class="ml-4">- 최소 2100 x 2100 x 내민길이 2000 (수레이동, 2인 작업 최소 거리)<br></span>
                        <span class="ml-4">- 간판 : 가로(사업장 크기) x 높이 900<br></span>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_place12.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="73" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>통행제한</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        1. 안전네트, 수직망 등을 이용하여통행불가 구역을 식별 및 통행제한<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_net.png" style="width: 350px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_net1.png" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          *설치 예시
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        2. 미사용 출입문 관리 : 작업중 또는 안전조치 미비할경우 출입문 봉쇄조치<br>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_net2.png" style="width: 60%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="74" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>메인 출입구 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        1. 색상 바탕 : 노랑색<br>
                        2. 재질<br>
                        <span class="ml-4">- 간판 : 후렉스<br></span>
                        <span class="ml-4">- 프레임 : 각 파이프<br></span>                        
                        3. 크기<br>
                        <span class="ml-4">- 출입구 : 구조물별크기에 맞춤 x 내민길이 2000<br></span>
                        <span class="ml-4">- 최소 2100 x 2100 x 내민길이 2000 (수레이동, 2인 작업 최소 거리)<br></span>
                        <span class="ml-4">- 간판 : 가로(사업장 크기) x 높이 900<br></span>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_enter1.jpg" style="width: 400px; height: auto; border-radius: 0px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <!-- 여백 -->
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents ml-12"><img src="../assets/SKMJ_enter2.png" style="width: 200px; height: auto; border-radius: 0px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents mr-12"><img src="../assets/SKMJ_enter3.png" style="width: 200px; height: auto; border-radius: 0px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="75" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>돌출부 마감</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" sm="12">
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap1.jpg" style="height:360px; border-radius: 10px;"/></div>비계마감(클렘프, 파이프)
                          </div> 
                        </div>
                      </v-col>

                      <v-col cols="12" md="3" sm="12">
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap2.jpg" style="height:150px; border-radius: 10px;"/></div>철근돌출부마감
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap3.jpg" style="height:150px; border-radius: 10px;"/></div>머리부딪침구간마감
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" md="3" sm="12">
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap4.jpg" style="height:150px; border-radius: 10px;"/></div>철근돌출부마감
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap5.jpg" style="height:150px; border-radius: 10px;"/></div>철근돌출부마감
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" md="3" sm="12">
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap6.jpg" style="height:150px; border-radius: 10px;"/></div>파이프말단마감
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_cap7.jpg" style="height:150px; border-radius: 10px;"/></div>접지선말기+표지부착
                          </div>
                        </div>
                      </v-col>


                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="76" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>안전통로 표지판 규격</strong><br>
                    <v-row>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        1. 색상<br>
                        <span class="ml-4">- 바탕 : 노랑색</span><br>
                        <span class="ml-4">- 글씨 : 검정색</span><br>
                        2. 크기<br>
                        <span class="ml-4">- 500 x 1500</span>
                        3. 재질<br>
                        <span class="ml-4">- 타포린</span><br>
                        4. 마감처리<br>
                        <span class="ml-4">- 사방 아이넷</span><br>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_saferoad1.jpg" style="width: 150px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      ※설치프레임이 없을경우 A형간판으로 제작후 설치(900x 1800)
                    </v-row>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <v-container>
                      <v-row justify="center" >
                        <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_saferoad2.jpg" height="200" contain /> 
                        </v-col>
                        <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_saferoad3.jpg" height="200" contain /> 
                        </v-col>
                        <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_saferoad4.jpg" height="200" contain /> 
                        </v-col>
                        <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                          <v-img src="../assets/SKMJ_saferoad5.jpg" height="200" contain /> 
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="77" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">가설 통로 / 비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설비계</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 개구부 추락</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 추락방호망</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 가설계단 경사로</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 자재 야적장</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 기타 사항</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                 
                  <span style="display: block;"><strong>비상대피로 간판 기준</strong><br>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        1. 위치 : TBM 조회장 측면<br>
                        2. 크기 : 1800 x 5400 (공사기간 3개월 미만의 경우 900 x 1800)<br>
                        3. 재질 : 갈바, 각파이프, 엥커형 또는 자립형<br>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_saferoad6.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                            TBM조회장
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-12 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents mr-12"><img src="../assets/SKMJ_plus.png" style="width: 100px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-8 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents mr-12"><img src="../assets/SKMJ_saferoad7.jpg" style="width: 400px; height: auto; border-radius: 10px;"/></div>
                            비상대피로 간판
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center education_content lineHeight2 grey--text text--darken-1">
                  <v-col cols="12" md="6" sm="12" class="mt-2" style="margin-left:-18%;">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_saferoad8.jpg" style="width: 400px; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" class="mt-2 education_content lineHeight2 grey--text text--darken-1">
                    1. TBM조회장은 가급적 비상집결지와 동일 장소로 선정<br>
                    2. 비상대피간판 內현 위치 표기<br>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="78" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 밀폐공간작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화학물질 취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ Grating 설치/해체기준</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>밀폐공간의 정의</strong><br>
                    1. 산소결핍, 유해가스로 인한 질식/화재/폭발 등의 위험이 있는 장소 (예시 : 설비 내부, 암거, 맨홀, Pit내부 등)<br>
                  </span>
                  <span style="display: block;"><strong>밀폐공간 작업 절차</strong><br>
                    1. 작업 장소에 대한 질식재해 예방 교육 : 작업 시작 전 질식 위험성 및 안전작업 절차 교육 (TBM) 실시<br>
                    2. 출입구 출입금지 표지판 설치, 출입제한, 작업 전 안전장비 구비 : 가스농도 측정기, 환기팬 공기호흡기, 무전기, 구조장비<br>
                    3. 밀폐공간 출입시 산소와 유해가스 농도 측정<br>
                    - 산소 20% 이상, 23%미만, 황화수소 10ppm 미만, 가연성가스 LEL 10%미만, CO 30ppm미만, CO2 1.5% 미만<br>
                    4. 환기장치 가동으로 밀폐공간 적정 공기 유지: 작업 전/작업 중 지속 실시 (호스 손상여부 체크)<br>
                    5.  작업 시, 산소농도 감지기 작업자 부착, 감시인 배치, 내부작업자와 연락제쳬 구축(무전기)<br>
                    6. 출입인원 기록관리<br>
                  </span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_process.png" style="max-width: 100%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                    ※ 산업안전보건법 시행규칙 별표 4에 의거<br>
                    "밀폐공간에서의 작업"은 특별교육 대상<br>
                    일용 근로자 외 근로자 : 16시간 이상 / 단기간 작업 및 간헐적 작업 : 2시간 이상<br>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="79" class="education_make_scroll pa-0">
          <div class="pledge_content">
            <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
              <v-card-title class="education_title">
                <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
                <v-spacer></v-spacer>
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              </v-card-title>
              <v-divider class="mb-2"></v-divider>

              <v-row>
                <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 밀폐공간작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화학물질 취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ Grating 설치/해체기준</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
                <v-col cols="12" md="12" sm="12">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <span style="display: block;"><strong>밀폐공간 작업 장비</strong><br></span>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-4 mb-0 text-h6" >
                    <table class="type09 text-center" style="margin-top: 40px;">
                      <thead>
                        <tr>
                          <th scope="cols">장비명</th>
                          <th scope="cols">사용용도</th>
                          <th scope="cols">장비예시</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>가스농도 측정기 (산소, 복합)</td>
                          <td>밀폐공간 가스농도 측정 (산소, 암모니아, 황화수소,가연성가스,CO, Co2, 기타 유해물질)<br></td>
                          <td>
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_ex1.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </td>
                        </tr>
                        <tr>
                          <td>공기 치환용 환기 팬</td>
                          <td>밀폐공간 내부를 신선한 외부 공기로 치환<br></td>
                          <td>
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_ex2.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </td>
                        </tr>
                        <tr>
                          <td>공기 호흡기 (송기마스크)</td>
                          <td>밀폐공간 내부 재해자 구조 시 사용하거나, 환기가 어려운 장소, 작업중 유해가스가 발생되어 질 식위험이 있는 경우 사용<br></td>
                          <td>
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_ex3.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </td>
                        </tr>
                        <tr>
                          <td>무전기 (송수신 장비)</td>
                          <td>감시자와 밀폐공간 내 작업자와 의 상호 연락수단<br></td>
                          <td>
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_ex4.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </td>
                        </tr>
                        <tr>
                          <td>휴대용 조명기구</td>
                          <td>정전, 비상상황 발생 시 비상구 안내용<br></td>
                          <td>
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_ex5.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </td>
                        </tr>
                        <tr>
                          <td>구조용 삼각대 및 윈치 등(필요 시/권고사항)</td>
                          <td>재해자 구조용<br></td>
                          <td>
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents"><img src="../assets/SKMJ_ex6.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                            </div> 
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <div class="text-left">
                              ▣ 산소 및 유해가스 농도 측정자<br>
                              가. 관리감독자<br>
                              나. 안전/보건관리자 <br>
                              다. KOSHA 교육 이수자<br>
                              라. 밀폐공간 유해가스 농도측정과 관련한 지식을 갖춘 경우<br>
                              <div class="mt-3">라)의 경우 시작 전 확인 사항<br></div>
                              1. 밀폐공간의 위험성<br>
                              2. 측정장비의 이상 유무 확인 및 조작 방법<br>
                              3. 밀폐공간 내에서의 산소 및 유해가스 농도 측정방법<br>
                              4. 적정공기의 기준과 평가 방법<br>
                            </div>
                          </td>
                          <td>
                            <div class="text-left" style="margin-top:-30%;">
                              ▣ 감시인<br>
                              가. 작업부서 관리자<br>
                              나. 해당업체 관리자(KOSHA 교육 이수자)<br>
                              ☞ KOSHA 교육 : 안전보건공단 주관 산소 및 유해가스농도 측정 교육<br>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-stepper-content>

        <v-stepper-content step="80" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 밀폐공간작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 화학물질 취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ Grating 설치/해체기준</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>화학물질 정의</strong><br>
                    모든 Chemical로써, 흔히 볼 수 있는 용품도 포함 (예시 : WD-40, 페인트, 신나, 락스, 청관제, 용접봉, 각종 스프레이류 등)<br>
                    <strong>관리 기준</strong><br>
                    1. MSDS 확보 > 작업자 MSDS교육 > 작업시 MSDS 비치<br>
                    2. 용기의 GHS 라벨 유무 확인 : GHS라벨이 없는 경우 반입 금지<br>
                    3. 용기 소분하여사용시 GHS라벨 제작하여부착 후 사용<br>
                    <strong>보호구</strong><br>
                    1. MSDS에 기재된 보호구 착용<br>
                    2. 도료/페인트/신너 등 사용 시, 호흡기 보호구의필터 형식에 맞는 필터 사용<br>
                    <strong>화학물질 누출/사고시</strong><br>
                    1. 인근 비상샤워기로 응급조치 및 오염물질제거<br>
                    2. 화학사고즉시 신고 : 사고 즉시 지체 없이 SKMJ관리자 보고<br>
                    * 사고 늑장신고시, 화학물질관리법에 따른 벌칙사항<br>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_che.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_che2.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="81" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 밀폐공간작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ 화학물질 취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ Grating 설치/해체기준</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>화학물질 사고발생 신고 Process</strong><br></span>
                </v-card-text>
                <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                  <v-col cols="12" md="12" sm="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_alert.png" style="max-width: 50%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="82" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">2. 안전수칙 준수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="education_content flex-wrap justify-left mt-0 mb-0">
                  <div class="ma-4 mb-0 lineHeight2 d-flex">
                    <div style="height: 10px;"></div> 
                    <div>
                      <strong class="deep-orange--text">일반 작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 밀폐공간작업</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="grey--text">▷ 화학물질 취급</strong>&nbsp;&nbsp;&nbsp;
                      <strong class="deep-orange--text">▶ Grating 설치/해체기준</strong>&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <span style="display: block;"><strong>관련 법령</strong><br>
                    산업안전보건 기준에 관한 규칙 제 14조(낙하물에 의한 위험의 방지), 제 20조(출입의 금지등), 제 42조(추락의 방지), 제 44조(안전대의 부착설비 등)<br>

                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <strong>준수 기준</strong><br>
                          1. 자재 운반 시 2인1조 작업 / 하부 출입통제 조치<br>
                          2. Grating 운반 설치 시 갈고리 사용<br>
                          3. 판개 시 정리정돈 및 미끄럼 상태 확인 후 작업<br>
                          4. 작업 전 단부 및 개구부 추락 방지 조치<br>
                          5. 추락방지망 미 설치 구간 작업금지<br>
                          6. 낙하방지용 이탈방지로프 체결(Lanyard)<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-12 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_law1.jpg" style="width: 300px; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" sm="12" class="mt-2"  >
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/SKMJ_law2.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                          </div> 
                        </div>
                      </v-col>
                    </v-row>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="83" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. MSDS</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>SKMJ 취급 화학물질</div>
                  </div>
                  <div class="d-flex ml-6">   
                    <div>- 사전 MSDS 교육 (협력사 자체)</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="84" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">당사에서 취급중인 화학물질에 대한 MSDS 작업자에게 교육하시기 바랍니다.</strong><br>
              > MSDS Pack 참고<br><br>
              <strong class="deep-orange--text">작업 시 취급하는 화학물질에 대해 <span style="text-decoration: underline;">MSDS확보 /교육 /MSDS 上안전보호구 지급 /작업현장 비치</span></strong><br>
              : 상기 사항 미준수 시, 작업허가 불가 및 작업중지<br>
              : 도료, 에폭시, 신너, 방청제, 청관제, WD-40, 용접봉, 락스, 세제 등등 <span style="text-decoration: underline;">모든 화학물질류</span><br>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12">
                <strong class="text-h5 deep-orange--text font-weight-black">※ MSDS 구성</strong><br>
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="ml-4">
                      <strong>16개 항목</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <!-- 세로 정렬 위해 -->
                      <!-- <v-col cols="12" md="4" sd="6">
                        <div class="d-flex"><strong class="deep-orange--text caption mr-2">1.</strong>화학제품과 회사에 관한 정보</div>
                        <div class="d-flex"><strong class="deep-orange--text caption mr-2">2.</strong>유해성 · 위험성</div>
                        <div class="d-flex"><strong class="deep-orange--text caption mr-2">3.</strong>유해성 · 위험성</div>
                      </v-col>
                      <v-col cols="12" md="4" sd="6">
                        <div class="d-flex"><strong class="deep-orange--text caption mr-2">4.</strong>화학제sdfasdfasef품과 회사에 관한 정보</div>
                        <div class="d-flex"><strong class="deep-orange--text caption mr-2">5.</strong>유해성 · 위험성</div>
                        <div class="d-flex"><strong class="deep-orange--text caption mr-2">6.</strong>유해성 · 위험성</div>
                      </v-col> -->

                      
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">1.</strong>화학제품과 회사에 관한 정보</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">2.</strong>유해성 · 위험성</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">3.</strong>구성성분의 명칭 및 함유량</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">4.</strong>응급조치 요령</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">5.</strong>폭발 · 화재 시 대처방법</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">6.</strong>누출 사고 시 대처방법</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">7.</strong>취급 및 저장방법</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">8.</strong><span style="text-decoration: underline;">노출방지 및 개인보호구</span></div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">9.</strong>물리화학적 특성</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">10.</strong>안전성 및 반응성</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">11.</strong>독성에 관한 정보</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">12.</strong>환경에 미치는 영향</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">13.</strong>고소 작업대</div></v-col>                      
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">14.</strong>운송에 필요한 정보</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">15.</strong>법적 규제현황</div></v-col>
                      <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">16.</strong>그 밖의 참고사항</div></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-5 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="8" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div>
                      <strong>MSDS 8번 항목 확인 하여 그에 맞는 안전보호구 준비 및 착용 필수</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      1. 화학물질의 노출기준, 생물학적 노출기준 등 :<br>
                      2. 적절한 공학적 관리 :<br>
                      3. 개인보호구<br>

                      - 호흡기 보호 : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 눈 보호 :<br>
                      - 손 보호 : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 신체 보호 :<br>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents mt-2"><img src="../assets/guide_dir_10.png" style="height:90px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                      <div class="ma-1 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:100px; border-radius: 10px;"/></div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="85" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업공정 별 관리 요령- 테트라하이드로푸란(THF)</strong><br>
              <div>
                <img src="../assets/warn_02.png" height="100" /> 
                <img src="../assets/warn_09.png" height="100" /> 
                <img src="../assets/warn_05.png" height="100" />
                <img src="../assets/warn_13.png" height="100" /> 
              </div>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>건강 및 환경에 대한 유해성, 물리적 위험성</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <v-col cols="12" md="6" sm="12" >
                        - 고인화성 액체 및 증기<br>
                        - 삼키면 유해함<br>
                        - 피부에 자극을 일으킴<br>
                        - 눈에 심한 손상을 일으킴<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" >
                        - 암을 일으킬 것으로 의심됨<br>
                        - 신체 중 호흡기계에 손상을 일으킬 수 있음<br>
                        - 호흡기계 자극을 일으킬 수 있음<br>
                        - 장기간 또는 반복노출되면 신체 중 간에 손상을 일으킴<br>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>취급 및 저장방법</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 안전취급요령</span><br>
                      - 피부접촉, 증기흡입 및 눈에 침입 방지<br>
                      - 모든 용기는 접지시킬 것<br><br>
                      <span style="text-decoration: underline;">나. 안전한 저장방법</span><br>
                      - 접지 및 등전위 접지 필요<br>
                      - 옥외 또는 격리된 건물에 보관할 것<br>
                      - 인화성 액체와 함께 저장하지 말 것<br>
                      - 혼합금지 물질과 분리할 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>적절한 보호구</strong>
                    </div>
                      - 호흡기 보호: 유기용제용 전면형 방독마스크(방진필터 부착)<br>
                      - 눈 보호: 화학물질용 보안경(전면형 방독마스크 착용시 제외)<br>
                      - 손 보호: 화학물질용 보호장갑<br>
                      - 신체 보호: 화학물질용 보호의<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>응급조치요령</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 눈에 들어갔을 때</span><br>
                      - 많은 양의 물이나 생리식염수로 15분이상 눈을 세척하고 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">나. 피부에 접촉했을 때</span><br>
                      - 오염된 의복 및 신발을 즉시 벗고 15분 이상 다량의 물과 비누로 씻을 것<br><br>
                      <span style="text-decoration: underline;">다. 흡입했을 때</span><br>
                      - 노출로부터 환자를 즉시 신선한 공기가 있는 곳으로 옮기고 호흡정지 및 곤란 시 인공호흡 실시 및 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">라. 먹었을때</span><br>
                      - 구토를 하지 않도록 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">마. 응급처치 및 의사의 주의사항</span><br>
                      - 흡입의 경우에는 산소의 공급을 고려할 것<br>
                      - 많은 양의 물이나 생리식염수로 15분이상 눈을 세척하고 즉시 의사의 치료를 받을 것<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>사고 시 대처방법</strong>
                    </div>
                    <span style="text-decoration: underline;">가. 폭발, 화재 시 대처방법</span><br>
                    - 적절한 소화제: 분말소화제, 내알코올성 포말소화제, 이산화탄소, 물분무<br>
                    - 열분해생성물: 탄소산화물<br>
                    - 위험 없이 할 수 있으면 용기를 화재지역으로부터 이동시킬 것<br>
                    - 방열복 및 공기호흡기 등 필요한 보호구를 반드시 착용 후 화재 진압을 하고 불가능 시 즉각 철수할 것<br>
                    - 진화가 된 후에라도 상당 시간 동안 물 분무로 용기를 냉각시킬 것<br>
                    - 관계인의 접근을 막고 위험 지역을 격리하며 출입을 금지할 것<br><br>
                    <span style="text-decoration: underline;">나. 누출사고 시 대처방법</span><br>
                    - 누출된 물질을 만지지 말것, 흡입과 피부 접촉을 피하고 밀폐장소인 경우 공기호흡기 착용 및 환기시키고 발화원을 제거할 것<br>
                    - 유출방지를 최소화하고 유출물질은 용기에 보관하여 회수할 것<br>
                    - 유출물질은 모래, 점토, 기타 흡착물질로 흡수시킬 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="86" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업공정 별 관리 요령- 아세톤(Acetone)</strong><br>
              <div>
                <img src="../assets/warn_01.png" height="100" /> 
                <img src="../assets/warn_09.png" height="100" /> 
                <img src="../assets/warn_13.png" height="100" /> 
              </div>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>건강 및 환경에 대한 유해성, 물리적 위험성</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <v-col cols="12" md="6" sm="12" >
                        - 고인화성 액체 및 증기<br>
                        - 삼켜서 기도로 유입되면 유해할 수 있음<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" >
                        - 눈에 심한 자극을 일으킴<br>
                        - 졸음 또는 현기증을 일으킬 수 있음<br>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>취급 및 저장방법</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 안전취급요령</span><br>
                      - 압력을 가하거나, 자르거나, 용접, 납땜, 접합, 뚫기, 연마 또는 점화원에 폭로하지 마시오<br>
                      - 용기가 비워진 후에도 제품 잔여물이 남아 있을 수 있으므로 모든 MSDS/ 라벨 예방조치를 따르시오<br>
                      - 개봉 전에 조심스럽게 마개를 열고 취급/저장에 주의하여 사용하시오<br>
                      - 물질 취급 시 모든 장비를 반드시 접지하시오<br>
                      - 폭발 방지용 전기, 환기, 조명 장비를 사용하시오<br>
                      - 스파크가 발생하지 않는 도구만을 사용하시오<br>
                      - 정전기 방지 조치를 취하시오<br>
                      - 취급 후에는 취급 부위를 철저히 씻으시오<br>
                      - 옥외 또는 환기가 잘되는 곳에서만 취급하시오<br><br>
                      <span style="text-decoration: underline;">나. 안전한 저장방법</span><br>
                        - 현행 법규 및 규정에 의하여 저장하시오<br>
                        - 용기에 물리적인 충격을 가하지 마시오<br>
                        - 직사광선을 피하고 원래의 용기에만 보관하시오<br>
                        - 피해야 할 물질 및 조건에 유의하고 밀폐용기에 담아 수거하시오<br>

                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>적절한 보호구</strong>
                    </div>
                      - 호흡기 보호: 유기용제용 전면형 방독마스크(방진필터 부착)<br>
                      - 눈 보호: 화학물질용 보안경(전면형 방독마스크 착용시 제외)<br>
                      - 손 보호: 화학물질용 보호장갑<br>
                      - 신체 보호: 화학물질용 보호의<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>응급조치요령</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 눈에 들어갔을 때</span><br>
                      - 눈을 문지르지 마시오<br>
                      - 많은 양의 물을 사용하여 적어도 15분동안 눈을 씻어내시오<br>
                      - 증상(발적, 자극 등)이 발생할 경우 즉시 병원으로 가시오<br><br>
                      <span style="text-decoration: underline;">나. 피부에 접촉했을 때</span><br>
                      - 오염된 의복 및 신발을 벗고 즉시 적처도 15분동안 비누와 물로 씻어내시오<br>
                      - 오염된 피복은 재사용 전에 (충분히) 세탁하시오<br>
                      - 취급 후 철저히 씻으시오<br><br>
                      <span style="text-decoration: underline;">다. 흡입했을 때</span><br>
                      - 다량의 증기나 미스트에 노출되었을 경우 맑은 공기가 있는 곳으로 이동하시오<br>
                      - 호흡이 불규칙하거나 멈출 경우 인공호흡을 실시하고 산소를 공급하시오<br><br>
                      <span style="text-decoration: underline;">라. 먹었을때</span><br>
                      - 구토를 유발해야 하는지에 대해서 의사의 조언을 받으시오<br>
                      - 즉시 물로 입을 씻어내시오<br><br>
                      <span style="text-decoration: underline;">마. 응급처치 및 의사의 주의사항</span><br>
                      - 오염상황을 의료관계자에게 알려 그들도 적절한 보호조치를 취하도록 하시오<br>
                      - 노출 및 노출 우려 시 의학적인 조치, 조언을 구하시오<br>
                      - 즉시 의사의 치료를 받으시오<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>사고 시 대처방법</strong>
                    </div>
                    <span style="text-decoration: underline;">가. 폭발, 화재 시 대처방법</span><br>
                    - 적절한 소화제: 분말소화제, 탄산가스, 일반 포말소화제, 분무<br>
                    - 직사주수를 사용한 소화는 피하시오<br>
                    - 증기는 점화원에 옮겨져 발화될 수 있음<br>
                    - 타는 동안 열분해 또는 연소에 의해 자극적이고 매우 유독한 가스가 발생될 수 있음<br>
                    - 인화점이나 그 이상에서 폭발성 혼합물을 형성할 수 있음<br>
                    - 가열시 용기가 폭발할 수 있음<br>
                    - 고인화성: 열, 스파크, 화염에 의해 쉽게 점화됨<br>
                    - 누출물은 화재/폭발 위험이 있음. 실내, 실외, 하수구에서 증기 폭발 위험이 있음<br>
                    - 증기는 공기와 폭발성 혼합물을 형성할 수 있음<br>
                    - 증기는 자각 없이 현기증 또는 질식을 유발할 수 있음<br>
                    - 흡입 및 접촉 시 피부와 눈을 자극하거나 화상을 입힘<br>
                    - 화재 진압 시 방화복, 소방용 구조헬멧, 소방용 안전화, 소방용 안전장갑, 공기호흡기를 착용하시오<br>
                    - 지역을 벗어나 안전거리를 유지하여 소화하시오<br>
                    - 대부분의 증기는 공기보다 무겁기 때문에 지면을 따라 확산하고 저지대나 밀폐공간에 축적될 수 있음<br>
                    - 위험하지 않다면 화재지역에서 용기를 옮기시오<br><br>
                    <span style="text-decoration: underline;">나. 누출사고 시 대처방법</span><br>
                    - 엎질러진 것을 즉시 닦아내고, 적절한 보호구를 착용하시오<br>
                    - 노출물을 만지거나 걸어다니지 말고 모든 점화원을 제거하시오<br>
                    - 물질 취급 시 모든 장비를 반드시 접지하시오<br>
                    - 위험하지 않다면 누줄을 멈추시오<br>
                    - 증기발생을 줄이기 위해 증기억제포말을 사용할 수 있음<br>
                    - 누출물이 하수시설, 수계에 유입되지 않도록 차단시키시오<br>
                    - 누출량이 많은 경우 119나 환경부, 지방환경관리청, 시,도(환경지도과)에 신고하시오<br>
                    - 폐기물관리법(환경부)에 의해 처리하시오<br>
                    - 누출된 물질의 처분을 위해 적당한 용기에 수거하시오<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="87" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업공정 별 관리 요령- 메탄올</strong><br>
              <div>
                <img src="../assets/warn_01.png" height="100" /> 
                <img src="../assets/warn_04.png" height="100" /> 
                <img src="../assets/warn_09.png" height="100" /> 
              </div>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>건강 및 환경에 대한 유해성, 물리적 위험성</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <v-col cols="12" md="6" sm="12" >
                        - 고인화성 액체 및 증기<br>
                        - 삼키면 유해함<br>
                        - 피부와 접촉하면 유독함<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" >
                        - 흡입하면 유독함<br>
                        - 눈에 심한 자극을 일으킴<br>
                        <span style="text-decoration: underline;">- 신체 중 중추신경계, 시각계에 손상을 일으킴</span><br>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>취급 및 저장방법</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 안전취급요령</span><br>
                      - 피부접촉, 증기흡입 및 눈에 침입 방지<br>
                      - 모든 용기는 접지시킬 것<br><br>
                      <span style="text-decoration: underline;">나. 안전한 저장방법</span><br>
                      - 접지 및 등전위 접지 필요<br>
                      - 옥외 또는 격리된 건물에 보관할 것<br>
                      - 인화성액체와 함께 저장하지 말것것<br>
                      - 혼합금지물질과 분리할 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>적절한 보호구</strong>
                    </div>
                      - 호흡기 보호: 전면형 송기마스크 이상 보호구<br>
                      - 눈 보호: 화학물질용 보안경(취급장소 근처에 눈 세척시설 및 비상세안장치 설치)<br>
                      - 손 보호: 화학물질용 보호장갑<br>
                      - 신체 보호: 화학물질용 보호의<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>응급조치요령</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 눈에 들어갔을 때</span><br>
                      - 많은 양의 물이나 생리식염수로 15분이상 눈을 세척하고 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">나. 피부에 접촉했을 때</span><br>
                      - 오염된 의복 및 신발을 즉시 벗고 15분 이상 다량의 물과 비누로 씻을 것<br><br>
                      <span style="text-decoration: underline;">다. 흡입했을 때</span><br>
                      - 노출로부터 환자를 즉시 신선한 공기가 있는 곳으로 옮기고 호흡정지 및 곤란 시 인공호흡 실시 및 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">라. 먹었을때</span><br>
                      - 구토를 하지 않도록 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">마. 응급처치 및 의사의 주의사항</span><br>
                      - 의료인력이 해당물질에 대해 인지하고 보호조치를 취하도록 할 것것<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>사고 시 대처방법</strong>
                    </div>
                    <span style="text-decoration: underline;">가. 폭발, 화재 시 대처방법</span><br>
                    - 적절한 소화제: 분말소화제, 내알코올성 포말소화제제, 이산화탄소, 물분무<br>
                    - 열분해생성물: 탄소산화물<br>
                    - 위험 없이 할 수 있으면 용기를 화재지역으로부터 이동시킬 것<br>
                    - 방열복 및 공기호흡기 등 필요한 보호구를 반드시 착용 후 화재 진압을 하고 불가능 시 즉각 철수할 것<br>
                    - 진화가 된 후에라도 상당 시간 동안 물 분무로 용기를 냉각시킬 것<br>
                    - 관계인의 접근을 막고 위험 지역을 격리하며 출입을 금지할 것<br><br>
                    <span style="text-decoration: underline;">나. 누출사고 시 대처방법</span><br>
                    - 누출된 물질을 만지지 말것, 흡입과 피부 접촉을 피하고 밀폐장소인 경우 공기호흡기 착용 및 환기시키고 발화원을 제거할 것<br>
                    - 모래, 흙 혹은 기타 적적한 방벽을 쌓아서, 하수구, 도랑 혹은 강으로 번지거나 들어가는 것을 방지할 것<br>
                    - 유출물질은 모래, 점토, 기타 흡착물질로 흡수시킬 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="88" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업공정 별 관리 요령- 아세토니트릴(Acetonitrille)</strong><br>
              <div>
                <img src="../assets/warn_01.png" height="100" /> 
                <img src="../assets/warn_04.png" height="100" /> 
              </div>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>건강 및 환경에 대한 유해성, 물리적 위험성</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <v-col cols="12" md="6" sm="12" >
                        - 고인화성 액체 및 증기<br>
                        - 삼키면 유해함<br>
                        - 피부와 접촉하면 유독함<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" >
                        - 흡입하면 유독함<br>
                        - 눈에 심한 자극을 일으킴<br>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>취급 및 저장방법</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 안전취급요령</span><br>
                      - 피부접촉, 증기흡입 및 눈에 침입 방지<br>
                      - 모든 용기는 접지시킬 것<br><br>
                      <span style="text-decoration: underline;">나. 안전한 저장방법</span><br>
                      - 보관용기는 밀봉하여 건조하고 서늘한 곳, 환기가 잘되는 곳에 저장할 것<br>
                      - 혼합금지물질과 격리시킬 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>적절한 보호구</strong>
                    </div>
                      - 호흡기 보호: 유기용제용 방독마스크<br>
                      - 눈 보호: 화학물질용 보안경(취급장소 근처에 눈 세척시설 및 비상세안장치 설치)<br>
                      - 손 보호: 화학물질용 보호장갑<br>
                      - 신체 보호: 화학물질용 보호의<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>응급조치요령</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 눈에 들어갔을 때</span><br>
                      - 많은 양의 물이나 생리식염수로 15분이상 눈을 세척하고 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">나. 피부에 접촉했을 때</span><br>
                      - 오염된 의복 및 신발을 즉시 벗고 15분 이상 다량의 물과 비누로 씻을 것<br><br>
                      <span style="text-decoration: underline;">다. 흡입했을 때</span><br>
                      - 노출로부터 환자를 즉시 신선한 공기가 있는 곳으로 옮기고 호흡정지 및 곤란 시 인공호흡 실시 및 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">라. 먹었을때</span><br>
                      - 구토를 하지 않도록 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">마. 응급처치 및 의사의 주의사항</span><br>
                      - 흡입한 경우에는 산소의 공급을 고려할 것<br>
                      - 섭취 시 위 세척 및 활성탄 슬러리의 투여를 고려할 것<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>사고 시 대처방법</strong>
                    </div>
                    <span style="text-decoration: underline;">가. 폭발, 화재 시 대처방법</span><br>
                    - 적절한 소화제: 분말소화제, 알코올 폼, 이산화탄소, 물분무<br>
                    - 열분해생성물: 사이안화물, 탄소산화물, 질소산화물<br>
                    - 위험 없이 할 수 있으면 용기를 화재지역으로부터 이동시킬 것<br>
                    - 방열복 및 공기호흡기 등 필요한 보호구를 반드시 착용 후 화재 진압을 하고 불가능 시 즉각 철수할 것<br>
                    - 진화가 된 후에라도 상당 시간 동안 물 분무로 용기를 냉각시킬 것<br>
                    - 관계인의 접근을 막고 위험 지역을 격리하며 출입을 금지할 것<br><br>
                    <span style="text-decoration: underline;">나. 누출사고 시 대처방법</span><br>
                    - 누출된 물질을 만지지 말것, 흡입과 피부 접촉을 피하고 밀폐장소인 경우 공기호흡기 착용 및 환기시키고 발화원을 제거할 것<br>
                    - 환경오염을 피하도록 적절한 차단 수단을 사용할 것. 모래, 흙 혹은 기타 적적한 방벽을 쌓아서, 하수구, 도랑 혹은 강으로 번지거나 들어가는 것을 방지할 것<br>
                    - 유출물질은 모래, 점토, 기타 흡착물질로 흡수시킬 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="89" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업공정 별 관리 요령- 2-프로판올(IPA)</strong><br>
              <div>
                <img src="../assets/warn_01.png" height="100" /> 
                <img src="../assets/warn_09.png" height="100" /> 
                <img src="../assets/warn_13.png" height="100" /> 
              </div>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>건강 및 환경에 대한 유해성, 물리적 위험성</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <v-col cols="12" md="6" sm="12" >
                        - 고인화성 액체 및 증기<br>
                        - 눈에 심한 자극을 일으킴<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" >
                        - 졸음 또는 현기증을 일으킬 수 있음<br>
                        - 삼켜서 기도로 유입되면 치명적일 수 있음<br>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>취급 및 저장방법</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 안전취급요령</span><br>
                      - 피부접촉, 증기흡입 및 눈에 침입 방지<br>
                      - 모든 용기는 접지시킬 것<br><br>
                      <span style="text-decoration: underline;">나. 안전한 저장방법</span><br>
                      - 접지 및 등전위 접지 필요<br>
                      - 옥외 또는 격리된 건물에 보관할 것<br>
                      - 혼합금지 물질과 분리할 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>적절한 보호구</strong>
                    </div>
                      - 호흡기 보호: 유기용제용 방독마스크<br>
                      - 눈 보호: 화학물질용 보안경(취급장소 근처에 눈 세척시설 및 비상세안장치 설치)<br>
                      - 손 보호: 화학물질용 보호장갑<br>
                      - 신체 보호: 화학물질용 보호의<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>응급조치요령</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 눈에 들어갔을 때</span><br>
                      - 많은 양의 물이나 생리식염수로 15분이상 눈을 세척하고 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">나. 피부에 접촉했을 때</span><br>
                      - 오염된 의복 및 신발을 즉시 벗고 15분 이상 다량의 물과 비누로 씻을 것<br><br>
                      <span style="text-decoration: underline;">다. 흡입했을 때</span><br>
                      - 노출로부터 환자를 즉시 신선한 공기가 있는 곳으로 옮기고 호흡정지 및 곤란 시 인공호흡 실시 및 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">라. 먹었을때</span><br>
                      - 구토를 하지 않도록 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">마. 응급처치 및 의사의 주의사항</span><br>
                      - 섭취 시 위 세척 및 활성탄 슬러리의 투여를 고려할 것<br>
                      - 의료인력이 해당물질에 대해 인지하고 보호조치를 취하도록 할 것<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>사고 시 대처방법</strong>
                    </div>
                    <span style="text-decoration: underline;">가. 폭발, 화재 시 대처방법</span><br>
                    - 적절한 소화제: 물분무, 내알코올성 포말, 이산화탄소, 분말 소화 약제<br>
                    - 부적절한 소화제: 고압주수<br>
                    - 열분해생성물: 탄소산화물<br>
                    - 위험 없이 할 수 있으면 용기를 화재지역으로부터 이동시킬 것<br>
                    - 방열복 및 공기호흡기 등 필요한 보호구를 반드시 착용 후 화재 진압을 하고 불가능 시 즉각 철수할 것<br>
                    - 진화가 된 후에라도 상당 시간 동안 물 분무로 용기를 냉각시킬 것<br>
                    - 관계인의 접근을 막고 위험 지역을 격리하며 출입을 금지할 것<br><br>
                    <span style="text-decoration: underline;">나. 누출사고 시 대처방법</span><br>
                    - 누출된 물질을 만지지 말것, 흡입과 피부 접촉을 피하고 밀폐장소인 경우 공기호흡기 착용 및 환기시키고 발화원을 제거할 것<br>
                    - 환경오염을 피하도록 적절한 차단 수단을 사용할 것. 모래, 흙 혹은 기타 적적한 방벽을 쌓아서, 하수구, 도랑 혹은 강으로 번지거나 들어가는 것을 방지할 것<br>
                    - 유출물질은 모래, 점토, 기타 흡착물질로 흡수시킬 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="90" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">3. 화학물질 취급</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업공정 별 관리 요령- 에탄올(Ethanol)</strong><br>
              <div>
                <img src="../assets/warn_01.png" height="100" /> 
                <img src="../assets/warn_09.png" height="100" /> 
                <img src="../assets/warn_13.png" height="100" /> 
              </div>
            </v-card-text>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>건강 및 환경에 대한 유해성, 물리적 위험성</strong>
                    </div>
                    <v-row class="ma-0 mb-2">
                      <v-col cols="12" md="6" sm="12" >
                        - 고인화성 액체 및 증기<br>
                        - 눈에 심한 자극을 일으킴<br>
                        - 유전적인 결함을 일으킬 수 있음<br>
                        - 태아 또는 생식능력에 손상을 일으킬 수 있음<br>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" >
                        - 호흡기계 자극을 일으킬 수 있음<br>
                        - 졸음 또는 현기증을 일으킬 수 있음<br>
                        - 장기간 또는 반복노출되면 신체 중 간, 호흡기 계통통에 손상을 일으킴<br>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>취급 및 저장방법</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 안전취급요령</span><br>
                      - 피부접촉, 증기흡입 및 눈에 침입 방지<br>
                      - 모든 용기는 접지시킬 것<br><br>
                      <span style="text-decoration: underline;">나. 안전한 저장방법</span><br>
                      - 접지 및 등전위 접지 필요<br>
                      - 옥외 또는 격리된 건물에 보관할 것<br>
                      - 인화성 액체와 함께 저장하지 말 것<br>
                      - 혼합금지 물질과 분리할 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>적절한 보호구</strong>
                    </div>
                      - 호흡기 보호: 유기용제용 방독마스크<br>
                      - 눈 보호: 화학물질용 보안경(취급장소 근처에 눈 세척시설 및 비상세안장치 설치)<br>
                      - 손 보호: 화학물질용 보호장갑<br>
                      - 신체 보호: 화학물질용 보호의<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>응급조치요령</strong>
                    </div>
                      <span style="text-decoration: underline;">가. 눈에 들어갔을 때</span><br>
                      - 많은 양의 물이나 생리식염수로 15분이상 눈을 세척하고 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">나. 피부에 접촉했을 때</span><br>
                      - 오염된 의복 및 신발을 즉시 벗고 15분 이상 다량의 물과 비누로 씻을 것<br><br>
                      <span style="text-decoration: underline;">다. 흡입했을 때</span><br>
                      - 노출로부터 환자를 즉시 신선한 공기가 있는 곳으로 옮기고 호흡정지 및 곤란 시 인공호흡 실시 및 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">라. 먹었을때</span><br>
                      - 구토를 하지 않도록 하고 의식이 있을 경우 즉시 2~4컵의 물이나 우유를 제공할 것<br>
                      - 즉시 의사의 치료를 받을 것<br><br>
                      <span style="text-decoration: underline;">마. 응급처치 및 의사의 주의사항</span><br>
                      - 의료인력이 해당물질에 대해 인지하고 보호조치를 취하도록 할 것<br><br>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12" >
                <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                  <v-card-text class="text_first_font lineHeight2">
                    <div class="text-center text-h5">
                      <strong>사고 시 대처방법</strong>
                    </div>
                    <span style="text-decoration: underline;">가. 폭발, 화재 시 대처방법</span><br>
                    - 적절한 소화제: 분말소화약제, 이산화탄소, 물분무, 내알코올성 포말소화제<br>
                    - 열분해생성물: 탄소산화물<br>
                    - 위험 없이 할 수 있으면 용기를 화재지역으로부터 이동시킬 것<br>
                    - 방열복 및 공기호흡기 등 필요한 보호구를 반드시 착용 후 화재 진압을 하고 불가능 시 즉각 철수할 것<br>
                    - 진화가 된 후에라도 상당 시간 동안 물 분무로 용기를 냉각시킬 것<br>
                    - 관계인의 접근을 막고 위험 지역을 격리하며 출입을 금지할 것<br><br>
                    <span style="text-decoration: underline;">나. 누출사고 시 대처방법</span><br>
                    - 누출된 물질을 만지지 말것, 흡입과 피부 접촉을 피하고 밀폐장소인 경우 공기호흡기 착용 및 환기시키고 발화원을 제거할 것<br>
                    - 환경오염을 피하도록 적절한 차단 수단을 사용할 것. 모래, 흙 혹은 기타 적적한 방벽을 쌓아서, 하수구, 도랑 혹은 강으로 번지거나 들어가는 것을 방지할 것<br>
                    - 유출물질은 모래, 점토, 기타 흡착물질로 흡수시킬 것<br>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="91" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">4. 교육</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>SKMJ 주관교육 이수 (이수증 부착)</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 신규출입자 교육<br>
                    - 화재감시자 교육
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>각 협력사 주관 교육 (요청시 교육결과서 제출)</div>
                  </div>
                  <div class="d-flex ml-6">   
                    <div>- 각 법에서 정하는 법정교육</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="92" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">4. 안전교육의 이수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">SK머티리얼즈제이엔씨 주관 공사업체 안전교육</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="col">교육과정</th>
                  <th scope="col">교육대상</th>
                  <th scope="col">교육대상자</th>
                  <th scope="col">인증기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>기본안전교육</td>
                  <td>모든 작업자</td>
                  <td>SK머티리얼즈제이엔씨 내에서 이루어지는 모든작업</td>
                  <td>6개월</td>
                </tr>
                <tr>
                  <td>화재감시자</td>
                  <td>화재감시자</td>
                  <td>화기작업시 해당작업의 화재감시자로 지정된 근로자</td>
                  <td>6개월</td>
                </tr>
                <tr>
                  <td>위험성평가 작성 교육</td>
                  <td>공사 관리자 (현장 소장)</td>
                  <td>SK머티리얼즈제이엔씨 내에서 이루어지는 모든작업</td>
                  <td>최초 1회</td>
                </tr>
              </tbody>
            </table>
            <v-row class="ma-0 mb-2">
              <div class="ml-9" style="text-align: start; line-height: 2;">
                ※ 작업시작전 SK머티리얼즈제이엔씨 주관 안전교육 이수 필요 (기본 작업자, 화재감시자)<br>
                ※ 화재감시자의 경우 기본안전교육이수 이후 추가 교육 진행<br>
                ※ 교육대상자 발생시 사전 요청 필요<br>
                ※ 안전교육필증 미부착 또는 분실시 안전교육 재이수 또는 교육수료 확인 후(통합SHE시스템) 필증 재부착<br>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" sd="12">
                <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                  <div class="ma-4 text-center font-weight-black">
                    <div class="iron_center_contents"><img src="../assets/SKMJ_sticker1.png" style="width: 200px; height: auto; border-radius: 10px;"/></div>
                    기본안전교육 필증
                  </div> 
                  <div class="ma-4 text-center font-weight-black">
                    <div class="iron_center_contents"><img src="../assets/SKMJ_sticker2.png" style="width: 200px; height: auto; border-radius: 10px;"/></div>
                    화재감시자 필증
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="93" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">4. 안전교육의 이수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">각 회사 주관 안전교육</strong><br>
            </v-card-text>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="col">교육과정</th>
                  <th scope="col">교육대상</th>
                  <th scope="col">교육시간 및 주기</th>
                  <th scope="col">교육방법</th>
                  <th scope="col">교육내용</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>정기안전보건교육</td>
                  <td>현장 근로자</td>
                  <td>12시간 / 반기</td>
                  <td>집체, 현장, 이러닝</td>
                  <td rowspan="3">산업안전보건법 시행규칙 별표 5번 확인</td>
                </tr>
                <tr>
                  <td>채용 시 안전보건교육</td>
                  <td>전 근로자</td>
                  <td>1주일이하 / 1시간, 1개월이하 / 4시간, 그 외 / 8시간</td>
                  <td>집체, 현장, 이러닝</td>
                </tr>
                <tr>
                  <td>관리감독자 안전보건교육</td>
                  <td>관리감독자</td>
                  <td>16시간 / 연간</td>
                  <td>사내, 사외, 이러닝</td>
                </tr>
                <tr>
                  <td>특별안전보건교육</td>
                  <td>유해위험작업 종사자</td>
                  <td>최초 16시간 단기간 작업 시 2시간</td>
                  <td>집체, 현장, 해당 회사 집체, 현장 교육</td>
                  <td>1~39 종</td>
                </tr>
                <tr>
                  <td>작업내용 변경 시 안전보건교육</td>
                  <td>전 근로자 (작업변경시)</td>
                  <td>작업 전 / 최초 2시간</td>
                  <td>집체, 현장, 해당 회사 집체, 현장 교육</td>
                  <td>산업안전보건법 시행규칙 별표 5번 확인</td>
                </tr>
                <tr>
                  <td>유해화학물질 취급자 교육</td>
                  <td>유해화학물질 취급 또는 도급신고대상</td>
                  <td>매 2년 마다 16시간</td>
                  <td>사외교육</td>
                  <td></td>
                </tr>
                <tr>
                  <td>유해화학물질 종사자 교육</td>
                  <td>유해화학물질 취급 또는 도급신고대상</td>
                  <td>2시간 / 년</td>
                  <td>사외교육</td>
                  <td></td>
                </tr>
                <tr>
                  <td>MSDS 교육</td>
                  <td>전 근로자</td>
                  <td>1회/ 년</td>
                  <td>집체, 현장</td>
                  <td>본 문서 [3.MSDS] 참고</td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="94" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>적격수급업체평가 (업체등록 시)</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 업체사전평가서 제출/평가<br>
                    - Fail 시 입찰 불가
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>적격수급업체 상세평가 (낙찰 후)</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 공사금액 상관없이 전체<br>
                    - 안전보건관리계획서 제출/평가<br>
                    - Fail 사항 미조치시 작업불가
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="95" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">SKMJ 협력업체 평가</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 적격수급업체 평가(업체등록 시) 자료 및 안전보건관리계획서(계약 시) 제출</strong><br>
                <div class="ml-4">
                  * 적격수급업체 평가 - 입찰 시<br>
                  * 안전보건관리계획서 - 계약 시<br>
                  안전환경관리 계획서 제출은 일정규모 이상(전 공사 (2000만원이상, 미만 구분하여 양식별도) 및 단가도급업체)의 공사를 실시 하는 협력회사<br>
                  단, 선작업이나 긴급작업의 경우 안전시방서를 먼저 제출하고 공사를 시행해야 하며 공사 완료 전에 안전환경관리계획서를 제출하여야 한다.
                  유해화학물질 취급, 고소 및 밀폐작업 등 해당하는 공사의 경우 공사금액과 상관없이 안전관리계획서를 제출 요청할 수 있음.
                </div>
                <strong>▣ 제출기한</strong><br>
                <div class="ml-4">
                  * 공사 요청 부서 및 SHE Part 담당자에게 <span  class="blue--text">입찰평가 전, 입찰시</span> 공사 시작 7일전까지 제출 필요.<br>
                  * 작성 미흡하거나 중요 부분 누락 시 재 작성을 요청할 수 있으며, 안전보건관리계획서 승인이 되지 않은 상태에서 작업불가.
                </div>
                <strong>▣ 제출서류</strong><br>
                <div class="ml-4">
                  - 안전관리계획서(SKMJ양식, 2000만원이상, 미만 구분)<br>
                  - 산업안전보건관리비 사용계획<br>
                  - 각종 중장비, 장비 사용에 대한 추가 서류<br>
                  - 산재보험 가입증명서 (근로자재해보장보험)<br>
                  - 출입인원 명단 및 건설업기초안전보건교육 이수증<br>
                  - 그 외 SKMJ에서 요구하는 서류<br>
                </div>
                <strong>▣ 안전보건관리계획서 평가</strong><br>
                <div class="ml-4">
                  - 제출된 안전환경관리계획서를 바탕으로 하여 적격수급업체 평가를 진행.<br>
                  <span style="color: blue-darken-1; text-decoration: underline;">- 제출서류 중 미제출 또는 수정요청사항 미조치시 작업불가</span><br>
                  ※ 평가 기준은 SKMJ-P-S-20 협력업체 안전환경관리절차 [첨부1] 에 따름<br>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="96" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">SKMJ 협력업체 공사 전 안전관리계획 평가 (2000만원 미만 공사)</strong><br>
              협력회사는 입찰 시 SHE Part에게 안전관리계획 평가를 받아야 함.<br>
            </v-card-text>
            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                평가사항
                <v-spacer></v-spacer>
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              평가사항
            </div>
            <table class="type09 text-center">
              <!-- <thead>
                <tr>
                  <th scope="col">교육과정</th>
                  <th scope="col">교육대상</th>
                </tr>
              </thead> -->
              <tbody>
                <tr>
                  <td> 일반원칙</td>
                  <td>산업안전 관계법령 및 SK머티리얼즈제이엔씨 관련 규정 숙지 및 실천 서약</td>
                </tr>
                <tr>
                  <td>전담인원지정</td>
                  <td>작업장에 안전보건관리인원 배치 계획 수립</td>
                </tr>
                <tr>
                  <td>안전교육</td>
                  <td>공사전 협력업체 안전교육 이수 계획 수립</td>
                </tr>
                <tr>
                  <td>안전작업 허가</td>
                  <td>작업 종류에 따른 안전작업허가 준비 및 이행상태점검 계획 수립</td>
                </tr>
                <tr>
                  <td>위험성평가</td>
                  <td>작업위험성평가 작성 및 법정 교육(특별, 정기, 신규, 건설업기초) , SK머티리얼즈제이엔씨 물질위험성 확인(MSDS)</td>
                </tr>
                <tr>
                  <td>공도구 확인</td>
                  <td>작업에 사용되는 공구 및 장비를 사용전 점검 계획</td>
                </tr>
                <tr>
                  <td>안전보호구</td>
                  <td>작업에 맞는 안전보호구, 안전인증 확인 계획</td>
                </tr>
                <tr>
                  <td>연락체계</td>
                  <td>SK머티리얼즈제이엔씨 공사 담당자, SHE Part 담당자 연락처 확인 비상대응 방안 숙지</td>
                </tr>
                <tr>
                  <td>현장안전</td>
                  <td>중장비 및 화기 작업 시 신호수, 화기감시자 배치 계획 및 적정 장비 사용 공사구역 설정 및 출입 금지 구역 설정 계획 수립</td>
                </tr>
                <tr>
                  <td>산업재해</td>
                  <td>최근 3년간 산업재해 유무</td>
                </tr>
              </tbody>
            </table>
            <div style="text-align:right;" >
              <strong class="indigo--text">제출서류 : SGRs 준수 서약서</strong>
            </div>
            <v-row class="ma-0 mb-2">
              <div class="ml-9" style="text-align: start; line-height: 2;">
                ※ 업체 자체평가 실시후 해당 서류는 최초 작업허가시 SHE Part에게 전달하여 해당 현장 평가를 받고 제출해야함.<br>
                ※ 점수평가 방법<br>
                - 일반원칙 (관련 서약서 서명 실시)<br>
                - 전담인원 지정 (해당인원 현장관리자 업무 시행 확인)<br>
                - 안전교육(작업전 협력업체 안전교육 및 안전교육필증확인)<br>
                - 안전작업허가, 위험성평가, 공도구 확인, 안전보호구, 연락체계, 현장안전 (해당 평가항목에서미흡사항 및 지적 사항 하나 발생시 -2점) 산업재해 (3년간 산업재해 無10점, 2년간 산업재해 無6점, 1년간 산업재해 無4점, 1년미만 산업재해 有0점)<br>
              </div>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="97" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 적용대상</strong><br>
                <div class="ml-4">
                  * 산업안전보건관리비는 일정규모 이상(총 공사금액 2,000만원 이상)의 공사를 실시하는 협력회사<br>
                </div>
                <strong>▣ 계상 방법 (25년 1월 1일 이후 공사)</strong><br>
                <div class="ml-4">
                  <v-col cols="12" md="12" sd="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div style="margin-left:-35%" class="iron_center_contents"><img src="../assets/SKMJ_cost.png" style="width: 50%; height: auto; border-radius: 0px;"/></div>
                      </div> 
                    </div>
                    <div style="text-align: start; line-height: 1.5;" class="text-h6">
                      ※ 대상액: 직접 재료비 + 간접 재료비 + 직접노무비<span style="color: red">(대상액이 구분되지 않은 경우: 총공사금액의 70%를 대상액으로 산정ㆍ계상)</span><br>
                      단, 발주자가 재료를 제공하거나 물품이 완제품의 형태로 제작 또는 납품되어 설치되는 경우에는 재료비 또는 완제품의 가액을 포함시키지 않은 대상액을 기준으로 계상한 안전관리비의 1.2배를 초과할 수 없음<br>
                    </div>
                  </v-col>
                </div>
                
                <strong>▣ 계상 시 유의사항</strong><br>
                <div class="ml-4">
                  * 공사 종류 및 안전관리비 계상 비율 확인하여 계상 필요<br>
                  * 안전관리비 미사용 및 부적절한 용도 사용시 해당 비용 반환<br>
                  * 공정률에 따른 안전관리비 사용 계상 확인 필요<br>
                </div>
              </div>
            </v-card-text>
            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="col">공정율</th>
                  <th scope="col">50% 이상 ~ 70% 미만</th>
                  <th scope="col">70% 이상 ~ 90% 미만</th>
                  <th scope="col">90% 이상</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>사용기준</td>
                  <td>50% 이상</td>
                  <td>70% 이상</td>
                  <td>90% 이상</td>
                </tr>
              </tbody>
            </table>
            - 자세한 사항 고용노동부고시 제2023-49호, 건설업 산업안전보건관리비 계상 및 사용기준 참조
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="98" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용 항목</strong><br>
                <div class="ml-4">
                  1. 안전관리자‧보건관리자의 임금 등<br>
                  ① 안전관리자‧보건관리자 선임 대상 공사의 전담업무 안전관리자‧보건관리자<br>
                  ② 안전‧보건관리 업무를 전담하지 않는 <span class="blue--text">안전‧보건관리자의 임금과 출장비의 각각 2분의 1</span>에 해당하는 비용<br>
                  ③ 안전관리자를 선임한 건설공사 현장에서 산재예방 업무만을 수행하는 <span class="blue--text">작업지휘자, 유도자, 신호자 등의 임금 전액</span><br>
                  ※ 안전관리자 선임 의무가 없는 현장의 경우도 사용 가능<br>
                  ➃ 별표 1의2 (특별안전보건교육 중 건설업해당)에 해당하는 작업을 직접 지휘･감독하는 직･조･반장 등 관리감독자의 직위에 있는 자가 영 제15조제1항(관리감독자의 업무) 에서 정하는 업무를 수행하는 경우에 지급하는 업무수당(임금의 10분의 1 이내)<br>
                </div>
                <div class="ml-4 mt-4">
                  2. 안전시설비 등<br>
                  ① 산업재해 예방을 위한 안전난간, 추락방호망, 안전대 부착설비,방호장치(기계‧기구와 방호장치가 일체로 제작된 경우 방호장치부분의 가액에 한함) 등 안전시설의 구입‧임대 및 설치, 해체를 위해 소요되는 비용<br>
                  <span class="blue--text">※ 안전방호장치가 아닌 시설물 설치시 비용처리 불가능</span>
                  ② 용접 작업 등 화재 위험작업 시 사용하는 소화기의 구입・임대비용<br>
                  ③ 스마트 안전장비 구입 임대 비용 (상세내용은 사용기준 참고)<br>
                </div>
                <div class="ml-4 mt-4">
                  3. 보호구 등<br>
                  <span class="blue--text">① 안전보호구 구매 및 유지 보수 비용</span>
                  <span class="blue--text">② 안전・보건관리자(선임필요)</span> 등의 업무용 피복, 기기 등을 구입하기 위한 비용, 점검 목적으로 사용하는 차량 유지 비용<br>
                </div>
                <div class="ml-4 mt-4">
                  4. 안전보건 진단비<br>
                  ① 유해위험방지계획서 작성 등에 소요되는 비용<br>
                  ② 안전보건진단에 소요되는 비용<br>
                  ③ 작업환경 측정에 소요되는 비용<br>
                  ➃ 산업재해예방을 위해 법에서 지정한 전문기관 등에서 실시하는 진단, 검사, 지도 등에 소요되는 비용<br>
                </div>
                - 자세한 사항 고용노동부고시 제2023-49호, 건설업 산업안전보건관리비 계상 및 사용기준 참조
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="99" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용 항목</strong><br>
                <div class="ml-4">
                  5. 안전보건교육비 등<br>
                  ① 의무교육이나 이에 준하는 교육을 위한 건설공사 현장의 교육 장소 설치・운영등에 소요되는 비용<br>
                  ※ 교육장 사용 목적으로 임대하는 컨테이너 임대 비용은 사용 가능하나, 컨테이너 구매에 소요되는 비용은 사용 불가<br>
                  ② 산업재해 예방 목적을 가진 다른 법령상 의무교육을 실시하기 위해 소요되는 비용 (산업안전보건법 이외 법 안전교육 가능)<br>
                  ③ 업무수행을 위해 필요한 정보를 취득하기 위한 목적으로 도서, 정기간행물을 구입하는 데 소요되는 비용<br>
                  ➃ 건설공사 현장에서 안전기원제 등 산업재해 예방을 기원하는 행사를 개최하기 위해 소요되는 비용<br>
                  ⑤ 건설공사 현장의 유해‧위험요인을 제보하거나 제도개선 방안 등을 제안한 근로자를 격려하기 위해 지급하는 비용<br>
                  ⑥ 안전보건교육 대상자 등에게 구조 및 응급처치에 관한 교육을 실시하기 위해 소요되는 비용<br>
                </div>
                <div class="ml-4 mt-4">
                  6. 근로자 건강장해예방비<br>
                  ① 법령에 규정되어 있거나 그에 준하여 요구되는 근로자의 각종 건강장해 예방에 필요한<br>
                  ※ 법・영・규칙 및 고시에서 규정하거나 그에 준하여 요구되는 근로자의 건강관리를 위한 각종 비용<br>
                  (탈수 예방 목적의 분말형태 이온음료, 정제된 소금 등) 및 작업의 특성에 따라 근로자 건강보호를 위해 소요되는 비용 등<br>
                  ② 감염병 확산 방지를 위한 마스크, 손소독제, 체온계 구입비<br>
                  ③ 휴게시설을 갖춘 경우 운도, 조명 설치·관리기준을 준수 하기 위해 소요되는 비용<br>
                  ➃ 건설공사 현장에서 근로자 심폐소생을 위해 사용되는 자동심장충격기(AED) 구입에 소요되는 비용<br>
                </div>
                <div class="ml-4 mt-4">
                  <v-card>
                    ※ 예시 : 혹서기 건설공사 현장 근로자에게 생수병을 제공하려는 경우<br>
                    ① 법 제36조에 따른 위험성평가 시 생수 부족에 대한 위험요인 분석<br>
                    ② 법 제75조 노사협의체에서 안전보건관리비로 생수병 구입･제공 결정<br>
                    ☞ 해당 증빙자료 등 작성･보존 후 안전보건관리비(생수병 구입) 사용<br>
                  </v-card>
                </div>
                - 자세한 사항 고용노동부고시 제2023-49호, 건설업 산업안전보건관리비 계상 및 사용기준 참조
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="100" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용 불가 항목</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">구분</th>
                    <th scope="col">사용불가 품목 및 주요 사례</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>인건비</td>
                    <td>
                    - 공사 도급내역서에 유도자 또는 신호자 인건비가 반영된 경우<br>
                    - 유도자 또는 신호수가 유도‧신호업무만을 전담하지 않은 경우<br>
                    - 유도자 또는 신호수가 사업장 주변 교통정리, 민원 및 환경 관리 등의 업무를 병행하는 경우<br>
                    - 보조원이 안전･보건관리업무 외의 업무를 겸임하는 경우<br>
                    - 산재예방과 무관한 업무에 종사하는 경비원, 청소원, 폐자재 처리원 및 사무보조원 임금<br>
                    </td>
                  </tr>
                  <tr>
                    <td>시설비</td>
                    <td>
                      - 외부인 등을 대상으로 하는 안내시설물․표지<br>
                      ※ 외부인 출입금지 표지, 공사장 경계표시를 위한 가설울타리 등<br>
                      - 공사수행에 필요한 비계, 작업발판, 가설계단･통로, 사다리 등<br>
                      ※ 안전발판, 안전통로, 안전계단 등 명칭에 관계없이 공사 수행에 필요한 가시설물은 사용 불가<br>
                      ※ 단, 비계･통로･계단에 추가 설치하는 추락방지용 안전난간, 사다리 전도방지장치, 틀비계에 별도로 설치하는 안전난간･사다리, 통로의 낙하물 방호선반 등은 사용 가능<br>
                      - 절토부 및 성토부 등의 토사유실 방지를 위한 설비<br>
                      - 작업장 간 상호 연락, 작업상황 파악 등 목적의 통신시설･설비<br>
                      ※ 스마트 안전시설･장비에 해당할 경우 예외적으로 인정<br>
                      - 건설장비의 운행 감시, 공사 진척상황 확인 등 목적의 CCTV 등 감시용 장비<br>
                      - 소음・환경 등 민원예방, 교통통제 등 목적의 표지･시설물<br>
                      ※ 공사안내･경고 표지판, 차량유도등･점멸등, 라바콘, 현장경계펜스, PE드럼 등<br>
                      - 동일 시공업체 소속의 타 현장에서 사용한 안전시설물을 전용 하여 사용할 때의 자재비(다만, 운반비는 사용가능)<br>
                      - 기성제품에 부착된 안전장치(기성제품에 부착된 안전장치고장 시 수리･교체비용은 사용 가능)<br>
                      ※ 톱날과 일체식으로 제작된 목재가공용 둥근톱의 톱날접촉 예방장치, 플러그와 접지 시설이 일체식 으로 제작된 접지형 플러그 등<br>
                      - 공사수행용 시설과 일체형인 안전시설 설치비<br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            - 자세한 사항 고용노동부고시 제2023-49호, 건설업 산업안전보건관리비 계상 및 사용기준 참조
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="101" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용 불가 항목</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">구분</th>
                    <th scope="col">사용불가 품목 및 주요 사례</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>보호구</td>
                    <td>
                      - 카메라, 컴퓨터, 프린터 등 사무용 기기<br>
                      - 근로자 보호목적 외 작업복, 면장갑, 코팅장갑 등 피복･장구류<br>
                      ※ 미세먼지 마스크, 쿨토시, 아이스조끼, 핫팩, 발열조끼는 사용가능<br>
                      - 감리원 또는 외부방문 인사 등에게 지급하는 보호구<br>
                    </td>
                  </tr>
                  <tr>
                    <td>안전진단비</td>
                    <td>
                      - ｢건설기술진흥법｣, ｢건설기계관리법｣등에 따른 가설구조물 등 구조검토, 안전점검 및 검사, 차량계 	건설기계의 신규등록･정기･구조변경･수시･확인검사 등<br>
                      - ｢전기사업법｣에 따른 전기안전대행<br>
                      - ｢환경법｣에 따른 외부 환경 소음 및 분진 측정<br>
                      - 기타 산안법 외 타 법령에 따른 진단에 소요되는 비용<br>
                      - 자전거, 전동킥보드, 오토바이, 자동차 등 안전순찰차량 임대･구입 비용<br>
                      ※ 단, 전담 안전･보건관리자가 선임･신고된 사업장 내 안전순찰 차량의 유류비･수리비･보험료는 사용 가능<br>
                    </td>
                  </tr>
                  <tr>
                    <td>교육비 · 행사비</td>
                    <td>
                      - 해당 현장이 아닌 장소에 설치하는 교육장의 설치・해체・운영비<br>
                      ※ 다만, 교육장소 부족, 교육환경 열악 등의 부득이한 사유로 해당 현장 내 교육장 설치가 곤란하여 현장 인근지역에 교육장을 설치하는 데 소요되는 비용은 사용가능<br>
                      - 교육장의 대지 구입비, 컨테이너 구입비 등 자산취득 비용<br>
                      - 교육장 운영과 관련 없는 전화기, 냉장고 등 비품 구입비<br>
                      - 안전관리 활동 기여도와 관계없이 일률적으로 지급하는 포상품<br>
                      - 안전관리자 협의체 등에서 적립을 위해 사용하는 회비<br>
                      - 안전보건 등 산업재해 예방에 관한 전문적, 기술적 정보제공이 주목적이 아닌 정기간행물 등 구독비용<br>
                      - 현장의 안전관리 활동을 홍보하기 위한 광고비용<br>
                      - 준공식 등 무재해 기원과 관계없는 행사 / 산업안전보건의식 고취 목적이 없는 단순 회식경비<br>
                      - 산재예방 목적으로 볼 수 없는 단순 교양･오락성 교육비용<br>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            - 자세한 사항 고용노동부고시 제2023-49호, 건설업 산업안전보건관리비 계상 및 사용기준 참조
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="102" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용 불가 항목</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">구분</th>
                    <th scope="col">사용불가 품목 및 주요 사례</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>건강 진단비</td>
                    <td>
                      - 복리후생 등 목적으로 휴식 시간에 사용하는 휴게시설, 탈의실, 이동식 화장실, 세면･샤워시설 설치비용<br>
                      ※ 분진･유해물질사용･석면해체제거 작업장에 설치하는 탈의실, 세면･샤워시설 설치비용은 사용 가능<br>
                      - 복리후생 목적의 급수시설, 정수기, 자외선 차단용품 등<br>
                      - 혹서･혹한기 건강 증진을 위한 보양식･보약 등 구입비용<br>
                      ※ 작업 중 혹한･혹서 등을 피하기 위한 간이 휴게시설 설치･해체･유지비용, 탈수방지 목적의 소금 정제비, 제빙기 임대 비용(6~10월에 한함)은 사용 가능<br>
                      - 체력단련 시설 및 운동 기구 등 구입･임대비<br>
                      - 작업장이 아닌 기숙사, 현장사무실 등의 방역･소독･방충비용<br>
                      - 병･의원 등 진료비, 암 검사비, 국민건강보험 납입비용 등<br>
                      - 파상풍, 독감 등 감염병 예방을 위한 접종 또는 의약품 등 구입비용<br>
                      - 다른 법에 따라 의무적으로 실시해야 하는 건강검진 비용<br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            - 자세한 사항 고용노동부고시 제2023-49호, 건설업 산업안전보건관리비 계상 및 사용기준 참조
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="103" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용계획서 작성</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <v-row>
                <v-col cols="12" md="6" sd="12">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div  class="iron_center_contents"><img src="../assets/SKMJ_plan1.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
                <v-col cols="12" md="6" sd="12">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMJ_plan2.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="104" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">5. 협력업체 SHE 평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 사용내역 작성시 첨부사항</strong><br>
                1. 제출 시기<br>
                - 1개월 미만 공사: 공사종료 후 1개월이내<br>
                - 1개월 이상 공사: 매월 말일 (30 ~ 31일) 까지<br>
                2. 제출처 : SHE Part, 주관부서 담당자 송부<br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <v-row>
                <v-col cols="12" md="4" sd="12">
                  <strong class="ml-3"> ·  사용 내역서</strong><br>
                  <span class="ml-6">1. 해당 월에 입고된 내역 작성</span><br>
                  <span class="ml-6"></span><br>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div  class="iron_center_contents"><img src="../assets/SKMJ_sheet1.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
                <v-col cols="12" md="4" sd="12">
                  <strong class="ml-3"> ·  계산 내역서</strong><br>
                  <span class="ml-6">1. 세금계산서</span><br>
                  <span class="ml-6">2. 거래내역서(수량 표기)</span><br>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMJ_sheet2.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
                <v-col cols="12" md="4" sd="12">
                  <strong class="ml-3"> ·  증빙 서류</strong><br>
                  <span class="ml-6">1. 실 입고된 물품의 사진 대지</span><br>
                  <span class="ml-6">2. 안전 인증서</span><br>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMJ_sheet3.png" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="105" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">6. 건설기계 연식제한</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>제한연식 사전 확인 및 작업투입</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 건설기계 투입 전 제한연식 확인<br>
                    - 제한연식 초과 시, 안전성검사(+비파괴검사) 증빙
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="106" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">6. 건설기계 연식제한</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">각 건설기계별 연식제한 및 추가서류</strong><br>
              <!-- <div class="mt-4 ml-4">
                <strong>▣ 사용 불가 항목</strong><br>
              </div> -->
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th rowspan="2">구 분</th>
                    <th rowspan="2">사 진</th>
                    <th rowspan="2">제한 연식</th>
                    <th rowspan="2">필수 서류</th>
                    <th colspan="2">제한 연식 불가 時 추가 확인 조건</th>
                    <th rowspan="2">비 고<span  class="blue--text">(수입 장비 경우)</span></th>
                  </tr>
                  <tr>
                    <th>점 검</th>
                    <th>서 류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>지게차</td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_mach1.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                        단, 3톤 미만 제외
                      </div> 
                    </td>
                    <td>10년</td>
                    <td>6종</td>
                    <td rowspan="5"><span style="text-decoration:underline"><strong>고용노동부 인정기관</strong></span><br> 안정성 검사 실시<span class="blue--text">(최근 6개월 내)</span></td>
                    <td>- 안전성검사 보고서<br>- 비파괴검사 성적서</td>
                    <td rowspan="5">[제조연식 확인목적]<br>1. 수입면장(수입신고필증)<br>2. 형식승인(신고) 수리 공문<br>3. 건설기계 제작증</td>
                  </tr>
                  <tr>
                    <td>이동식 크레인</td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_mach2.png" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>10년</td>
                    <td>8종</td>
                    <td>- 안전성검사 보고서</td>
                  </tr>
                  <tr>
                    <td>굴착기</td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_mach3.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>10년</td>
                    <td>6종</td>
                    <td>- 안전성검사 보고서<br>- 비파괴검사 성적서</td>
                  </tr>
                  <tr>
                    <td>고소작업대(차량)</td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_mach4.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>7년</td>
                    <td>8종</td>
                    <td>- 안전성검사 보고서</td>
                  </tr>
                  <tr>
                    <td>고소작업대(시저)</td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_mach5.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>7년</td>
                    <td>4종</td>
                    <td>- 안전성검사 보고서<br>- 비파괴검사 성적서</td>
                  </tr>
                </tbody>
              </table>
            </div>
            - 작업인원 탑승 7년 그 外 10년 기준, 기준 미충족 時 노동부 인정기관 검사보고서 확인 必
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="107" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">6. 건설기계 연식제한</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">장비별 서류</strong><br>
              <!-- <div class="mt-4 ml-4">
                <strong>▣ 사용 불가 항목</strong><br>
              </div> -->
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th>구 분</th>
                    <th>지게차</th>
                    <th>이동식 크레인</th>
                    <th>굴착기</th>
                    <th>고소작업대(차량)</th>
                    <th>고소작업대(시저)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>공통</td>
                    <td colspan="5">- 사업자 등록증&nbsp;&nbsp;&nbsp;&nbsp;- 보험증권 사본&nbsp;&nbsp;&nbsp;&nbsp;- 장비 제원표</td>
                  </tr>
                  <tr>
                    <td>장비별</td>
                    <td>
                      - 건설기계 등록, 검사증<br>
                      - 건설기계 조종사 면허증<br>
                      - 건설기계 조종사 안전교육 이수증<br>
                    </td>
                    <td>
                      - 건설기계 등록, 검사증<br>
                      - 건설기계 조종사 면허증<br>
                      - 건설기계 조종사 안전교육 이수증<br>
                      - 작업반경도<br>
                      - 비파괴검사 성적서(6개월 이내)<br>
                    </td>
                    <td>
                      - 건설기계 등록, 검사증<br>
                      - 건설기계 조종사 면허증<br>
                      - 건설기계 조종사 안전교육 이수증<br>
                    </td>
                    <td>
                      - 차량 등록, 검사증<br>
                      - 운전면허증<br>
                      - 안전인증서<br>
                      - 작업반경도<br>
                      - 비파괴검사 성적서(6개월 이내)<br>
                    </td>
                    <td>
                      - 안전인증서<br>
                    </td>
                  </tr>
                </tbody>
              </table>


              <table class="type09 text-center mt-5">
                <thead>
                  <tr>
                    <th>사업자등록증</th>
                    <th>보험증권</th>
                    <th>장비 제원표</th>
                    <th>건설기계 등록증, 검사</th>
                    <th>건설기계조종사 면허증</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit1.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                        
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit2.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
            
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit3.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
   
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit4.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
              
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit5.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                    
                      </div> 
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th>안전교육 이수증</th>
                    <th>작업반경도</th>
                    <th>크레인 제원표</th>
                    <th>비파괴검사 성적서</th>
                    <th>안전 인증서</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit6.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                        
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit7.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                   
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit8.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit9.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                  
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit10.jpg" style="width: 50%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="108" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">6. 건설기계 연식제한</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">장비별 서류</strong><br>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center mt-5">
                <thead>
                  <tr>
                    <th>안전성 검사 보고서</th>
                    <th>수입면장(수입장비)</th>
                    <th>형식승인 수리공문</th>
                    <th>건설기계 제작증</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit11.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit12.jpg" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit13.png" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents"><img src="../assets/SKMJ_limit14.png" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="type09 text-center mt-5">
                <thead>
                  <tr>
                    <th colspan="5">고용노동부 인정기관</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>지방청</td>
                    <td>기관명</td>
                    <td>주 소</td>
                    <td>전화번호</td>
                    <td>2022년 평가등급</td>
                  </tr>
                  <tr>
                    <td>· 중부청</td>
                    <td>
                      · 에스솔류션<br>
                      · 한국산업안전검사<br>
                    </td>
                    <td>
                      · 경기 하남시 하남대로 947<br>
                      · 경기 수원시 장안로 458번길 75<br>
                    </td>
                    <td>
                      · 02-525-1952<br>
                      · 031-252-9411<br>
                    </td>
                    <td>
                      · B<br>
                      · B<br>
                    </td>
                  </tr>
                  <tr>
                    <td>· 부산청</td>
                    <td>
                      · 코리아 안전검사<br>
                      · 한국산업안전검사<br>
                    </td>
                    <td>
                      · 울산광역시 남구 삼호로 37번길 8-1<br>
                      · 경남 창원시 의창구 차상로 72번길 2<br>
                    </td>
                    <td>
                      · 052-267-4090<br>
                      · 055-276-3722<br>
                    </td>
                    <td>
                      · A<br>
                      · A<br>
                    </td>
                  </tr>
                  <tr>
                    <td>· 대구청</td>
                    <td>
                      · 지스텍<br>
                      · 한국산업안전검사<br>
                    </td>
                    <td>
                      · 경북 포항시 남구 대송면 장동홍계길 205<br>
                      · 경북 포항시 북구 두호로 56<br>
                    </td>
                    <td>
                      · 054-173-8130<br>
                      · 054-1544-0017<br>
                    </td>
                    <td>
                      · A<br>
                      · A<br>
                    </td>
                  </tr>
                  <tr>
                    <td>· 대전청</td>
                    <td>
                      · 코리아종압안전<br>
                      · 유양에스엔지주식회사<br>
                    </td>
                    <td>
                      · 대전광역시 유성구 갑천로 361-35<br>
                      · 충남 당진시 송산면 삼무로 19<br>
                    </td>
                    <td>
                      · 042-472-7768<br>
                      · 041-680-7604<br>
                    </td>
                    <td>
                      · A<br>
                      · B<br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="109" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>위험성평가 실시</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 작업허가 전 제출<br>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>TBM (Tool Box Meeting)</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 작업 전 실시<br>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>안전작업허가</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 작업 준비 완료 후 허가 실시<br>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="110" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 작업위험성평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <!-- <strong class="deep-orange--text">산업안전보건 관리비</strong><br> -->
              협력회사는 사업장의 유해 · 위험요인을 파악하고 해당 유해 · 위험 요인에 의한 부상 또는 질병의 발생 가능성(빈도)과 중대성(강도)을 추 정·결정하여 감소 대책을 수립해야 한다. 
              또한 경영책임자는 파악된 유해 · 위험요인의 개선을 위해 필요한 자원을 제공 하고 개선여부를 반기 1회 이상 점검 하여야함.
              <div class="mt-4 ml-4">
                <strong>▣ 준수 가이드</strong><br>
                - 위험성평가는 모든 근로자가 참여 하여 진행해야 함.<br>
                - 위험성 감소대책 및 이행여부 확인 필요<br>
                - SKMJ는 협력업체가 실시한 위험성평가를 검토하여 미흡한 사항에 대해 추가 위험성평가를 요청할수 있음<br>
                - 현장 관리자는 SKMJ에서 진행하는 작업위험성평가 교육을 이수 해야한다.<br>
                <strong>▣ 위험성평가 실시시기</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">구분</th>
                    <th scope="col">수행시기</th>
                    <th scope="col">참여자</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>최초</td>
                    <td>
                    - 전체 작업에 대해 처음으로 실시<br>
                    </td>
                    <td rowspan="3">
                    관리감독자(현장소장, 담당자)<br>
                    </td>
                  </tr>
                  <tr>
                    <td>정기</td>
                    <td>
                    - 최초 평가 후 매년(1회/년) 모든 단위 작업별 위험성 평가 재실시<br>
                    </td>
                  </tr>
                  <tr>
                    <td>수시</td>
                    <td>
                    - 중대산업사고 또는 산업재해 발생 시<br>
                    - 이상등급 이상의 인적, 물적사고, 아차사고의 경우 필요 시<br>
                    - 작업장 변경 시(작업자, 설비, 작업방법 및 절차 등의 변경)<br>
                    - 건설물, 기계, 기구, 설비의 정비 또는 보수 작업 시<br>
                    - 작업절차 등에 규정되지 않은 비정형화된 작업을 실시 시<br>
                    - 유해, 위험요인 정보 및 지식 변경으로 관리방법 변경이 필요할 시<br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <v-card-text class="education_content lineHeight2 mr-5 ml-2">
              <strong>▣ 위험성평가 기법</strong><br>
              - JSA (작업위험성평가) 권장<br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="111" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 작업위험성평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업안전보건 관리비</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 위험성평가 교육실시</strong><br>
                <div class="ml-4">
                  * 협력업체 작업 부서에서는 위험성평가를 실시한 경우 실시 내용과 결과를 기록해야 하며, 위험성평가를 해당 구성원이 알수 있도록 위 험성평가 방침, 추진 목표 및 그밖의 주지 사항을 회의 또는 TBM을 통해 교육을 진행해야함.<br>
                </div>
                <strong>▣ 위험성평가 절차</strong><br>
                <div class="ml-4">
                  <v-col cols="12" md="12" sd="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div style="margin-left:-35%" class="iron_center_contents"><img src="../assets/SKMJ_evaluationProcess.png" style="width: 80%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                    <div style="text-align: start; line-height: 1.5;" class="text-h6">
                      사전준비1) : 위험성평가 대상 작업목록 확보, 작업절차서, 위험성평가 실시계획 작성, 각종 자료수집<br>
                      유해위험요인파악2) : 순회점검, 안전보건 체크리스트 등을 활용한 <span  class="blue--text">현장 작업 중 유해.위험요인 파악 실시</span><br>
                      위험성 추정3) : 유해.위험요인의 <span  class="blue--text">가능성(빈도)과 중대성(강도)을 추정</span>(위험성 계산 = 가능성 X 중대성)<br>
                      위험성 결정4) : 현재 수립된 각 단위작업별 안전대책.기준 등을 비교하여 <span  class="blue--text">가능성(빈도)과 중대성(강도)을 결정</span><br>
                      위험성 감소대책 수립.실행5) : 합리적으로 실천 가능한 범위에서 <span  class="blue--text">유해.위험요인</span>을 낮은 수준으로 <span  class="blue--text">감소</span>시키기 위한 대책 수립.실행<br>
                    </div>
                  </v-col>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="112" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 작업위험성평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 위험성평가 JSA 양식</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <v-row>
                <v-col cols="12" md="6" sd="12">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div  class="iron_center_contents"><img src="../assets/SKMJ_evaluation1.png" style="width: 80%; height: auto; border-radius: 0px;"/></div>
                    </div> 
                  </div>
                </v-col>
                <v-col cols="12" md="6" sd="12">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <v-card-text class="education_content lineHeight2 mr-5 " style="color: #666666;">
                      <div class="mt-0 ml-4">
                        <strong>▣ 위험성평가 JSA 양식</strong><br>
                        - 모든 JSA 과정에서 최초 준비 단계와 정리정돈 단계가 필요함<br>
                        - 단계별 위험성 파악 시 모든 위험요소 추가 필요
                      </div>
                    </v-card-text>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="113" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 작업위험성평가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 위험성평가 JSA 위험요인 예시표</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">대분류</th>
                    <th scope="col">중분류</th>
                    <th scope="col">대분류</th>
                    <th scope="col">중분류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>떨어짐(높이가 있는 곳에서 사람이 떨어짐)</td>
                    <td>
                      - 계단, 사다리에서 떨어짐<br>
                      - 개구부 등 지면에서 떨어짐<br>
                      - 재료더미 및 적재물에서 떨어짐<br>
                      - 지붕에서 떨어짐<br>
                      - 비계 등 가설구조물에서 떨어짐<br>
                      - 건물 대들보나 철골 등 기타 구조물에서 떨어짐<br>
                      - 운송수단 또는 기계 등 설비에서 떨어짐<br>
                    </td>
                    <td>
                      무너짐 (건축물이나 쌓인 물체가 무너짐)<br>
                    </td>
                    <td>
                      - 상세정보 부족한 무너짐<br>
                      - 도랑의 굴착사면 무너짐<br>
                      - 적재물 등의 무너짐<br>
                      - 건축물 구조물의 무너짐<br>
                      - 가설구조물의 무너짐<br>
                      - 절취사면 등의 무너짐<br>
                      - 기타 무너짐<br>
                    </td>
                  </tr>

                  <tr>
                    <td>넘어짐(사람이 미끄러지거나 넘어짐)</td>
                    <td>
                      - 상세정보 부족 넘어짐<br>
                      - 계단에서 넘어짐 , 바닥에서 미끄러져 넘어짐<br>
                      - 바닥의 돌출물 등에 걸려 넘어짐<br>
                      - 운송수단, 설비에서 넘어짐<br>
                      - 기타 넘어짐<br>
                    </td>
                    <td>
                      감전<br>
                    </td>
                    <td>
                      - 상세정보 부족 감전<br>
                      - 충전부에 감전<br>
                      - 누설전류에 감전<br>
                      - 아크감전(접촉)<br>
                      - 기타 감전<br>
                    </td>
                  </tr>
                  <tr>
                    <td>깔림(물체의 쓰러짐이나 뒤집힘)</td>
                    <td>
                      - 상세정보부족 깔림 · 뒤집힘<br>
                      - 쓰러지는 물체에 깔림<br>
                      - 운송수단 등 뒤집힘<br>
                      - 기타 깔림 · 뒤집힘<br>
                    </td>
                    <td>
                      절단 · 배임 · 찔림<br>
                    </td>
                    <td>
                      - 상세정보부족 절단 · 베임 · 찔림<br>
                      - 회전날 등에 의한 절단, 취급물체에 의한 절단<br>
                      - 회전날 등에 의한 베임<br>
                      - 취급물체에 의한 베임 찔림<br>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      부딪힘(물체에 부딪힘)<br>
                    </td>
                    <td>
                      - 상세정보 부족 부딪힘<br>
                      - 사람에 의한 부딪힘<br>
                      - 바닥에서 구르는 물체에 부딪힘<br>
                      - 흔들리는 물체 등에 부딪힘<br>
                      - 취급, 사용 물체에 부딪힘<br>
                      - 차량 등과의 부딪힘<br>
                    </td>
                    <td>끼임 (기계설비에 끼이거나 감김)</td>
                    <td>
                      - 상세정보 부족 끼임 · 감김<br>
                      - 직선운동 중인 설비. 기계 사이에 끼임<br>
                      - 회전부와 고정체 사이의 끼임<br>
                      - 두 회전체의 물림점에 끼임<br>
                      - 회전체 및 돌기부에 감김<br>
                      - 인력운반 · 취급중인 불체에 끼임<br>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      맞음(날아오거나 떨어진 물체에 맞음)<br>
                    </td>
                    <td>
                      - 상세정보 부족 날아옴 · 떨어짐<br>
                      - 떨어진 물체에 맞음<br>
                      - 날아온 물체에 맞음<br>
                      - 기타 날아옴 · 떨어짐<br>
                    </td>
                    <td>불균형 및 무리한 동작</td>
                    <td>
                      - 상세정보 부족 불균형 및 무리한 동작<br>
                      - 신체 불균형 동작<br>
                      - 과도한 무리한 힘 · 동작<br>
                      - 기타 불균형 및 무리한 동작<br>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      폭발 · 파열<br>
                    </td>
                    <td>
                      - 상세정보부족 폭발<br>
                      - 기계 · 설비의 폭발<br>
                      - 캔 · 드럼 폭발, 파열 ,기타 폭발<br>
                    </td>
                    <td>화학물질 누출 · 접촉</td>
                    <td>
                      - 상세정보부족 화학물질누출 · 접촉<br>
                      - 화학물질 누출<br>
                      - 화학물질 접촉<br>
                      - 기타 화학물질 누출 · 접촉<br>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      화재<br>
                    </td>
                    <td>
                      - 화재<br>
                    </td>
                    <td>
                      이상온도 · 물체접촉<br>
                    </td>
                    <td>
                      - 이상온도 물체접촉<br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="114" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              작업 현장 근처에서 작업 전에 관리감독자(작업반장, 직장, 팀장 등)를 중심으로 작업자들이 모여 작업의 내용과 안전 작업 절차 등에 대해 서로 확인 및 의논하는 활동 약칭<br>
              ※ TBM 실행 시간은 산업안전보건법상의 안전보건교육시간으로 인정
              <div class="mt-4 ml-4">
                <strong>▣ 실행 시간과 장소</strong><br>
                <div class="ml-4">
                  - TBM은 작업자가 작업을 하는 현장에서 작업 전에 빠르고 쉽게 진행하는 간단한 브리핑<br>
                  - 이러한 특성을 고려할 때 TBM은 10분 내외로 실행하는 것이 효과적<br>
                  - 다만, 이 시간 동안에는 가급적 다른 주제 또는 여러 주제를 같이 논의하지 않아야 함.<br>
                </div>
                <div class="ml-4 mt-4">
                  <strong>▣ TBM 효과</strong><br>
                  <div class="ml-4">
                    - 주기적인 TBM 활동은 작업자가 안전하게 작업하는 데 많은 도움을 줍니다.<br>
                    - 특히, 위험성평가에 기반한 TBM을 통해 작업자는 위험요인을 재확인하며 예방대책도 잊지 않게 됩니다.<br>
                    - TBM은 조직의 안전 문화와 인식 수준을 향상시킵니다.<br>
                  </div>
                </div>
                <div class="ml-4 mt-4">
                  <strong>▣ TBM 실시방법</strong><br>
                  <div class="ml-4">
                    - Step1. 먼저 생각 (Think Before Move)<br>
                    - Step2. 작업 상황에 맞게 실시<br>
                  </div>
                </div>
                <div class="ml-4 mt-4">
                  <strong>▣ TBM 논의 주제 (예시)</strong><br>
                  <div class="ml-4">
                    - 작업 절차변경 내용<br>
                    - 새로운 위험의 식별 및 기존 위험 검토<br>
                    - 위험요인 통제방안<br>
                    - 최근 이슈와 사건·사고 사례<br>
                    - 작업 일정(일일 또는 주간)<br>
                    - 안전 작업절차<br>
                    - 새로 도입되는 장비와 설비의 사용법<br>
                    - 날씨·계절 변화에 따른 위험요인 (폭염·탈수)<br>
                    - 교대 근무에 따라 다음 근무자에 전달해야 할 안전 사항<br>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="115" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ TBM 실행 예시</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">순 서</th>
                    <th scope="col">내 용</th>
                    <th scope="col">사 진</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1. 작업장소 이동</td>
                    <td>
                      - 주관: TBM리더, 근로자<br>
                      - TBM 리더, 근로자 작업장소로 이동<br>
                      - 체조 및 스트레칭<br>
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_train1.png" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/>
                          <!-- <img src="../assets/SKMJ_train2.jpg" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/> -->
                        </div>
                      </div> 
                    </td>
                  </tr>

                  <tr>
                    <td>2. 건강상태 확인</td>
                    <td>
                      - 주관: TBM리더, 근로자<br>
                      - 근로자 상호 간 건강상태 확인 (TBM 리더가 최종확인)<br>
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_train2.jpg" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/>
                        </div>
                      </div> 
                    </td>
                  </tr>

                  <tr>
                    <td>3. 보호구 점검</td>
                    <td>
                      - 주관: TBM리더, 근로자<br>
                      - 작업자 보호구 착용상태 확인 (2인1조)<br>
                      · 안전모 및 턱끈 착용상태<br>
                      · 안전화 착용여부<br>
                      · 안전대 고리 기능 상태<br>

                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_train3.jpg" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/>
                        </div>
                      </div> 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="116" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ TBM 실행 예시</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">순 서</th>
                    <th scope="col">내 용</th>
                    <th scope="col">사 진</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>4. 작업내용</td>
                    <td rowspan="2">
                      - 주관: TBM리더, 근로자<br>
                      - TBM 리더가 금일 작업내용 지시<br>
                      - 연속·신규작업을 구분하여 세부 작업별 위험요인 및 감소대책 공유<br>
                      - 근로자가 자발적으로 추가 위험요인 의견 제시토록 참여 분위기 형성<br>
                    </td>
                    <td rowspan="2">
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_train4.jpg" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/>
                        </div>
                      </div> 
                    </td>
                  </tr>
                  <tr>
                    <td>작업절차</td>
                  </tr>
                  <tr>
                    <td>위험요인</td>
                    <td rowspan="2">
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_workprocess.png" class="ml-2" style="width: 100%; height: auto; border-radius: 10px;"/>
                        </div>
                      </div> 
                    </td>
                    <td rowspan="2"></td>
                  </tr>
                  <tr>
                    <td>대책공유</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="117" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ TBM 실행 예시</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">순 서</th>
                    <th scope="col">내 용</th>
                    <th scope="col">사 진</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>5. 숙지여부 확인</td>
                    <td>
                      - 주관: TBM리더<br>
                      - 질문형태로 근로자 숙지여부 체크<br>
                      - 전일작업에 대한 미흡한 부분 강조<br>
                      - 추가 전달사항 안내<br>
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_train5.jpg" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/>
                        </div>
                      </div> 
                    </td>
                  </tr>
                  <tr>
                    <td>6. 비상시 행동 요령</td>
                    <td>
                      - 주관: TBM리더<br>
                      - 작업장소 내 비상사태 발생(화재 등) 시 대피 경로와 집합장소 주지<br>
                      - 작업장소 내 소화시설(소화기 등) 위치 주지<br>
                    </td>
                    <td>
                      <div class="ma-4 text-center font-weight-black">
                        <div class="iron_center_contents">
                          <img src="../assets/SKMJ_train6.jpg" class="ml-2" style="width: 150px; height: auto; border-radius: 10px;"/>
                        </div>
                      </div> 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="118" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전작업허가 준수사항</strong><br>
                <div class="ml-4">
                  협력회사는 사내 사업장에서 작업을 하기 전 적법한 절차에 따라 안전작업허가를 받아야 하며, 
                  작업에 대한 안전교육을 이수하고 작업별 안전지침을 준수하여 작업을 진행해야 함. 
                  또한 작업지휘자를 포함한 모든 근로자는 산업재해가 발생할 급박한 위험이 있는 경우에는 작업을 중지하고 대피해야 함.<br>
                  - 모든 허가서 발급은 SKMJ 통합SHE시스템을 이용하는 것이 원칙<br>
                  - 작업허가 구역 외에서 작업을 수행할 경우에는 작업 장소가 변경될 때 마다 허가서를 별도로 발급·허가를 받아야 함<br>
                  - 동일 장소에서 1일 이상 연속작업이 수행될 경우라 하더라도, 작업허가서는 당 작업허가 기준 시간인 8시간 기준하여 작업허가서 발행요청 해야함.<br>
                  - 연장작업은 연장작업 전 운전부서 팀장의 최종승인을 받고 실시 해야 하며, 허가당일 24시 이내에 한하여 작업가능<br>
                  - 작업허가가 되지 않은 상태에서 작업 시 SGR 위반으로 제재를 받게 됨.<br>
                </div>
                <div class="ml-4 mt-4">
                  <strong>▣ 안전작업 허가 등급</strong><br>
                </div>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col" rowspan="2">등 급</th>
                    <th scope="col" colspan="2">작업내용</th>
                    <th scope="col" colspan="3">현장입회자</th>
                  </tr>
                  <tr>
                    <th scope="col">작업내용</th>
                    <th scope="col">현장입회자</th>
                    <th scope="col">작업부서</th>
                    <th scope="col">운전부서</th>
                    <th scope="col">협력업체</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A등급</td>
                    <td>화기작업+보충작업</td>
                    <td>공정확인사항 해당 + 보충작업 (밀폐/정전/굴착/방사선)</td>
                    <td>비상주 (협력업체 작업에 한함)</td>
                    <td>상주</td>
                    <td>상주</td>
                  </tr>
                  <tr>
                    <td>B등급</td>
                    <td>화기작업만해당(보충작업없음)</td>
                    <td>공정확인사항 해당 + 보충작업(중장비/고소)</td>
                    <td>비상주 (협력업체 작업에 한함)</td>
                    <td>상주</td>
                    <td>상주</td>
                  </tr>
                  <tr>
                    <td>C등급</td>
                    <td>해당 없음</td>
                    <td>공정확인사항 해당 없으며, 보 충작업이 없는 경우</td>
                    <td>비상주</td>
                    <td>비상주</td>
                    <td>상주</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="119" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전작업허가 프로세스</strong><br>
                <div>
                  <div class="ma-4 text-center font-weight-black">
                    <div class="iron_center_contents">
                      <img src="../assets/SKMJ_safeprocess.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/>
                    </div>
                  </div> 
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="120" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - TBM(Tool Box Meeting) 위험예지 훈련</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 검수 대상 도구 및 기계기구</strong><br>
              </div>
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">검수대상</th>
                    <th scope="col">사고유형</th>
                    <th scope="col">비 고</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>아크용접기 등 용접기전체</td>
                    <td>화재/감전</td>
                    <td>원형 라벨</td>
                  </tr>
                  <tr>
                    <td>고소작업대(렌탈)</td>
                    <td>추락</td>
                    <td>원형 라벨</td>
                  </tr>
                  <tr>
                    <td>작업대(A형사다리, 안전난간발판, 계단형, 우마형) </td>
                    <td>추락</td>
                    <td>원형 라벨</td>
                  </tr>
                  <tr>
                    <td>전동, 수동리프트</td>
                    <td>전도/협착</td>
                    <td>원형 라벨</td>
                  </tr>
                  <tr>
                    <td>회전체 공구류</td>
                    <td>말림/절단</td>
                    <td>원형 라벨</td>
                  </tr>
                  <tr>
                    <td>이동전선(전기 릴선)</td>
                    <td>감전</td>
                    <td>일자 라벨, 원형 라벨</td>
                  </tr>
                  <tr>
                    <td>이동식 대차 (500KG이상)</td>
                    <td>전도</td>
                    <td>원형 라벨</td>
                  </tr>
                  <tr>
                    <td>달기구 및 중량물 인양 작업 사용 기구</td>
                    <td>추락</td>
                    <td>일자 라벨</td>
                  </tr>
                </tbody>
              </table>
              <v-row>
                <v-col cols="12" md="6" sd="12">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div  class="iron_center_contents"><img src="../assets/SKMJ_checkk1.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
                <v-col cols="12" md="6" sd="12">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div  class="iron_center_contents"><img src="../assets/SKMJ_checkk2.jpg" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                    </div> 
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="121" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 보호구 종류</strong><br>
                <div>
                  <div class="ma-4 text-center font-weight-black">
                    <div class="iron_center_contents">
                      <img src="../assets/SKMJ_protect.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/>
                    </div>
                  </div> 
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="122" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전인증(자율안전확인) 표시가 있는 안전한 제품 사용</strong><br>
                - 보호구는 산업안전보건법에 따라 그 성능을 인증(안전인증, 자율안전확인)받은 제품 사용<br>
                - 인증 여부는 보호구에 표시된 KCs마크 확인<br>
                <div>
                  <div class="ma-4 text-center font-weight-black">
                    <div class="iron_center_contents">
                      <img src="../assets/SKMJ_kc.jpg" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/>
                    </div>
                    산업안전보건법에서 성능을 인증(안전인증, 자율안전확인)하는 종류 이외의 보호구는 타 법령에서 정하는 기준, 제품 사양, 용도 등을 고려해 선택·사용
                  </div> 
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="123" class="education_make_scroll pa-0">
          <div class="pledge_content">
            <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
              <v-card-title class="education_title">
                <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
                <v-spacer></v-spacer>
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              </v-card-title>
              <v-divider class="mb-2"></v-divider>
              <v-card-text class="education_content lineHeight2 mr-5">
                <div class="mt-4 ml-4">
                  <strong>▣ 작업구분 안전보호구</strong><br>
                </div>
              </v-card-text>
              <div class="ml-4">
                <table class="type09 text-center">
                  <thead>
                    <tr>
                      <th scope="col" rowspan="2">작업구분/ 보호구</th>
                      <th scope="col">
                        <div class="iron_center_contents">
                          <img src="../assets/guide_dir_05.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/>
                        </div>
                      </th>
                      <th scope="col"><img src="../assets/guide_dir_07.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_08.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_01.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_03.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_02.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_10.png" class="ml-2" style="width: 42%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_04.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_01.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                      <th scope="col"><img src="../assets/guide_dir_09.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/></th>
                    </tr>
                    <tr>
                      <th scope="col">안전모 (ABE인증)</th>
                      <th scope="col">안전화 (내화학, 절연)</th>
                      <th scope="col">안전장갑 (일반,내화학, 절연등)</th>
                      <th scope="col">보안경</th>
                      <th scope="col">방진마스크</th>
                      <th scope="col">방독마스크</th>
                      <th scope="col">송기마스크, 공기호흡기</th>
                      <th scope="col">보안면</th>
                      <th scope="col">안전대 (안전벨트)</th>
                      <th scope="col">내화학복</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>일반작업</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                    </tr>
                    <tr>
                      <td>화기작업</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                    </tr>
                    <tr>
                      <td>고소작업(1m이상)</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                    </tr>
                    <tr>
                      <td>화학물질 취급작업(내화학보호구)</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text">●</td>
                    </tr>
                    <tr>
                      <td>밀폐공간 작업</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                    </tr>
                    <tr>
                      <td>정전(전기)작업(절연보호구)</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text">●</td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                      <td  class="blue--text"></td>
                    </tr>
                  </tbody>
                </table>
                ※ 화기작업시 : 보안면 (안전모 착용 가능 보안면)<br>
                ※ 화학물질 취급작업시 : 페인트 작업, 사용중인 공정배관 수정 작업, 기타 화학물질 취급작업시 MSDS 8번 안전보호구 항목에 있는 안전보호구 필수 착용
              </div>
            </v-card>
          </div>
        </v-stepper-content>

        <v-stepper-content step="124" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전보호구 (안전대, 안전벨트)</strong><br>
                <v-row>
                  <v-col cols="12" md="12" sd="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div  class="iron_center_contents"><img src="../assets/SKMJ_protect1.png" style="width: 40%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </div>
              ※ 안전그네식 이외 상체식, 허리식 사용불가
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col" colspan="2">포이죔줄(권장 - 24년부터 필수)</th>
                    <th scope="col">일반형</th>
                  </tr>
                  <tr>
                    <th scope="col">1개 걸이</th>
                    <th scope="col">2개 걸이</th>
                    <th scope="col">1,2개 걸이</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_protect2.png" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_protect3.jpg" class="ml-2" style="width: 30%; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_protect4.jpg" class="ml-2" style="width: 50%; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              ※ 일반 작업시 1개 걸이 사용 (안전고리 체결후 이동하지 않는 경우로만 제한)
              ※ 비계설치, 해체 및 고소작업하며 이동시 2개걸이 사용 / 예시) 비계상부 또는 고소작업대 배관라인 이동 작업
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="125" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전보호구 (보안면)</strong><br>
                <v-row>
                  <v-col cols="12" md="12" sd="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div  class="iron_center_contents"><img src="../assets/SKMJ_protect5.png" style="width: 30%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </div>
              ※ 안전모에 설치가능한 보안면만 사용가능 (임의 개조 또는 손상시 사용불가)<br>
              해당 보호구 사용시에는 안전모 앞에 CAP이 없는 안전모 구매 필요. 안전모 인증 (ABE 필수)<br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="126" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전보호구 (내화학장화, 내화학장갑)</strong><br>
              </div>
              ※ 안전그네식 이외 상체식, 허리식 사용불가
            </v-card-text>
            <div class="ml-4">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="col">품목</th>
                    <th scope="col">사용제품(SK머티리얼즈제이엔 씨 사용품)</th>
                    <th scope="col">사용조건</th>
                    <th scope="col">사진</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>내화학장갑</td>
                    <td>케미프로 224X</td>
                    <td>화학물질 취급 작업 시</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool1.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>내화학장갑</td>
                    <td>Microflex 93-260</td>
                    <td>화학물질 취급 작업 시</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool2.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>내화학장화</td>
                    <td>빅토스 내화학장화 PS-04</td>
                    <td>3형식 화학물질보호복 착용시</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool3.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>화학물질 보호복</td>
                    <td>3M 4570</td>
                    <td>액체차단성능을 갖는 보호복</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool4.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>화학물질 보호복</td>
                    <td>3m 4500~4545</td>
                    <td>분진 등 에어로졸에 대한 차단성능을 갖는 보호복</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/safe_tool_2.jpg" class="ml-2" style="width: 80px; height: 80px; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>전면형 직결식 마스크</td>
                    <td>3M #6800</td>
                    <td>물질(액체, 에어로졸형태)이 얼굴에 비산되어 피부에 손상을 일으키는 물질 사용시</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool6.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>반면형 마스크</td>
                    <td>3M #6200</td>
                    <td>물질(기체, 분진 형태)로 얼굴에 비산되어도 반응성이 낮아 위험도가 낮은 작업</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool7.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>방독면 정화통</td>
                    <td>3M #6006K</td>
                    <td>복합가스용 (SK머티리얼즈제이엔씨 사용품)</td>
                    <td>
                      <div class="iron_center_contents">
                        <img src="../assets/SKMJ_safetool8.jpg" class="ml-2" style="width: 80px; height: auto; border-radius: 10px;"/>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="127" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전보호구 (보안면)</strong><br>
                <v-row>
                  <v-col cols="12" md="12" sd="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div  class="iron_center_contents"><img src="../assets/SKMJ_safetoollist.png" style="width: 70%; height: auto; border-radius: 0px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="128" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가 - 보호구</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <strong>▣ 안전보호구 (관리자, 근로자 및 분류 안내) 권장사항(단, 공사비 1억이상시 필수)</strong><br>
                <v-row>
                  <v-col cols="12" md="12" sd="12">
                    <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                      <div class="ma-4 text-center font-weight-black">
                        <div  class="iron_center_contents"><img src="../assets/SKMJ_set.png" style="width: 70%; height: auto; border-radius: 10px;"/></div>
                      </div> 
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="129" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">7. 작업허가</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>폐기물 관리</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 공사폐기물 반출<br>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>도급승인/도급신고</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 해당 시 승인/신고 후 작업 가능<br>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>건설공사 산업재해 예방기술지도 대상여부 판단</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - 지도계약 체결 주체는 SKMJ<br>
                    - 기술 지도에 따른 시정조치 이행<br>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="130" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">8. 기타 - 폐기물 관리</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">폐기물 배출</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 공사로 인해 발생된 모든 폐기물은 기본적으로 수급업체에서 반출하여 처리 必</strong><br>
                <div class="ml-4">
                  - 단, 지정 및 일부 매각 품목에 한해서는 원청의 확인 후 반납 必
                </div>
                <div class="ml-4 mt-4">
                  <strong>▣ 협력회사는 폐기물관리법 시행령 제 7조에 의거하여 적법한 절차로 폐기물을 배출해야함</strong><br>
                  <div class="ml-4">
                    - 폐기물은 종류와 성질, 상태별로 구분하여 운반 및 배출하여함<br>
                    - 폐기물관리법 제 2조에 따라 일반/지정/건설폐기물로 구분하며, 지정된 장소에 분리 배출해야함<br>
                    - 지정폐기물은 성상을 구분하여, 사내 배출기준(스피커 부착 및 필수정보 기재)에 따라 배출하야함<br>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="131" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">8. 기타 - 도급승인, 도급신고</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">도급신고</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 화학물질관리법에 따른 도급신고 대상 협력업체 23년 1월 현재 3개사, 계약 변경시점에 신고 실시</strong><br>
                <div class="ml-4">
                  - 실제 유해화학물질 취급이나 물질잔류배관의 공사는 없으나, 당사는 유해화학물질취급사업소로써 당사 취급품목 누출에 의한 사고를 우려하여 단가대상 업체를 대상으로 도급신고 실시
                  <v-row>
                    <v-col cols="12" md="12" sd="12">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div  class="iron_center_contents"><img src="../assets/SKMJ_chemicallist1.png" style="width: 70%; height: auto; border-radius: 0px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="mt-12">
                <!-- 여백 -->
              </div>
              <strong class="deep-orange--text">도급승인</strong><br>
              <div class="mt-4 ml-4">
                <strong>▣ 산업안전보건법에 따른 도급승인 대상: 없음</strong><br>
                <div class="ml-4">
                  ※ 중량비율 1퍼센트 이상의 황산, 불화수소, 질산, 염화수소취급 설비의 개조, 분해, 해체, 철거작업또는 해당 설비 내부 작업을 사내도급하려는 도급인은 미리 안전보건조치 후 승인을 받아야 함.                          
                  단, 해당화학물질을 모두 제거한 후 증명자료 첨부하여 고용노동부장관에게 신고 시 제외
                  <div class="ml-8">
                    도급승인 대상 검토 근거:<br>
                      1) 대상공정: 있음 (황산: OO 단, 저장되어있지 않음, 불화수소: OO, 질산: OO)<br>
                      2) 정비작업: 없음 (개조, 분해, 해체, 철거 또는 해당 설비 내부 작업)<br>
                      3) 작업 발생 시 : 당사 직원이 직접 작업 실시<br>
                      <strong>4) BP사 도급 작업이 필요한 경우: 해당물질완전 제거 후 노동부 신고 예정</strong><br>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="132" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">8. 기타 - 건설공사의 산업재해 예방 기술 지도</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">지도계약 체결</strong><br>
              <div class="mt-4 ml-4">
                <div class="ml-4">
                  <v-row>
                    <v-col cols="12" md="12" sd="12">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div  class="iron_center_contents"><img src="../assets/SKMJ_contract.png" style="width: 70%; height: auto; border-radius: 0px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="133" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">8. 기타 - 건설공사의 산업재해 예방 기술 지도</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">산업재해 예방기술 지도 프로세스</strong><br>
              <div class="mt-4 ml-4">
                <div class="ml-4">
                  <v-row>
                    <v-col cols="12" md="6" sd="12">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div  class="iron_center_contents"><img src="../assets/SKMJ_preventprocess.png" style="width: 100%; height: auto; border-radius: 10px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" sd="12">
                      <div class="flex-wrap d-flex mt-0 mb-0 text-h6">
                        <div class="ma-4 font-weight-black">
                          1. 신규프로젝트 진행 시 기술지도 대상 확인 요청<br>
                            → SHE Part (대상공사, 금액, 제외요건 확인)<br>
                            → 미대상시 종료<br>
                          2. 대상 시 구매요청 실시<br>
                            ※ SKwithus (품목코드: S210075453)<br>
                          3. 구매팀 지도기관 계약체결<br>
                          → 주관부서, SHE Part, 구매팀 계약서 보관<br>
                          4. 실제 현장 지도시 SHE Part 및 주관부서 담당자 동행<br>
                          5. 지도결과서 → 주관부서, SHE Part 보관<br>
                            ※ SHE Part에서 시정조치에 대한 결과 수령(건설사) 건설사에서 시정 조치 미실시로 인한 지도기관 요청시 주관부서, SHE Part 공동 대응 실시<br>
                          6. 정산 전 완료증명서 수령<br>
                          7. 완료증명서 대표이사 날인 이후 SHE Part 공유<br>

                        </div> 
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="134" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">8. 기타 - 휴게시설 운영</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <strong class="deep-orange--text">작업자 휴게 공간 운영</strong><br>
              <div class="mt-4 ml-4">
                <div class="ml-4">
                  * 해당 공사의 총 공사금액이 20억원 이상인 사업장<br>
                  <div class="ml-4">
                    ※ 공사금액은 부가가치세를 포함한 총공사금액을 기준<br>
                    ※ 분리발주의 경우에는 발주자로부터 수주한 각 공종별 시공사가 휴게시설의 설치 의무가 있는 사업주가 되므로, 
                    총공사금액은 각 시공사별로 발주자와 계약한 금액을 기준으로 산정. 다만, 공종별 시공사가 협의하여 공사현장 내 모든 근로자가 이용할 수 있는 공동휴게시설을 설치하여 운영할 수 있음.
                  </div>
                  <div class="ml-8">
                    1) 간이 휴게시설을 설치필요<br>
                    - 작업의 특성상 작업장소가 일정하지 않거나 전기가 공급되지 않는 등 실내에 휴게시설을 설치하는 것이 곤란해 그늘막 등으로 휴게시설을 간이로 설치한 경우에는 
                    온도, 습도, 조명, 환기 기준을 제외하여 휴게 시설을 설치 할 수 있음.<br>
                    - 간이로 설치한 시설물은 그늘막, 천막, 몽골텐트 등이 해당<br>
                    - 휴게시설 관리 담당자를 지정해야 함.<br>
                    2) 휴게시설 설치 기준<br>
                    - 첨부서류 참고<br>
                  </div>
                  * 그 외 공사 SKMJ 내 휴게실 사용 - 근로자 휴게시설 사용<br>
                </div>

                  <v-row class="mt-2 ml-2 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="12" sm="12">
                      <v-container>
                        <v-row justify="center" >
                          <v-col cols="12" md="3" class="text-center" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_rest1.jpg" height="200" contain /> 
                          </v-col>
                          <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_rest2.jpg" height="200" contain /> 
                          </v-col>
                          <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_rest3.jpg" height="200" contain /> 
                          </v-col>
                          <v-col cols="12" md="3" class="text-center ml-2" style="margin-left:-5%">
                            <v-img src="../assets/SKMJ_rest4.jpg" height="200" contain /> 
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-col>
                  </v-row>

                </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="135" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">8. 기타 - 건설공사의 산업재해 예방 기술 지도</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 mr-5">
              <div class="mt-4 ml-4">
                <div class="ml-4">
                  <v-row>
                    <v-col cols="12" md="12" sd="12">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div  class="iron_center_contents"><img src="../assets/SKMJ_restform.png" style="width: 65%; height: auto; border-radius: 0px;"/></div>
                        </div> 
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="136" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">별첨</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>제출 서류</div>
                  </div>
                  <div class="d-flex ml-6">   
                    - SGR 준수서약<br>
                    - 적격수급업체 사전 평가<br>
                    <br>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="137" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">별첨. SGR 준수서약</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              나는 SGR을 반드시 준수하여 우리 회사의 행복과 구성원의 안전에 기여하겠습니다.
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="iron_center_contents" ><img src="../assets/SKTC_SGR.png" style="height:30%; width: 40%;"/></div>
              <div style="text-align: right; margin-right:25%">
                <v-text-field 
                  v-model="oCustomInfo.CustomNm" 
                  label="성명을 입력하세요" 
                  placeholder="성명을 입력하세요." 
                  style="max-width: 200px; display: inline-block;">
                </v-text-field>          
              </div>
            </v-card-text>
            <div style="margin-top:-1%"> 
              <v-card-text class="greeting_date text-center" >
                {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
              </v-card-text>
              <v-card-text class="greeting_title text-center">
                {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
              </v-card-text>   
            </div>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn v-show="e1 == 1" @click="$emit('CloseEdu')" text width="100"><v-icon>mdi-close</v-icon>취소</v-btn>
      <v-btn v-show="e1 != 1" text width="100" @click="PreviewPage()"><v-icon>mdi-chevron-left</v-icon>뒤로</v-btn>
      <v-btn v-if="$store.state.CustomInfo.SiteId == 'SKTC'" v-show="e1 != 25" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'" v-show="e1 != 32" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" v-show="e1 != 15" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'" v-show="e1 != 137" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'" v-show="e1 != 34" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-else v-show="e1 != 33" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-if="$store.state.CustomInfo.SiteId == 'SKTC'" v-show="e1 == 25" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMG14'" v-show="e1 == 32" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMA'" v-show="e1 == 15" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMJ'" v-show="e1 == 137" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
      <v-btn v-else-if="$store.state.CustomInfo.SiteId == 'SKMP'" v-show="e1 == 34" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
      <v-btn v-else v-show="e1 == 33" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
    </v-card-actions>
  </v-card>    
</template>
<script>
import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    e1: 1,
    ChangableHeight : "",
  }),

  props: {
    oCustomInfo: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  computed: {
    ...mapState(["sNowYear","sNowMounth","sNowDate"]),
  },

  mounted() {
    this.$nextTick(() => {
  try {
    const element = document.getElementById("1");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  } catch (e) {
    // 오류 발생 시에도 콘솔에 아무것도 출력 안 하고 조용히 무시
  }
});

  },

  methods: {
    onResize(){
      if (window.innerWidth > 1350) {
        this.ChangableHeight = "calc(90vh - 225px)"
      } else if (window.innerWidth > 950 && window.innerWidth <= 1350) {
        this.ChangableHeight = "calc(90vh - 250px)"
      } else {
        this.ChangableHeight = String(document.getElementById('safe_4_rules_content').clientHeight) + "px"
      }
    },

    PreviewPage(){
      this.e1 -= 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })
    },

    NextPage(){
      this.e1 += 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })

      if (this.e1 == 33) {
        setTimeout(() => {
          this.onResize();
        }, 10);
      }
    },
  }
};
</script>

<style scoped lang="scss">
  @import "../publishing/visit.scss";

  .box_2{
    width : inherit;    
    border-radius: 20px;    
    color: #FFEB3B;
    background-color: #F44336;
    text-align: center;    
  }
  .box_3{
    width : 350px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_4{
    width : 500px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_outlined{
    width : 300px;
    height : 200px;
    border-radius: 10px;    
    outline: solid;
    outline-color: #AAAAAA;
    outline-width: 1px;
    background-color: #f0f0f0;
    text-align: center;    
  }
  .circle_Box{    
    width : 32px;
    height : 32px;
    border-radius: 100px;    
    color : white;
    background-color: #000088;
    text-align: center;    
  }
  .circle_Box2{
    width : 170px;
    height : 170px;
    border-radius: 100px;        
    background-color: #EEEEEE;
    padding-top: 20px;
    text-align: center;    
  }
  .square_Box{
    width : 160px;
    height : 100px;
    border-radius: 10px;        
    background-color: #eb854a;
    padding-top: 10px;
    text-align: center;    
  }

  .square_Box2{
    width : 250px;
    height : 120px;
    border-radius: 10px;        
    background-color: #EEEEEE;
    padding-top: 10px;
    text-align: center;    
  }

  .circle_Box4{
    width : 190px;
    height : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3; 
  }
  .circle_Box4_longtext {
    max-width : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3;
  }
  .circle_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .circle_Box3{
    width : 160px;
    height : 160px;
    border-radius: 100px;        
    background-color: #F44336;
    padding-top: 20px;
    text-align: center;    
  }
  .lineHeight2{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type10 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type10 thead th {
    padding: 11px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type10 body th {
    width: 350px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    
  }
  table.type10 td {
    width: 500px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
    font-size: 18px;
  }
  
  table.type11 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type11 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type11 tbody th {
    max-width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type11 td {
    max-width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type11 td.img_area {
    max-width: 400px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }


  table.type12 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width: 100%;
    vertical-align: middle;
  }

  table.type12 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    border-bottom: 1px solid #ccc; 
    border-top: 1px solid rgb(141, 141, 141);
    border-right: 1px solid #ccc; 
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 td {
    width: 350px;
    padding: 10px;
    vertical-align: center;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  .safe_4_rules {
    position : absolute;
    top : 0px;
    left : 0px;
    width : 100%;
  }

  .table_line_right {
    border-right: 1px solid #ccc;
  }

  .superscript {
    vertical-align: super;
    font-size: 12px;
  }

  .pledge_content {
    overflow:auto;
    @media screen and (min-width: 1065px) {
      width: 100%;
      height:calc(90vh - 155px);

      :deep(.v-card__text) {
        letter-spacing: .0125rem;
        font-size: 1.25rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .009375rem;
        font-size: 1rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      height:calc(90vh - 135px);

      :deep(.v-card__text) {
        // background-color : blue;
        letter-spacing: .01rem;
        font-size: 1rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        // background-color : green;
        letter-spacing: .009375rem;
        font-size: 0.9rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (max-width: 601px) {
      height:calc(90vh - 115px);
      :deep(.v-card__text) {
        letter-spacing: .0075rem;
        font-size: 0.9rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .007rem;
        font-size: 0.8rem;
        font-weight: 400;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }



</style>
